export interface Person {
  firstName: string;
  lastName: string;
  title: string;
  slug: string;
  dei: boolean;
  category: string;
}

export const people: Person[] = [
  {
    firstName: "Linda",
    lastName: "A",
    title: "Senior Instructional Designer GSE Information Technology",
    slug: "linda-a",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Mindy",
    lastName: "Aaronson",
    title: "Executive Director Compensation Human Resources - Compensation",
    slug: "mindy-aaronson",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Sisaye",
    lastName: "Abaye",
    title: "Supervisor, Transportation and Parking Parking",
    slug: "sisaye-abaye",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Aous",
    lastName: "Abbas",
    title:
      " Systems Administrator Senior Nursing Office of Information Services",
    slug: "aous-abbas",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Tara",
    lastName: "Abbott",
    title: "Resident COH Extramural Activities",
    slug: "tara-abbott",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "India",
    lastName: "Abbott",
    title: "Digital Production Supervisor Penn Live Arts",
    slug: "india-abbott",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Akilah",
    lastName: "Abdul-Rahman",
    title: "Recruitment Specialist College of Liberal and Professional Studies",
    slug: "akilah-abdul-rahman",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "RABI'A",
    lastName: "ABDUSSHAHEED",
    title: "ADMINISTRATIVE COORDINATOR FOR THE CHAIR'S OFFICE MGMT DEPARTMENT",
    slug: "rabi-a-abdusshaheed",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Ashley",
    lastName: "Abel",
    title:
      " Information Technology Support Specialist A ISC-CLIENT SERVICES-HIREIT",
    slug: "ashley-abel",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jay L",
    lastName: "Abramovitz",
    title: "PCI CHIEF FINANCIAL OFFICER Penn Center for Innovation",
    slug: "jay-l-abramovitz",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Ryan",
    lastName: "Acito",
    title: "Senior Academic Initiatives Coordinator Wharton Dean's Office",
    slug: "ryan-acito",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "STEPHANIE",
    lastName: "ACKERMAN",
    title: "Marketing and Enrollment Manager English Language Program",
    slug: "stephanie-ackerman",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Laurie A",
    lastName: "Actman",
    title:
      " Chief Marketing, Communications & Program Officer Penn Center for Innovation",
    slug: "laurie-a-actman",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Vera",
    lastName: "Adams",
    title: "Human Resources Generalist ISC-ACIO-Shared Services",
    slug: "vera-adams",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Patricia R",
    lastName: "Adams",
    title: "Human Resources Director School of Nursing",
    slug: "patricia-r-adams",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "CANDICE",
    lastName: "ADAMS",
    title: "UNDERGRADUATE COORDINATOR Chemistry",
    slug: "candice-adams",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Stephanie",
    lastName: "Adams",
    title: "Assistant Biosafety Officer Environmental Health and Safety",
    slug: "stephanie-adams",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Trevor",
    lastName: "Adams",
    title: "Information Technology Support Specialist A SDM Computing",
    slug: "trevor-adams",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "BETH",
    lastName: "ADAMS",
    title: "Director of Publications SDM Communications",
    slug: "beth-adams",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Michael S",
    lastName: "Adams",
    title:
      " Information Technology Support Specialist Senior Wharton Computing and Instructional Technology (WCIT)",
    slug: "michael-s-adams",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Victor",
    lastName: "Adams",
    title: "Director, Payroll Operations Comptroller's Office",
    slug: "victor-adams",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Joan",
    lastName: "Adams Hewitt",
    title:
      " Senior Director, Alumni and Student Engagement Wharton External Affairs",
    slug: "joan-adams-hewitt",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Sonia Daniele Obam",
    lastName: "Adamson",
    title: "Assistant Director of Outreach and Communications Parent's Program",
    slug: "sonia-daniele-obam-adamson",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "BARBARA",
    lastName: "ADDARIO",
    title:
      " Information Technology Support Specialist Senior ISC-Client Services-Technology Support Services",
    slug: "barbara-addario",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Maxine",
    lastName: "Adekoya",
    title:
      " Senior Associate Director, Student Finances Wharton Graduate Division",
    slug: "maxine-adekoya",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Caitlin",
    lastName: "Adkins",
    title:
      " Associate Director The Jerome Fisher Program in Management and Technology",
    slug: "caitlin-adkins",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Betty S.",
    lastName: "Adler",
    title: "SR. COUNSEL GENERAL COUNSEL",
    slug: "betty-s-adler",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Thalie",
    lastName: "Adolphus",
    title: "Administrative Coordinator Perry World House",
    slug: "thalie-adolphus",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ammarah",
    lastName: "Aftab",
    title:
      " Manager C, Learning Experience Designer (Penn Online Learning), Graduate Coordinator (AMCS) Professional Programs",
    slug: "ammarah-aftab",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Pooja",
    lastName: "Agarwal",
    title: "Executive Director of Legal Affairs Abramson Cancer Center",
    slug: "pooja-agarwal",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Justin M.",
    lastName: "Agnew",
    title: "Content Program Manager Wharton Computing",
    slug: "justin-m-agnew",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Waldo",
    lastName: "Aguirre",
    title: "Director of Multimedia Services Annenberg School",
    slug: "waldo-aguirre",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Joseph-James J.",
    lastName: "Ahern",
    title: "SENIOR ARCHIVIST UNIVERSITY ARCHIVES",
    slug: "joseph-james-j-ahern",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ross D",
    lastName: "Aikins",
    title:
      " Program Manager, Higher Education & Director, Penn GSE Graduate Assistantship Program Education",
    slug: "ross-d-aikins",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Taiwo",
    lastName: "Aina",
    title: "Supervisor, ULAR Husbandry ULAR",
    slug: "taiwo-aina",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Newar",
    lastName: "Aita",
    title: "Coordinator, Program Undergraduate Division",
    slug: "newar-aita",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Soma",
    lastName: "Aktar",
    title: "Affiliation: Staff",
    slug: "soma-aktar",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Anne O",
    lastName: "Albert",
    title:
      " Director for Public Programs; Managing Editor, Jewish Quarte Katz Center for Advanced Judaic Studies",
    slug: "anne-o-albert",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kelsey R.",
    lastName: "Alderman",
    title:
      " Associate Director, Penn Alumni Ambassador Program Alumni Relations",
    slug: "kelsey-r-alderman",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Elisavel",
    lastName: "Aleman",
    title: "STEWARDSHIP COORDINATOR SAS Office of Advancement",
    slug: "elisavel-aleman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Taylor Ann Plunkett",
    lastName: "Alexander",
    title: "Center Coordinator, Center for Professional Learning Education",
    slug: "taylor-ann-plunkett-alexander",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jeff",
    lastName: "Alexander",
    title: "Project Manager - 3 Year Term Project Management",
    slug: "jeff-alexander",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ariana E",
    lastName: "Alexander",
    title:
      " Associate Director D, Student Services, Academic Programs Leadership Program",
    slug: "ariana-e-alexander",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Isabel Rose",
    lastName: "Algrant",
    title:
      " Assistant Director, AISP Training & Technical Assistance Actionable Intelligence for Social Policy",
    slug: "isabel-rose-algrant",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Rebecca",
    lastName: "Alig",
    title: "Events Manager MBA Career Management",
    slug: "rebecca-alig",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Beth M.",
    lastName: "Alioto",
    title: "Associate Director, Research Services Research Services",
    slug: "beth-m-alioto",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Tamara",
    lastName: "Alizzi",
    title: "Administrative Coordinator Basic and Translational Sciences",
    slug: "tamara-alizzi",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Liyan",
    lastName: "Alkawafhah",
    title: "Coordinator A Middle East Center",
    slug: "liyan-alkawafhah",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Ali",
    lastName: "Alkhairo",
    title: "IT Systems Project Manager BSD Support",
    slug: "ali-alkhairo",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jonathan",
    lastName: "Allan",
    title:
      " Associate Director of Communications Annenberg School for Communication",
    slug: "jonathan-allan",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "David M",
    lastName: "Allegretti",
    title: "Senior Director, IT SP2 Finance and Administration",
    slug: "david-m-allegretti",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Yvonne Y.",
    lastName: "Allen",
    title: "Senior Accounts Payable Specialist Procurement Services",
    slug: "yvonne-y-allen",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Patrice M",
    lastName: "Allen",
    title: "Senior Training Specialist Financial Systems",
    slug: "patrice-m-allen",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "James G Iv",
    lastName: "Allen",
    title:
      " HOUSEKEEPING SR. SHIFT MANAGER QUADRANGLE FACIL OPER AND MAINT ADMIN",
    slug: "james-g-iv-allen",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Gwenn",
    lastName: "Allen",
    title: "Industrial Hygienist B Environmental Health and Safety",
    slug: "gwenn-allen",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Folatomi",
    lastName: "Alli Balogun",
    title: "Investment Associate Office of Investments",
    slug: "folatomi-alli-balogun",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Samuel",
    lastName: "Allingham",
    title: "Associate Director, Leadership Communications University Museum",
    slug: "samuel-allingham",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Lindsay F",
    lastName: "Allison",
    title:
      " Senior Associate Director, Strategic Initiatives MBA Career Management",
    slug: "lindsay-f-allison",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Mohammed",
    lastName: "Almashhadani",
    title:
      " 3 YR Term Assistant PM/System Administrator (e-Builder) Project Management",
    slug: "mohammed-almashhadani",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Diana B",
    lastName: "Altegoer",
    title:
      " Executive Director of Foundation Relations Corporate and Foundation Relations",
    slug: "diana-b-altegoer",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Joseph M",
    lastName: "Altemus",
    title: "Manager, ULAR Husbandry ULAR",
    slug: "joseph-m-altemus",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Wesley",
    lastName: "Alvers",
    title:
      " LGBT Center Associate Director Lesbian Gay Bisexual Transgender Center",
    slug: "wesley-alvers",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Selin",
    lastName: "Amado",
    title:
      " Director C, Business and Finance, Investments Office of Investments",
    slug: "selin-amado",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Gretchen Anne",
    lastName: "Amen",
    title: "Director of Events, Penn Medicine Penn Medicine Development",
    slug: "gretchen-anne-amen",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Neetu Singh",
    lastName: "Amin",
    title:
      " Assistant Director, Technology Licensing Penn Center for Innovation",
    slug: "neetu-singh-amin",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Sajid",
    lastName: "Amir",
    title: "Global Data and Communications Manager Global Support Services",
    slug: "sajid-amir",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Peter",
    lastName: "Ammon",
    title: "Chief Investment Officer General University Special",
    slug: "peter-ammon",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Shibu",
    lastName: "Anamalayil",
    title:
      " Associate Director of Medical Physics Residency Program RO-Radiation Oncology",
    slug: "shibu-anamalayil",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Brian",
    lastName: "Anders",
    title: "Assistant Director, Penn Alumni Interview Program Alumni Relations",
    slug: "brian-anders",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Stacie",
    lastName: "Anderson",
    title: "Coordinator, Program Operations, Information and Decisions",
    slug: "stacie-anderson",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Rebecca A",
    lastName: "Anderson",
    title: "Associate Director for Communications Penn Law",
    slug: "rebecca-a-anderson",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Leah Seppanen",
    lastName: "Anderson",
    title: "Executive Director SNF Paideia Program",
    slug: "leah-seppanen-anderson",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Latifah K",
    lastName: "Anderson",
    title:
      " Netter UACS Operations Manager Netter Center for Community Partnerships",
    slug: "latifah-k-anderson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Christine",
    lastName: "Anderson",
    title:
      " Sr. Associate Director, CRM and Marketing Analytics Marketing and Communications Group",
    slug: "christine-anderson",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Carla E.",
    lastName: "Anderson",
    title:
      " Director of Operations for Admissions and Financial Aid, and Director of Access Initiatives Law School",
    slug: "carla-e-anderson",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Ardeth P.",
    lastName: "Anderson",
    title: "Designer, Publications University Museum",
    slug: "ardeth-p-anderson",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "JANE L",
    lastName: "ANDERSON",
    title: "Regulatory Manager Center for Cellular Immunotherapy",
    slug: "jane-l-anderson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Brigit",
    lastName: "Andersson",
    title: "Development Assistant, Penn Medicine Penn Medicine Development",
    slug: "brigit-andersson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Brianna",
    lastName: "Andes",
    title: "Grants Manager B Biomedical Sciences",
    slug: "brianna-andes",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "William G",
    lastName: "Andresen",
    title:
      " Associate VP of Federal Affairs Office of Government & Community Affairs",
    slug: "william-g-andresen",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Scott",
    lastName: "Andrews",
    title: "Assistant Head Of Stacks II Access Services",
    slug: "scott-andrews",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Maria-Antonia",
    lastName: "Andrews",
    title:
      " Assoc Director of Undergraduate Programs Earth and Environmental Science",
    slug: "maria-antonia-andrews",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kelly J",
    lastName: "Andrews",
    title:
      " Director, Knowledge Management and Marketing Center for High Impact Philanthropy",
    slug: "kelly-j-andrews",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Christopher B",
    lastName: "Angelucci",
    title:
      " Emrollment Management Coordinator Professional and Liberal Education (PLE)",
    slug: "christopher-b-angelucci",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Gabriel V",
    lastName: "Angrand",
    title:
      " Temporary Staff - Temp Academic Coach Office of Diversity, Equity and Inclusion",
    slug: "gabriel-v-angrand",
    dei: true,
    category: "Academic",
  },
  {
    firstName: "Jill Allison",
    lastName: "Anick",
    title:
      " Director C, Student Services, Academic Programs Wharton Entrepreneurship",
    slug: "jill-allison-anick",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Celestina",
    lastName: "Anino",
    title:
      " Associate Director of Career Services, College of Arts and Sciences Career Services",
    slug: "celestina-anino",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Sandy",
    lastName: "Antoine",
    title: "Senior Tuition Benefits Specialist Quality of Work Life",
    slug: "sandy-antoine",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "MARGARET",
    lastName: "ANTZOULATOS",
    title: "Assistant Director, Marketing Technology Alumni Relations",
    slug: "margaret-antzoulatos",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Veronica E",
    lastName: "Aplenc",
    title: "Manager C, Academic Affairs, Academic Center Real Estate Center",
    slug: "veronica-e-aplenc",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kathe Marie",
    lastName: "Archibald",
    title: "Director Penn Alumni Regional Clubs Alumni Relations",
    slug: "kathe-marie-archibald",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Andrew P",
    lastName: "Arenge",
    title:
      " Director of Operations, Fox Leadership and PORES Fox Leadership Program",
    slug: "andrew-p-arenge",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Brian Adrian",
    lastName: "Armstead",
    title:
      " Temporary Staff - Temporary Employee - Non-Exempt Stavros Niarchos Foundation Paideia Program",
    slug: "brian-adrian-armstead",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Mellany",
    lastName: "Armstrong",
    title:
      " Communications Coordinator; Morris Arboretum Morris Arboretum Marketing",
    slug: "mellany-armstrong",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Gabrielle",
    lastName: "Arnold",
    title: "Staff Recruiter Recruitment",
    slug: "gabrielle-arnold",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Alexander D",
    lastName: "Arnon",
    title: "Director of Policy Analysis Penn Wharton Budget Model",
    slug: "alexander-d-arnon",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Amanda S",
    lastName: "Aronoff",
    title:
      " Director of Cross-Disciplinary Programs & Student Engagement for JD/MBA Programs Law Registrar",
    slug: "amanda-s-aronoff",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "RAQUEL M.",
    lastName: "ARREDONDO",
    title: "Assistant Dean of Climate and Community GSE Deans Office",
    slug: "raquel-m-arredondo",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Holli Sands",
    lastName: "Arrison",
    title: "Associate General Counsel General Counsel",
    slug: "holli-sands-arrison",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Wilma",
    lastName: "Arroyo",
    title: "Office Coordinator Leadership Program",
    slug: "wilma-arroyo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Joana",
    lastName: "Arruda",
    title: "Global Programs Manager Penn Abroad",
    slug: "joana-arruda",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Aleta",
    lastName: "Arthurs",
    title: "Coordinator B Impact & Assessment",
    slug: "aleta-arthurs",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Brahain",
    lastName: "Ascencio",
    title:
      " Business Administrator (Finance); Residential Services RHS Central Services",
    slug: "brahain-ascencio",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "MARK",
    lastName: "ASELTINE",
    title: "IT Technical Director, Business Services Business Services",
    slug: "mark-aseltine",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "AMY P",
    lastName: "ASHBRIDGE",
    title:
      " Director of Fiscal Operations Dept. of Medical Ethics & Health Policy",
    slug: "amy-p-ashbridge",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "DR ALAN D",
    lastName: "ASKENASE",
    title: "DIRECTOR NUCLEAR CARDIOLOGY",
    slug: "dr-alan-d-askenase",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kenisha",
    lastName: "Askew",
    title: "Director of Operations TPIC Public Interest Center",
    slug: "kenisha-askew",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Scott J",
    lastName: "Asman",
    title: "Project Manager Network Operations",
    slug: "scott-j-asman",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Steven",
    lastName: "Atchison",
    title: "Clerk B Vet Dean's Office",
    slug: "steven-atchison",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "ALAN",
    lastName: "ATCHISON",
    title: "SENIOR PUBLICATIONS EDITOR Center for the Advanced Study of India",
    slug: "alan-atchison",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Stephanie",
    lastName: "Atkins",
    title: "Director, Marketing & Creative Services Admissions",
    slug: "stephanie-atkins",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Adrienne T",
    lastName: "Atkins",
    title: "Editor Assistant Senior Katz Center for Advanced Judaic Studies",
    slug: "adrienne-t-atkins",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kristen",
    lastName: "Auch",
    title: "Director of External Strategy, MBA Admissions Graduate Admissions",
    slug: "kristen-auch",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Anthony D",
    lastName: "Auge",
    title:
      " Information Technology Project Leader Nursing Office of Information Services",
    slug: "anthony-d-auge",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Nicole",
    lastName: "Auge",
    title:
      " Director of Instructional Design and Educational Technology New Ventures",
    slug: "nicole-auge",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Dawn C",
    lastName: "Augustino",
    title: "Information Technology Technical Director ISC-ACIO-Shared Services",
    slug: "dawn-c-augustino",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Elisabeth Fern",
    lastName: "Aulepp",
    title: "Assistant Director of Alumni Engagement Law Alumni and Development",
    slug: "elisabeth-fern-aulepp",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Linara",
    lastName: "Axanova",
    title:
      " Associate Director, Technology Licensing Senior Penn Center for Innovation",
    slug: "linara-axanova",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Deniz",
    lastName: "Aybar-Nevin",
    title: "GRANTS MANAGER Walnut Business Administration Services",
    slug: "deniz-aybar-nevin",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Kentrone Mercy",
    lastName: "Ayilo",
    title: "Africana Studies Librarian Collection Development and Management",
    slug: "kentrone-mercy-ayilo",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Byron",
    lastName: "Azarm",
    title:
      " Information Technology Support Specialist A General University EB Pool",
    slug: "byron-azarm",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Eileen",
    lastName: "Babe",
    title: "Administrative Assistant B Pathobiology",
    slug: "eileen-babe",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Cordelia",
    lastName: "Baffic",
    title: "Associate Director of Medical Education RADIATION ONCOLOGY",
    slug: "cordelia-baffic",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "FATOUMATA",
    lastName: "BAH",
    title: "Development Assistant, Penn Medicine Penn Medicine Development",
    slug: "fatoumata-bah",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Juni",
    lastName: "Bahuguna",
    title:
      " Assistant Director, Student and Visitor Programs Center for Advanced Study of India",
    slug: "juni-bahuguna",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "KATHLEEN M",
    lastName: "BAILEY",
    title: "Director, Administration and Finance Vet Dean's Office",
    slug: "kathleen-m-bailey",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Katherine P. U.",
    lastName: "Baillie",
    title:
      " Director, Environmental Innovations Initiative Environmental Innovations Initiative",
    slug: "katherine-p-u-baillie",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Brooke",
    lastName: "Bakan",
    title:
      " Associate Director of Instructional Design, Wharton Online Executive Education Online",
    slug: "brooke-bakan",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Brandon K",
    lastName: "Baker",
    title: "STAFF WRITER University Communications",
    slug: "brandon-k-baker",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Michael C",
    lastName: "Baker",
    title: "Senior Director of Global Operations SAS Office of Advancement",
    slug: "michael-c-baker",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "IBRAHIM M",
    lastName: "BAKRI",
    title:
      " Associate Director B, Academic Affairs, Academic Center Andrea Mitchell Center for the Study of Democracy",
    slug: "ibrahim-m-bakri",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kalyani",
    lastName: "Balasubramanian",
    title: "Application Architect ISC-Applications & Information Services",
    slug: "kalyani-balasubramanian",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Laura",
    lastName: "Baldasarre",
    title:
      " Admissions Communications & Marketing Specialist SP2 Enrollment Services",
    slug: "laura-baldasarre",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Tonya Geanne",
    lastName: "Baldwin",
    title: "Administrative Coordinator Chemistry",
    slug: "tonya-geanne-baldwin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "ATIYA L.",
    lastName: "BALDWIN",
    title: "OFFICE MANAGER Law School",
    slug: "atiya-l-baldwin",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Khalesha D",
    lastName: "Baldwin-Campbell",
    title: "Class Giving Director, The Penn Fund Penn Fund",
    slug: "khalesha-d-baldwin-campbell",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "MARTINA W",
    lastName: "BALE",
    title:
      " Department Administrator Department of Francophone, Italian, and Germanic Studies",
    slug: "martina-w-bale",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Anna",
    lastName: "Balfanz",
    title: "Coordinator, Program Office of the University Architect",
    slug: "anna-balfanz",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Osman",
    lastName: "Balkan",
    title:
      " Associate Director D, Student Services, Academic Programs Program in International Studies and Business",
    slug: "osman-balkan",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jeffrey S",
    lastName: "Ballentine",
    title:
      " Information Technology Director ISC-Tech Services-Network Operations",
    slug: "jeffrey-s-ballentine",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Sarah",
    lastName: "Bandos",
    title: "Travel Services Manager, Penn Procurement Procurement Services",
    slug: "sarah-bandos",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mandira",
    lastName: "Banerjee",
    title:
      " Senior Director of Marketing & Communications Annenberg School for Communication",
    slug: "mandira-banerjee",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Haimanti",
    lastName: "Banerjee",
    title:
      " Associate Director B, Academic Affairs, Academic Center Lauder Institute",
    slug: "haimanti-banerjee",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Mark W.",
    lastName: "Bangela",
    title: "Senior Director of Major Gifts Major Gifts Program",
    slug: "mark-w-bangela",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Ashley",
    lastName: "Banks",
    title:
      " Associate Director, Student Leadership & Engagement SP2 Student Services and Activities",
    slug: "ashley-banks",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Eddie D",
    lastName: "Banks-Crosson",
    title: "Director of Student Life, MBA Program Wharton School",
    slug: "eddie-d-banks-crosson",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Joshua",
    lastName: "Banta",
    title: "Senior IT Support Specialist; Business Services BSD Support",
    slug: "joshua-banta",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Blair V",
    lastName: "Baranowski",
    title: "Program Manager Wharton Executive Education (Open Enrollment)",
    slug: "blair-v-baranowski",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Eric",
    lastName: "Baratta",
    title:
      " Administrative Director, Professional Masters Programs, Earth & Environmental Science Master of Environmental Studies",
    slug: "eric-baratta",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kendal",
    lastName: "Barbee",
    title:
      " Student Records Processing Coordinator Student Registration & Financial Services",
    slug: "kendal-barbee",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jane M",
    lastName: "Barber",
    title: "Mail Carrier; Business Services Mail",
    slug: "jane-m-barber",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "JOSEPH",
    lastName: "BARBER",
    title: "Director C, Student Services, Advising Career Services",
    slug: "joseph-barber",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Katherine M",
    lastName: "Barghaus",
    title:
      " Executive Director, Penn Early Childhood and Family Research Center Education",
    slug: "katherine-m-barghaus",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Mary Ann Kalei",
    lastName: "Baricuatro",
    title:
      " Associate Director B, Student Services, Student Engagement Greenfield Intercultural Center",
    slug: "mary-ann-kalei-baricuatro",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Michael R",
    lastName: "Barker",
    title: "Designer, Exhibit University Museum",
    slug: "michael-r-barker",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sharon A",
    lastName: "Barkley",
    title:
      " Business and Departmental Operations Manager Finance Administration",
    slug: "sharon-a-barkley",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Margo Pietras",
    lastName: "Barnes",
    title: "Director Project Management Project Management",
    slug: "margo-pietras-barnes",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kacey",
    lastName: "Barnes",
    title: "Director of External Engagement MBA Admissions and Financial Aid",
    slug: "kacey-barnes",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "JOYCE",
    lastName: "BARNETT-MORGAN",
    title: "Affiliation: Staff",
    slug: "joyce-barnett-morgan",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Andrea L.",
    lastName: "Barol",
    title: "RESEARCH CENTER COORDINATOR Biobehavioral and Health Sciences",
    slug: "andrea-l-barol",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Emily R",
    lastName: "Barrale",
    title:
      " Associate Director for Data Visualization, Analysis & Reporting Career Services",
    slug: "emily-r-barrale",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "GINA",
    lastName: "BARRETT",
    title:
      " Associate Director E, Student Services, Graduate Programs Wharton Communications Unit",
    slug: "gina-barrett",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Vanessa",
    lastName: "Barrett-Pearsall",
    title: "Executive Assistant Provost Office",
    slug: "vanessa-barrett-pearsall",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Catherine E.M.",
    lastName: "Bartch",
    title:
      " Associate Director C, Academic Affairs, Academic Center Latin American and Latino Studies",
    slug: "catherine-e-m-bartch",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "David Samuel",
    lastName: "Barth",
    title:
      " Sr. Manager - Lithography & Advanced Processing - Quattrone Nanofabrication Facility Quattrone Nanofabrication Facility Service Center",
    slug: "david-samuel-barth",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Marta",
    lastName: "Bartholomew",
    title:
      " Director of Research Programs and Communication Vice Provost for Research",
    slug: "marta-bartholomew",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Erin",
    lastName: "Bartnett",
    title:
      " Assistant Director of Communications Center for Excellence in Teaching, Learning and Innovation",
    slug: "erin-bartnett",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "John",
    lastName: "Bartol",
    title: "Director of Non-Broadcast Distribution WXPN",
    slug: "john-bartol",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Barkley J.",
    lastName: "Barton",
    title: "Associate Director D, Student Services, Admissions Admissions",
    slug: "barkley-j-barton",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "ANTHONY",
    lastName: "BARUFFI",
    title:
      " IT SUPPORT SPECIALIST DESKTOP SUPPORT SAS COMPUTING/Psychology/Biology",
    slug: "anthony-baruffi",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Raymond M",
    lastName: "Bates",
    title: "Executive Director Division of Business Services",
    slug: "raymond-m-bates",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kimberly",
    lastName: "Batista",
    title:
      " Program Manager, Professional and Organizational Development Professional and Organizational Development (POD)",
    slug: "kimberly-batista",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "John",
    lastName: "Batzel",
    title:
      " Information Technology Architect ISC-Tech Services-Network Operations",
    slug: "john-batzel",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Lauren",
    lastName: "Bauer",
    title: "Executive Coordinator, Office of the President President's Office",
    slug: "lauren-bauer",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mike",
    lastName: "Baver",
    title: "Major Gifts Officer Penn Medicine Development",
    slug: "mike-baver",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Robyn",
    lastName: "Baxter",
    title: "Manager B, Healthcare Periodontics",
    slug: "robyn-baxter",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jill A.",
    lastName: "Baxter",
    title: "Director, Fiscal Operations SM-DN-Biomedical Graduate Studies",
    slug: "jill-a-baxter",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Christine S",
    lastName: "Baxter",
    title:
      " Associate Director E, Business and Finance, Innovation Penn Center for Innovation",
    slug: "christine-s-baxter",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Caryn M",
    lastName: "Baxter",
    title: "Immunization Navigator Lead Prevention, Education, and Promotion",
    slug: "caryn-m-baxter",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Amy L",
    lastName: "Baxter-Bellamy",
    title: "ASSOC DIRECTOR",
    slug: "amy-l-baxter-bellamy",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sheila L.",
    lastName: "Bayes",
    title:
      " Information Technology Support Specialist Senior ISC-Client Services-Technology Support Services",
    slug: "sheila-l-bayes",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Menty",
    lastName: "Bayleyen",
    title: "Associate Director of Admissions SDM Admissions",
    slug: "menty-bayleyen",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Moira M.",
    lastName: "Baylson",
    title:
      " Associate Vice President, University Communications University Communications",
    slug: "moira-m-baylson",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Peter",
    lastName: "Bayne",
    title: "Financial Administrative Co-ordinator Office of Admissions",
    slug: "peter-bayne",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Gillian R",
    lastName: "Bazelon",
    title:
      " Senior Associate Director, Student Engagement Wharton Finance Pillar",
    slug: "gillian-r-bazelon",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "dana",
    lastName: "bazelon",
    title:
      " Evaluation Manager - Conviction Integrity Projects Quattrone Center for the Fair Administration of Justice",
    slug: "dana-bazelon",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "MICHAEL T. , IV",
    lastName: "BEACHEM",
    title: "Counselor Student Engagement",
    slug: "michael-t-iv-beachem",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Andrew H",
    lastName: "Beal",
    title: "Associate Director C, Business and Finance Kelly Writer's House",
    slug: "andrew-h-beal",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Mary",
    lastName: "Bearden",
    title: "Grant and Contract Finance Administrator Research Services",
    slug: "mary-bearden",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Pamela",
    lastName: "Beatrice",
    title: "Director - Physical Sciences Licensing Penn Center for Innovation",
    slug: "pamela-beatrice",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nadine N",
    lastName: "Beauharnois",
    title: "Associate Director of Finance Weitzman School of Design Finance",
    slug: "nadine-n-beauharnois",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "STEVEN M",
    lastName: "BECKER",
    title: "DIRECTOR FACIL SVCS PROJ MGMT",
    slug: "steven-m-becker",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Shanice Renee Frances",
    lastName: "Beckham",
    title:
      " Coordinator, Office of Registrar & Student Affairs SP2 Student Services and Activities",
    slug: "shanice-renee-frances-beckham",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Tara",
    lastName: "Beckwith",
    title: "Senior Compensation Specialist Provost's Office",
    slug: "tara-beckwith",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Greta Elise",
    lastName: "Bednarczyk",
    title:
      " Director of Annual Giving, ACC, Penn Medicine Penn Medicine Development",
    slug: "greta-elise-bednarczyk",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Joshua D",
    lastName: "Beeman",
    title:
      " Associate Vice President Information Technology & Associate Chief Information Officer ISC-ACIO-Shared Services",
    slug: "joshua-d-beeman",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Anne",
    lastName: "Beeman",
    title: "Affiliation: Staff",
    slug: "anne-beeman",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Gwendolyn A",
    lastName: "Beetham",
    title:
      " Associate Director of the Program in Gender, Sexuality and W Program in Gender, Sexuality and Women's Studies",
    slug: "gwendolyn-a-beetham",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Tina",
    lastName: "Behari",
    title: "Business Administrator B SAS Graduate Division Administration",
    slug: "tina-behari",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Benjamin Simon",
    lastName: "Behrend",
    title: "Major Gifts Officer Development and Alumni Relations",
    slug: "benjamin-simon-behrend",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Abigail",
    lastName: "Behrends",
    title:
      " Associate Director C, Arts and Media, Communications and Marketing Graduate Admissions",
    slug: "abigail-behrends",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "JoDe H.",
    lastName: "Beitler",
    title: "Affiliation: Staff",
    slug: "jode-h-beitler",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Thomas J.",
    lastName: "Belitza",
    title: "Associate Director, Corporate Contracts Penn Center for Innovation",
    slug: "thomas-j-belitza",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "George K.",
    lastName: "Belka",
    title: "Director D, Research CB-Cancer Biology",
    slug: "george-k-belka",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Latoya S.",
    lastName: "Bell",
    title: "Supervisor, ULAR Husbandry ULAR",
    slug: "latoya-s-bell",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jonathan J",
    lastName: "Bell",
    title:
      " Director of F&S Residential Community Fraternity and Sorority Affairs-Operating",
    slug: "jonathan-j-bell",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "JASON A.",
    lastName: "BELL",
    title: "Manager, Husbandry ULAR",
    slug: "jason-a-bell",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Yuliis",
    lastName: "Bell",
    title: "Manager B Student Health Services",
    slug: "yuliis-bell",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Laura Garnick",
    lastName: "Bellet",
    title:
      " Director of Strategic Communication Projects Exec Dir: Strategy Engagement & Campaign",
    slug: "laura-garnick-bellet",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Andrew Joseph",
    lastName: "Bellet",
    title:
      " Senior Director of Development, Biomedical Research Development Penn Medicine Development",
    slug: "andrew-joseph-bellet",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ciaran",
    lastName: "Bellwoar",
    title: "Development Communications Director External Affairs",
    slug: "ciaran-bellwoar",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "MARK R",
    lastName: "BENDAS",
    title: "Executive Director A, Arts and Media, Events President's Office",
    slug: "mark-r-bendas",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Brigitte Rose",
    lastName: "Benecke",
    title: "Associate Director C, Academic Affairs Leadership Program",
    slug: "brigitte-rose-benecke",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Dolores E.",
    lastName: "Benedetto",
    title: "Instrument Sterilization Attendant A Instrument Management Service",
    slug: "dolores-e-benedetto",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Amy L",
    lastName: "Benedict",
    title:
      " Director of Career and Professional Development Graduate School of Education",
    slug: "amy-l-benedict",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Kimberly A",
    lastName: "Benenhaley",
    title: "Director of Alumni Engagement Law School Dean's Office",
    slug: "kimberly-a-benenhaley",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Lisa",
    lastName: "Benigni",
    title: "Senior Associate Director, Events External Affairs",
    slug: "lisa-benigni",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Joseph M",
    lastName: "Benner",
    title: "SUPERVISOR Operations and Maintenance Administration",
    slug: "joseph-m-benner",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ember A",
    lastName: "Bennett",
    title:
      " Development Coordinator Weitzman School of Design Development Office",
    slug: "ember-a-bennett",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Catherine",
    lastName: "Bennett",
    title: "Grant and Contract Finance Administrator Research Services",
    slug: "catherine-bennett",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "STUART",
    lastName: "BENOFF",
    title:
      " Information Technology Project Leader Senior ISC-Applications & Information Services",
    slug: "stuart-benoff",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Robert F",
    lastName: "Benson",
    title: "Defensive Coordinator Football Team",
    slug: "robert-f-benson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Noshavyah",
    lastName: "Benyehudah",
    title: "Leadership Annual Giving Officer Penn Medicine Development",
    slug: "noshavyah-benyehudah",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Caitlin L",
    lastName: "Benyi",
    title: "Manager, Development Operations SP2 Development",
    slug: "caitlin-l-benyi",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Nancy",
    lastName: "Bercich",
    title:
      " Application Developer Senior ISC-Applications & Information Services",
    slug: "nancy-bercich",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Lila",
    lastName: "Berenholz",
    title:
      " PennCard Operations Administrative Coordinator; Business Services Campus Card Services",
    slug: "lila-berenholz",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Karen Knoll",
    lastName: "Bergbauer",
    title: "Regional Departmental Administrator SAS",
    slug: "karen-knoll-bergbauer",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Suzana",
    lastName: "Berger",
    title: "Coordinator B-01 Netter Center for Community Partnerships",
    slug: "suzana-berger",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Michele W",
    lastName: "Berger",
    title: "Director of News & Publications SAS in DAR",
    slug: "michele-w-berger",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Julie B",
    lastName: "Berger",
    title: "Senior Associate Director, OSCE Education",
    slug: "julie-b-berger",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "James M.",
    lastName: "Berger",
    title: "TECH OPHTHAL PHOTOGRAPHY",
    slug: "james-m-berger",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Danielle",
    lastName: "Bergez",
    title:
      " Programs Manager, English Language Programs English Language Program",
    slug: "danielle-bergez",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Claire",
    lastName: "Bergsten",
    title:
      " Assistant Director of Student Philanthropy in The Penn Fund Penn Fund",
    slug: "claire-bergsten",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Taylor A",
    lastName: "Berkowitz",
    title: "SR PLANNER, SPEC PROJ OFC UNIV ARCH",
    slug: "taylor-a-berkowitz",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Anabel",
    lastName: "Bernal Estrada",
    title: "Administrative Coordinator Asian American Studies Program",
    slug: "anabel-bernal-estrada",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Nancy",
    lastName: "Bernard",
    title: "Director, Communications OB-Obstetrics and Gynecology",
    slug: "nancy-bernard",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "CHERRY A.",
    lastName: "BERNARDINO",
    title: "Assistant Director; Penn Children's Center Day Care Center",
    slug: "cherry-a-bernardino",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Michael , Ph. D.",
    lastName: "Bernhardt",
    title: "Director Penn Transit",
    slug: "michael-ph-d-bernhardt",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Shannon",
    lastName: "Berning",
    title: "Director and Publisher University Press",
    slug: "shannon-berning",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Edwin",
    lastName: "Berrios",
    title: "Associate Director, Building Operations RHS",
    slug: "edwin-berrios",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jerel",
    lastName: "Berry",
    title:
      " Information Technology Project Leader ISC-Client Services-Technology Support Services",
    slug: "jerel-berry",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "John F.",
    lastName: "Bertos",
    title: "Windows Systems Administrator PMACS",
    slug: "john-f-bertos",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Elizabeth C.",
    lastName: "Berwick",
    title: "BENEFITS SPECIALIST SOM",
    slug: "elizabeth-c-berwick",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Brad",
    lastName: "Beshara",
    title: "Director of Strategic Analysis, Business Office Education",
    slug: "brad-beshara",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Christopher M",
    lastName: "Bester",
    title: "Contract Administrator Senior Research Services",
    slug: "christopher-m-bester",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Monique",
    lastName: "Betterson",
    title: "GRANTS  COORD IN-Institute for Neuroscience",
    slug: "monique-betterson",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "ELISE M",
    lastName: "BETZ",
    title: "Director of Penn Alumni and Penn Traditions DAR",
    slug: "elise-m-betz",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jackson C",
    lastName: "Betz",
    title: "Editorial Assistant Almanac",
    slug: "jackson-c-betz",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Marcy R",
    lastName: "Bevan",
    title: "ASSOC DIRECTOR ADMISSIONS/ALUMNI AFFAIRS LAUDER INST",
    slug: "marcy-r-bevan",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Amanda",
    lastName: "Bewley",
    title: "Senior Industrial Hygienist Environmental Health and Safety",
    slug: "amanda-bewley",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Shilpa H",
    lastName: "Bhansali",
    title: "Associate Director Technology Licensing Penn Center for Innovation",
    slug: "shilpa-h-bhansali",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Lila",
    lastName: "Bhide",
    title:
      " Penn Food and Wellness Collaborative Prevention, Education, and Promotion",
    slug: "lila-bhide",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Celeste A",
    lastName: "Bichey",
    title:
      " Executive Assistant to Dean of The Wharton School Wharton Dean's Office",
    slug: "celeste-a-bichey",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jessica",
    lastName: "Bicknell",
    title: "Director C, Curatorial, University Museum University Museum",
    slug: "jessica-bicknell",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jillian D",
    lastName: "Bieber",
    title:
      " Associate Director, Lifelong Learning & Global Forums External Affairs",
    slug: "jillian-d-bieber",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Michael",
    lastName: "Bieda",
    title: "Assistant Chief Of Medical Physics RO-Radiation Oncology",
    slug: "michael-bieda",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kelly",
    lastName: "Bierling",
    title:
      " Director, Finance & Administration Departments of Biomedical Sciences & Pathobiology",
    slug: "kelly-bierling",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jennifer",
    lastName: "Bieter",
    title:
      " Director, Fiscal Operations, Office of the Executive Vice President Central Administration",
    slug: "jennifer-bieter",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Walter",
    lastName: "Biggins",
    title: "Editor C University Press",
    slug: "walter-biggins",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Anjeza",
    lastName: "Bilbili",
    title:
      " Director, Marketing & Media Strategy Wharton Executive Education (Operations)",
    slug: "anjeza-bilbili",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Nancy",
    lastName: "Biller",
    title: "Assistant Dean for Global Health Affairs School of Nursing",
    slug: "nancy-biller",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Emmett",
    lastName: "Binkowski",
    title: "Disability Specialist Student Disability Services Office",
    slug: "emmett-binkowski",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jackie",
    lastName: "Binstead",
    title: "Associate Director Financial Systems",
    slug: "jackie-binstead",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jonah C",
    lastName: "Binstock",
    title: "Dean's Office Coordinator Wharton Dean's Office",
    slug: "jonah-c-binstock",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Sarah",
    lastName: "Birkle",
    title: "Events and Guest Services Manager Penn Live Arts Administration",
    slug: "sarah-birkle",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Heather",
    lastName: "Birmingham",
    title: "Administrative Assistant B CB-Cancer Biology",
    slug: "heather-birmingham",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Robert Penn",
    lastName: "Biron",
    title: "Director D, Research CC-Cancer Center",
    slug: "robert-penn-biron",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Christian",
    lastName: "Bitto",
    title: "Associate Director, PennERA Research Services",
    slug: "christian-bitto",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kyle",
    lastName: "Black",
    title:
      " Information Technology Support Specialist B ISC-CLIENT SERVICES-HIREIT",
    slug: "kyle-black",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Lex",
    lastName: "Blackman",
    title:
      " Health and Safety Technical Specialist C Environmental Health and Safety",
    slug: "lex-blackman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Torren J.",
    lastName: "Blair",
    title:
      " Senior Director of Development for Biomedical Research Penn Medicine Development & Alumni Relations",
    slug: "torren-j-blair",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tim",
    lastName: "Blake",
    title:
      " IT Technical Director, Wharton Marketing and Communications Marketing and Communications Group",
    slug: "tim-blake",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Katherine",
    lastName: "Blanchard",
    title: "Manager, Museum Collections University Museum",
    slug: "katherine-blanchard",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Eric",
    lastName: "Blanchet",
    title: "Financial Administrator Education",
    slug: "eric-blanchet",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Ann Sizemore",
    lastName: "Blevins",
    title: "Application Developer Senior Pathobiology",
    slug: "ann-sizemore-blevins",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Christopher E",
    lastName: "Blickley",
    title:
      " Director of Workday Operations ISC - Application and Information Services",
    slug: "christopher-e-blickley",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Allison",
    lastName: "Blisard",
    title: "Business Administrator B Wharton Finance and Administration",
    slug: "allison-blisard",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Rebecca",
    lastName: "Block",
    title:
      " Associate Director D, Human Resources, School/ Center Provost's Office",
    slug: "rebecca-block",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Patricia F",
    lastName: "Blood",
    title: "Coordinator, Program Accounting",
    slug: "patricia-f-blood",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "ROSEMARY MESISCA",
    lastName: "BLOSER",
    title:
      " Managing Director, Custom Programs Wharton Executive Education (Custom)",
    slug: "rosemary-mesisca-bloser",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Marissa",
    lastName: "Bluestine",
    title:
      " Assistant Director Quattrone Center for the Fair Administration of Justice",
    slug: "marissa-bluestine",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Dewayne",
    lastName: "Bluford",
    title: "Senior Staff Recruiter Human Resources",
    slug: "dewayne-bluford",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Kenneth S",
    lastName: "Blum",
    title: "Assistant Director, Art and Creative Services Alumni Relations",
    slug: "kenneth-s-blum",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Andria",
    lastName: "Board",
    title: "Assistant Director of Admissions Admissions",
    slug: "andria-board",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Chenelle S",
    lastName: "Boatswain",
    title: "Associate Director, Mid-Career Doctoral Program Education",
    slug: "chenelle-s-boatswain",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jacqueline",
    lastName: "Boccanfuso",
    title: "IT SUPPORT SPECIALIST BE-Informatics Division",
    slug: "jacqueline-boccanfuso",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Genny Mercedes",
    lastName: "Boccardo Dubey",
    title: "Chief Operating Officer University Museum",
    slug: "genny-mercedes-boccardo-dubey",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Cintia V M",
    lastName: "Bock",
    title:
      " Application Developer Senior ISC-Applications & Information Services",
    slug: "cintia-v-m-bock",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Aaron",
    lastName: "Boczkowski",
    title: "Manager Master of Applied Positive Psychology - LPS",
    slug: "aaron-boczkowski",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Bria",
    lastName: "Boddie",
    title: "Student Loan Specialist Student Registration & Financial Services",
    slug: "bria-boddie",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Anna",
    lastName: "Boffice",
    title:
      " Associate Director C, Student Services, Academic Programs Chemistry",
    slug: "anna-boffice",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Lawrence W",
    lastName: "Boggs",
    title: "Financial Coordinator ULAR",
    slug: "lawrence-w-boggs",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Shailesh",
    lastName: "Boghara",
    title: "Information Technology Support Specialist B SDM Computing",
    slug: "shailesh-boghara",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "LeighAnn",
    lastName: "Bogner Winslow",
    title: "Coordinator Graduate Fine Art Program",
    slug: "leighann-bogner-winslow",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "CHRISTOPHER R",
    lastName: "BOGS",
    title: "MARKETING COORDINATOR COL HSES & ACAD SVCS",
    slug: "christopher-r-bogs",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Herbie",
    lastName: "Bohnet",
    title: "Associate General Counsel Office of Investments",
    slug: "herbie-bohnet",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Marie-Claude",
    lastName: "Boileau",
    title: "Director A, Curatorial, University Museum University Museum",
    slug: "marie-claude-boileau",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "M'HAMED KRIMO",
    lastName: "BOKRETA",
    title: "House Dean Kings Court English College House/CHAS",
    slug: "m-hamed-krimo-bokreta",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Sharicca M.",
    lastName: "Boldon",
    title:
      " Director, Comprehensive Executive Programs Wharton Executive Education",
    slug: "sharicca-m-boldon",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "William R",
    lastName: "Bole",
    title: "Chief Advancement Officer Wharton in DAR",
    slug: "william-r-bole",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nicholas",
    lastName: "Bolger",
    title: "Pre Award Systems Manager Research Services",
    slug: "nicholas-bolger",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jessica M.",
    lastName: "Bolker",
    title: "Director Family Resource Center",
    slug: "jessica-m-bolker",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Stephanie",
    lastName: "Bongiovanni",
    title: "Senior Contract and Project Manager CC-Cancer Center",
    slug: "stephanie-bongiovanni",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Bob J",
    lastName: "Bonhage",
    title:
      " Disbursement Representative-Greenphire Program Penn Purchasing Services",
    slug: "bob-j-bonhage",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Raymond",
    lastName: "Bonikowski",
    title: "Office of Software Licensing and Client Services BUSINESS SERVICES",
    slug: "raymond-bonikowski",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Julia",
    lastName: "Bonilla",
    title: "RECORDS ASST UNIV RECORDS CTR",
    slug: "julia-bonilla",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Katie",
    lastName: "Bonner",
    title: "Executive Director Office of Student Affairs",
    slug: "katie-bonner",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Colleen P",
    lastName: "Bonner",
    title:
      " Associate Director C, Student Services, Advising Fels Institute of Government",
    slug: "colleen-p-bonner",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Kevin J",
    lastName: "Bonner",
    title:
      " Associate Athletic Director, Administration & Strategic Communications DRIA",
    slug: "kevin-j-bonner",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Katrina N",
    lastName: "Booker",
    title: "Operations Manager, Applicant Care Admissions",
    slug: "katrina-n-booker",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Janae S.",
    lastName: "Boone",
    title:
      " Associate Director C, Human Resources, School/ Center Finance and Administration",
    slug: "janae-s-boone",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Michael J",
    lastName: "Borda",
    title: "Associate Vice Provost for Research Vice Provost for Research",
    slug: "michael-j-borda",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "DR YVETTE",
    lastName: "BORDEAUX",
    title:
      " Director for Professional Masters Programs EARTH &ENVIRONMENTAL SCI",
    slug: "dr-yvette-bordeaux",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Matthew B",
    lastName: "Borlik",
    title:
      " Information Technology Support Specialist A Wharton Computing and Instructional Technology (WCIT)",
    slug: "matthew-b-borlik",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jennifer",
    lastName: "Bornstein",
    title: "Assistant Director, Contracts Office of Research Services",
    slug: "jennifer-bornstein",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Michael S",
    lastName: "Borokhovsky",
    title: "Senior Database Administrator University of Pennsylvania",
    slug: "michael-s-borokhovsky",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Angelina M",
    lastName: "Borrelli",
    title: "Supervisor, ULAR Husbandry ULAR",
    slug: "angelina-m-borrelli",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Josh",
    lastName: "Borrow",
    title: "Systems Architect Physics and Astronomy",
    slug: "josh-borrow",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Matthew Antonio",
    lastName: "Bosch",
    title:
      " Vice Dean, Director of Strategic Engagement and Organizational Development Admissions",
    slug: "matthew-antonio-bosch",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "McKenzie M",
    lastName: "Boschitsch",
    title: "Coordinator, Program Biobehavioral and Health Sciences",
    slug: "mckenzie-m-boschitsch",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "CASEY",
    lastName: "BOSS",
    title:
      " Associate Director, Planning, Design, and Construction Provost's Office",
    slug: "casey-boss",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Bonnie K",
    lastName: "Botel-Sheppard",
    title: "DIR PENN LITERACY NETWORK GSE",
    slug: "bonnie-k-botel-sheppard",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kim",
    lastName: "Bothi",
    title:
      " Managing Director, Office of Academic Services Office of Academic Services",
    slug: "kim-bothi",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Robert",
    lastName: "Botto",
    title:
      " Information Technology Director Wharton Computing and Instructional Technology (WCIT)",
    slug: "robert-botto",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jennifer",
    lastName: "Bottomley",
    title: "OFFICE MANAGER POLIT SCI",
    slug: "jennifer-bottomley",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nadia",
    lastName: "Bouamar",
    title: "Sr. Business Administrator Graduate Division",
    slug: "nadia-bouamar",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Isabella",
    lastName: "Boudnik",
    title: "Academic Counselor PennCAP",
    slug: "isabella-boudnik",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Mounir",
    lastName: "Boukitab",
    title: "Assistant Controller; Business Services Business Services",
    slug: "mounir-boukitab",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "CHRISSO",
    lastName: "BOULIS",
    title: "MUSEUM REGISTRAR, RECORDS Penn Museum",
    slug: "chrisso-boulis",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Eric W.",
    lastName: "Bowden",
    title: "Associate Director University Life Technology Services",
    slug: "eric-w-bowden",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Denise",
    lastName: "Bowden",
    title: "Administrative Coordinator, Human Resources DAR Human Resources",
    slug: "denise-bowden",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "James W.",
    lastName: "Bowen",
    title:
      " Executive Director of Corporate Alliances Penn Center for Innovation",
    slug: "james-w-bowen",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Victoria R",
    lastName: "Bowen",
    title: "ADMIN ASST FIN SVCS CTR COL HOUSES & ACAD SVCS",
    slug: "victoria-r-bowen",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Wes",
    lastName: "Bower",
    title: "Corporate Underwriting Rep WXPN",
    slug: "wes-bower",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Kimberly A",
    lastName: "Bowers",
    title:
      " Executive Assistant for the Vice President of Development and Alumni Relations VP Development and Alumni Relations",
    slug: "kimberly-a-bowers",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jamie Sheree",
    lastName: "Bowers",
    title: "Curatorial Assistant, Morris Arboretum & Gardens Botany",
    slug: "jamie-sheree-bowers",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Cory M",
    lastName: "Bowman",
    title: "Associate Director Netter Center for Community Partnerships",
    slug: "cory-m-bowman",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Sarah",
    lastName: "Boyer",
    title: "Assistant Director, Disbursements Projects Procurement Services",
    slug: "sarah-boyer",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Frankie",
    lastName: "Boyer",
    title:
      " Temporary Staff - Non-Degree Penn Student SM-DN-Inclusion, Diversity, Equity, & Learner Exp Prog in Me",
    slug: "frankie-boyer",
    dei: true,
    category: "Student Life",
  },
  {
    firstName: "Beth A",
    lastName: "Boyer",
    title:
      " Accounting Operations Specialist Wharton Finance and Administration",
    slug: "beth-a-boyer",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jacqueline",
    lastName: "Boytim",
    title: "Manager C, Curatorial, University Museum University Museum",
    slug: "jacqueline-boytim",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Samantha L",
    lastName: "Bozarth",
    title: "IT Project Leader ISC",
    slug: "samantha-l-bozarth",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jessica L",
    lastName: "Bradbury",
    title:
      " Director of Young Alumni and Student Philanthropy for The Penn Fund Penn Fund",
    slug: "jessica-l-bradbury",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Monica",
    lastName: "Bradford",
    title: "Coordinator B SAS Graduate Division Administration",
    slug: "monica-bradford",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Christopher A., Ed.D.",
    lastName: "Bradie",
    title: "Associate Vice President Business Services",
    slug: "christopher-a-ed-d-bradie",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Courtney D",
    lastName: "Bradshaw",
    title: "Assistant Director of Admissions Admissions",
    slug: "courtney-d-bradshaw",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Katie",
    lastName: "Brady",
    title:
      " Head, E-Resources and Licensing Collection Development and Management",
    slug: "katie-brady",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Alan E",
    lastName: "Brady",
    title:
      " Senior Associate Director, Program Delivery OE Wharton Executive Education (Open Enrollment)",
    slug: "alan-e-brady",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Natalia",
    lastName: "Bragilevskaya",
    title: "Business Manager C Linguistic Data Consortium",
    slug: "natalia-bragilevskaya",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "William D.",
    lastName: "Branan",
    title:
      " Information Technology Director ISC-Applications & Information Services",
    slug: "william-d-branan",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Anne M.",
    lastName: "Brancati",
    title: "Registrar, University Museum University Museum",
    slug: "anne-m-brancati",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Daniela",
    lastName: "Branco",
    title: "Graduate Program Specialist Graduate and Professional Programs",
    slug: "daniela-branco",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Brenda T",
    lastName: "Brand",
    title: "Associate Director The Tutoring Center, VPUL",
    slug: "brenda-t-brand",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Joseph R",
    lastName: "Brand",
    title:
      " Manager B, Academic Affairs, Academic Partnerships Netter Center for Community Partnerships",
    slug: "joseph-r-brand",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Leona M",
    lastName: "Brandwene",
    title:
      " Associate Director D, Student Services, Graduate Programs LPS Administration",
    slug: "leona-m-brandwene",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Patrick Michael",
    lastName: "Bransfield",
    title: "Academic Coordinator City Planning",
    slug: "patrick-michael-bransfield",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Paulette Nicole",
    lastName: "Branson",
    title:
      " Director of Student Engagement and Community Building Netter Center for Community Partnerships",
    slug: "paulette-nicole-branson",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "JULIE L",
    lastName: "BRANTLEY",
    title: "Senior Associate Director Gift & Investment Services",
    slug: "julie-l-brantley",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "John J.",
    lastName: "Breen",
    title:
      " Information Technology Director ISC-Tech Services-Network Operations",
    slug: "john-j-breen",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Matthew",
    lastName: "Breen",
    title:
      " Assistant Director of Events Services for Institutional Advancement SDM Development",
    slug: "matthew-breen",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Emily K.",
    lastName: "Breen-Fredrick",
    title:
      " Assistant Director for Principal Gifts Operations AVP for Principal Gifts",
    slug: "emily-k-breen-fredrick",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jennifer",
    lastName: "Brehm",
    title: "Director, Learning & Public Engagement University Museum",
    slug: "jennifer-brehm",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Mark P",
    lastName: "Breitenbach",
    title: "SENIOR PROJECT MANAGER FACIL SVCS PROJ MGMT",
    slug: "mark-p-breitenbach",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Laura M.",
    lastName: "Brennan",
    title:
      " Communications Specialist, Office of the Secretary Secretary's Office",
    slug: "laura-m-brennan",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "LESLIE",
    lastName: "BRENNAN",
    title: "Financial Coordinator PATHOBIOLOGY NBC",
    slug: "leslie-brennan",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jessica Coyle",
    lastName: "Brennan",
    title: "Legal Coordinator Senior Penn Center for Innovation",
    slug: "jessica-coyle-brennan",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Courtney M.",
    lastName: "Brennan",
    title: "Department Academic Coordinator South Asia Studies",
    slug: "courtney-m-brennan",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Hannah A",
    lastName: "Brenneman",
    title:
      " Associate Director of Fieldwork & Service Learning Educational Linguistics",
    slug: "hannah-a-brenneman",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jerry",
    lastName: "Brennian",
    title:
      " Information Technology Project Leader Senior SM-DN External Info Services",
    slug: "jerry-brennian",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Nicole Hope",
    lastName: "Breslin",
    title: "Director of Marketing & Brand Strategy, MarComm Education",
    slug: "nicole-hope-breslin",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "John E",
    lastName: "Brestelli",
    title: "Information Technology Manager Senior Biology",
    slug: "john-e-brestelli",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Suzannah",
    lastName: "Bretz",
    title: "Associate Director of Admissions Admissions",
    slug: "suzannah-bretz",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "James",
    lastName: "Brewer",
    title:
      " Information Technology Director ISC-Tech Services-Network Operations",
    slug: "james-brewer",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Regina",
    lastName: "Brewington",
    title:
      " Administrative Coordinator Operations and Maintenance Administration",
    slug: "regina-brewington",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jason S",
    lastName: "Breyan",
    title: "Assistant Dean for Advising The College",
    slug: "jason-s-breyan",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Maxie T.",
    lastName: "Brinkley",
    title: "Instrument Sterilization Attendant A Instrument Management Service",
    slug: "maxie-t-brinkley",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Patricia G",
    lastName: "Briscoe-Cypress",
    title: "Assignment Coordinator for Tutoring Center Tutoring",
    slug: "patricia-g-briscoe-cypress",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "DR CHRISTINE",
    lastName: "BRISSON",
    title:
      " Chief Information Officer - School of Arts & Sciences Finance and Administration",
    slug: "dr-christine-brisson",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Anyea",
    lastName: "Brittingham",
    title: "Finance Administrator Penn Live Arts Administration",
    slug: "anyea-brittingham",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "DIANA",
    lastName: "BROACH",
    title: "Business Administrator C Business Economics and Public Policy",
    slug: "diana-broach",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Holly",
    lastName: "Broadnax-Woodbury",
    title: "Prospect Research Assistant DAR Advancement Research & Analysis",
    slug: "holly-broadnax-woodbury",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Janice H",
    lastName: "Brochetti",
    title: "Grants Manager Department of Chemistry",
    slug: "janice-h-brochetti",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Ry",
    lastName: "Brody",
    title: "Administrative Coordinator Master of Chemical Sciences",
    slug: "ry-brody",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Corey R",
    lastName: "Brooker",
    title:
      " Information Technology Manager Senior ISC-Client Services-Technology Support Services",
    slug: "corey-r-brooker",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Terence Marcel",
    lastName: "Brooks",
    title: "PROJECT MANAGER FACIL SVCS PROJ MGMT",
    slug: "terence-marcel-brooks",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jacob",
    lastName: "Brooks",
    title: "Business Administrator (Finance) - HS RHS Central Services",
    slug: "jacob-brooks",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Eric M",
    lastName: "Brooks",
    title: "Supervisor B Escort",
    slug: "eric-m-brooks",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jamiella N",
    lastName: "Brooks",
    title:
      " Director of Student Equity & Inclusion Initiatives Diversity and Engagement",
    slug: "jamiella-n-brooks",
    dei: true,
    category: "Student Life",
  },
  {
    firstName: "Kathryn D.",
    lastName: "Brossa",
    title: "Director of Student Information & Registrar School of Nursing",
    slug: "kathryn-d-brossa",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Edriana",
    lastName: "Broughton",
    title: "Workers' Compensation Program Manager Risk Management",
    slug: "edriana-broughton",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Zareah",
    lastName: "Brown",
    title:
      " Associate Director of Student Life & Wellness, SP2 SP2 Student Services and Activities",
    slug: "zareah-brown",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Stacey D",
    lastName: "Brown",
    title: "MGR RES PROJECT A Biobehavioral Health Sciences",
    slug: "stacey-d-brown",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nathan A.",
    lastName: "Brown",
    title: "Administrative Coordinator, Catalyst @ Penn GSE Education",
    slug: "nathan-a-brown",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nancie",
    lastName: "Brown",
    title: "Manager Central Billing Office",
    slug: "nancie-brown",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Melissa",
    lastName: "Brown",
    title: "Associate General Counsel General Counsel",
    slug: "melissa-brown",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Maggie",
    lastName: "Brown",
    title: "Associate Director for Operations Graduate Student Center",
    slug: "maggie-brown",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Marla",
    lastName: "Brown",
    title: "Administrative Coordinator Sociology",
    slug: "marla-brown",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Michael",
    lastName: "Brown",
    title:
      " Director B, Student Services, Academic Programs Environmental, Social and Governance (ESG) Analytics Lab",
    slug: "michael-brown",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Keith",
    lastName: "Brown",
    title: "Associate Director, Radiation Safety EHRS",
    slug: "keith-brown",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Joanna",
    lastName: "Brown",
    title: "Administrative Assistant Leave Management Benefits",
    slug: "joanna-brown",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Eugene E",
    lastName: "Brown",
    title:
      " Information Technology Support Specialist Senior Nursing Office of Information Services",
    slug: "eugene-e-brown",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Erin",
    lastName: "Brown",
    title: "Director C, Human Resources, School/ Center HCM Operations",
    slug: "erin-brown",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Ericka S",
    lastName: "Brown",
    title: "Office of Student Life Coordinator Student Affairs Office",
    slug: "ericka-s-brown",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "MS. DIANA M",
    lastName: "BROWN",
    title: "Executive Assistant A Nursing Administration",
    slug: "ms-diana-m-brown",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Albert",
    lastName: "Brown",
    title: "BLDG SVC ASST BIOL",
    slug: "albert-brown",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Carolyn A.",
    lastName: "Brown",
    title:
      " Sr. Associate Director of Development & Community Engagement, Penn Medicine Penn Medicine Development",
    slug: "carolyn-a-brown",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "STEPHANIE C",
    lastName: "BROWN",
    title: "Communications Specialist Learning & Education",
    slug: "stephanie-c-brown",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Brittney Marie",
    lastName: "Brown",
    title:
      " HR Generalist, Development and Alumni Relations DAR Human Resources",
    slug: "brittney-marie-brown",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Dante",
    lastName: "Brown",
    title: "Administrative Coordinator Office of University Life",
    slug: "dante-brown",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Anthony Maurice",
    lastName: "Brown",
    title: "Associate Director C, Student Services School Partnerships",
    slug: "anthony-maurice-brown",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Angelle",
    lastName: "Brown",
    title:
      " Temporary Staff - Non-Degree Penn Student SM-DN-Inclusion, Diversity, Equity, & Learner Exp Prog in Me",
    slug: "angelle-brown",
    dei: true,
    category: "Student Life",
  },
  {
    firstName: "Christine",
    lastName: "Brown-Lawrence",
    title: "Executive Assistant A Office of University Life",
    slug: "christine-brown-lawrence",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Kimberly Ann",
    lastName: "Brown-Pearson",
    title:
      " CUSTOMER CALL CENTER AGENT Operations and Maintenance Administration",
    slug: "kimberly-ann-brown-pearson",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Elayna A",
    lastName: "Browne",
    title:
      " Curriculum Specialist Bachelor of Applied Arts & Sciences and Certificate Programs",
    slug: "elayna-a-browne",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "David",
    lastName: "Brubaker",
    title:
      " Senior IT Director, Academic Strategic Partnership & Advanced Initiatives Wharton Computing and Instructional Technology (WCIT)",
    slug: "david-brubaker",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kristin W",
    lastName: "Brudy",
    title: "Director of Strategic Finance FINANCE AND TREASURY",
    slug: "kristin-w-brudy",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Mitchell",
    lastName: "Brudy",
    title:
      " Information Technology Project Leader Student Registration & Financial Services",
    slug: "mitchell-brudy",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Matthew J.",
    lastName: "Brukman",
    title:
      " MANAGER, SCANNING AND LOCAL PROBE FACILITY Krishna P. Singh Center for Nanotechnology",
    slug: "matthew-j-brukman",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "TRICIA A",
    lastName: "BRUNING",
    title:
      " Executive Director of Development ABRAMSON CANCER CENTER & DEPT OF RADIATION ONCOLOGY",
    slug: "tricia-a-bruning",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Danielle Madeline",
    lastName: "Bruno",
    title: "Manager, Wharton Academy Wharton Global Youth Programs",
    slug: "danielle-madeline-bruno",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Cierra",
    lastName: "Brunson",
    title: "Administrative Assistant A Real Estate",
    slug: "cierra-brunson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Daniel A",
    lastName: "Brutus",
    title: "Systems Administrator Senior SM-DN External Info Services",
    slug: "daniel-a-brutus",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Glenn D",
    lastName: "Bryan",
    title: "ASST VP COMMUNITY RELATIONS",
    slug: "glenn-d-bryan",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Zaida",
    lastName: "Bryant",
    title:
      " Associate Director, Resource & Community Engagement Penn First Plus",
    slug: "zaida-bryant",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "SALEM",
    lastName: "BRYANT",
    title:
      " Director of Strategic Planning & Data Analytics, University Development SAVP University Development",
    slug: "salem-bryant",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Chelsea T",
    lastName: "Bryant",
    title: "Senior Gifts and Records Administrator Gift Administration",
    slug: "chelsea-t-bryant",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kareem B.",
    lastName: "Bryant",
    title: "Manager, Racquet Centers Levy Tennis",
    slug: "kareem-b-bryant",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Cher M",
    lastName: "Bryant",
    title: "Mgr Admin and Finance Fisher Bennett Business Office",
    slug: "cher-m-bryant",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Kiana",
    lastName: "Bucci",
    title:
      " Assistant Director of Young Alumni Philanthropy in The Penn Fund Penn Fund",
    slug: "kiana-bucci",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jessica",
    lastName: "Buchanan",
    title:
      " Senior Director, Research Security and Export Compliance Research Services",
    slug: "jessica-buchanan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Colleen",
    lastName: "Buck",
    title: "Communications Coordinator External Affairs",
    slug: "colleen-buck",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Lauren Frances",
    lastName: "Buckheit",
    title:
      " Associate Director of Development, Penn Medicine Penn Medicine Development",
    slug: "lauren-frances-buckheit",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "LENA",
    lastName: "BUFORD",
    title: "Director of Finance Annenberg Public Policy Center",
    slug: "lena-buford",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Pierce",
    lastName: "Buller",
    title:
      " Associate Vice President and Advisor to the President President's Office",
    slug: "pierce-buller",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sandra L.",
    lastName: "Bullock",
    title: "BUS ADMINISTRATOR PENN MED DEV & ALUM RELS",
    slug: "sandra-l-bullock",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Robert",
    lastName: "Bumbera",
    title: "News Director/Morning Show Anchor WXPN",
    slug: "robert-bumbera",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jorey",
    lastName: "Bump",
    title:
      " Systems Administrator Senior Computing and Educational Technology Services",
    slug: "jorey-bump",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Lyndsi N",
    lastName: "Burcham",
    title: "Financial Wellness Program Manager Financial Wellness",
    slug: "lyndsi-n-burcham",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "McKay",
    lastName: "Burdette",
    title: "Assistant Museum Collections, University Museum University Museum",
    slug: "mckay-burdette",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Donna L.",
    lastName: "Burdumy",
    title: "Director of Human Resources Annenberg School for Communication",
    slug: "donna-l-burdumy",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Sarah",
    lastName: "Burger",
    title: "Curriculum Coordinator Vet Dean's Office",
    slug: "sarah-burger",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Sean V.",
    lastName: "Burke",
    title: "Associate General Counsel General Counsel",
    slug: "sean-v-burke",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Jonathan E",
    lastName: "Burke",
    title: "Building Administrator Chemistry",
    slug: "jonathan-e-burke",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Eleanor A.",
    lastName: "Burke",
    title: "FCH DEPARTMENT COORDINATOR Family and Community Health",
    slug: "eleanor-a-burke",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Brendan",
    lastName: "Burke",
    title: "Building Administrator Operations & Planning",
    slug: "brendan-burke",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Michael A",
    lastName: "Burkeitt",
    title: "Associate Athletic Trainer Trainer Support",
    slug: "michael-a-burkeitt",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Nina",
    lastName: "Burnaford",
    title:
      " Senior Associate Director, Legal Affairs; Associate General Counsel Penn Center for Innovation; University of Pennsylvania",
    slug: "nina-burnaford",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Rosemarie",
    lastName: "Burnett",
    title: "ASST DIRECTOR OF ATHLETICS ACAD COORD",
    slug: "rosemarie-burnett",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "ERIKA",
    lastName: "BURNETT",
    title: "Administrative Coordinator Wharton Marketing Department",
    slug: "erika-burnett",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Sully",
    lastName: "Burns",
    title: "Development Assistant, Penn Medicine Penn Medicine Development",
    slug: "sully-burns",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jessie W",
    lastName: "Burns",
    title: "Director, Administration Provost's Office",
    slug: "jessie-w-burns",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "William J",
    lastName: "Burns",
    title: "Director PEFS Research Services Pre-Award SEAS ADMINISTRATION",
    slug: "william-j-burns",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Gavin",
    lastName: "Burris",
    title:
      " Sr IT Project Leader Wharton Computing and Instructional Technology (WCIT)",
    slug: "gavin-burris",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kahleil",
    lastName: "Burroughs",
    title: "Financial Administrative Coordinator Business Operations",
    slug: "kahleil-burroughs",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Lisa",
    lastName: "Burton-Grika",
    title:
      " Associate Director, Academic Advising Wharton Undergraduate Division",
    slug: "lisa-burton-grika",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Mary B",
    lastName: "Bustamante",
    title:
      " Assistant Director of Enrollment Management, LPS Professional and Liberal Education (PLE)",
    slug: "mary-b-bustamante",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Kevin J.",
    lastName: "Butler",
    title: "Information Technology Director Wharton Research Data Services",
    slug: "kevin-j-butler",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Elizabeth",
    lastName: "Butler",
    title: "FINANCIAL COORD CONTINUING MED EDUC",
    slug: "elizabeth-butler",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Bernadette",
    lastName: "Butler",
    title:
      " Associate Director of Student Development & Community Partnerships Undergraduate Division",
    slug: "bernadette-butler",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Terri",
    lastName: "Butrymowicz",
    title: "Program Manager Mack Institute for Innovation Management",
    slug: "terri-butrymowicz",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Batsirai",
    lastName: "Bvunzawabaya",
    title:
      " Director of Integrated Care Initiatives, Student Health and Counseling Counseling and Psychological Services",
    slug: "batsirai-bvunzawabaya",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jessica E",
    lastName: "Byler",
    title: "Museum Conservator University Museum",
    slug: "jessica-e-byler",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Regina Monique",
    lastName: "Bynum",
    title:
      " Associate Director C, Academic Affairs, Academic Partnerships Netter Center for Community Partnerships",
    slug: "regina-monique-bynum",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kimberley D",
    lastName: "Byrd",
    title:
      " Information Technology Project Leader Senior Nursing Office of Information Services",
    slug: "kimberley-d-byrd",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Victoria",
    lastName: "Byrd",
    title: "Executive Assistant FRES Office of the Vice President",
    slug: "victoria-byrd",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kate",
    lastName: "Caccavo",
    title: "Director of Events for Wharton External Affairs External Affairs",
    slug: "kate-caccavo",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Kayla",
    lastName: "Cade",
    title: "Manager B, Student Services, Student Engagement Student Engagement",
    slug: "kayla-cade",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Dr. VALARIE",
    lastName: "CADE",
    title: "VICE PROVOST Division of Student Engagement",
    slug: "dr-valarie-cade",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Kevin M",
    lastName: "Cahail",
    title: "OFF SITE COLLECTIONS MANAGER University Museum",
    slug: "kevin-m-cahail",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Remy Lapidus",
    lastName: "Cahn",
    title: "Career Counselor Office of Career Strategy",
    slug: "remy-lapidus-cahn",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Linda M",
    lastName: "Caiazzo",
    title: "OFFICE/ADVERTISING COORDINATOR PENNSYLVANIA GAZETTE",
    slug: "linda-m-caiazzo",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Curt",
    lastName: "Calafut",
    title: "Systems Administrator Senior SM-DN External Info Services",
    slug: "curt-calafut",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Carter",
    lastName: "Caldwell",
    title:
      " Co-Investment Program Director Penn Medicine and Penn Center for Innovation",
    slug: "carter-caldwell",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Duane E.",
    lastName: "Caldwell",
    title: "Business Administrator Nursing Finance",
    slug: "duane-e-caldwell",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "JACKIE",
    lastName: "CALIMAN",
    title: "Director Computer and Information Science Dept.",
    slug: "jackie-caliman",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jenel",
    lastName: "Call",
    title: "Associate Director Family and Community Health",
    slug: "jenel-call",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Joanne D.",
    lastName: "Callahan",
    title: "Assistant Director, Risk Management General Counsel",
    slug: "joanne-d-callahan",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Melissa",
    lastName: "Calvert",
    title:
      " Vice Dean for Development and Alumni Relations Graduate School of Education",
    slug: "melissa-calvert",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kevin",
    lastName: "Calvert",
    title: "Supervisor B University Museum",
    slug: "kevin-calvert",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "HEATHER J",
    lastName: "CALVERT",
    title: "Executive Director MindCORE",
    slug: "heather-j-calvert",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Dana D",
    lastName: "Camacho",
    title: "Database Administrator Senior ISC-Tech Services-Network Operations",
    slug: "dana-d-camacho",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Tiara",
    lastName: "Campbell",
    title: "Grants Manager A Business Operations",
    slug: "tiara-campbell",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Teya",
    lastName: "Campbell",
    title: "Department of Africana Studies Center for Africana Studies",
    slug: "teya-campbell",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Shane P",
    lastName: "Campbell",
    title: "Gardening Aide Horticulture",
    slug: "shane-p-campbell",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sandra Dee",
    lastName: "Campbell",
    title: "Legal Coordinator General Counsel",
    slug: "sandra-dee-campbell",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Hannah",
    lastName: "Campbell",
    title: "Director, Strategic Writing DAR Communications",
    slug: "hannah-campbell",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Bruce",
    lastName: "Campbell",
    title: "Director C, Student Services, Graduate Programs Education",
    slug: "bruce-campbell",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Christol",
    lastName: "Campbell",
    title: "Administrative Assistant Gift Administration",
    slug: "christol-campbell",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Gina",
    lastName: "Campellone",
    title: "Solution Center Specialist HCM Operations",
    slug: "gina-campellone",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Dr. Jacqueline P.",
    lastName: "Candido",
    title: "Sr. Director, Online Learning SAS",
    slug: "dr-jacqueline-p-candido",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Krystal",
    lastName: "Cannon",
    title:
      " eResource and Access Librarian Collection Development and Management",
    slug: "krystal-cannon",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Colleen N.",
    lastName: "Cannon",
    title:
      " Senior Writer Development and Alumni Relations Marketing and Communications",
    slug: "colleen-n-cannon",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jennifer L",
    lastName: "Canose",
    title: "Director for Education & Academic Admininstration Provost's Office",
    slug: "jennifer-l-canose",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Sarah Jane",
    lastName: "Capasso",
    title: "Biosafety Officer B Environmental Health and Safety",
    slug: "sarah-jane-capasso",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "John S",
    lastName: "Caperton",
    title:
      " Communications Coordinator Weitzman School of Design Communications",
    slug: "john-s-caperton",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Toni",
    lastName: "Capik",
    title: "Donor Support Administrator in The Penn Fund Penn Fund",
    slug: "toni-capik",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Taylor C",
    lastName: "Caputo",
    title: "Director of the Studios at Venture Labs Venture Lab at Tangen Hall",
    slug: "taylor-c-caputo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Brian",
    lastName: "Caputo",
    title:
      " Associate Director, Procurement Systems & Operations Financial Systems",
    slug: "brian-caputo",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Kristy",
    lastName: "Carabello",
    title: "Marketing Coordinator B Real Estate Development",
    slug: "kristy-carabello",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Kate",
    lastName: "Carangi",
    title: "Corporate Tax Compliance Manager Comptroller's Office",
    slug: "kate-carangi",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Heather",
    lastName: "Cardamone",
    title: "Senior Manager - Independent Contractors Penn Purchasing Services",
    slug: "heather-cardamone",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Samantha",
    lastName: "Cardenas",
    title: "Admissions Counselor Admissions",
    slug: "samantha-cardenas",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Richard",
    lastName: "Cardona",
    title:
      " Director of Information Technology Annenberg School for Communication",
    slug: "richard-cardona",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Silvia R",
    lastName: "Cardona",
    title: "Admissions Coordinator Law Admissions and Financial Aid",
    slug: "silvia-r-cardona",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Zachary D.",
    lastName: "Carduner",
    title: "Manager C, Arts and Media Kelly Writers House",
    slug: "zachary-d-carduner",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sally A.",
    lastName: "Cardy",
    title:
      " Director of Academic Operations - Office of Academic Services Office of Academic Services",
    slug: "sally-a-cardy",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Ryann T",
    lastName: "Carey",
    title:
      " Associate Director, Corporate and Foundation Relations Corporate and Foundation Relations",
    slug: "ryann-t-carey",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Adrian Madison",
    lastName: "Cario",
    title: "Executive Director, Wharton San Francisco Wharton San Francisco",
    slug: "adrian-madison-cario",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Nicole C",
    lastName: "Carl",
    title:
      " Director, Urban Teaching Residency Program Executive Education and Professional Development",
    slug: "nicole-c-carl",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Keimahney",
    lastName: "Carlisle",
    title:
      " SNF Paideia Fellows Coordinator Stavros Niarchos Foundation Paideia Program",
    slug: "keimahney-carlisle",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Stacey L",
    lastName: "Carlough",
    title: "Associate Director of Teaching & Learning, OSCE Education",
    slug: "stacey-l-carlough",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jessica E",
    lastName: "Carmine",
    title: "Collections Digitization Assistant University Museum",
    slug: "jessica-e-carmine",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kody",
    lastName: "Carmody",
    title: "Application Developer Senior Penn Wharton Budget Model",
    slug: "kody-carmody",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "CRAIG R",
    lastName: "CARNAROLI",
    title: "EXEC VICE PRESIDENT",
    slug: "craig-r-carnaroli",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Britton N",
    lastName: "Carnevali",
    title:
      " Program Manager, Ph.D. Program, CIS Computer and Information Science",
    slug: "britton-n-carnevali",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Sandra",
    lastName: "Carney",
    title: "Associate Director A, Research RA-Radiology",
    slug: "sandra-carney",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Octavia M",
    lastName: "Carr",
    title:
      " Associate Director C, Academic Affairs, Academic Administration SAS Dean",
    slug: "octavia-m-carr",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Megan",
    lastName: "Carr",
    title:
      " Senior Director of Digital Learning Strategies Center for Excellence in Teaching, Learning and Innovation",
    slug: "megan-carr",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Garry",
    lastName: "Carr",
    title: "Parking Attendant Parking",
    slug: "garry-carr",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Flavio",
    lastName: "Carrabino",
    title: "Information Technology Manager Senior ISC-CLIENT SERVICES-HIREIT",
    slug: "flavio-carrabino",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Marco",
    lastName: "Carrara",
    title:
      " Director, Employer Partnerships Master of Behavioral and Decision Sciences",
    slug: "marco-carrara",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "ANGELA",
    lastName: "CARRIERO",
    title: "Administrative Assistant Penn First Plus",
    slug: "angela-carriero",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Lynnea N",
    lastName: "Carrington",
    title: "Labor and Staff Relations Specialist Senior Staff & Labor",
    slug: "lynnea-n-carrington",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Tara M.",
    lastName: "Carroll",
    title: "Scheduling Coordinator Wharton Operations",
    slug: "tara-m-carroll",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Gilbert",
    lastName: "Carroll",
    title:
      " IT Director, Client Services Computing and Educational Technology Services",
    slug: "gilbert-carroll",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Elizabeth",
    lastName: "Carroll",
    title:
      " Director of Class Giving and Reunion Programs in The Penn Fund Penn Fund",
    slug: "elizabeth-carroll",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Charles",
    lastName: "Carroll",
    title:
      " Associate Director of Development, Major Gifts - Athletics DRIA Development",
    slug: "charles-carroll",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Todd",
    lastName: "Carson",
    title: "Senior Associate Director MBA Career Management",
    slug: "todd-carson",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Latanya L.",
    lastName: "Carter",
    title: "Procurement Service Coordinator Procurement Services",
    slug: "latanya-l-carter",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Dacia D",
    lastName: "Carter",
    title:
      " Associate Director of Community Partnerships and Engagement, Civic House Civic House",
    slug: "dacia-d-carter",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Angela A.",
    lastName: "Carter",
    title: "Affiliation: Staff",
    slug: "angela-a-carter",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Beverly",
    lastName: "Carter- Fulmore",
    title: "Associate Director D Recruitment",
    slug: "beverly-carter-fulmore",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Christopher R",
    lastName: "Caruso",
    title: "Application Developer Senior Linguistic Data Consortium",
    slug: "christopher-r-caruso",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Lucille I",
    lastName: "Casalena",
    title: "Manager, Strategic Sourcing Penn Procurement Services",
    slug: "lucille-i-casalena",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Kristen Michele",
    lastName: "Casalenuovo",
    title: "Manager, Moonlight & Roses; Morris Arboretum Arboretum Development",
    slug: "kristen-michele-casalenuovo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jessica C",
    lastName: "Casciano",
    title:
      " Assistant Director, Technology Licensing Penn Center for Innovation",
    slug: "jessica-c-casciano",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Quinn",
    lastName: "Casey",
    title: "Associate Director, Research Services Research Services",
    slug: "quinn-casey",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Amelia A",
    lastName: "Cason",
    title: "Administrative Assistant B Health and Wellness Administration",
    slug: "amelia-a-cason",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Matthew",
    lastName: "Cass",
    title:
      " Information Technology Manager Wharton Computing and Instructional Technology (WCIT)",
    slug: "matthew-cass",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kyle",
    lastName: "Cassidy",
    title: "Digital Design Specialist Annenberg School for Communication",
    slug: "kyle-cassidy",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "JoAnna",
    lastName: "Cassidy",
    title:
      " Director, Digital Strategy and Creative Design Wharton Executive Education (Operations)",
    slug: "joanna-cassidy",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Anna",
    lastName: "Cassidy",
    title:
      " Academic Program Services Manager Student Registration & Financial Services",
    slug: "anna-cassidy",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Suzanne",
    lastName: "Cassidy",
    title: "Department Administrator Department of Spanish and Portuguese",
    slug: "suzanne-cassidy",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Joshua",
    lastName: "Castillo",
    title: "Services Assistant D Operational Services",
    slug: "joshua-castillo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Grace Jacqueline",
    lastName: "Cataldo",
    title:
      " Operations Coordinator, The McGraw Center and Executive Format Programs Education",
    slug: "grace-jacqueline-cataldo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Chris",
    lastName: "Cataldo",
    title: "Director of Finance Weitzman School of Design",
    slug: "chris-cataldo",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Rhonda",
    lastName: "Cates",
    title: "Executive Director B, Human Resources Benefits Finance",
    slug: "rhonda-cates",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Flora F.",
    lastName: "Cauley",
    title: "STAFF ASST RADIOL",
    slug: "flora-f-cauley",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lucille D",
    lastName: "Caulfield",
    title: "BUSINESS ADMINISTRATOR Dept. of Med Geriatrics Div",
    slug: "lucille-d-caulfield",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lauren",
    lastName: "Cawley",
    title: "Grants Manager Annenberg School for Communication",
    slug: "lauren-cawley",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jillian R",
    lastName: "Cawley",
    title: "Associate Director, Research Services Research Services",
    slug: "jillian-r-cawley",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "MELANIE E",
    lastName: "CEDRONE",
    title: "LIBRARIAN BIOMEDICAL LIB",
    slug: "melanie-e-cedrone",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Casey",
    lastName: "Celious",
    title: "Graduate Grants Program Administrator Graduate Student Center",
    slug: "casey-celious",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Alexis M.",
    lastName: "Celotto",
    title:
      " Associate Director, Business Development & Special Events Other Event Management",
    slug: "alexis-m-celotto",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jillian",
    lastName: "Cener",
    title:
      " Director B, Student Services, Academic Programs Environmental, Social and Governance (ESG) Analytics Lab",
    slug: "jillian-cener",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Ariel T",
    lastName: "Censor",
    title:
      " Associate Director, CHIP Communications Center for High Impact Philanthropy",
    slug: "ariel-t-censor",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Kristina",
    lastName: "Centore",
    title: "Administrative Coordinator ICA Exhibitions",
    slug: "kristina-centore",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "John J.",
    lastName: "Cepis",
    title: "Building Manager, Wharton Operations Wharton Operations",
    slug: "john-j-cepis",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Susan",
    lastName: "Cerrone",
    title:
      " Associate Director Administration & Finance Cohen Hall Business Administration Services",
    slug: "susan-cerrone",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Chloe E.",
    lastName: "Cerwinka",
    title: "Landscape Planner Office of the University Architect",
    slug: "chloe-e-cerwinka",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Desirae J.",
    lastName: "Cesar",
    title: "Administrative Director Management and Technology Program",
    slug: "desirae-j-cesar",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kathy",
    lastName: "Chan",
    title:
      " Associate Director D, Business and Finance Wharton Finance and Administration",
    slug: "kathy-chan",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Christopher",
    lastName: "Chan",
    title: "Coordinator, Program English",
    slug: "christopher-chan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Linda J",
    lastName: "Chandler",
    title: "Administrative Assistant Quantitative Methods",
    slug: "linda-j-chandler",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Prithi",
    lastName: "Chandra",
    title:
      " Senior Associate Director, Corporate and Foundation Relations Penn Museum",
    slug: "prithi-chandra",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Janhavi S.",
    lastName: "Chandra",
    title: "Director, Annual Giving School of Arts & Sciences",
    slug: "janhavi-s-chandra",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Betty",
    lastName: "Chandy",
    title: "Director, Catalyst Education",
    slug: "betty-chandy",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kenneth P",
    lastName: "Chaney",
    title:
      " PARCC Associate Director of AI and Technology Penn Advanced Research Computing Center (PARCC)",
    slug: "kenneth-p-chaney",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Wilson",
    lastName: "Chang",
    title: "IT Architect/Consulting Lead ISC - Technology Services",
    slug: "wilson-chang",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Patrick S",
    lastName: "Chang",
    title: "Application Developer Senior SDM Computing",
    slug: "patrick-s-chang",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Lisa",
    lastName: "Chang",
    title:
      " Job Posting Title Associate Director, Academic Advisor, Global Co-curricular Programs MBA Program Office",
    slug: "lisa-chang",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kimberly A",
    lastName: "Charlier",
    title: "SR. CONTRACT and BOARD ADMIN GENERAL COUNSEL",
    slug: "kimberly-a-charlier",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "LEO",
    lastName: "CHARNEY",
    title: "ASSOCIATE PROVOST Provost's Office",
    slug: "leo-charney",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Paul B",
    lastName: "Chase",
    title: "Journals Coordinator Penn Press",
    slug: "paul-b-chase",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Alissa F.",
    lastName: "Chase-Murray",
    title: "IT Project Manager ISC-ACIO-Shared Services",
    slug: "alissa-f-chase-murray",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Margie",
    lastName: "Chavez",
    title: "Special Assistant to the Provost Provost's Office",
    slug: "margie-chavez",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Becca",
    lastName: "Chazin",
    title:
      " Director, Human Resources, Development and Alumni Relations DAR Human Resources",
    slug: "becca-chazin",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Daniel J.M.",
    lastName: "Cheely",
    title: "Executive Directors, PRRUCS Fox Leadership International",
    slug: "daniel-j-m-cheely",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Greer",
    lastName: "Cheeseman",
    title:
      " Director, Information Services and Technology AVP DEV - Development and Alumni Relations",
    slug: "greer-cheeseman",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Sonja L",
    lastName: "Chen",
    title:
      " Senior Associate Director of Individual Giving Weitzman School of Design Development Office",
    slug: "sonja-l-chen",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Shizhi",
    lastName: "Chen",
    title: "Sr. DATABASE ADMINISTRATOR ISC/SEO",
    slug: "shizhi-chen",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Nathinee",
    lastName: "Chen",
    title:
      " Associate Director Wharton Communications Program Wharton Communications Unit",
    slug: "nathinee-chen",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Danning",
    lastName: "Chen",
    title:
      " Assistant Director, FLI International Master of Public Administration",
    slug: "danning-chen",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Alice C",
    lastName: "Chen",
    title: "ADMINISTRATIVE ASSISTANT Chemistry",
    slug: "alice-c-chen",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Timothy P",
    lastName: "Cheney",
    title: "CHOPR NURSING",
    slug: "timothy-p-cheney",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Katie",
    lastName: "Cheng",
    title: "Director of Academic Operations MBA Program Office",
    slug: "katie-cheng",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Rebecca A",
    lastName: "Cheyney",
    title: "GRANTS MANAGER Pathobiology",
    slug: "rebecca-a-cheyney",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Allison Leib",
    lastName: "Chiacchiere",
    title:
      " Director of Volunteer Strategy and Special Projects Strategy Engagement & Campaign",
    slug: "allison-leib-chiacchiere",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jennifer",
    lastName: "Chiappardi",
    title: "Assistant Photographer University Museum",
    slug: "jennifer-chiappardi",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ernesto",
    lastName: "Chieffo",
    title: "Application Architect ISC-HCM Operations",
    slug: "ernesto-chieffo",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Tula",
    lastName: "Childs",
    title: "Coordinator, Program MASTER IN LAW",
    slug: "tula-childs",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Kristine",
    lastName: "Chin",
    title: "HR Manager, Training & Operations Graduate School of Education",
    slug: "kristine-chin",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Richard C",
    lastName: "Chinery",
    title:
      " Director of Development Communications and Stewardship SEAS, Development and Alumni Relations",
    slug: "richard-c-chinery",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Lori B",
    lastName: "Chinitz",
    title: "Language Specialist English Language Program",
    slug: "lori-b-chinitz",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jill",
    lastName: "Chivers",
    title: "Information Technology Support Specialist B SASC-Computing",
    slug: "jill-chivers",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kultaran S.",
    lastName: "Chohan",
    title:
      " Executive Director of Licensing for the Perelman School of Medicine Penn Center for Innovation",
    slug: "kultaran-s-chohan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Elizabeth JinKyo",
    lastName: "Chong",
    title: "Senior Coordinator, Visitor Services ICA Outreach",
    slug: "elizabeth-jinkyo-chong",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Dan",
    lastName: "Christopher",
    title: "Network Specialist Senior ISC-Tech Services-Network Operations",
    slug: "dan-christopher",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Aleruchi",
    lastName: "Chuku",
    title: "Resident COH Extramural Activities",
    slug: "aleruchi-chuku",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Kevin Douglas",
    lastName: "Chun",
    title: "ADM ASST THARTS NBC COLLEGE OF ARTS & SCIENCES",
    slug: "kevin-douglas-chun",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Traci J",
    lastName: "Chupik",
    title: "Director C, Business and Finance Leonard Davis Institute",
    slug: "traci-j-chupik",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Amanda",
    lastName: "Cialino",
    title:
      " Associate Director of Development, Penn Medicine Penn Medicine Development",
    slug: "amanda-cialino",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Carol A",
    lastName: "Cianci",
    title:
      " IT Support Specialist Sr Wharton Computing and Instructional Technology (WCIT)",
    slug: "carol-a-cianci",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Matthew Thomas",
    lastName: "Cianfrani",
    title: "Senior Video Producer DAR Communications",
    slug: "matthew-thomas-cianfrani",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Alissa",
    lastName: "Cielecki",
    title:
      " Application Developer C Wharton Computing and Instructional Technology (WCIT)",
    slug: "alissa-cielecki",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Emily Gohn",
    lastName: "Cieri",
    title: "Senior Director of Strategic Initiatives Wharton External Affairs",
    slug: "emily-gohn-cieri",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Richard A.",
    lastName: "Cintron Torres",
    title:
      " Information Technology Support Specialist Senior Wharton Executive Education",
    slug: "richard-a-cintron-torres",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Tina M",
    lastName: "Ciocco",
    title:
      " ADMIN COORDINATOR Barbara and Edward Netter Center for Community Partnerships",
    slug: "tina-m-ciocco",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Daniel J",
    lastName: "Cipolla",
    title:
      " Application Developer Senior ISC-Applications & Information Services",
    slug: "daniel-j-cipolla",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Filomena",
    lastName: "Circelli",
    title:
      " Associate Director of Enrollment Management Office of Academic Affairs",
    slug: "filomena-circelli",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Michael",
    lastName: "Citro",
    title: "Vice President and Chief of Staff Special President",
    slug: "michael-citro",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Courtney E",
    lastName: "Clarahan",
    title:
      " Associate Director D, Student Services, Executive Education Wharton Executive Education (Custom)",
    slug: "courtney-e-clarahan",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "PAULA F",
    lastName: "CLARK",
    title:
      " Executive Director, Principal Gifts Development and Alumni Relations",
    slug: "paula-f-clark",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "KRISTINA L",
    lastName: "CLARK",
    title: "DIRECTOR OPERATIONS & SPECIAL PROGRAMS ALUMNI RELS",
    slug: "kristina-l-clark",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jessica C",
    lastName: "Clark",
    title: "Archivist B Center for the Study of the History of Nursing",
    slug: "jessica-c-clark",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Joshua",
    lastName: "Clark",
    title:
      " Information Technology Support Specialist B Weitzman School of Design Computing Center",
    slug: "joshua-clark",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Alison Noji",
    lastName: "Clauser",
    title: "Associate Director Penn Global",
    slug: "alison-noji-clauser",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "James",
    lastName: "Clavin",
    title:
      " Sr. Associate Director, Post Award Financial Administration Office of Research Services",
    slug: "james-clavin",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Kelly A.",
    lastName: "Cleary",
    title:
      " Director C, Student Services, Academic Programs Program in International Studies and Business",
    slug: "kelly-a-cleary",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Stacy M",
    lastName: "Clements",
    title: "Director Professional and Organizational Development",
    slug: "stacy-m-clements",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Irene Patricia",
    lastName: "Clements",
    title: "GRAD COORD MATERIALS SCI & ENGRS",
    slug: "irene-patricia-clements",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Melissa",
    lastName: "Clerval",
    title: "Associate Director of Student Life Student Affairs",
    slug: "melissa-clerval",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Charles J.",
    lastName: "Cobine",
    title: "Digital Outreach Librarian Humanities Collections",
    slug: "charles-j-cobine",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Linda",
    lastName: "Cocco",
    title: "Manager, ULAR Husbandry ULAR",
    slug: "linda-cocco",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ben",
    lastName: "Cochran",
    title: "Research Manager, CGIR Center for Guaranteed Income",
    slug: "ben-cochran",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Nathan A",
    lastName: "Cockrum",
    title: "IT Operations Manager, Business Services BSD Support",
    slug: "nathan-a-cockrum",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Dani",
    lastName: "Coellner",
    title: "Contract Administrator Senior Research Services",
    slug: "dani-coellner",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lauren J.",
    lastName: "Coffey",
    title: "Director of Stewardship SAS Office of Advancement",
    slug: "lauren-j-coffey",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Amy S",
    lastName: "Coffey",
    title:
      " Director, Penn Athletics Wharton Leadership Academy DRIA Academic Support",
    slug: "amy-s-coffey",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Wendy B",
    lastName: "Coffman",
    title:
      " Administrative Assistant B McNeil Center for Early American Studies (MCEAS)",
    slug: "wendy-b-coffman",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Mary Kate",
    lastName: "Coghlan",
    title: "Director of Communications Health and Wellness Administration",
    slug: "mary-kate-coghlan",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Sara R",
    lastName: "Cohen",
    title: "Associate Director of Admissions Admissions",
    slug: "sara-r-cohen",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Jenn L.",
    lastName: "Cohen",
    title:
      " Director of Engagement, Center for Ethics and the Rule of Law Annenberg Public Policy Center",
    slug: "jenn-l-cohen",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jennifer N",
    lastName: "Cohen",
    title: "Chester County NICU Medical Director PE-Pediatrics",
    slug: "jennifer-n-cohen",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Gwen E",
    lastName: "Cohen",
    title: "Associate Director for Admissions & Communications The College",
    slug: "gwen-e-cohen",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "David J",
    lastName: "Cohen",
    title:
      " Information Technology Project Leader Senior ISC-Tech Services-Network Operations",
    slug: "david-j-cohen",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Bill",
    lastName: "Cohen",
    title:
      " Associate Director Operations, Planning and Data Analysis Kleinman Center on Energy Policy",
    slug: "bill-cohen",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Matthew W",
    lastName: "Cohen",
    title: "Director E, Information Technology Wharton Research Data Services",
    slug: "matthew-w-cohen",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Regina",
    lastName: "Cohen",
    title:
      " Associate Director, Marketing & Communications Professional and Liberal Education (PLE)",
    slug: "regina-cohen",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Ashley",
    lastName: "Colabella",
    title:
      " Senior Associate Director, Annual Giving and Alumni Relations Design in DAR",
    slug: "ashley-colabella",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Blake A.",
    lastName: "Cole",
    title: "STAFF WRITER SAS External Affairs",
    slug: "blake-a-cole",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Elisabeth",
    lastName: "Colella",
    title:
      " Business Administrator, Annenberg Public Policy Center Annenberg Public Policy Center",
    slug: "elisabeth-colella",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "April L",
    lastName: "Coleman",
    title: "Administrative Assistant Education",
    slug: "april-l-coleman",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kyana S",
    lastName: "Coles",
    title: "Information Technology Project Leader ISC-CLIENT SERVICES-HIREIT",
    slug: "kyana-s-coles",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Thomasina T",
    lastName: "Coley",
    title: "Upwardbound Administative Assistant Student Engagement",
    slug: "thomasina-t-coley",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Aishah F",
    lastName: "Coley",
    title: "Client Care Manager Admissions",
    slug: "aishah-f-coley",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Cornelia",
    lastName: "Colijn",
    title: "Executive Director Kleinman Center on Energy Policy",
    slug: "cornelia-colijn",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Catherine J",
    lastName: "Coll",
    title: "Systems Administrator Senior ISC-Tech Services-Network Operations",
    slug: "catherine-j-coll",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Theresa Anne",
    lastName: "Colligon",
    title: "Operations Director CVPF CI-TCSL/CVPF",
    slug: "theresa-anne-colligon",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Bob",
    lastName: "Colligon",
    title: "IT SR PROJECT LEADER Penn Medicine Academic Computing Services",
    slug: "bob-colligon",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Stacey",
    lastName: "Collins",
    title: "Workday Functional Lead Recruiting ISC-HCM Operations",
    slug: "stacey-collins",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "JACK",
    lastName: "COLLINS",
    title: "Business Administrator B Management",
    slug: "jack-collins",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "David",
    lastName: "Collins",
    title: "Director, Procurement Contracting Procurement Services",
    slug: "david-collins",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "LAURA KAY",
    lastName: "COLLINS",
    title:
      " College Mental Health Professional Counseling and Psychological Services",
    slug: "laura-kay-collins",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Amy",
    lastName: "Collins",
    title:
      " Associate Vice Provost, Finance and Administration Provost's Office",
    slug: "amy-collins",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Clayton D",
    lastName: "Colmon",
    title: "Associate Director of Instructional Design Online Learning",
    slug: "clayton-d-colmon",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Patricia",
    lastName: "Colonna",
    title: "Legal Coordinator General Counsel",
    slug: "patricia-colonna",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Dan",
    lastName: "Comly",
    title: "Director of Stewardship, Penn Medicine Penn Medicine Development",
    slug: "dan-comly",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Julia",
    lastName: "Commander",
    title: "Senior Project Conservator Egyptian Section",
    slug: "julia-commander",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Michael W",
    lastName: "Condiff",
    title:
      " Application Developer C DM-Translational Medicine and Human Genetics",
    slug: "michael-w-condiff",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Carli M.",
    lastName: "Condon",
    title: "Senior Talent Acquisition Specialist Provost's Office",
    slug: "carli-m-condon",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "SHANNON A",
    lastName: "CONNELLY",
    title: "Executive Director of Alumni Relations External Affairs",
    slug: "shannon-a-connelly",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Patricia A",
    lastName: "Connolly",
    title: "Process Development Associate DM-Gene Therapy Program",
    slug: "patricia-a-connolly",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "DR Dareus O",
    lastName: "Conover",
    title: "Systems Architect SASC-Computing",
    slug: "dr-dareus-o-conover",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kimberley Ann",
    lastName: "Conroy",
    title: "Lauder Global Career Advisor Lauder Institute",
    slug: "kimberley-ann-conroy",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Susan J",
    lastName: "Contess",
    title: "Associate Director, Investments Office of Investments",
    slug: "susan-j-contess",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Angelina",
    lastName: "Conti",
    title:
      " Director of Digital Learning Arts & Sciences, Liberal and Professional Studies",
    slug: "angelina-conti",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Theresa",
    lastName: "Convery",
    title: "Affiliation: Staff",
    slug: "theresa-convery",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Gina N",
    lastName: "Conway",
    title: "Graduate Coordinator Department of Economics",
    slug: "gina-n-conway",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Mark J",
    lastName: "Conway",
    title: "URBAN PARK SUPERVISOR Operations and Maintenance Administration",
    slug: "mark-j-conway",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Christopher R",
    lastName: "Cook",
    title: "IT SR PROJECT LEADER - VIDEO PRODUCER ISC/PENN VIDEO NETWORK",
    slug: "christopher-r-cook",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Nick",
    lastName: "Cookson",
    title: "Operations Support Center Supervisor FRES",
    slug: "nick-cookson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "ELIZABETH",
    lastName: "COONEY-ZINGMAN",
    title:
      " Director D, Research DM-Palliative and Advanced Illness Research Center",
    slug: "elizabeth-cooney-zingman",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Nicole",
    lastName: "Cooper",
    title: "Managing Director of Research Annenberg School for Communication",
    slug: "nicole-cooper",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Elizabeth G.",
    lastName: "Cooper",
    title: "Help Desk Manager Annenberg School for Communication",
    slug: "elizabeth-g-cooper",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jeffrey",
    lastName: "Cooper",
    title: "Vice President General University Special",
    slug: "jeffrey-cooper",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lori G.",
    lastName: "Coopersmith",
    title:
      " Director, Penn Hotels; Division of Business Services Business Services",
    slug: "lori-g-coopersmith",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Andy S.",
    lastName: "Coopersmith",
    title: "Director C, Research Penn Policy on Regulation",
    slug: "andy-s-coopersmith",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Karen",
    lastName: "Cope-Scarfo",
    title:
      " Associate Dir., UPHS & Centers & Institutes, Penn Medicine Penn Medicine Development",
    slug: "karen-cope-scarfo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Camden",
    lastName: "Copeland",
    title:
      " Associate Director B, Curatorial, University Museum University Museum",
    slug: "camden-copeland",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jawanza J",
    lastName: "Corbin",
    title:
      " Coordinator, Program Environmental, Social and Governance (ESG) Analytics Lab",
    slug: "jawanza-j-corbin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Andre",
    lastName: "Corbitt",
    title: "Information Technology Support Specialist DRIA Technical Support",
    slug: "andre-corbitt",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kelly A",
    lastName: "Corcoran",
    title:
      " Director, AMP/EMP & OE Leadership Sector Wharton Executive Education (Open Enrollment)",
    slug: "kelly-a-corcoran",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Albert",
    lastName: "Cordero",
    title:
      " Information Technology Support Specialist A ISC-CLIENT SERVICES-HIREIT",
    slug: "albert-cordero",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Lauren",
    lastName: "Cordova",
    title:
      " Associate Director, Health Education Prevention, Education, and Promotion",
    slug: "lauren-cordova",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Sherrie F",
    lastName: "Cornish",
    title: "BSD Business Services",
    slug: "sherrie-f-cornish",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Samantha",
    lastName: "Corson",
    title: "Director of Operations Law Alumni and Development",
    slug: "samantha-corson",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Dani",
    lastName: "Cosme",
    title: "Scientific Director Annenberg School for Communication",
    slug: "dani-cosme",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Christina M.",
    lastName: "Costanzo",
    title: "Assistant Dean of Admissions & Academic Affairs SCH NURS",
    slug: "christina-m-costanzo",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Cara M",
    lastName: "Costello",
    title: "Director, Alumni Services MBA Career Management",
    slug: "cara-m-costello",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Maureen A",
    lastName: "Cotterill",
    title: "PROGRAM MANAGER Urban Teaching Apprenticeship Program",
    slug: "maureen-a-cotterill",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Theo , JR",
    lastName: "Cottle",
    title:
      " IT Manager for Classroom Support Wharton Computing and Instructional Technology (WCIT)",
    slug: "theo-jr-cottle",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "John H.",
    lastName: "Cotton",
    title:
      " Associate Director of Operations & Staff Development English Language Program",
    slug: "john-h-cotton",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Rebecca",
    lastName: "Cottrell",
    title: "Information Technology Project Leader Senior SASC-Computing",
    slug: "rebecca-cottrell",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Eric",
    lastName: "Cottrell",
    title: "House Director CHAS House Deans",
    slug: "eric-cottrell",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Caroline E",
    lastName: "Couture",
    title:
      " Information Technology Support Specialist Senior ISC-Client Services-Technology Support Services",
    slug: "caroline-e-couture",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "TINA SKOV",
    lastName: "COWAN",
    title: "Senior Managing Director International Development",
    slug: "tina-skov-cowan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kim A",
    lastName: "Cowperthwaite",
    title: "WEMBA Class Manager, Global Cohort Wharton Executive MBA",
    slug: "kim-a-cowperthwaite",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Lisa M",
    lastName: "Coyle",
    title: "Contract Administrator CC-Cancer Center",
    slug: "lisa-m-coyle",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Courtney Hain",
    lastName: "Coyle",
    title:
      " Senior Director of Alumni Relations, Penn Medicine Penn Medicine Development",
    slug: "courtney-hain-coyle",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Barbara Nelles",
    lastName: "Craft",
    title: "Director of Admissions Wharton Executive MBA",
    slug: "barbara-nelles-craft",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "KIMBERLY A",
    lastName: "CRAIG",
    title: "Research Compliance Officer Vice Provost for Research",
    slug: "kimberly-a-craig",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Joanna",
    lastName: "Craig",
    title: "Associate Dean for Career Strategy Office of Career Strategy",
    slug: "joanna-craig",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jennifer A",
    lastName: "Craig",
    title: "Associate Director D, Academic Affairs Wharton Executive MBA",
    slug: "jennifer-a-craig",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Leslie A",
    lastName: "Crane",
    title:
      " Associate Director, Corporate and Foundation Relations Arboretum Development",
    slug: "leslie-a-crane",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Shante T",
    lastName: "Crawford",
    title: "Affiliation: Staff",
    slug: "shante-t-crawford",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Renee",
    lastName: "Crews",
    title: "IRB Administrator Institutional Review Board",
    slug: "renee-crews",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Lauren C.",
    lastName: "Criscione",
    title:
      " Director of Marketing, Wharton Online Wharton Executive Education (Operations)",
    slug: "lauren-c-criscione",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "STEVE",
    lastName: "CRISPI",
    title: "Associate Director Institutional Research & Analysis",
    slug: "steve-crispi",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Adrienne",
    lastName: "Cromartie",
    title: "Residential Services Manager Residential Operations",
    slug: "adrienne-cromartie",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jason E",
    lastName: "Cronk",
    title:
      " Director, Recruitment and Financial Aid Graduate School of Education",
    slug: "jason-e-cronk",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Ray",
    lastName: "Cross",
    title:
      " Macintosh Systems Administrator - CETS Computing and Educational Technology Services",
    slug: "ray-cross",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "NINA",
    lastName: "CROSS",
    title: "Research Manager, CGIR Center for Guaranteed Income",
    slug: "nina-cross",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Danielle L",
    lastName: "Crowl",
    title:
      " Associate Director Center for Community Standards and Accountability",
    slug: "danielle-l-crowl",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "James",
    lastName: "Crumley",
    title: "Compliance Manager Environmental Health and Safety",
    slug: "james-crumley",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "CHERIE",
    lastName: "CRUSE",
    title: "Business Administrator B PATHOBIOLOGY NBC",
    slug: "cherie-cruse",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Joe",
    lastName: "Cruz",
    title:
      " Senior IT Director, Technology Services, Solutions Development & Platforms Wharton Computing and Instructional Technology",
    slug: "joe-cruz",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Elena",
    lastName: "Cruz",
    title:
      " Coordinator B SM-DN-Inclusion, Diversity, Equity, & Learner Exp Prog in Me",
    slug: "elena-cruz",
    dei: true,
    category: "Student Life",
  },
  {
    firstName: "Cara",
    lastName: "Cuiule",
    title: "Application Developer C Wharton Research Data Services",
    slug: "cara-cuiule",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "William G",
    lastName: "Cullina",
    title:
      " F. Otto Haas Executive Director, Morris Arboretum & Public Gardens Arboretum Administration",
    slug: "william-g-cullina",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kristin",
    lastName: "Cummings",
    title:
      " Associate Director of Marketing & Communications RHS Central Services",
    slug: "kristin-cummings",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Dishea",
    lastName: "Cummings",
    title: "FINANCIAL ADMIN COORD ULAR",
    slug: "dishea-cummings",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Elizabeth R.",
    lastName: "Cummings",
    title: "Business Administrator Finance",
    slug: "elizabeth-r-cummings",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Lauren",
    lastName: "Cunius",
    title: "Business Administrator B University Press",
    slug: "lauren-cunius",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Thomas M.",
    lastName: "Cunningham",
    title:
      " Associate Director, SP2 Sponsored Research SP2 Finance and Administration",
    slug: "thomas-m-cunningham",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Amy",
    lastName: "Curci",
    title: "Associate Director, Academic Affairs PDM Academic Affairs",
    slug: "amy-curci",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "JANICE",
    lastName: "CURINGTON",
    title: "ASST DEAN MULTICULTURAL AFFRS CAS",
    slug: "janice-curington",
    dei: true,
    category: "Academic",
  },
  {
    firstName: "Leann",
    lastName: "Curley",
    title:
      " Associate Director B, Student Services, Undergraduate Programs Undergraduate Division",
    slug: "leann-curley",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Kelly S",
    lastName: "Curran",
    title: "Associate General Counsel SM-DN-Research",
    slug: "kelly-s-curran",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "JUDITH N",
    lastName: "CURRANO",
    title: "LIBRARIAN HEAD CHEM LIB",
    slug: "judith-n-currano",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Tracy Renee",
    lastName: "Curtis",
    title: "Information Technology Support Specialist A-01 SASC-Computing",
    slug: "tracy-renee-curtis",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Lauren",
    lastName: "Curtis",
    title: "Coordinator B Restorative Clinic",
    slug: "lauren-curtis",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sean Edwin",
    lastName: "Cusack",
    title:
      " Chief Operating Officer, Development & Alumni Relations Services Development & Alumni Relations",
    slug: "sean-edwin-cusack",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Don L",
    lastName: "Custer",
    title:
      " Information Technology Director Wharton Computing and Instructional Technology (WCIT)",
    slug: "don-l-custer",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Rosemarie F",
    lastName: "Cutrufello",
    title: "Senior Business Administrator SP2 Finance and Administration",
    slug: "rosemarie-f-cutrufello",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "ULA M",
    lastName: "CUTTEN",
    title: "Instructional Technology Specialist ELP",
    slug: "ula-m-cutten",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "KEITH",
    lastName: "CZABAN",
    title: "Systems Administrator Senior SASC-Computing",
    slug: "keith-czaban",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Julia Alexa",
    lastName: "Czech",
    title: "Stewardship Program Manager Law Alumni and Development",
    slug: "julia-alexa-czech",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Karina Lane",
    lastName: "Czoka",
    title:
      " Assistant Director of Research Administration & Compliance Business Operations",
    slug: "karina-lane-czoka",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Matthew Christian",
    lastName: "D'Adamo",
    title:
      " Information Technology Support Specialist Senior Information Technology Services",
    slug: "matthew-christian-d-adamo",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jo",
    lastName: "D'Avella",
    title:
      " Student Services Coordinator Student Registration & Financial Services",
    slug: "jo-d-avella",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Matthew",
    lastName: "D'Ippolito",
    title: "Communications Specialist Education",
    slug: "matthew-d-ippolito",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Stefano G.",
    lastName: "Daddi",
    title: "Business Manager B Wharton Research Data Services",
    slug: "stefano-g-daddi",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Brian W.",
    lastName: "Daddino",
    title: "Grants Manager B CV-Cardiovascular Institute",
    slug: "brian-w-daddino",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Sherie",
    lastName: "Daffe'",
    title: "Affiliation: Staff",
    slug: "sherie-daffe",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Rui",
    lastName: "Dai",
    title:
      " Senior Research Support Director WRDS Wharton Research Data Services",
    slug: "rui-dai",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Victoria K.",
    lastName: "Dailey",
    title: "Support Specialist, Client Care Admissions",
    slug: "victoria-k-dailey",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Jaime",
    lastName: "Dale",
    title:
      " Assistant Director of Institutional Events - Penn Medicine Penn Medicine Development",
    slug: "jaime-dale",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tony R",
    lastName: "Dallas",
    title: "NETWORK SPEC ISC INFO. SYST. AND COMP., VICE PROVOST",
    slug: "tony-r-dallas",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Renée",
    lastName: "Damato",
    title:
      " Director of Open Enrollment Programs Wharton Executive Education (Open Enrollment)",
    slug: "ren-e-damato",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Lee I",
    lastName: "Dandelias",
    title: "Administrative Assistant B Wharton Behavioral Lab",
    slug: "lee-i-dandelias",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Trang",
    lastName: "Dang",
    title: "Administrative Coordinator Annenberg School for Communication",
    slug: "trang-dang",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Micah",
    lastName: "Danges",
    title: "IT Support Specialist B Fine Arts",
    slug: "micah-danges",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kate",
    lastName: "Daniel",
    title: "Coordinator, City and Regional Planning City Planning",
    slug: "kate-daniel",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jeffrey",
    lastName: "Danielewicz",
    title:
      " Associate Director of Web and Application Services Financial Systems",
    slug: "jeffrey-danielewicz",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Ivri",
    lastName: "Daniels",
    title: "Associate Director, Events Marketing and Communications",
    slug: "ivri-daniels",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Brian I",
    lastName: "Daniels",
    title: "Director of Research and Programs University Museum",
    slug: "brian-i-daniels",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Andy",
    lastName: "Danilchick",
    title: "Director Project for Mental Health and Optimal Development",
    slug: "andy-danilchick",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "DR MICHAEL D",
    lastName: "DANTI",
    title:
      " Iraq Heritage Stabilization Program Project Manager Middle Eastern Languages and Cultures",
    slug: "dr-michael-d-danti",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "David D",
    lastName: "Darrow",
    title:
      " IT Technical Director for Informational Systems Information Technology Services",
    slug: "david-d-darrow",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Darien",
    lastName: "Davenport",
    title: "Manager, Husbandry ULAR",
    slug: "darien-davenport",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Katerina",
    lastName: "Davidson",
    title: "Admissions Counselor Admissions",
    slug: "katerina-davidson",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Mark",
    lastName: "Davidson",
    title: "Information Technology Manager SASC-Computing",
    slug: "mark-davidson",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Tara",
    lastName: "Davies",
    title:
      " Executive Director of Capital Planning, Parent and Family Engagement Parent's Program",
    slug: "tara-davies",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Wayne C",
    lastName: "Davis",
    title:
      " Information Technology Director Wharton Computing and Instructional Technology (WCIT)",
    slug: "wayne-c-davis",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "TANYA M.",
    lastName: "DAVIS",
    title:
      " Business Operations Coordinator Wharton School of Business External Affairs",
    slug: "tanya-m-davis",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Sylvia",
    lastName: "Davis",
    title:
      " Administrative Coordinator, Development & Alumni Relations GSE in DAR",
    slug: "sylvia-davis",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Sara E",
    lastName: "Davis",
    title:
      " Marketing & Communications Writer Professional and Liberal Education (PLE)",
    slug: "sara-e-davis",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Liza Druck",
    lastName: "Davis",
    title:
      " Associate Vice President, Finance and Treasury Management FINANCE AND TREASURY",
    slug: "liza-druck-davis",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "LaTonya",
    lastName: "Davis",
    title: "Manager C, Student Services The College",
    slug: "latonya-davis",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Kenneth",
    lastName: "Davis",
    title:
      " Information Technology Project Leader Senior Wharton Computing and Instructional Technology (WCIT)",
    slug: "kenneth-davis",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jason E",
    lastName: "Davis",
    title: "Admissions Coordinator Admissions and Financial Aid",
    slug: "jason-e-davis",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Heather",
    lastName: "Davis",
    title: "Director, News Publications University Communications",
    slug: "heather-davis",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Halima",
    lastName: "Davis",
    title: "Contract Coordinator Project Management",
    slug: "halima-davis",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Emily Claire",
    lastName: "Davis",
    title: "Senior Communications and Engagement Specialist ESG Initiative",
    slug: "emily-claire-davis",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Carol L",
    lastName: "Davis",
    title: "Department Administrator DEPARTMENT OF AFRICANA STUDIES",
    slug: "carol-l-davis",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "William R.",
    lastName: "Davis",
    title: "Network Specialist Senior ISC-Tech Services-Network Operations",
    slug: "william-r-davis",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Yvonne N.",
    lastName: "Davis",
    title: "Manager, ULAR Husbandry ULAR",
    slug: "yvonne-n-davis",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Blake",
    lastName: "Davis",
    title:
      " Information Technology Support Specialist B Wharton Computing and Instructional Technology (WCIT)",
    slug: "blake-davis",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Eric James",
    lastName: "Dawson",
    title: "Gifts and Records Administrator Alumni Records",
    slug: "eric-james-dawson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jennifer O",
    lastName: "Daywalt",
    title: "Business Administrator C Nursing Finance",
    slug: "jennifer-o-daywalt",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Tessa",
    lastName: "de Alarcon",
    title: "Museum Conservator University Museum",
    slug: "tessa-de-alarcon",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "VALERIE",
    lastName: "DE CRUZ",
    title: "DIR GREENFIELD INTERCULTURAL CTR GREENFIELD INTERCULTURAL CENTER",
    slug: "valerie-de-cruz",
    dei: true,
    category: "Student Life",
  },
  {
    firstName: "Frank David",
    lastName: "De Francis",
    title: "Business Administrator (C) Wharton School Undergraduate Division",
    slug: "frank-david-de-francis",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kristen",
    lastName: "de Groot",
    title: "Senior Writer, Penn Medicine Penn Medicine Development",
    slug: "kristen-de-groot",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Joy L.",
    lastName: "De Jesus",
    title:
      " Executive Associate AD, Finance and Administration/CFO DRIA Administrative Affairs",
    slug: "joy-l-de-jesus",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Ralph J.",
    lastName: "De Lucia",
    title: "ASSOC DIRECTOR Office of Equal Opportunity Programs",
    slug: "ralph-j-de-lucia",
    dei: true,
    category: "Human Resources",
  },
  {
    firstName: "Andrew E.",
    lastName: "Deal",
    title:
      " Associate Director of Development, Penn Medicine Penn Medicine Development",
    slug: "andrew-e-deal",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alex",
    lastName: "Dean",
    title: "Grants Manager A SDM Deans Office",
    slug: "alex-dean",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "J. Michael",
    lastName: "DeAngelis",
    title:
      " Senior Associate Director, Communication & Technology Career Services",
    slug: "j-michael-deangelis",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "William M",
    lastName: "Decristofano",
    title:
      " Director, Open Enrollment Programs Wharton Executive Education (Open Enrollment)",
    slug: "william-m-decristofano",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Margaret M Smith",
    lastName: "Deeney",
    title: "Department Administrator Music/SAS",
    slug: "margaret-m-smith-deeney",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Nadina R",
    lastName: "Deigh",
    title:
      " Chief of Staff & Associate Vice President Development and Alumni Relations",
    slug: "nadina-r-deigh",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Diane",
    lastName: "Deissroth",
    title: "Business Administrator Real Estate",
    slug: "diane-deissroth",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Dawn Maglicco",
    lastName: "Deitch",
    title: "Exec Director Office of Government and Community Affairs",
    slug: "dawn-maglicco-deitch",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Amy",
    lastName: "Deitz",
    title: "Director of Procurement Office of Finance and Administration",
    slug: "amy-deitz",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Vincent Michael",
    lastName: "Dejesus",
    title:
      " Information Technology Support Specialist Senior Information Technology Services",
    slug: "vincent-michael-dejesus",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jessica",
    lastName: "Dejesus",
    title:
      " Director of the Research Support Center Research Support Center (RSC)",
    slug: "jessica-dejesus",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Ashley S.",
    lastName: "Del Bianco",
    title: "Director, ORS Pre Award Services Research Services",
    slug: "ashley-s-del-bianco",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Ana S",
    lastName: "del Puerto",
    title: "Associate Director Admissions",
    slug: "ana-s-del-puerto",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Bianca Marisa",
    lastName: "Del Rio",
    title:
      " Director of University Assisted Community Schools Netter Center for Community Partnerships",
    slug: "bianca-marisa-del-rio",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Anna T",
    lastName: "Delaney",
    title: "Chief Administrative Officer Academic Programs",
    slug: "anna-t-delaney",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Zussette Waleska",
    lastName: "Delgado",
    title: "Associate Director D, Business and Finance Provost's Office",
    slug: "zussette-waleska-delgado",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Tony",
    lastName: "Delgozzo",
    title: "Building Administrator Senior Education",
    slug: "tony-delgozzo",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Samuel T",
    lastName: "Dellert",
    title: "Vitale Digital Media Lab Consultant Information Commons",
    slug: "samuel-t-dellert",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "BETH",
    lastName: "DELLIPRISCOLI",
    title:
      " Associate Director B, Academic Affairs, Academic Administration Finance",
    slug: "beth-dellipriscoli",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "John T",
    lastName: "DeLong",
    title: "Associate Director of Financial Aid Nursing Academic Affairs",
    slug: "john-t-delong",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Barbara J",
    lastName: "Delregino",
    title: "ADMIN ASST ORTHODONTICS",
    slug: "barbara-j-delregino",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Claire",
    lastName: "DeLuca",
    title:
      " Associate Director of JD Admissions Law Admissions and Financial Aid",
    slug: "claire-deluca",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Joseph J",
    lastName: "Demarest",
    title: "Network Architect ISC-Tech Services-Network Operations",
    slug: "joseph-j-demarest",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Anne DeVivo",
    lastName: "DeMesa",
    title: "Director, Gift Planning Gift Planning",
    slug: "anne-devivo-demesa",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lisa Mcclatchy",
    lastName: "Deming",
    title:
      " Assoc.Vice President, Development & Alumni Relations Strategic Planning & Services Development and Alumni Relations",
    slug: "lisa-mcclatchy-deming",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Betsy",
    lastName: "Deming",
    title: "Information Technology Manager IT CLIENT SERVICES",
    slug: "betsy-deming",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Brian",
    lastName: "Dempsey",
    title:
      " Information Technology Manager Senior ISC-Client Services-Classroom Technology Services",
    slug: "brian-dempsey",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Allison",
    lastName: "Denenberg",
    title: "Associate Director, Global Clubs External Affairs",
    slug: "allison-denenberg",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jim",
    lastName: "Denk",
    title:
      " Director, Information Security Wharton Computing and Instructional Technology (WCIT)",
    slug: "jim-denk",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Christopher",
    lastName: "Denman",
    title: "Associate Director of Research Services University of Pennsylvania",
    slug: "christopher-denman",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "LEAH L",
    lastName: "DENNIS",
    title: "ADMIN ASST CHAIRMAN'S OFFICE BIOL",
    slug: "leah-l-dennis",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Erika Fitzpatrick",
    lastName: "Dennis",
    title: "CIR Team PE-Pediatrics",
    slug: "erika-fitzpatrick-dennis",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tracey L",
    lastName: "Dennis-Booker",
    title: "Administrative Coordinator The College",
    slug: "tracey-l-dennis-booker",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Maria A.",
    lastName: "Deoliveira",
    title:
      " Program and Office Coordinator Student Registration & Financial Services",
    slug: "maria-a-deoliveira",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Krystyna",
    lastName: "Dereszowska",
    title: "Associate General Counsel General Counsel",
    slug: "krystyna-dereszowska",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Tammy M",
    lastName: "Desalis",
    title: "MANAGER-CASHIER'S OFFICE TREASURER'S OFFICE",
    slug: "tammy-m-desalis",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "MARY",
    lastName: "DESALVO CORRELL",
    title: "Director, Administrative Affairs SM-DN-Business Office",
    slug: "mary-desalvo-correll",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Emily",
    lastName: "Despinoy",
    title: "Investment Associate Office of Investments",
    slug: "emily-despinoy",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Joseph Edward",
    lastName: "DeStefano",
    title: "Building Administrator Operations & Planning",
    slug: "joseph-edward-destefano",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lisa",
    lastName: "DeStephanis",
    title: "Executive Assistant, Office of the Dean SDM Deans Office",
    slug: "lisa-destephanis",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "David",
    lastName: "Dettmann",
    title:
      " Associate Director B, Academic Affairs, Academic Center Center for East Asian Studies",
    slug: "david-dettmann",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kathryn F.",
    lastName: "Detzel",
    title:
      " Senior Director of Development, Penn Medicine Penn Medicine Development",
    slug: "kathryn-f-detzel",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Daineen Michelle",
    lastName: "Devan",
    title: "Accountant SDM Fiscal Operations",
    slug: "daineen-michelle-devan",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Leon",
    lastName: "Devine",
    title:
      " Supervisor, Campus Maintenance Operations and Maintenance Administration",
    slug: "leon-devine",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Doreen Renee",
    lastName: "DeVose-Parlin",
    title: "Senior Information Technology Support Specialist Financial Systems",
    slug: "doreen-renee-devose-parlin",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Gangotri",
    lastName: "Dey",
    title: "Licensing Officer Penn Center for Innovation",
    slug: "gangotri-dey",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Juliana",
    lastName: "Di Giustini",
    title: "Deputy Director Center for the Advanced Study of India",
    slug: "juliana-di-giustini",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Frank P",
    lastName: "Di Maria",
    title:
      " Application Developer Senior ISC-Applications & Information Services",
    slug: "frank-p-di-maria",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Cristina Amber",
    lastName: "Diaczuk",
    title: "Associate Director, Student and Young Alumni External Affairs",
    slug: "cristina-amber-diaczuk",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Benjamin Charles",
    lastName: "Dibling",
    title:
      " Managing Director, Penn Center for Innovation Penn Center for Innovation",
    slug: "benjamin-charles-dibling",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Molly Rheanne",
    lastName: "Dichairo",
    title:
      " Administrative Assistant, Teaching, Learning, and Leadership Division Education",
    slug: "molly-rheanne-dichairo",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Anne",
    lastName: "Dickinson",
    title:
      " Senior Associate Director, College of Arts and Sciences Career Services",
    slug: "anne-dickinson",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Tera L",
    lastName: "Dicks-Peace",
    title:
      " Sr. System Administrator and Service Desk Manager Nursing Office of Information Services",
    slug: "tera-l-dicks-peace",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Evan",
    lastName: "Dienstman",
    title:
      " Information Technology Project Leader Senior Wharton Research Data Services",
    slug: "evan-dienstman",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Maura",
    lastName: "DiFilippo",
    title: "Staff Writer Wharton External Affairs",
    slug: "maura-difilippo",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Ms. Diane M.",
    lastName: "DiGiacomo",
    title:
      " Associate Director, Prospect Research DAR Advancement Research & Analysis",
    slug: "ms-diane-m-digiacomo",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Nathanael S.",
    lastName: "DiGiorgio",
    title:
      " Information Technology Project Leader Senior SM-DN External Info Services",
    slug: "nathanael-s-digiorgio",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "James",
    lastName: "Diienno",
    title: "Manager of Post Awards Grant Operations CB-Cancer Biology",
    slug: "james-diienno",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Rosalee B.",
    lastName: "DiIulio",
    title:
      " Administrative Coordinator International Master of Public Administration",
    slug: "rosalee-b-diiulio",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Daniel",
    lastName: "DiIulio",
    title:
      " Assistant Director for IMPA Recruitment International Master of Public Administration",
    slug: "daniel-diiulio",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Catherine",
    lastName: "Dillingham",
    title: "Assistant Director DAR",
    slug: "catherine-dillingham",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Robert N",
    lastName: "Dimeo",
    title: "Admissions Officer Vet Dean's Office",
    slug: "robert-n-dimeo",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Gabrielle",
    lastName: "Dimick",
    title:
      " UACS CHOP Healthier Together Project Associate, Netter Center for Community Partnerships Netter Center for Community Partnerships",
    slug: "gabrielle-dimick",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Clare",
    lastName: "Din",
    title: "Systems Administrator Senior SASC-Computing",
    slug: "clare-din",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Lucia",
    lastName: "Dinapoli",
    title: "Assistant Dean, Office of the Dean Nursing Dean's Office",
    slug: "lucia-dinapoli",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Lisa A.",
    lastName: "DiNezza",
    title: "Sr. IT Audit Specialist Audit and Privacy",
    slug: "lisa-a-dinezza",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jing",
    lastName: "Ding",
    title:
      " Information Technology Project Leader Senior ISC-Tech Services-Network Operations",
    slug: "jing-ding",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Mark F",
    lastName: "Dingfield",
    title: "Vice President for Finance and Treasurer Division of Finance",
    slug: "mark-f-dingfield",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Debra Newman",
    lastName: "Dionis",
    title:
      " Executive Director of Principal Gift Strategy Development & Alumni Relations",
    slug: "debra-newman-dionis",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Denise T.",
    lastName: "DiPersio",
    title: "ASSOC DIRECTOR, EXTERNAL RELATIONS Linguistic Data Consortium",
    slug: "denise-t-dipersio",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Lisa Taylor",
    lastName: "Dirr",
    title: "Senior Designer Law Communications",
    slug: "lisa-taylor-dirr",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Mary",
    lastName: "Disangro",
    title:
      " Coordinator, Project for Mental Health and Optimal Development Education",
    slug: "mary-disangro",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jill",
    lastName: "DiSanto",
    title: "PR Director University Museum",
    slug: "jill-disanto",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Dennis A.",
    lastName: "Disbrow",
    title: "CLASS GIVING DIRECTOR, OLD GUARD PROGRAM PENN FUND",
    slug: "dennis-a-disbrow",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rob",
    lastName: "Ditto",
    title:
      " IT Technical Director Wharton Computing and Instructional Technology (WCIT)",
    slug: "rob-ditto",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Brian",
    lastName: "Divver",
    title: "Web Content Developer WXPN",
    slug: "brian-divver",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Keith",
    lastName: "Dixon",
    title: "Director, Operations and Cash Management Research Services",
    slug: "keith-dixon",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jennifer M.",
    lastName: "Dixon",
    title: "CLAIMS/RISK COORDINATOR General Counsel",
    slug: "jennifer-m-dixon",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Thao Rosemary Tran Phi",
    lastName: "Do",
    title: "Resident COH Extramural Activities",
    slug: "thao-rosemary-tran-phi-do",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lee",
    lastName: "Dobkin",
    title: "DEPUTY GEN COUNSEL & CHIEF COUNSEL UNIV OFFICE OF LEGAL AFFAIRS",
    slug: "lee-dobkin",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Theresa N",
    lastName: "Dodds",
    title: "IT SUPPORT SPECIALIST",
    slug: "theresa-n-dodds",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Charles",
    lastName: "Dodson",
    title:
      " Records Data Integrity Analyst and Program Coordinator AVP FOR EQUITY AND TITLE IX",
    slug: "charles-dodson",
    dei: true,
    category: "Miscellaneous",
  },
  {
    firstName: "Antoine JaQuard-Angle",
    lastName: "Dodson",
    title: "Administrative Coordinator Office of University Life",
    slug: "antoine-jaquard-angle-dodson",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "PAUL",
    lastName: "DOHERTY",
    title: "Information Technology Project Leader Senior SASC-Computing",
    slug: "paul-doherty",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Brian",
    lastName: "Doherty",
    title: "Information Technology Director Senior SASC-Computing",
    slug: "brian-doherty",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Natalie B",
    lastName: "Dohrmann",
    title:
      " Coeditor, Jewish Quarterly Review Center for Advanced Judaic Studies",
    slug: "natalie-b-dohrmann",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Stephen M",
    lastName: "Dolan",
    title:
      " Director of M & W Track and Field and Cross Country Men's Track Team",
    slug: "stephen-m-dolan",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Samuel R",
    lastName: "Dolan",
    title: "AEGD Resident COH Extramural Activities",
    slug: "samuel-r-dolan",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Lynn S",
    lastName: "Dolby",
    title: "Director, Penn Art Collection University Curator",
    slug: "lynn-s-dolby",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Michelle L",
    lastName: "Dolce",
    title: "Finance PSOM",
    slug: "michelle-l-dolce",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "DEBORAH A",
    lastName: "DOLE",
    title: "Grants Manager B Business Operations",
    slug: "deborah-a-dole",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Abigail",
    lastName: "Dolinger",
    title: "Managing Director Population Studies Center",
    slug: "abigail-dolinger",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Tara Lynn",
    lastName: "Doll",
    title:
      " Associate Director of Development Communications, Stewardship, and Digital Strategies Development and Alumni Relations",
    slug: "tara-lynn-doll",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Steve",
    lastName: "Dolnack",
    title:
      " Senior Information Technology Support Specialist Wharton Computing and Instructional Technology (WCIT)",
    slug: "steve-dolnack",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Courtney R",
    lastName: "Dombroski",
    title:
      " Director, Communications and External Relations; Business Services Business Services",
    slug: "courtney-r-dombroski",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "AGNES S",
    lastName: "DONALDSON",
    title: "AREA MANAGER FACIL OPER AND MAINT ADMIN",
    slug: "agnes-s-donaldson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "David",
    lastName: "Donigan",
    title: "Academic Coordinator Real Estate",
    slug: "david-donigan",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Wendy S",
    lastName: "Donnan",
    title:
      " Senior Application Developer Wharton Computing and Instructional Technology (WCIT)",
    slug: "wendy-s-donnan",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Samuel N",
    lastName: "Donnelly",
    title:
      " Application Developer Senior ISC-Applications & Information Services",
    slug: "samuel-n-donnelly",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kathryn A.",
    lastName: "Donohue",
    title:
      " Director, Legal Affairs and Associate General Counsel Penn Center for Innovation",
    slug: "kathryn-a-donohue",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "DR CHRISTOPHER",
    lastName: "DONOVAN",
    title:
      " Assistant Dean of Administration, Student Services, Advising The College",
    slug: "dr-christopher-donovan",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Christopher M",
    lastName: "Dorman",
    title: "Director, Visitor Experience Arboretum Visitor Program",
    slug: "christopher-m-dorman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Micah L",
    lastName: "Dornfeld",
    title: "Coordinator B Historic Preservation",
    slug: "micah-l-dornfeld",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "MICHELLE",
    lastName: "DORON",
    title: "Primary Care Unit Coordinator Restorative Clinic",
    slug: "michelle-doron",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kate",
    lastName: "Dorsch",
    title:
      " Associate Director C, Student Services, Undergraduate Programs Philosophy, Politics and Economics",
    slug: "kate-dorsch",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Tia N",
    lastName: "Dorsey",
    title: "Financial Administrative Coordinator Leadership Program",
    slug: "tia-n-dorsey",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "ELIZABETH E",
    lastName: "DOUGHERTY-FEENEY",
    title: "Executive Assistant A Office of Investments",
    slug: "elizabeth-e-dougherty-feeney",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "André",
    lastName: "Douglas",
    title: "Manager, Wharton-AltFinance Institute AltFinance Institute",
    slug: "andr-douglas",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Donkey Edward",
    lastName: "Dover",
    title: "Director, Alumni Engagement & Annual Giving SP2 in DAR",
    slug: "donkey-edward-dover",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Melissa Catherine",
    lastName: "Downey",
    title: "Senior Business Administrator Penn Global",
    slug: "melissa-catherine-downey",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Anjanette",
    lastName: "Downey",
    title: "Business Administrator B Wharton Finance and Administration",
    slug: "anjanette-downey",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Rachel",
    lastName: "Dozier",
    title: "Assistant Director, OSS Education",
    slug: "rachel-dozier",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Robert",
    lastName: "Drake",
    title: "HOST / PRODUCER WXPN",
    slug: "robert-drake",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Diana",
    lastName: "Drake",
    title: "Managing Editor, KWHS Wharton Global Youth Programs",
    slug: "diana-drake",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Stanley J",
    lastName: "Drake",
    title:
      " Associate Director, Audit and Contract Compliance RHS Central Services",
    slug: "stanley-j-drake",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Kay A",
    lastName: "Draper",
    title: "Assistant Director of Research SAS Office of Advancement",
    slug: "kay-a-draper",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Dennis J",
    lastName: "Drass",
    title:
      " Information Technology Project Leader Senior ISC-Client Services-Classroom Technology Services",
    slug: "dennis-j-drass",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Freda (Qingyi) Song",
    lastName: "Drechsler",
    title: "Research Support Director Wharton Research Data Services",
    slug: "freda-qingyi-song-drechsler",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Lisa G",
    lastName: "Dresner",
    title:
      " Associate Director of Strategic Planning Wharton Finance and Administration",
    slug: "lisa-g-dresner",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Nandor C.",
    lastName: "Dressnandt",
    title: "ELECTRONICS ENGR PHYSICS",
    slug: "nandor-c-dressnandt",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Virginia Mary",
    lastName: "Drier",
    title: "Accountant Procurement Services",
    slug: "virginia-mary-drier",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Christine",
    lastName: "Droesser",
    title: "Associate Dean and CIO Information Technology Services",
    slug: "christine-droesser",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Benoit",
    lastName: "Dube",
    title: "Associate Provost & Chief Wellness Officer Office of the Provost",
    slug: "benoit-dube",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Joanne M",
    lastName: "Dubil",
    title: "COORD",
    slug: "joanne-m-dubil",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Timothy",
    lastName: "Duff",
    title: "Systems Administrator Annenberg Public Policy Center",
    slug: "timothy-duff",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "J. M.",
    lastName: "DUFFIN",
    title: "OFFICE MANAGER & SENIOR ARCHIVIST UNIV. ARCHIVES & RECORDS CTR",
    slug: "j-m-duffin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "TAMARA CUNNINGHAM",
    lastName: "DUFFY",
    title:
      " Information Technology Project Leader Senior ISC-Applications & Information Services",
    slug: "tamara-cunningham-duffy",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Debra Lynn",
    lastName: "Duffy",
    title: "Business Administrator B SDM Fiscal Operations",
    slug: "debra-lynn-duffy",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "CAROLYN A",
    lastName: "DUFFY",
    title:
      " Senior Associate Director of Data Analytics & Reporting Penn Med Development",
    slug: "carolyn-a-duffy",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Lee",
    lastName: "Dukes",
    title:
      " Sr. Director of Academic Affairs - CIS Computer and Information Science",
    slug: "lee-dukes",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jessie A",
    lastName: "Dummer",
    title: "Librarian B IT CLIENT SERVICES",
    slug: "jessie-a-dummer",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Marlayne N.",
    lastName: "Dundovich",
    title: "DIRECTOR PENNCARD CTR CAMPUS CARD SVCS",
    slug: "marlayne-n-dundovich",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "JoAnne",
    lastName: "Dunham",
    title: "Staff Assistant C Penn Center for Innovation",
    slug: "joanne-dunham",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Melissa S.",
    lastName: "Dunlap",
    title: "Assistant Director, Assignments & Operations Residential Services",
    slug: "melissa-s-dunlap",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Karen Y",
    lastName: "Dunlop",
    title: "Staff Recruiter Senior Recruitment",
    slug: "karen-y-dunlop",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Thomas",
    lastName: "Dunn",
    title: "Grants Manager A Business Operations",
    slug: "thomas-dunn",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Kara",
    lastName: "Dunn",
    title:
      " Director, Communication & Competitions Wharton Global Youth Programs",
    slug: "kara-dunn",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "GIULIA ROMA",
    lastName: "DUNN",
    title: "Academic Coordinator Philosophy",
    slug: "giulia-roma-dunn",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "RICHARD E",
    lastName: "DUNN",
    title: "Director of Course Management and Student Records The College",
    slug: "richard-e-dunn",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Tamra N",
    lastName: "Dunston",
    title: "Assistant Director of Gift Management Gift Management",
    slug: "tamra-n-dunston",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Sam",
    lastName: "Duplessis",
    title:
      " Associate Vice President, University Development DAR (Development and Alumni Relations)",
    slug: "sam-duplessis",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alexis",
    lastName: "Duprey Roman",
    title: "Systems Administrator C Information Technology Services",
    slug: "alexis-duprey-roman",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Pat",
    lastName: "Durante",
    title:
      " Information Technology Project Leader Senior ISC-Applications & Information Services",
    slug: "pat-durante",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Selamawit K",
    lastName: "Duressa",
    title: "Parking Attendant Parking",
    slug: "selamawit-k-duressa",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Taylor",
    lastName: "Durham",
    title: "Associate Director of Communications Penn Wharton Entrepreneurship",
    slug: "taylor-durham",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Heather C",
    lastName: "Durham",
    title: "Financial Administrative Coordinator Office of Student Affairs",
    slug: "heather-c-durham",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Sudeshna",
    lastName: "Dutta",
    title:
      " Information Technology Project Leader Information Technology Services",
    slug: "sudeshna-dutta",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jenean",
    lastName: "Duvall",
    title: "Solution Center Service Representative HCM Operations",
    slug: "jenean-duvall",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Janet M",
    lastName: "Dwyer",
    title: "DIRECTOR, ADMIN & FINANCE President's Office",
    slug: "janet-m-dwyer",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Tina",
    lastName: "Dy",
    title: "Academic Affairs Coordinator Nursing Academic Affairs",
    slug: "tina-dy",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Denise I",
    lastName: "Dyson",
    title: "GLP Documentation Specilist DM-Gene Therapy Program",
    slug: "denise-i-dyson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Joseph",
    lastName: "Dzwill",
    title:
      " Information Technology Support Specialist Wharton Computing and Instructional Technology (WCIT)",
    slug: "joseph-dzwill",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Douglass W.",
    lastName: "Eagar",
    title: "IT SUPPORT SPECIALIST",
    slug: "douglass-w-eagar",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "TAMIKA",
    lastName: "EASLEY",
    title: "Program Manager, Literacy Studies Graduate School of Education",
    slug: "tamika-easley",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jen",
    lastName: "East",
    title: "Executive Assistant A Periodontics",
    slug: "jen-east",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tinamarie M,",
    lastName: "Eastment",
    title: "Quality Manager PATHOBIOLOGY NBC",
    slug: "tinamarie-m-eastment",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Julian",
    lastName: "Ebbesen",
    title:
      " Information Technology Support Specialist B Vet Information Technology",
    slug: "julian-ebbesen",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Joan-Marie",
    lastName: "Eberwine",
    title: "Administrative Assistant B PH-Pharmacology",
    slug: "joan-marie-eberwine",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Peter D",
    lastName: "Eckel",
    title: "Director, Global Higher Education Management Education",
    slug: "peter-d-eckel",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Michelle L",
    lastName: "Eckert",
    title: "Digital Technology Coordinator SDM Computing",
    slug: "michelle-l-eckert",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Megan H.",
    lastName: "Edelman",
    title: "Associate Director Platt Student Performing Arts House",
    slug: "megan-h-edelman",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Kylie",
    lastName: "Edmond",
    title:
      " Associate University Registrar for Catalog, Curriculum, and Degree Audit Student Registration & Financial Services",
    slug: "kylie-edmond",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "JENNIFER B",
    lastName: "EDMONDSON",
    title: "HEALTH PHYSICS COORDINATOR EHRS",
    slug: "jennifer-b-edmondson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Harbour",
    lastName: "Edney",
    title: "Lighting Supervisor Penn Live Arts",
    slug: "harbour-edney",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Pamela",
    lastName: "Edwards",
    title:
      " Executive Director, Penn Student Engagement Programs Student Engagement",
    slug: "pamela-edwards",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jeffrey S",
    lastName: "Edwards",
    title:
      " Information Technology Manager Senior ISC-Tech Services-Network Operations",
    slug: "jeffrey-s-edwards",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "James W",
    lastName: "Effrece",
    title: "Athletic Trainer Health Services",
    slug: "james-w-effrece",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kristen",
    lastName: "Egan",
    title:
      " Assistant Development Officer, Penn Medicine Penn Medicine Development",
    slug: "kristen-egan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Whitney",
    lastName: "Eggers",
    title: "Senior Director of Advancement SAS Office of Advancement",
    slug: "whitney-eggers",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sarah",
    lastName: "Egoville",
    title:
      " Associate Director D, Student Services, Graduate Programs Public Interest Center",
    slug: "sarah-egoville",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Heather M",
    lastName: "Ehly",
    title: "Rodent Health Monitoring Tech. ULAR-Diagnostic Services",
    slug: "heather-m-ehly",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Stephanie",
    lastName: "Eib",
    title: "Associate Director Programs & Special Events",
    slug: "stephanie-eib",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jamie A",
    lastName: "Eidlin",
    title:
      " Director of Admissions Weitzman School of Design Admissions and Financial Aid",
    slug: "jamie-a-eidlin",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Lory",
    lastName: "Eighme",
    title: "MGR ADM FIN BIOL",
    slug: "lory-eighme",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Rachel",
    lastName: "Eisen Mayover",
    title:
      " Director of Administration for Curricular Affairs & Executive Director of Externships Law Registrar",
    slug: "rachel-eisen-mayover",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "David",
    lastName: "Eisenhower",
    title: "Director Annenberg School for Communication",
    slug: "david-eisenhower",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Alexander Mitchell Westbrook",
    lastName: "Eisenthal",
    title: "Administrative Coordinator Penn Abroad",
    slug: "alexander-mitchell-westbrook-eisenthal",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Chinedu O",
    lastName: "Eke",
    title:
      " Director of Graduate Student Programming Office of Academic Services",
    slug: "chinedu-o-eke",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Rhina",
    lastName: "El-Amin",
    title:
      " Director of Undergraduate Education & Innovation Stavros Niarchos Foundation Paideia Program",
    slug: "rhina-el-amin",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Bob",
    lastName: "Elder",
    title:
      " Information Technology Technical Director Wharton Computing and Instructional Technology (WCIT)",
    slug: "bob-elder",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Liat",
    lastName: "Eldor",
    title: "Associate Director C Research Advisory Group",
    slug: "liat-eldor",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Lena S",
    lastName: "Elguindi",
    title: "Senior Director of Programs Wharton Next Administrative",
    slug: "lena-s-elguindi",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Michael",
    lastName: "Elias",
    title:
      " Director D, Student Services, Undergraduate Programs Undergraduate Division",
    slug: "michael-elias",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Diane M",
    lastName: "Eliasson",
    title:
      " Sr. Associate Director, Career Advisor and Program Manager MBA Career Management",
    slug: "diane-m-eliasson",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Colleen",
    lastName: "Elisii",
    title: "Director, Marketing & Stewardship Gift Planning",
    slug: "colleen-elisii",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Daniel",
    lastName: "Ellerbroek",
    title: "Museum Gift Shop Manager Museum Director's Office",
    slug: "daniel-ellerbroek",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Amy Celeste",
    lastName: "Elliott",
    title: "Production Manager Penn Live Arts Administration",
    slug: "amy-celeste-elliott",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sean F.",
    lastName: "Ellis",
    title: "Director C, Research, Administration Behavior Change for Good",
    slug: "sean-f-ellis",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "James",
    lastName: "Ellis",
    title: "Operations Manager, Penn Transit Transportation",
    slug: "james-ellis",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kait",
    lastName: "Ellis",
    title:
      " Executive Assistant, Dean's Office Weitzman School of Design Dean's Office",
    slug: "kait-ellis",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Amanda",
    lastName: "Ellis",
    title:
      " Assistant Director of Alumni Relations Graduate School of Education",
    slug: "amanda-ellis",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Hakiem",
    lastName: "Ellison",
    title:
      " Health Careers Coordinator, Netter Center for Community Partnerships Netter Center for Community Partnerships",
    slug: "hakiem-ellison",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kristopher",
    lastName: "Elmer",
    title: "Community Engagement Manager - OAI Online Education Programs",
    slug: "kristopher-elmer",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Brian",
    lastName: "Elmore",
    title: "Associate Director, Strategic Finance FINANCE AND TREASURY",
    slug: "brian-elmore",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Helene",
    lastName: "Emanoff",
    title: "Sr. IP and Compliance Paralegal Penn Center for Innovation (PCI)",
    slug: "helene-emanoff",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Heather N",
    lastName: "Emery",
    title: "IRB Senior Administrative Manager Institutional Review Board",
    slug: "heather-n-emery",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tim",
    lastName: "Emgushov",
    title: "Sr. IT Support Specialist GSE Information Technology",
    slug: "tim-emgushov",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Mark",
    lastName: "Engleka",
    title:
      " Associate Director, Technology Licensing Senior Penn Center for Innovation",
    slug: "mark-engleka",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Tim",
    lastName: "Engler",
    title:
      " Trust Administrator - Gift & Investment Services Treasurer's Office",
    slug: "tim-engler",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "SYLVIA V. J.",
    lastName: "ENGLISH",
    title: "ADMISSIONS OFFICER ENROLLMENT MGMT",
    slug: "sylvia-v-j-english",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Tamara R",
    lastName: "English",
    title: "BUS ADM LEGAL STUDIES AND BUSINESS ETHICS",
    slug: "tamara-r-english",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Rhys E.",
    lastName: "Enoch",
    title: "Vaccine Field Canvasser FM-Family Medicine",
    slug: "rhys-e-enoch",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jessica M",
    lastName: "Enright",
    title: "ADMIN COORDINATOR Alumni Relations - Classes and Reunions",
    slug: "jessica-m-enright",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Alexa Rose",
    lastName: "Epstein",
    title:
      " Development Assistant for Class Giving and Reunion Programs Penn Fund",
    slug: "alexa-rose-epstein",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Ali Guray",
    lastName: "Erus",
    title: "Director D, Information Technology RA-Radiology",
    slug: "ali-guray-erus",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Anthony S",
    lastName: "Erz",
    title: "Head Athletic Trainer Trainer Support",
    slug: "anthony-s-erz",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Oscar",
    lastName: "Escudero-Ortega",
    title: "STEM Learning Specialist Learning Resources",
    slug: "oscar-escudero-ortega",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Stacey O.",
    lastName: "Espenlaub",
    title: "Manager, Museum Collections University Museum",
    slug: "stacey-o-espenlaub",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Linda P.",
    lastName: "Esposito",
    title: "Legal Secretary General Counsel",
    slug: "linda-p-esposito",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "DR ANTHONY P",
    lastName: "ESPOSITO",
    title: "UNDERGRADUATE CHAIR SPANISH AND PORTUGUESE",
    slug: "dr-anthony-p-esposito",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Yulanda N",
    lastName: "Essoka",
    title:
      " Associate Director, Cora Ingrum Center for Community and Outreach Cora Ingrum Center for Community and Outreach",
    slug: "yulanda-n-essoka",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Edgardo",
    lastName: "Esteves",
    title: "Supervisor C University Museum",
    slug: "edgardo-esteves",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sarah",
    lastName: "Estey",
    title:
      " Program and Case Manager, Office of Religious and Ethnic Interests Office of Religious and Ethnic Interests",
    slug: "sarah-estey",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jeremy",
    lastName: "Estrada",
    title:
      " Assistant Director Projects and Contract Mgmt. Residential Operations",
    slug: "jeremy-estrada",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Justin R",
    lastName: "Ettore",
    title:
      " Information Technology Architect Senior ISC-Tech Services-Network Operations",
    slug: "justin-r-ettore",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jonathan",
    lastName: "Evans",
    title: "Executive Director of Development, Penn Vet Vet in DAR",
    slug: "jonathan-evans",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Evelyn Gora",
    lastName: "Evans",
    title: "Administrative Coordinator Wharton Finance Pillar",
    slug: "evelyn-gora-evans",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Amy E",
    lastName: "Everwine Bru",
    title: "Coordinator Office of Government and Community Affairs",
    slug: "amy-e-everwine-bru",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lee W.",
    lastName: "Every",
    title:
      " Executive Director, Finance and Planning, ISC ISC-ACIO-Shared Services",
    slug: "lee-w-every",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Megan Therese",
    lastName: "Ewing",
    title: "Assistant Director, Classes and Reunions Alumni Relations",
    slug: "megan-therese-ewing",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Adiza M.",
    lastName: "Ezell",
    title: "Director, Admissions & Recruitment SP2 Enrollment Services",
    slug: "adiza-m-ezell",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Yvonne E",
    lastName: "Fabella",
    title: "Undergraduate Coordinator History Department",
    slug: "yvonne-e-fabella",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Marie-Luise",
    lastName: "Faber",
    title: "Associate Biosafety Officer Environmental Health and Safety",
    slug: "marie-luise-faber",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Amanda",
    lastName: "Faber",
    title: "Business Manager C Wharton Finance and Administration",
    slug: "amanda-faber",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Carmen J.",
    lastName: "Facciolo",
    title: "Senior Advisor Criminology",
    slug: "carmen-j-facciolo",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Mina P.",
    lastName: "Fader",
    title:
      " Managing Director, Baker Retailing Center Baker Retailing Initiative",
    slug: "mina-p-fader",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "John",
    lastName: "Fafalios",
    title: "IT Manager, Technology Services SDM Computing",
    slug: "john-fafalios",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Corrinne",
    lastName: "Fahl",
    title: "Coordinator Office of Inclusion and Diversity",
    slug: "corrinne-fahl",
    dei: true,
    category: "Student Life",
  },
  {
    firstName: "Steven A",
    lastName: "Fala",
    title: "Grants Coordinator B Statistics and Data Science",
    slug: "steven-a-fala",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Nick",
    lastName: "Falcone",
    title:
      " IT EXECUTIVE DIRECTOR INFORMATION SECURITY ISC-Information Security",
    slug: "nick-falcone",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Sherry",
    lastName: "Falese",
    title:
      " Visitors Experience Supervisor; Morris Arboretum Arboretum Visitor Program",
    slug: "sherry-falese",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Leah",
    lastName: "Falk",
    title:
      " Director of Education and Engagement, Penn Live Arts Penn Live Arts",
    slug: "leah-falk",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Erin A.",
    lastName: "Fallon",
    title: "DIRECTOR MULTI-MEDIA SVCS",
    slug: "erin-a-fallon",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Donald M",
    lastName: "Falso",
    title: "Elop Fres",
    slug: "donald-m-falso",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Angela",
    lastName: "Faranda",
    title: "Academic Coordinator History",
    slug: "angela-faranda",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Frank",
    lastName: "Fardone",
    title: "ADMIN ASST Accounting",
    slug: "frank-fardone",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Olivia",
    lastName: "Farkas",
    title: "HR Manager of Recruitment of Retention Education",
    slug: "olivia-farkas",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Robert A",
    lastName: "Farley",
    title: "Deputy Director, FactCheck.org Annenberg Public Policy Center",
    slug: "robert-a-farley",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Julee Peyton",
    lastName: "Farley",
    title:
      " Director B, Academic Affairs, Academic Administration Science Outreach Initiative",
    slug: "julee-peyton-farley",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kaelyn",
    lastName: "Farrell",
    title: "DEVELOPMENT DATA & MEMBERSHIP ASSISTANT Arboretum Development",
    slug: "kaelyn-farrell",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Audrey Lynn",
    lastName: "Farrell",
    title: "Customer Service Assistant Senior Biotech Poster and 3D Printing",
    slug: "audrey-lynn-farrell",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jason",
    lastName: "Farris",
    title: "Grants Manager A CB-Cancer Biology",
    slug: "jason-farris",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Patrick H",
    lastName: "Faulk",
    title:
      " Senior Associate Director, University Life Space & Events Space and Events Management",
    slug: "patrick-h-faulk",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Kelly",
    lastName: "Faust",
    title: "Director, Online Business Development Executive Education Online",
    slug: "kelly-faust",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Elizabeth Lai",
    lastName: "Featherman",
    title: "Associate General Counsel Penn Center for Innovation",
    slug: "elizabeth-lai-featherman",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Nicole Collum",
    lastName: "Federico",
    title: "Associate Director of Academic Affairs MASTER IN LAW",
    slug: "nicole-collum-federico",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Edward M.",
    lastName: "Federico",
    title: "Director, Public and Media Relations Marketing and Communications",
    slug: "edward-m-federico",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jennifer B.",
    lastName: "Feldman",
    title: "ASSOC GENERAL COUNSEL General Counsel",
    slug: "jennifer-b-feldman",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Alla F",
    lastName: "Feldman",
    title: "WEMBA Academic Operations Coordinator Wharton Executive MBA",
    slug: "alla-f-feldman",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "NOELLE",
    lastName: "FELIPE",
    title:
      " IT SUPPORT SPECIALIST ISC-Client Services-Technology Support Services",
    slug: "noelle-felipe",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Samantha",
    lastName: "Fellman",
    title: "Coordinator C ME-Division of Health Policy",
    slug: "samantha-fellman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ke",
    lastName: "Feng",
    title: "SENIOR ARCHITECT/PLANNER Office of the University Architect",
    slug: "ke-feng",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jessica",
    lastName: "Feng",
    title:
      " Enrollment Systems and Admissions Coordinator Professional and Liberal Education (PLE)",
    slug: "jessica-feng",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Stephanie",
    lastName: "Fenhagen",
    title: "Assistant Director Parent Outreach and Development",
    slug: "stephanie-fenhagen",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Michael",
    lastName: "Fennell",
    title: "Registrar and Director, Student Records Education",
    slug: "michael-fennell",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Natasha",
    lastName: "Ferguson",
    title: "BSD Business Services",
    slug: "natasha-ferguson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kim",
    lastName: "Ferko",
    title:
      " Student Records Coordinator Professional and Liberal Education (PLE)",
    slug: "kim-ferko",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Noemi",
    lastName: "Fernandez",
    title: "Program Manager Teaching, Learning, and Leadership",
    slug: "noemi-fernandez",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Luisa Leonore",
    lastName: "Fernandez",
    title: "Marketing Coordinator A Leonard Davis Institute",
    slug: "luisa-leonore-fernandez",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Stephanie",
    lastName: "Fernandez-Guckes",
    title: "AEGD Resident COH Extramural Activities",
    slug: "stephanie-fernandez-guckes",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Michael A",
    lastName: "Ferraiolo",
    title: "AREA MANAGER FACIL OPER AND MAINT ADM",
    slug: "michael-a-ferraiolo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Christopher",
    lastName: "Ferraiolo",
    title: "MANAGER Wharton Operations",
    slug: "christopher-ferraiolo",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Rorujorona",
    lastName: "Ferrell",
    title:
      " Associate Director B, Curatorial, University Museum Museum Director's Office",
    slug: "rorujorona-ferrell",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Elizabeth H",
    lastName: "Ferruzzi",
    title: "Program Manager Wharton Executive Education (Open Enrollment)",
    slug: "elizabeth-h-ferruzzi",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "DR HOCINE",
    lastName: "FETNI",
    title: "ASST DEAN CAS",
    slug: "dr-hocine-fetni",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Dane",
    lastName: "Fetterman",
    title:
      " Information Technology Architect Senior ISC-Tech Services-Network Operations",
    slug: "dane-fetterman",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Sarah Catherine",
    lastName: "Fetzer",
    title:
      " Assistant Development Officer, Penn Medicine Penn Medicine Development",
    slug: "sarah-catherine-fetzer",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Katherine",
    lastName: "Fibiger",
    title: "Associate General Counsel Penn Center for Innovation",
    slug: "katherine-fibiger",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Michele",
    lastName: "Fiducioso",
    title: "Director of Claims and Risk Mitigation Risk Management",
    slug: "michele-fiducioso",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mrs. Danielle Crumb",
    lastName: "Fike",
    title: "Financial Services Advisor Office of Student Affairs",
    slug: "mrs-danielle-crumb-fike",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "GEOFFREY J",
    lastName: "FILINUK",
    title: "BUSINESS MANAGER",
    slug: "geoffrey-j-filinuk",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Sarah",
    lastName: "Filippi-Field",
    title:
      " Assistant Development Officer, Penn Medicine Penn Medicine Development",
    slug: "sarah-filippi-field",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Robertino A",
    lastName: "Fillari",
    title: "Systems Administrator Senior SM-DN External Info Services",
    slug: "robertino-a-fillari",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Julia Lauryn",
    lastName: "Fillman",
    title: "Class Giving Director, The Penn Fund Penn Fund",
    slug: "julia-lauryn-fillman",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Benjamin A",
    lastName: "Filreis",
    title:
      " Coordinator, Data Analytics and International Initiatives Professional and Liberal Education (PLE)",
    slug: "benjamin-a-filreis",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Meredith",
    lastName: "Finch",
    title: "Assistant & Artistic Coordinator Penn Live Arts Administration",
    slug: "meredith-finch",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Steven J",
    lastName: "Fincham",
    title:
      " Information Technology Support Specialist Senior SM-DN External Info Services",
    slug: "steven-j-fincham",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jean M",
    lastName: "Findlay",
    title:
      " Executive Director, School & Center Annual Giving Support School and Center - Annual Giving",
    slug: "jean-m-findlay",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "SHANNON MANGANO",
    lastName: "FIORAVANTI",
    title: "ASST GRADUATION AUDITOR CAS",
    slug: "shannon-mangano-fioravanti",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Bruno",
    lastName: "Fiorenza",
    title:
      " Associate Director, Finance & Administration Chemistry Business Administration Services",
    slug: "bruno-fiorenza",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Lauren K",
    lastName: "Fiori",
    title: "Director of Global Engagement Office of Global Engagement",
    slug: "lauren-k-fiori",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Stephen D.",
    lastName: "Fischer",
    title: "Affiliation: Staff",
    slug: "stephen-d-fischer",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Michael",
    lastName: "Fisher",
    title:
      " Assistant Director of Digital Content & Communications Nursing Office of Commuincations",
    slug: "michael-fisher",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "JESSIE A",
    lastName: "FISHER",
    title: "Personnel/Payroll COORD PHARM/CET/ITMAT",
    slug: "jessie-a-fisher",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Jennifer L",
    lastName: "Fisher",
    title: "Assistant Director of Advancement SAS Office of Advancement",
    slug: "jennifer-l-fisher",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Katherine A",
    lastName: "Fitz-Henry",
    title:
      " Administrative Coordinator Mack Institute for Innovation Management",
    slug: "katherine-a-fitz-henry",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kate",
    lastName: "FitzGerald",
    title:
      " Director of Marketing and Communications McNulty Leadership Program",
    slug: "kate-fitzgerald",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Danielle K",
    lastName: "Fitzgerald",
    title: "Senior Content Producer, Communications Admissions",
    slug: "danielle-k-fitzgerald",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Nicole McGarry",
    lastName: "Fitzpatrick",
    title: "Associate Director of Alumni Relations Penn Medicine Development",
    slug: "nicole-mcgarry-fitzpatrick",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Denise M.",
    lastName: "Fitzpatrick",
    title:
      " Director B, Arts and Media, Communications and Marketing Center for Excellence in Teaching, Learning and Innovation",
    slug: "denise-m-fitzpatrick",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Shawn F.",
    lastName: "Flack",
    title: "Dir. Human Resources & CHIEF ADMIN GEN COUNSEL PRESIDENT'S CTR",
    slug: "shawn-f-flack",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "John E.",
    lastName: "Flaherty",
    title: "Mail Carrier; Business Services Mail",
    slug: "john-e-flaherty",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Justin H",
    lastName: "Flax",
    title: "Head Creative Director Wharton Marketing and Communications Group",
    slug: "justin-h-flax",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Brian K",
    lastName: "Fleeger",
    title: "APPLICATION DEVELOPER PATHOBIOLOGY NBC",
    slug: "brian-k-fleeger",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Emylee Nova",
    lastName: "Fleshman",
    title:
      " Penn Food and Wellness Collaborative Coordinator Prevention, Education, and Promotion",
    slug: "emylee-nova-fleshman",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Daniel",
    lastName: "Flinchbaugh",
    title: "Coordinator B Office of the University Architect",
    slug: "daniel-flinchbaugh",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Pamela G.",
    lastName: "Flinn",
    title: "Manager, Investment Accounting Gift & Investment Services",
    slug: "pamela-g-flinn",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Richard",
    lastName: "Flom",
    title: "Accountant Research Services",
    slug: "richard-flom",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jacklyn",
    lastName: "Floyd",
    title: "Coordinator of Business Development Other Event Management",
    slug: "jacklyn-floyd",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Anthony",
    lastName: "Floyd",
    title: "Administrative Coordinator Law in DAR",
    slug: "anthony-floyd",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Maya",
    lastName: "Focht",
    title:
      " Associate Director, Inbound Sales Wharton Executive Education (Open Enrollment)",
    slug: "maya-focht",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Kathryn A",
    lastName: "Fogle",
    title:
      " Immigration and Employment Compliance Manager Office of Budget and Administration, SEAS",
    slug: "kathryn-a-fogle",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Timothy B",
    lastName: "Folan",
    title: "Senior Associate Athletic Director Athletics in DAR",
    slug: "timothy-b-folan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Emma",
    lastName: "Foley",
    title:
      " Senior Executive Director, Communications and External Affairs Penn Medicine Development and Alumni Relations",
    slug: "emma-foley",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Edward C.",
    lastName: "Fong",
    title: "Financial Administrative Coordinator Institutional Review Board",
    slug: "edward-c-fong",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Paul",
    lastName: "Forchielli",
    title:
      " Assistant Director for Projects and Quality Assurance Residential Services",
    slug: "paul-forchielli",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Mariah E",
    lastName: "Ford",
    title: "Director of Curriculum, Instructional Support Curricular Affairs",
    slug: "mariah-e-ford",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Ilene",
    lastName: "Ford",
    title: "Recruitment & Admissions Specialist LPS Online",
    slug: "ilene-ford",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Charicha T",
    lastName: "Ford",
    title: "ADMIN AST WH GRAD ADMISS",
    slug: "charicha-t-ford",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Evelyn J",
    lastName: "Ford",
    title: "Associate Director PennERA Group, Office of Research Services",
    slug: "evelyn-j-ford",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Minita L.",
    lastName: "Ford",
    title: "Associate Director Executive Education",
    slug: "minita-l-ford",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Sabrina",
    lastName: "Foreman",
    title: "Payroll Coordinator University Museum",
    slug: "sabrina-foreman",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "HELEN",
    lastName: "FORMANES",
    title: "Associate Director External Affairs",
    slug: "helen-formanes",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Kris",
    lastName: "Forrest",
    title: "Director of Finance University Museum",
    slug: "kris-forrest",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Elisa C",
    lastName: "Foster",
    title: "Director C, Student Services Penn Women's Center Administration",
    slug: "elisa-c-foster",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Lucy",
    lastName: "Fowler",
    title: "Manager, Museum Collections University Museum",
    slug: "lucy-fowler",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Julia L",
    lastName: "Fox",
    title:
      " Assistant Director, Annual Fund and Individual Giving ICA Development",
    slug: "julia-l-fox",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "David",
    lastName: "Fox",
    title: "Director New Student Orientation and Academic Initiatives",
    slug: "david-fox",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Mary Frances",
    lastName: "Frabotta",
    title: "Administrative Coordinator, SEAS Penn Center for Innovation",
    slug: "mary-frances-frabotta",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tina P",
    lastName: "Fragoso",
    title:
      " Tina Fragroso ? Senior Advisor to the Dean for Special Projects Admissions",
    slug: "tina-p-fragoso",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Michael Robert",
    lastName: "Fraker",
    title:
      " Information Technology Architect Marketing and Communications Group",
    slug: "michael-robert-fraker",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Colleen P",
    lastName: "France",
    title:
      " Associate Director E, Student Services, Advising Wharton Executive MBA",
    slug: "colleen-p-france",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Mary",
    lastName: "Francis",
    title: "Director, University Press University Press",
    slug: "mary-francis",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jacob",
    lastName: "Francis",
    title: "Information Technology Support Specialist B SDM Computing",
    slug: "jacob-francis",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Traci F",
    lastName: "Frank",
    title: "ADMIN ASST PED",
    slug: "traci-f-frank",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Morgan E.",
    lastName: "Franklin",
    title: "Administrative Coordinator Project Management",
    slug: "morgan-e-franklin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Brittany",
    lastName: "Franklin",
    title:
      " Sr Associate Director of Operations, Finance & Administraiton Baker Retailing Initiative",
    slug: "brittany-franklin",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "STACY L",
    lastName: "FRANKS",
    title: "ASSOC DIRECTOR WH SCH/FNCE/Academic Affairs",
    slug: "stacy-l-franks",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Gabrielle",
    lastName: "Franks",
    title: "Audiovisual Coordinator IT CLIENT SERVICES",
    slug: "gabrielle-franks",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Heidi",
    lastName: "Franz",
    title: "Accountant C WXPN Surrogate",
    slug: "heidi-franz",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Ryan",
    lastName: "Frasch",
    title: "Senior Training Specialist Financial Systems",
    slug: "ryan-frasch",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Joan T",
    lastName: "Fraser",
    title: "Business Administrator C FINANCE AND ADMINISTRATION",
    slug: "joan-t-fraser",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Brenda",
    lastName: "Fraser",
    title: "ASSOC GEN COUNSEL",
    slug: "brenda-fraser",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Heather",
    lastName: "Frattone",
    title: "Vice Dean of DAR, Law School Law in DAR",
    slug: "heather-frattone",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Shirraine",
    lastName: "Frazier",
    title: "Instrument Sterilization Attendant A Instrument Management Service",
    slug: "shirraine-frazier",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Monica R",
    lastName: "Fread",
    title: "Grants Manager A Statistics and Data Science",
    slug: "monica-r-fread",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Melissa",
    lastName: "Freas",
    title:
      " Associate Director of Human Resources, ISC ISC-ACIO-Shared Services",
    slug: "melissa-freas",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Mr. Alexander M.",
    lastName: "Freeman",
    title:
      " Director of Marketing & Ticketing Annenberg Center for the Performing Arts",
    slug: "mr-alexander-m-freeman",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Dionne",
    lastName: "Freeman",
    title:
      " Case Manager/Referral Coordinator Counseling and Psychological Services",
    slug: "dionne-freeman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lisa M.",
    lastName: "Frenz",
    title: "SR DIR PRINCIPAL GIFTS Principal Gifts",
    slug: "lisa-m-frenz",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Tori",
    lastName: "Frew",
    title:
      " Assistant Director of Graduate Programs Research and Academic Services",
    slug: "tori-frew",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Susan A",
    lastName: "Friedman",
    title: "DIR CHOP INTERNATIONAL ADOPTION HEALTH PROGRAM CHOP",
    slug: "susan-a-friedman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Brent Allan",
    lastName: "Friedman",
    title: "Senior IT Director Division of Finance",
    slug: "brent-allan-friedman",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Becky",
    lastName: "Friedman",
    title: "Associate Director of Undergraduate Studies English",
    slug: "becky-friedman",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Rachel",
    lastName: "Friend",
    title: "Enrollment Operations Manager Office of Academic Innovation",
    slug: "rachel-friend",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Edward A",
    lastName: "Friess",
    title: "Grants Manager A Business Operations",
    slug: "edward-a-friess",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Afuah",
    lastName: "Frimpong",
    title: "Business Administrator, Finance and Operations DAR Operations",
    slug: "afuah-frimpong",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Gabriella S",
    lastName: "Frisone",
    title: "Administrative Coordinator Statistics and Data Science",
    slug: "gabriella-s-frisone",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Christine Councill",
    lastName: "Fritton",
    title: "Associate Director for Clerkships Office of Career Strategy",
    slug: "christine-councill-fritton",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Erik J",
    lastName: "Froelich",
    title:
      " Senior Director of innovation Technology and Design, Wharton Online Executive Education Online",
    slug: "erik-j-froelich",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Tara",
    lastName: "Fromm",
    title: "Senior Intellectual Property Paralegal Penn Center for Innovation",
    slug: "tara-fromm",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "John W.",
    lastName: "Frommeyer",
    title: "APPLICATION DEVELOPER Computer and Information Science",
    slug: "john-w-frommeyer",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Heather D.",
    lastName: "Frost",
    title:
      " College Mental Health Professional Counseling and Psychological Services",
    slug: "heather-d-frost",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Serena",
    lastName: "Fryar",
    title: "Gifts Accountant Comptroller's Office",
    slug: "serena-fryar",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jessica D",
    lastName: "Frye",
    title: "Assistant Director, Husbandry Operations ULAR",
    slug: "jessica-d-frye",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rudy",
    lastName: "Fuller",
    title:
      " Senior Associate Athletic Director for Intercollegiate Programs DRIA Administrative Affairs",
    slug: "rudy-fuller",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ellen",
    lastName: "Furxhi",
    title:
      " Vice Dean and Chief of Staff, Office of the Dean School of Arts and Sciences",
    slug: "ellen-furxhi",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Aaliyah",
    lastName: "Gabriel",
    title: "Customer Service Rep; Penn Parking Parking",
    slug: "aaliyah-gabriel",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rick",
    lastName: "Gabrill",
    title:
      " Information Technology Project Leader ISC-Tech Services-Network Operations",
    slug: "rick-gabrill",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Deepa Sree",
    lastName: "Gadde",
    title: "AEGD Resident COH Extramural Activities",
    slug: "deepa-sree-gadde",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tessa",
    lastName: "Gadomski",
    title: "CONSERVATION LIBRARIAN Collection Development and Management",
    slug: "tessa-gadomski",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Amy E",
    lastName: "Gadsden",
    title: "Executive Director Penn Global",
    slug: "amy-e-gadsden",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "STEVEN",
    lastName: "GAGNE",
    title: "Assistant Manager President's Office",
    slug: "steven-gagne",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Andy",
    lastName: "Gahagan",
    title: "Associate Director B, Academic Affairs Architecture",
    slug: "andy-gahagan",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Rachel",
    lastName: "Gaines",
    title: "IRB Administrator Institutional Review Board",
    slug: "rachel-gaines",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Brian",
    lastName: "Gainor",
    title: "Application Developer Senior Linguistic Data Consortium",
    slug: "brian-gainor",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Joseph Patrick",
    lastName: "Gaither",
    title:
      " HOUSEKEEPING OPERATIONS MANAGER Operations and Maintenance Administration",
    slug: "joseph-patrick-gaither",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Bindu",
    lastName: "Gajria",
    title: "Senior Bioinformatics Data Type Developer Biology",
    slug: "bindu-gajria",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Diane",
    lastName: "Galeone",
    title: "Systems Architect ISC-Tech Services-Network Operations",
    slug: "diane-galeone",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Regan M.",
    lastName: "Gallagher",
    title: "Director of Operations, Men's Basketball Men's Basketball Team",
    slug: "regan-m-gallagher",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Christopher",
    lastName: "Gallagher",
    title: "SENIOR PROJECT MANAGER FACIL SVCS PROJ MGMT",
    slug: "christopher-gallagher",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Gabrielle",
    lastName: "Gallante",
    title: "Coordinator, Program Biobehavioral and Health Sciences",
    slug: "gabrielle-gallante",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "KRISTEN D",
    lastName: "GALLI",
    title: "Donor Support Administrator Penn Fund",
    slug: "kristen-d-galli",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Rebecca J.",
    lastName: "Gallo",
    title: "EXECUTIVE COORDINATOR General Counsel",
    slug: "rebecca-j-gallo",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Jordan E.",
    lastName: "Gallo",
    title: "OGCA Coordinator Office of Government and Community Affairs",
    slug: "jordan-e-gallo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Joe",
    lastName: "Gallo",
    title: "Associate Director of MBA Student Life Student Affairs Office",
    slug: "joe-gallo",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Ursula Jasmine",
    lastName: "Gamache",
    title: "Associate Director B, Student Services, Advising Penn First Plus",
    slug: "ursula-jasmine-gamache",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Ariel",
    lastName: "Gamache",
    title: "Business Administrator Nursing Finance",
    slug: "ariel-gamache",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Anna Michelle",
    lastName: "Gamarnik",
    title: "Multimedia Services Manager Annenberg School for Communication",
    slug: "anna-michelle-gamarnik",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "John F",
    lastName: "Gamba",
    title: "Director C, Student Services, Graduate Programs Education",
    slug: "john-f-gamba",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "DR SRILATA",
    lastName: "GANGULEE",
    title: "ASST DEAN ACAD ADVISING COL",
    slug: "dr-srilata-gangulee",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Tammy",
    lastName: "Gantz",
    title: "Associate Director C, Academic Affairs Vet Student Affairs",
    slug: "tammy-gantz",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Sara",
    lastName: "Gao",
    title:
      " Regional Director, Business Development Wharton Executive Education (Custom)",
    slug: "sara-gao",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alicia",
    lastName: "Gao",
    title: "Grants Coordinator B Research Support Center (RSC)",
    slug: "alicia-gao",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Wesley",
    lastName: "Garant",
    title: "Academic Coordinator Architecture",
    slug: "wesley-garant",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Sarai",
    lastName: "Garcia",
    title:
      " Temporary Staff - Non-Degree Penn Student SM-DN-Inclusion, Diversity, Equity, & Learner Exp Prog in Me",
    slug: "sarai-garcia",
    dei: true,
    category: "Academic",
  },
  {
    firstName: "Kristina Linnea",
    lastName: "Garcia",
    title: "Staff Writer D SAS Office of Advancement",
    slug: "kristina-linnea-garcia",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Keith F",
    lastName: "Garcia",
    title:
      " Senior IT Project Leader, Instructional Design and Ed. Architects and Wharton Computing and Instructional Technology (WCIT)",
    slug: "keith-f-garcia",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Edwin",
    lastName: "Garcia Ramos",
    title: "Help Desk Support Annenberg School for Communication",
    slug: "edwin-garcia-ramos",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Nakia",
    lastName: "Gard",
    title: "Program Manager, Education Policy Educational Policy",
    slug: "nakia-gard",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jen",
    lastName: "Gardiner",
    title: "Staff Assistant C Secretary's Office",
    slug: "jen-gardiner",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Delphine",
    lastName: "Gardiner",
    title: "Senior Communications Specialist Computational Social Science Lab",
    slug: "delphine-gardiner",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Barbara",
    lastName: "Gardner",
    title:
      " Operations Support Coordinator Weingarten Learning Resource Center Operations",
    slug: "barbara-gardner",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Mason E.",
    lastName: "Garnett",
    title: "Manager, Husbandry ULAR",
    slug: "mason-e-garnett",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Randi S.",
    lastName: "Garnick",
    title: "Director of Admissions Law School",
    slug: "randi-s-garnick",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Gary",
    lastName: "Garofalo",
    title: "BSD General University EB Pool",
    slug: "gary-garofalo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Amelia",
    lastName: "Garrett",
    title:
      " Information Technology Technical Director Information Technology Services",
    slug: "amelia-garrett",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Rachael E",
    lastName: "Garrett Canfield",
    title: "Coordinator, Program Fraternity and Sorority Affairs-Operating",
    slug: "rachael-e-garrett-canfield",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Mr. REGINALD F.",
    lastName: "GARRISON",
    title: "IT SUPPORT SPECIALIST SR DEV & ALUMNI RELS",
    slug: "mr-reginald-f-garrison",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kim M.",
    lastName: "Garrison",
    title:
      " SR. DIRECTOR, POST AWARD FINANCIAL ADMINISTRATION RESEARCH SERVICES",
    slug: "kim-m-garrison",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Rosemary",
    lastName: "Garrity",
    title: "Manager C, Business and Finance PENN WASHINGTON",
    slug: "rosemary-garrity",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Leigh-Anne",
    lastName: "Garry",
    title: "Director, Strategic Planning and Initiatives AVP Development",
    slug: "leigh-anne-garry",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Marjan O",
    lastName: "Gartland",
    title: "Chief Creative Officer, SP2 SP2 Office of the Dean",
    slug: "marjan-o-gartland",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sheryl",
    lastName: "Garton",
    title: "Director of Development Penn Medicine Development",
    slug: "sheryl-garton",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Deborah",
    lastName: "Gaspari",
    title: "Grants Manager Business Operations",
    slug: "deborah-gaspari",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Daniela M",
    lastName: "Gastner",
    title: "Managing Director Investments Office of Investments",
    slug: "daniela-m-gastner",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jeremy",
    lastName: "Gatens",
    title: "Information Technology Director HR Information Management",
    slug: "jeremy-gatens",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Michael R",
    lastName: "Gau",
    title: "Director B, Research Chemistry",
    slug: "michael-r-gau",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "NELLIE",
    lastName: "GAYNOR",
    title: "Director of Graduate Studies Graduate Studies and Student Research",
    slug: "nellie-gaynor",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Christine",
    lastName: "Gehman",
    title:
      " Director of Finance and Administration Morris Arboretum / Business Services",
    slug: "christine-gehman",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Gary L",
    lastName: "Gehman",
    title: "IT/AV/Web Director Annenberg Public Policy Center",
    slug: "gary-l-gehman",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "DR ANITA F",
    lastName: "GELBURD",
    title:
      " Director of Information Assurance & Mission Continuity ISC Office of Information Security",
    slug: "dr-anita-f-gelburd",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Paul",
    lastName: "Gentile",
    title:
      " Information Technology Project Leader Senior ISC-Tech Services-Network Operations",
    slug: "paul-gentile",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Nicola M",
    lastName: "Gentili",
    title: "Associate Director Cinema & Media Studies",
    slug: "nicola-m-gentili",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Marco Antonio",
    lastName: "Georeno",
    title: "Associate Dean of Finance and CFO SDM Deans Office",
    slug: "marco-antonio-georeno",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Alisha Michelle",
    lastName: "George",
    title: "Assistant/Web Editor Almanac",
    slug: "alisha-michelle-george",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Matthew T.",
    lastName: "Geraghty",
    title:
      " Director of Boards for Recruitment and External Relations Secretary's Office",
    slug: "matthew-t-geraghty",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Natalie",
    lastName: "Gerich Brabson",
    title: "Grants Manager B Wharton Finance and Administration",
    slug: "natalie-gerich-brabson",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jessica B.",
    lastName: "German",
    title:
      " Associate Director, ITMAT Education TM-Institute for Translational Medicine and Therapeutics",
    slug: "jessica-b-german",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "ATIYA",
    lastName: "GERMAN",
    title: "Facility Rentals Manager Penn Museum",
    slug: "atiya-german",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "NEAL W",
    lastName: "GERRISH",
    title:
      " Information Technology Director Computing and Educational Technology Services",
    slug: "neal-w-gerrish",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jennifer",
    lastName: "Gers",
    title: "Director, Financial Services Executive Education",
    slug: "jennifer-gers",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Dorothy M., AS, RLAT",
    lastName: "Getz",
    title: "Senior Training and Wellness Specialist ULAR",
    slug: "dorothy-m-as-rlat-getz",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "John H",
    lastName: "Ghazvinian",
    title:
      " Associate Director B, Academic Affairs, Academic Center Middle East Center",
    slug: "john-h-ghazvinian",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Hyemi",
    lastName: "Ghilardi",
    title: "Financial Administrative Coordinator Business Operations",
    slug: "hyemi-ghilardi",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Lisa",
    lastName: "Giang",
    title: "Assistant Director of Development, SP2 SP2 Development",
    slug: "lisa-giang",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Joseph O.",
    lastName: "Gibbs",
    title: "Corporate Tax Director Comptroller's Office",
    slug: "joseph-o-gibbs",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Karen",
    lastName: "Gibson",
    title: "Contract Coordinator FRES Design & Construction",
    slug: "karen-gibson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kayowa",
    lastName: "Gibson-Tshilenge",
    title:
      " Managing Editor, Journals, Editing and Production Coordinator University Press",
    slug: "kayowa-gibson-tshilenge",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Kate",
    lastName: "Gilbert",
    title: "Project Manager Project Management",
    slug: "kate-gilbert",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jup",
    lastName: "Gill",
    title:
      " Director of Data Administration and Institutional Research Wharton Dean's Office",
    slug: "jup-gill",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Claire",
    lastName: "Gill",
    title:
      " Assistant Director of Annual Giving, Penn Carey Law School Penn Carey Law School",
    slug: "claire-gill",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Courtney L",
    lastName: "Gillespie",
    title: "Grants Manager A Business Operations",
    slug: "courtney-l-gillespie",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Michelle D",
    lastName: "Gilliard Houston",
    title: "Associate Director B, Student Services, Student Engagement Makuu",
    slug: "michelle-d-gilliard-houston",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Elizabeth G.",
    lastName: "Gillstrom",
    title:
      " Associate Director of Instructional Design Office of Academic Innovation",
    slug: "elizabeth-g-gillstrom",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Roxanne",
    lastName: "Gilmer",
    title: "Associate Director MANAGEMENT DEPARTMENT",
    slug: "roxanne-gilmer",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Sarah Rachel",
    lastName: "Gilmour",
    title:
      " Director of Development for Biomedical Research Penn Medicine Development",
    slug: "sarah-rachel-gilmour",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kristy",
    lastName: "Gingras",
    title: "Associate Director of Donor Relations SAS Office of Advancement",
    slug: "kristy-gingras",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Camille",
    lastName: "Giordano",
    title:
      " Learning Science Research Assistant Executive Education and Professional Development",
    slug: "camille-giordano",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "William",
    lastName: "Gipson",
    title: "Associate Vice Provost for Equity and Access VPUL",
    slug: "william-gipson",
    dei: true,
    category: "Academic",
  },
  {
    firstName: "Sarah E",
    lastName: "Gish-Kraus",
    title: "Administrative Coordinator Classical Studies",
    slug: "sarah-e-gish-kraus",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Robin Y",
    lastName: "Glass",
    title: "Associate Director C, Arts and Media, Events Graduate Admissions",
    slug: "robin-y-glass",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "David",
    lastName: "Glassman",
    title:
      " College Mental Health Professional Counseling and Psychological Services",
    slug: "david-glassman",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Molly",
    lastName: "Gleeson",
    title: "Museum Conservator Senior Conservation Lab",
    slug: "molly-gleeson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Elizabeth M",
    lastName: "Glover",
    title: "Editing & Production Manager University Press",
    slug: "elizabeth-m-glover",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jerome",
    lastName: "Glowzenski",
    title:
      " Information Technology Support Specialist Senior Wharton Computing and Instructional Technology (WCIT)",
    slug: "jerome-glowzenski",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Rikki R",
    lastName: "Godshall",
    title: "IT Director Penn Medicine Academic Computing Services",
    slug: "rikki-r-godshall",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Rebecca",
    lastName: "Goering",
    title: "Director of Marketing & Communications Penn Live Arts",
    slug: "rebecca-goering",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Michele",
    lastName: "Goff",
    title:
      " Assistant Director of Tuition Management and Student Account Systems Student Registration & Financial Services",
    slug: "michele-goff",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Michael",
    lastName: "Golden",
    title: "Vice Dean of Innovative Programs and Partnerships Education",
    slug: "michael-golden",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Bridget",
    lastName: "Goldhahn",
    title:
      " Communications Director, CPRE Consortium for Policy Research in Education",
    slug: "bridget-goldhahn",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Brett P",
    lastName: "Goldhammer",
    title: "Application Developer Senior Marketing and Communications Group",
    slug: "brett-p-goldhammer",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Maureen",
    lastName: "Goldsmith",
    title: "Staff Assistant C ISC-VP and Administration",
    slug: "maureen-goldsmith",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Angela K",
    lastName: "Goldston",
    title: "Director of Fiscal Operations ULAR",
    slug: "angela-k-goldston",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Angela Henshaw",
    lastName: "Golub",
    title:
      " Manager D, Academic Affairs, Academic Administration ME-HEALTHCARE TRANSFORMATION INSTITUTE",
    slug: "angela-henshaw-golub",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Nancy",
    lastName: "Golumbia",
    title:
      " Information Technology Technical Director Wharton Computing and Instructional Technology (WCIT)",
    slug: "nancy-golumbia",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Charles T.",
    lastName: "Gondos",
    title: "Stewardship Coordinator, ACC Penn Medicine Development",
    slug: "charles-t-gondos",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "CATHERINE L",
    lastName: "GONTAREK",
    title: "ART DIR PENN GAZETTE DEV. & ALUMNI RELATIONS",
    slug: "catherine-l-gontarek",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Vanessa E",
    lastName: "Gonzalez",
    title: "Director of Operations- TCSL CI-TCSL/CVPF",
    slug: "vanessa-e-gonzalez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Brenda M",
    lastName: "Gonzalez",
    title: "ADMIN COORDINATOR SPEC EVENTS PRESIDENT'S OFFICE",
    slug: "brenda-m-gonzalez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Caroline",
    lastName: "Gonzalez",
    title: "Degree Coordinator Vice Provost Education",
    slug: "caroline-gonzalez",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Joann",
    lastName: "Gonzalez-Generals",
    title: "Director, Upwardbound Student Engagement",
    slug: "joann-gonzalez-generals",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Felicia N",
    lastName: "Goodson",
    title: "House Coordinator, Fisher Hassenfeld CHAS",
    slug: "felicia-n-goodson",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Priya P",
    lastName: "Gor",
    title: "Virtua- On Call Coverage Role DM-Hematology/Oncology",
    slug: "priya-p-gor",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Michalina",
    lastName: "Goral-Burnosky",
    title: "HR & Operations Manager Penn Center for Innovation",
    slug: "michalina-goral-burnosky",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "D'Angelo J.",
    lastName: "Gore",
    title: "Senior Staff Writer, FactCheck.org Annenberg Public Policy Center",
    slug: "d-angelo-j-gore",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Molly",
    lastName: "Gorelick",
    title: "Enrollment Specialist Professional and Liberal Education (PLE)",
    slug: "molly-gorelick",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Colleen",
    lastName: "Gorman",
    title: "Administrative Assistant B General University EB Pool",
    slug: "colleen-gorman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Joanne",
    lastName: "Gorman",
    title: "Human Resources and Business Manager CB-Cancer Biology",
    slug: "joanne-gorman",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Avinash M",
    lastName: "Goss",
    title: "Database Administrator Wharton Finance Pillar",
    slug: "avinash-m-goss",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Che",
    lastName: "Gossett",
    title:
      " Associate Director C, Academic Affairs, Academic Center Center for Research in Feminist, Queer, &Transgender Studies",
    slug: "che-gossett",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Adam K.",
    lastName: "Gould",
    title: "Business Administrator B Wharton Finance and Administration",
    slug: "adam-k-gould",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Valentina B.",
    lastName: "Goutorova",
    title: "Director Penn Wharton Entrepreneurship",
    slug: "valentina-b-goutorova",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Arjun Kolar",
    lastName: "Govind",
    title: "Investment Associate Office of Investments",
    slug: "arjun-kolar-govind",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Aman S",
    lastName: "Goyal",
    title:
      " Director, Penn Traditions and Young Alumni Programs Alumni Relations",
    slug: "aman-s-goyal",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Donna Marie",
    lastName: "Graber",
    title: "EXEC Coordinator GENERAL COUNSEL",
    slug: "donna-marie-graber",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Karen",
    lastName: "Grabowski",
    title: "Administrative Coordinator, MSSP Masters of Social Policy",
    slug: "karen-grabowski",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Janice Rafferty",
    lastName: "Grady",
    title: "Major Gifts Officer Penn Medicine Development",
    slug: "janice-rafferty-grady",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Frank , III",
    lastName: "Graham",
    title: "Grants Manager B Education",
    slug: "frank-iii-graham",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jill M",
    lastName: "Gran",
    title: "HR Business Partner, Talent Management Wharton Human Resources",
    slug: "jill-m-gran",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Jean-Luc",
    lastName: "Grandchamp",
    title: "IT SUPPORT SPECIALIST",
    slug: "jean-luc-grandchamp",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Steven P",
    lastName: "Grant",
    title: "Associate Registrar Nursing Academic Affairs",
    slug: "steven-p-grant",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Michael R",
    lastName: "Grant",
    title: "Director of Communications PennDesign",
    slug: "michael-r-grant",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jamie C.",
    lastName: "Grant",
    title: "SENIOR ASSOC DIRECTOR Career Services",
    slug: "jamie-c-grant",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Ethiopia Faith",
    lastName: "Grant",
    title: "BSD Day Care Center",
    slug: "ethiopia-faith-grant",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Samara",
    lastName: "Gray",
    title: "Greenhouse Coordinator Biology",
    slug: "samara-gray",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Matthew",
    lastName: "Gray",
    title:
      " Director of Operations & Student Engagement, Analytics at Wharton Wharton's AI & Analytics Initiative",
    slug: "matthew-gray",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jeffrey W.",
    lastName: "Gray",
    title:
      " Director, PSOM HCM Operations SM-DN Strategic Planning and Reporting",
    slug: "jeffrey-w-gray",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Dana Denise",
    lastName: "Gray",
    title: "Guest Services Attendant University Meeting and Guest House",
    slug: "dana-denise-gray",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Celina L",
    lastName: "Gray",
    title: "Sr. Director of Academic Affairs Undergraduate Division",
    slug: "celina-l-gray",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Brian",
    lastName: "Greco",
    title:
      " Associate Director of Design, Construction, and Infrastructure SEAS Planning, Design, and Construction",
    slug: "brian-greco",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alyssa R",
    lastName: "Greco",
    title:
      " Director of Client Relations & Strategic Relationships, Executive Education Wharton Executive Education (Open Enrollment)",
    slug: "alyssa-r-greco",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Yolanda",
    lastName: "Green",
    title:
      " Director of Award Development & Finance, CGIR Center for Guaranteed Income",
    slug: "yolanda-green",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Bilal",
    lastName: "Green",
    title: "Supervisor, ULAR Husbandry ULAR",
    slug: "bilal-green",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Natalie Dury",
    lastName: "Green",
    title:
      " Associate Director, Master in Law Program Graduate and Professional Programs",
    slug: "natalie-dury-green",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Kerry",
    lastName: "Green",
    title:
      " Program Manager, Executive Education Wharton Executive Education (Custom)",
    slug: "kerry-green",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Josh",
    lastName: "Green",
    title:
      " Advisor to the President & Director of Communications President's Office",
    slug: "josh-green",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Adam Y.",
    lastName: "Greenberg",
    title: "BUSINESS ADMINISTRATOR Statistics and Data Science",
    slug: "adam-y-greenberg",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Eric",
    lastName: "Greenberg",
    title:
      " Sr Director Marketing Strategy and Operations Marketing and Communications Group",
    slug: "eric-greenberg",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Natalie",
    lastName: "Greene",
    title:
      " Manager, Membership & Development Data Systems Arboretum Development",
    slug: "natalie-greene",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Linda",
    lastName: "Greene",
    title: "Department Administrator EALC/NELC",
    slug: "linda-greene",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jasmine C",
    lastName: "Greene",
    title:
      " Associate Director C, Student Services Penn Women's Center Administration",
    slug: "jasmine-c-greene",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Tamara Lynn",
    lastName: "Greenfield King",
    title:
      " Associate Vice Provost for Student Affairs Office of University Life",
    slug: "tamara-lynn-greenfield-king",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "DR ANNE M",
    lastName: "GREENHALGH",
    title: "DEPUTY EXECUTIVE DIRECTOR ANNE & JOHN MCNULTY LEADERSHIP PROGRAM",
    slug: "dr-anne-m-greenhalgh",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Leah B.",
    lastName: "Greenspoon",
    title: "University Connection Programs Manager English Language Program",
    slug: "leah-b-greenspoon",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Patti",
    lastName: "Greenwood",
    title: "Athletics Administrative Coordinator DRIA Administrative Affairs",
    slug: "patti-greenwood",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Danielle",
    lastName: "Grega",
    title:
      " Associate Director, Student Financial Services SDM Fiscal Operations",
    slug: "danielle-grega",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Maura",
    lastName: "Gricoski",
    title:
      " Visitor Experience Associate, Morris Arboretum Arboretum Visitor Program",
    slug: "maura-gricoski",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Michael J",
    lastName: "Griego",
    title: "Associate Director Penn Abroad",
    slug: "michael-j-griego",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Amber E",
    lastName: "Grier",
    title: "Event Coordinator SAS Office of Advancement",
    slug: "amber-e-grier",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jeffrey",
    lastName: "Griffin",
    title: "BUSINESS MANAGER GENETICS",
    slug: "jeffrey-griffin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Matthew A",
    lastName: "Griffin",
    title: "MANAGER, NEW MEDIA University Communications",
    slug: "matthew-a-griffin",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Maryeileen B.",
    lastName: "Griffith",
    title: "Administrative Director Integrated Product Design",
    slug: "maryeileen-b-griffith",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Fareeda Genise",
    lastName: "Griffith",
    title: "Senior Director, Wharton Opportunity Lab OPPORTUNITY LAB",
    slug: "fareeda-genise-griffith",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kathryn J.",
    lastName: "Griffo",
    title:
      " Chief Advancement Officer PENN Medicine Development & Alumni Relations",
    slug: "kathryn-j-griffo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Emma G",
    lastName: "Grigore",
    title:
      " Executive Director, Wharton Human Resources & People Operations The Wharton School",
    slug: "emma-g-grigore",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Richella",
    lastName: "Grimsley",
    title: "Front Desk/Membership WXPN",
    slug: "richella-grimsley",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jennine",
    lastName: "Groce-Martin",
    title: "Community Liaison Geriatrics",
    slug: "jennine-groce-martin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "DENA",
    lastName: "GROMET",
    title: "Director E, Research, Administration Behavior Change for Good",
    slug: "dena-gromet",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jeffrey B",
    lastName: "Groon",
    title:
      " Sr. Director of Financial Planning and Operations Wharton Graduate Division",
    slug: "jeffrey-b-groon",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Sarah A.",
    lastName: "Grosik",
    title: "Director of Programs English Language Program",
    slug: "sarah-a-grosik",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Mark Thomas",
    lastName: "Gross",
    title: "Director of Advancement System Operations Information Services",
    slug: "mark-thomas-gross",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Joelle",
    lastName: "Gross",
    title: "Coordinator B Data Science Initiative",
    slug: "joelle-gross",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Erika N.",
    lastName: "Gross",
    title:
      " Director of Finance, Administration and Risk Management Student Health Services",
    slug: "erika-n-gross",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Paul J",
    lastName: "Grossman",
    title:
      " Information Technology Project Leader Senior Wharton Computing and Instructional Technology (WCIT)",
    slug: "paul-j-grossman",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Stephen",
    lastName: "Groundwater",
    title:
      " Senior Application Developer Office of Residential Computer Support",
    slug: "stephen-groundwater",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "KIMBERLEY F.V.",
    lastName: "GRUBE",
    title:
      " Chief Executive Director of Development & Alumni Relations MED CTR DEV",
    slug: "kimberley-f-v-grube",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ilana R",
    lastName: "Grubin",
    title: "Camp Coordinator, Morris Arboretum Arboretum Education",
    slug: "ilana-r-grubin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tre",
    lastName: "Grue",
    title: "Director A, Student Services, Admissions Education",
    slug: "tre-grue",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Nadine E",
    lastName: "Gruhn",
    title:
      " Managing Director Vagelos Institute for Energy Science and Technology (VIEST)",
    slug: "nadine-e-gruhn",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Christopher A",
    lastName: "Gruits",
    title:
      " Executive and Artistic Director Annenberg Center for the Performing Arts",
    slug: "christopher-a-gruits",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Chelsea",
    lastName: "Gu",
    title: "Assistant Director, Post-award Penn",
    slug: "chelsea-gu",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jun",
    lastName: "Gu",
    title: "DIRECTOR, NMR FACILITY Chemistry",
    slug: "jun-gu",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Igor",
    lastName: "Guba",
    title: "Manager, ULAR Husbandry ULAR",
    slug: "igor-guba",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nicole Michelle",
    lastName: "Guerrero",
    title: "Associate Program Director, CLO/MedEd Education",
    slug: "nicole-michelle-guerrero",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kevin C",
    lastName: "Guerrier",
    title: "Solution Center Specialist HCM Operations",
    slug: "kevin-c-guerrier",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Steven",
    lastName: "Guglielmi",
    title: "Senior Editor Knowledge at Wharton",
    slug: "steven-guglielmi",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Patrick A",
    lastName: "Guinan",
    title: "Vice Dean Finance and Administration Penn Nursing",
    slug: "patrick-a-guinan",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kelsey",
    lastName: "Guinnup",
    title: "Assistant Event Manager External Affairs",
    slug: "kelsey-guinnup",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Antonio James",
    lastName: "Guirola",
    title: "Investment Associate Office of Investments",
    slug: "antonio-james-guirola",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Vincent",
    lastName: "Gumbs",
    title: "Supplier Engagement Manager Procurement Services",
    slug: "vincent-gumbs",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Emily",
    lastName: "Gunther",
    title:
      " Associate Director D, Research, Administration Wharton Center for Leadership and Change Management",
    slug: "emily-gunther",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Weining",
    lastName: "Guo",
    title: "Sr. Application Developer VPUL Computing Services",
    slug: "weining-guo",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Yanan",
    lastName: "Guo",
    title:
      " Information Technology Technical Director Wharton Computing and Instructional Technology (WCIT)",
    slug: "yanan-guo",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jessica Jones",
    lastName: "Gupta",
    title:
      " Administrative Director Philadelphia Regional Center for Children's Environmental Health - Penn Medicine",
    slug: "jessica-jones-gupta",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Anushkaa",
    lastName: "Gupta",
    title:
      " Project Manager - Computational Social Science Lab Computer and Information Science",
    slug: "anushkaa-gupta",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Marta",
    lastName: "Guron",
    title:
      " Project Manager, Environmental Health & Radiation Safety Environmental Health and Safety",
    slug: "marta-guron",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "John",
    lastName: "Gustafson",
    title: "Associate Director Transportation",
    slug: "john-gustafson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Noah M",
    lastName: "Gustkey",
    title: "DIRECTOR ATHLETIC FACIL DRIA",
    slug: "noah-m-gustkey",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Joseph G",
    lastName: "Guttman",
    title: "BUSINESS MANAGER UNIV PRESS",
    slug: "joseph-g-guttman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Roseilyn",
    lastName: "Guzman",
    title:
      " Associate Director B, Student Services, Student Engagement La Casa Latina-Penn Center for Hispanic Excellence",
    slug: "roseilyn-guzman",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Dr. S. Sonya",
    lastName: "Gwak",
    title: "Director, Student Life Research and Academic Services, SEAS",
    slug: "dr-s-sonya-gwak",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "L. Jonathan",
    lastName: "Haas",
    title: "Manager, Web Development University Communications",
    slug: "l-jonathan-haas",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Tiffany",
    lastName: "Haas",
    title: "Director, Payroll Services Office of Finance and Administration",
    slug: "tiffany-haas",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Asha",
    lastName: "Habib",
    title: "Information Technology Project Leader SASC-Computing",
    slug: "asha-habib",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Iyasu",
    lastName: "Habtemicael",
    title: "BSD Parking",
    slug: "iyasu-habtemicael",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Carol A",
    lastName: "Hagan",
    title:
      " Associate Director - Graduate & Professional School Advising Career Services",
    slug: "carol-a-hagan",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Catherine A",
    lastName: "Hagele",
    title:
      " Associate Director B, Student Services, Graduate Programs SM-ED-Vice Dean Education",
    slug: "catherine-a-hagele",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Eero",
    lastName: "Hagen",
    title: "Information Technology Manager ISC-CLIENT SERVICES-HIREIT",
    slug: "eero-hagen",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "John",
    lastName: "Haggerty",
    title:
      " Senior Associate Director, Undergraduate Aid Student Registration & Financial Services",
    slug: "john-haggerty",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Brian F.",
    lastName: "Hahn",
    title: "Director B, Student Services, Admissions SDM Admissions",
    slug: "brian-f-hahn",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Julia",
    lastName: "Halbherr",
    title: "Coordinator, Program Legal Education Programs",
    slug: "julia-halbherr",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Ashlee",
    lastName: "Halbritter",
    title:
      " Executive Director, Public Health and Wellbeing Prevention, Education, and Promotion",
    slug: "ashlee-halbritter",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sharifa",
    lastName: "Halimi",
    title: "Outreach Coordinator, South Asia Center South Asia Center",
    slug: "sharifa-halimi",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Sheila D",
    lastName: "Hall",
    title: "Staff Recruiter Recruitment",
    slug: "sheila-d-hall",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Laurie A",
    lastName: "Hall",
    title:
      " Assistant Vice Provost for Strategic Planning and Operations Office of University Life",
    slug: "laurie-a-hall",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jennifer",
    lastName: "Hall",
    title:
      " Senior Director of Major and Planned Gifts Wharton External Affairs",
    slug: "jennifer-hall",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Michele A.",
    lastName: "Hall",
    title:
      " Senior Associate Director, Delivery Operations Wharton Executive Education (Operations)",
    slug: "michele-a-hall",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Bryant",
    lastName: "Hall",
    title: "Building Administrator, Wharton Operations Wharton Operations",
    slug: "bryant-hall",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Krysta L",
    lastName: "Halye",
    title: "Business Administrator C Business Operations",
    slug: "krysta-l-halye",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jake",
    lastName: "Hamblen",
    title: "Systems Administrator B Linguistic Data Consortium",
    slug: "jake-hamblen",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Mary",
    lastName: "Hamburg",
    title: "Coordinator CME & Special Events OT-Otorhinoloaryngology",
    slug: "mary-hamburg",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Ben R.",
    lastName: "Hamilton",
    title:
      " Administrative Coordinator, Penn Spectrum Programs Alumni Relations",
    slug: "ben-r-hamilton",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Garick L",
    lastName: "Hamlin",
    title:
      " Information Technology Architect ISC-Tech Services-Network Operations",
    slug: "garick-l-hamlin",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Sarah",
    lastName: "Hammer",
    title:
      " Director of FinTech Initiatives & Exec Dir Cypher Accelerator Deputy Dean's Office",
    slug: "sarah-hammer",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Shea D",
    lastName: "Hammond",
    title:
      " Information Technology Director ISC-Applications & Information Services",
    slug: "shea-d-hammond",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Alise S",
    lastName: "Hammond",
    title: "Associate Director, Alumni Engagement Nursing in DAR",
    slug: "alise-s-hammond",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Aziz",
    lastName: "Hammouche",
    title: "Information Technology Manager Senior ISC-CLIENT SERVICES-HIREIT",
    slug: "aziz-hammouche",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Sharon E",
    lastName: "Hampton",
    title:
      " CUSTOMER CALL CENTER AGENT Operations and Maintenance Administration",
    slug: "sharon-e-hampton",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "JAMAL",
    lastName: "HAMPTON",
    title: "Services Assistant Annenberg School for Communication",
    slug: "jamal-hampton",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jeffrey",
    lastName: "Hancock",
    title: "TECHNICAL INSTRUMENTATION Physics and Astronomy",
    slug: "jeffrey-hancock",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Lawanna S",
    lastName: "Handwerk",
    title: "Administrative Coordinator, Operations External Affairs",
    slug: "lawanna-s-handwerk",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Christopher D.",
    lastName: "Hankenson",
    title:
      " Administrative Coordinator, Corporate & Foundation Relations External Affairs",
    slug: "christopher-d-hankenson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tania V.",
    lastName: "Hanna",
    title: "Supervisor B ULAR",
    slug: "tania-v-hanna",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Andrew M",
    lastName: "Hanna",
    title: "Senior Building Administrator Operational Services",
    slug: "andrew-m-hanna",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Benjamin A",
    lastName: "Hannon",
    title:
      " SHIFT MANAGER/2ND SHIFT SUPERVISOR Operations and Maintenance Administration",
    slug: "benjamin-a-hannon",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Madeleine V",
    lastName: "Hansen",
    title:
      " Associate Director of Development, Penn Medicine Penn Medicine Development",
    slug: "madeleine-v-hansen",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Elizabeth",
    lastName: "Hansen",
    title: "Executive Director - Finance and Administration FRES",
    slug: "elizabeth-hansen",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Louis W",
    lastName: "Hansrote",
    title: "Medical Director PE-Pediatrics",
    slug: "louis-w-hansrote",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tiffany",
    lastName: "Hanulec",
    title:
      " Information Technology Executive Director ISC-Tech Services-Network Operations",
    slug: "tiffany-hanulec",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Dr. Omar S.",
    lastName: "Harb",
    title: "Director of Scientific Outreach and Education VEuPathDB.org",
    slug: "dr-omar-s-harb",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Olaino B",
    lastName: "Hardaway",
    title: "Executive Director for Technology Services Wharton Computing",
    slug: "olaino-b-hardaway",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Cheryl D",
    lastName: "Hardy",
    title:
      " Associate Dean for Professional Engagement and Strategic Initiatives Law Registrar",
    slug: "cheryl-d-hardy",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Marie Elizabeth",
    lastName: "Harf",
    title: "Executive Director of Perry World House Perry World House",
    slug: "marie-elizabeth-harf",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Maria H.",
    lastName: "Haring",
    title: "Assistant Director, Talent Management DAR Human Resources",
    slug: "maria-h-haring",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Ira",
    lastName: "Harkavy",
    title:
      " Associate VP; Founding Director, Barbara and Edward  Netter Center for Community Partnerships Office of Government & Community Affairs",
    slug: "ira-harkavy",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Scott",
    lastName: "Harkey",
    title: "Associate Director, Annual & Special Gifts Penn Medicine",
    slug: "scott-harkey",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Robert J",
    lastName: "Harkins",
    title: "Director, Penn Class of 1923 Ice Rink Ice Rink",
    slug: "robert-j-harkins",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Hallie Spencer",
    lastName: "Harmon",
    title: "Events Services Coordinator Penn Live Arts",
    slug: "hallie-spencer-harmon",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Peter",
    lastName: "Harnish",
    title: "COORDINATOR INSTRUCTION LABS Physics and Astronomy",
    slug: "peter-harnish",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jenny",
    lastName: "Harnish",
    title: "Grants Manager A Business Operations",
    slug: "jenny-harnish",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Tyler",
    lastName: "Harold",
    title: "IT SUPPORT SPECIALIST Vet Dean's Office",
    slug: "tyler-harold",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jessie R",
    lastName: "Harper",
    title:
      " Director of Inclusion Education & Social Justice Scholars Program SP2 Office of the Dean",
    slug: "jessie-r-harper",
    dei: true,
    category: "Academic",
  },
  {
    firstName: "Elizabeth Paige",
    lastName: "Harper",
    title: "Application Developer Senior Biology",
    slug: "elizabeth-paige-harper",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Saida",
    lastName: "Harpi",
    title:
      " Associate Director of Collaborative Partnerships, Engagement, and Inclusion, OSCE Education",
    slug: "saida-harpi",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Lisa",
    lastName: "Harrell",
    title: "SENIOR IT HIREIT/ISC",
    slug: "lisa-harrell",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Corinn M",
    lastName: "Harrell",
    title:
      " Vice Dean of Finance and Administration, Penn Arts and Sciences SAS Dean",
    slug: "corinn-m-harrell",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Grace Kathryn",
    lastName: "Harrington",
    title: "Major Gifts Officer Major Gifts Program",
    slug: "grace-kathryn-harrington",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Wendy M",
    lastName: "Harris",
    title: "Senior Communications Specialist Learning & Education",
    slug: "wendy-m-harris",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Robin L",
    lastName: "Harris",
    title: "Affiliation: Staff",
    slug: "robin-l-harris",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "MIRIAM Y",
    lastName: "HARRIS",
    title: "Financial Administrator GSE Business Office",
    slug: "miriam-y-harris",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Lisa E",
    lastName: "Harris",
    title:
      " Administrative Coordinator Director of CHAS (College House and Academic Services",
    slug: "lisa-e-harris",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "ANDRE W",
    lastName: "HARRIS",
    title: "Client Relationship Manager ISC Client Services",
    slug: "andre-w-harris",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Gineen N.",
    lastName: "Harris",
    title: "Administrative Assistant A ULAR",
    slug: "gineen-n-harris",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Danean",
    lastName: "Harris",
    title:
      " Information Technology Support Specialist Senior IT CLIENT SERVICES",
    slug: "danean-harris",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Cassandra",
    lastName: "Harris",
    title: "ADM ASST COUNSELING HUMAN RESOURCES SCH MED HUMAN RESOURCES",
    slug: "cassandra-harris",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Caroline Joan",
    lastName: "Harris",
    title:
      " Assistant Development Officer, Penn Medicine Penn Medicine Development",
    slug: "caroline-joan-harris",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Brandon Alan",
    lastName: "Harris",
    title: "Human Resources Generalist Finance and Administration",
    slug: "brandon-alan-harris",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Andrew",
    lastName: "Harris",
    title: "Administrative Coordinator Dean's Office",
    slug: "andrew-harris",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Amena",
    lastName: "Harris",
    title: "Associate Director, Treasury Services FINANCE AND TREASURY",
    slug: "amena-harris",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Alexis",
    lastName: "Harris",
    title: "Graduate Programs Operations Manager LAW SCH GRAD PROG",
    slug: "alexis-harris",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Elgin",
    lastName: "Harryman",
    title: "Contract Administrator Senior General Counsel",
    slug: "elgin-harryman",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Andrew",
    lastName: "Hart",
    title: "Librarian D Preservation",
    slug: "andrew-hart",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Claire",
    lastName: "Harte",
    title: "Administrative Coordinator Real Estate Center",
    slug: "claire-harte",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Molly",
    lastName: "Hartig",
    title: "Coordinator, Program Law",
    slug: "molly-hartig",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Gregory J",
    lastName: "Hartley",
    title: "SR. IT MANAGER ISC TECHNOLOGY SERVICES",
    slug: "gregory-j-hartley",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Michael D",
    lastName: "Hartman",
    title: "Associate General Counsel General Counsel",
    slug: "michael-d-hartman",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "KIM",
    lastName: "HARTNETT",
    title: "Senior Designer Admissions",
    slug: "kim-hartnett",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Zachary Joseph",
    lastName: "Hartwell",
    title:
      " Information Technology Project Leader Wharton Computing and Instructional Technology (WCIT)",
    slug: "zachary-joseph-hartwell",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Ronald D., Jr.",
    lastName: "Harvey",
    title: "PennRSSA Program Director Student Engagement",
    slug: "ronald-d-jr-harvey",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Janet",
    lastName: "Harvey",
    title:
      " Director, Prospect Research & Prospect Management Wharton External Affairs",
    slug: "janet-harvey",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Charles Gervase",
    lastName: "Harvey",
    title: "Application Architect ISC-Applications & Information Services",
    slug: "charles-gervase-harvey",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kia",
    lastName: "Haslam",
    title: "Grants Manager A SP2 Finance and Administration",
    slug: "kia-haslam",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Susan M",
    lastName: "Hassett",
    title: "Enrollment Systems Manager LPS Administration",
    slug: "susan-m-hassett",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Tanner",
    lastName: "Haugen",
    title: "Assistant Director, Annual Giving DRIA Development",
    slug: "tanner-haugen",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Joseph W",
    lastName: "Haughey",
    title:
      " Assistant Athletic Director, Business Development Other Event Management",
    slug: "joseph-w-haughey",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Chuck",
    lastName: "Haughton",
    title: "Director, Office of Organization Effectiveness School of Medicine",
    slug: "chuck-haughton",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "William C",
    lastName: "Haun",
    title:
      " Application Developer Senior Wharton Computing and Instructional Technology (WCIT)",
    slug: "william-c-haun",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Wallace D.",
    lastName: "Haviland",
    title:
      " Information Technology Director Wharton Computing and Instructional Technology (WCIT)",
    slug: "wallace-d-haviland",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Andrew R.",
    lastName: "Hawkes",
    title: "Assistant Arborist Morris Arboretum",
    slug: "andrew-r-hawkes",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ned",
    lastName: "Hawkins",
    title:
      " Associate Director, Legal Education Programs Legal Education Programs",
    slug: "ned-hawkins",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Lauren Elizabeth",
    lastName: "Hawkins",
    title:
      " Assistant Director, Annenberg Health and Risk Communication Institute Annenberg Public Policy Center",
    slug: "lauren-elizabeth-hawkins",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Gregory M",
    lastName: "Hawkins",
    title: "Senior Customer Service Representative Wharton Operations",
    slug: "gregory-m-hawkins",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kerryn",
    lastName: "Hayes",
    title: "Simulation Delivery Expert Learning Lab, Wharton Computing",
    slug: "kerryn-hayes",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kyla",
    lastName: "Hayworth",
    title: "Training and Wellness Specialist ULAR",
    slug: "kyla-hayworth",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "David A.",
    lastName: "Heagerty",
    title:
      " IRB Associate Director, Operations and Education Institutional Review Board",
    slug: "david-a-heagerty",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Sarah",
    lastName: "Healy",
    title: "Program and Payroll Coordinator Tutoring",
    slug: "sarah-healy",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "MONICA CONVERY",
    lastName: "HEATER",
    title: "Associate Director D, Business and Finance Provost's Office",
    slug: "monica-convery-heater",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Michael",
    lastName: "Heath",
    title: "Senior IT Support Specialist Classroom Technology Services",
    slug: "michael-heath",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Lauren",
    lastName: "Heath",
    title:
      " Associate Director, Communication Strategist Wharton Graduate Division",
    slug: "lauren-heath",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "MARGARET A",
    lastName: "HEER",
    title: "ASSOC TREASURER, INVESTMENT SVCS TREASURER'S OFFICE",
    slug: "margaret-a-heer",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Catherine",
    lastName: "Hegarty",
    title: "Industrial Hygienist B Environmental Health and Safety",
    slug: "catherine-hegarty",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Peter G",
    lastName: "Heinemann",
    title: "Application Developer Senior ISC-Tech Services-Network Operations",
    slug: "peter-g-heinemann",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jonathan",
    lastName: "Heisler",
    title: "Associate Director, Major Gifts and Planned Giving Museum in DAR",
    slug: "jonathan-heisler",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Danica Ann",
    lastName: "Helb",
    title: "Application Developer Senior Biology",
    slug: "danica-ann-helb",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Robert E",
    lastName: "Helfman",
    title: "DIR MGMT ANALYSIS BUDGET & MGMT ANALYSIS",
    slug: "robert-e-helfman",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Carol",
    lastName: "Heller",
    title:
      " Communications Manager Wharton Risk Management and Decision Processes Center",
    slug: "carol-heller",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Britton",
    lastName: "Helmuth",
    title: "Administrative Coordinator Wharton Doctoral Program Office",
    slug: "britton-helmuth",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Stephanie",
    lastName: "Heminger",
    title: "Senior Systems Administrator SASC-Computing",
    slug: "stephanie-heminger",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Emily M",
    lastName: "Hemming",
    title:
      " Director, Media Relations and Research Marketing Marketing and Communications Group",
    slug: "emily-m-hemming",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Denita",
    lastName: "Henderson",
    title: "Managing Director Pennovation Works Institutional Real Estate",
    slug: "denita-henderson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "CAROL B",
    lastName: "HENDERSON",
    title:
      " Business Administrator Director of CHAS (College House and Academic Services",
    slug: "carol-b-henderson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Abhishek",
    lastName: "Hendi",
    title:
      " Information Technology Director Wharton Computing and Instructional Technology (WCIT)",
    slug: "abhishek-hendi",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Lucy Weise",
    lastName: "Hendrickson",
    title: "Director, Building Administration Provost's Office",
    slug: "lucy-weise-hendrickson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kaitlyn",
    lastName: "Hendrickson",
    title:
      " Associate Director Executive Doctorate in Higher Education Management Program",
    slug: "kaitlyn-hendrickson",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Denise L",
    lastName: "Henhoeffer",
    title: "Video Producer University Communications",
    slug: "denise-l-henhoeffer",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Katherine",
    lastName: "Henkel",
    title: "Business Administrator B Business Operations",
    slug: "katherine-henkel",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kyle",
    lastName: "Henrich",
    title: "Business Administrator B Linguistic Data Consortium",
    slug: "kyle-henrich",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Andrea",
    lastName: "Henriquez",
    title: "Development Assistant Penn Medicine Development",
    slug: "andrea-henriquez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Anthony",
    lastName: "Henry",
    title: "DIRECTOR FIN AID LAW SCH",
    slug: "anthony-henry",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Angela",
    lastName: "Henry",
    title: "Business Administrator ISC-ACIO-Shared Services",
    slug: "angela-henry",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tiffani L",
    lastName: "Henry-Baker",
    title: "CLERK FRES ACCTG & PAYROLL",
    slug: "tiffani-l-henry-baker",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Virginia",
    lastName: "Herbert",
    title: "Event Services Coordinator Penn Live Arts Audience Services",
    slug: "virginia-herbert",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Santina",
    lastName: "Hernandez",
    title: "Administrative Assistant A DM-Hematology/Oncology",
    slug: "santina-hernandez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jennifer",
    lastName: "Herold",
    title:
      " Administrative Coordinator for Capital Giving Engagement Strategy AVP for Principal Gifts",
    slug: "jennifer-herold",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Michael J",
    lastName: "Herring",
    title: "Dispatcher Escort",
    slug: "michael-j-herring",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jannah",
    lastName: "Herring",
    title:
      " Information Technology Support Specialist B VPUL Computing Services",
    slug: "jannah-herring",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Zachary",
    lastName: "Herrmann",
    title: "Executive Director, Center for Professional Learning Education",
    slug: "zachary-herrmann",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jacqueline A.",
    lastName: "Herron",
    title: "Administrative Coordinator, Orthodontics Orthodontics",
    slug: "jacqueline-a-herron",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kathleen P.",
    lastName: "Hertkorn",
    title:
      " Sr. Executive Dir. of Development, ACC, Penn Medicine Penn Medicine Development",
    slug: "kathleen-p-hertkorn",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kya L",
    lastName: "Hertz",
    title:
      " Associate Director C, Academic Affairs, Community Engagement SM-DN-Office of Inclusion and Diversity",
    slug: "kya-l-hertz",
    dei: true,
    category: "Academic",
  },
  {
    firstName: "Marie E",
    lastName: "Hess",
    title: "Administrative Coordinator Oral Medicine",
    slug: "marie-e-hess",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Amy M",
    lastName: "Hess",
    title: "Director of Marketing Wharton Executive Education",
    slug: "amy-m-hess",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Peter J.",
    lastName: "Heverin",
    title: "Director MAGPI",
    slug: "peter-j-heverin",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "DR BARBARA L",
    lastName: "HEWITT",
    title: "EXECUTIVE DIRECTOR CAREER SVCS",
    slug: "dr-barbara-l-hewitt",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Claire",
    lastName: "Hewitt",
    title: "Director of Operations, Track & Field/Penn Relays Penn Relays",
    slug: "claire-hewitt",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Saida",
    lastName: "Heywood",
    title: "MSW Practicum Education, Associate Director Masters of Social Work",
    slug: "saida-heywood",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Michelle D",
    lastName: "Hickman",
    title:
      " Associate Director of Finance Planning and Administration ISC Finance and HR",
    slug: "michelle-d-hickman",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Beth A.",
    lastName: "Hicks",
    title:
      " Information Technology Manager Senior ISC-Applications & Information Services",
    slug: "beth-a-hicks",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Caitlin",
    lastName: "Hier",
    title: "Coordinator, Program Professional and Liberal Education (PLE)",
    slug: "caitlin-hier",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "WILMA HELENE",
    lastName: "HIGGINBOTHAM",
    title:
      " Financial Administrative Coordinator, Penn Medicine Penn Medicine Development",
    slug: "wilma-helene-higginbotham",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Sean",
    lastName: "Higgins",
    title: "National Human Resources Manager Benefits",
    slug: "sean-higgins",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Kathleen M",
    lastName: "Higgins",
    title: "Pennant Records Director Financial Systems",
    slug: "kathleen-m-higgins",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Karen M",
    lastName: "Higgins",
    title: "Operations Manager Penn Procurement Services",
    slug: "karen-m-higgins",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Crystal A",
    lastName: "High",
    title:
      " Senior Disbursement Specialist - Greenphire Program Procurement Services",
    slug: "crystal-a-high",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Erica J",
    lastName: "Hildenbrand",
    title: "Assistant Chief of Staff Penn Athletics & Recreation",
    slug: "erica-j-hildenbrand",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Roshell",
    lastName: "Hill",
    title: "Administrative Coordinator General University EB Pool",
    slug: "roshell-hill",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Pearette A.",
    lastName: "Hill",
    title: "TECHNICAL SYSTEMS SUPPORT SPECIALIST Institutional Review Board",
    slug: "pearette-a-hill",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Adrienne M",
    lastName: "Hill",
    title: "ADMINISTRATIVE ASSISTANT President's Office",
    slug: "adrienne-m-hill",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "John",
    lastName: "Hinchman",
    title:
      " Manager C, Student Services, Graduate Programs Historic Preservation",
    slug: "john-hinchman",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Mark",
    lastName: "Hing",
    title: "Maintenance Coordinator Transportation",
    slug: "mark-hing",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Matthew Spencer",
    lastName: "Hirsh",
    title: "Development Assistant, Penn Medicine Penn Medicine Development",
    slug: "matthew-spencer-hirsh",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Emily G",
    lastName: "Hirshorn",
    title: "Associate Director, School Programs University Museum",
    slug: "emily-g-hirshorn",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mayumi",
    lastName: "Hirtzel",
    title:
      " Information Technology Project Leader Senior ISC-Tech Services-Network Operations",
    slug: "mayumi-hirtzel",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "LeLe",
    lastName: "Hobbs",
    title:
      " Director, Student Records and Services, Office of the University Registrar Student Registration & Financial Services",
    slug: "lele-hobbs",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Rita Axelroth",
    lastName: "Hodges",
    title:
      " Associate Director, Netter Center Netter Center for Community Partnerships",
    slug: "rita-axelroth-hodges",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Andrew",
    lastName: "Hojnowski",
    title: "Systems Administrator Senior ISC-Tech Services-Network Operations",
    slug: "andrew-hojnowski",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Rachel",
    lastName: "Hoke",
    title:
      " JR00070092 Associate Director, Technology and Pedagogy Center for Excellence in Teaching, Learning and Innovation",
    slug: "rachel-hoke",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jane F",
    lastName: "Holahan",
    title:
      " Director E, Student Services Weingarten Learning Resource Center Operations",
    slug: "jane-f-holahan",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Carlton , II",
    lastName: "Holmes",
    title:
      " Information Technology Project Leader Wharton Computing and Instructional Technology (WCIT)",
    slug: "carlton-ii-holmes",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "CHRISTINE D",
    lastName: "HOLMES",
    title: "Staff Assistant C General University EB Pool",
    slug: "christine-d-holmes",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alexander",
    lastName: "Holmes",
    title:
      " Associate Director D, Student Services, Advising MBA Career Management",
    slug: "alexander-holmes",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Albert",
    lastName: "Holtsclaw",
    title: "Database Administrator Senior ISC-Tech Services-Network Operations",
    slug: "albert-holtsclaw",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kathryn",
    lastName: "Homa",
    title: "Director, Penn Travel Programs Procurement Services",
    slug: "kathryn-homa",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Thomas Tok-Young",
    lastName: "Hong",
    title: "Artistic Director and Conductor Music",
    slug: "thomas-tok-young-hong",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Amy R.",
    lastName: "Hooper",
    title:
      " Director of Compliance and Training, Student Registration & Financial Services Student Registration & Financial Services",
    slug: "amy-r-hooper",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Lily",
    lastName: "Hoot",
    title:
      " Program Manager and Social Media Outreach for the Warren Center Department of Computer and Information Science",
    slug: "lily-hoot",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Sara M.",
    lastName: "Hoover",
    title:
      " Associate Director C, Arts and Media, Communications and Marketing Undergraduate Division",
    slug: "sara-m-hoover",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Lauren L",
    lastName: "Hoover",
    title:
      " Associate Director for Admissions and Financial Aid Weitzman School of Design Admissions and Financial Aid",
    slug: "lauren-l-hoover",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Michele",
    lastName: "Horgan",
    title: "Associate Director D, Business and Finance SM-DN-Business Office",
    slug: "michele-horgan",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Robert Eugene",
    lastName: "Hormann",
    title:
      " Associate Director, Technology Licensing Penn Center for Innovation",
    slug: "robert-eugene-hormann",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kate",
    lastName: "Hornberger",
    title:
      " Director B, Arts and Media, Communications and Marketing Wharton Executive Education (Operations)",
    slug: "kate-hornberger",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Timothy H.",
    lastName: "Horning",
    title: "Librarian B University Archives",
    slug: "timothy-h-horning",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Ben",
    lastName: "Hornung",
    title:
      " Information Technology Support Specialist Senior Information Technology Services",
    slug: "ben-hornung",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Tina A.",
    lastName: "Horowitz",
    title: "Admin Coord Health Care",
    slug: "tina-a-horowitz",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Christopher Peter",
    lastName: "Horrocks",
    title: "IT MANAGER, CAMPUS CARD SERVICES Business Services",
    slug: "christopher-peter-horrocks",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Sharon Xiaoyun",
    lastName: "Hou",
    title:
      " Director D, Student Services, Executive Education Wharton Executive Education (Custom)",
    slug: "sharon-xiaoyun-hou",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Valerie D",
    lastName: "Houck",
    title: "Administrative Coordinator External Affairs",
    slug: "valerie-d-houck",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Rebecca",
    lastName: "Houk",
    title: "Business Manager, Fiscal Operations SDM Deans Office",
    slug: "rebecca-houk",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Ily",
    lastName: "Houston",
    title:
      " Office Manager, Wharton Communications Program Wharton Communications Unit",
    slug: "ily-houston",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Courtney M.",
    lastName: "Houtsma",
    title:
      " Director of Development SM-DN-Penn Center for Health, Devices and Technology",
    slug: "courtney-m-houtsma",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "RUBEN",
    lastName: "HOVHANNISYAN",
    title: "Manager, QC Cloning & Characterization SM-DN-Research",
    slug: "ruben-hovhannisyan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Umi H.",
    lastName: "Howard",
    title: "Senior Director Leadership Program",
    slug: "umi-h-howard",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Monique S.",
    lastName: "Howard",
    title:
      " Director D, Academic Affairs, Academic Administration Center for Global Women's Health in the School of Nursing",
    slug: "monique-s-howard",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Lia",
    lastName: "Howard",
    title: "Fellows Director Stavros Niarchos Foundation Paideia Program",
    slug: "lia-howard",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jacqueline",
    lastName: "Howard",
    title:
      " Director of Custom Programs - Wharton Online Executive Education Online",
    slug: "jacqueline-howard",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Cheryl L",
    lastName: "Howard",
    title: "Affiliation: Staff",
    slug: "cheryl-l-howard",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Charles L",
    lastName: "Howard",
    title: "University Chaplain Office of the Chaplain",
    slug: "charles-l-howard",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ricardo O.",
    lastName: "Howell",
    title:
      " Associate Director and Assistant Dean for Academic Affairs The College",
    slug: "ricardo-o-howell",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Rasheeda",
    lastName: "Hubert",
    title:
      " Admin Coordinator, Academic Advisor- Organizational Dynamics LPS Administration",
    slug: "rasheeda-hubert",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Pernot",
    lastName: "Hudson",
    title: "Exhibitions Coordinator Fine Arts",
    slug: "pernot-hudson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Bea",
    lastName: "Huff Hunter",
    title: "Communications Specialist Museum Development",
    slug: "bea-huff-hunter",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "MIKE",
    lastName: "HUGEL",
    title: "Senior Executive Director University of Pennsylvania Health System",
    slug: "mike-hugel",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Benjamin J.",
    lastName: "Hughes",
    title: "Grants Coordinator, Teaching, Learning, and Leadership Education",
    slug: "benjamin-j-hughes",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Karen E.",
    lastName: "Hughey",
    title: "PAYROLL ADMINISTRATOR FRES ACCTG & PAYROLL",
    slug: "karen-e-hughey",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Maria",
    lastName: "Huitron De Romero",
    title: "Services Assistant A New Bolton Center",
    slug: "maria-huitron-de-romero",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Zachary R",
    lastName: "Humenik",
    title: "Director B, Student Services, Online Learning Online Learning",
    slug: "zachary-r-humenik",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Johanna",
    lastName: "Humphrey",
    title:
      " Director of Digital Communications Marketing and Communications - DARMAX",
    slug: "johanna-humphrey",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Irene D",
    lastName: "Hung",
    title:
      " Administrative Director Center for Health Outcomes and Policy Research",
    slug: "irene-d-hung",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sandra Maro",
    lastName: "Hunt",
    title:
      " Managing Director, Wharton ESG Environmental, Social and Governance (ESG) Analytics Lab",
    slug: "sandra-maro-hunt",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "DR LYNNE A",
    lastName: "HUNTER",
    title: "Associate Provost for Administration Office of the Provost",
    slug: "dr-lynne-a-hunter",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "EJ",
    lastName: "Hunter",
    title: "Administrative Coordinator Pathobiology",
    slug: "ej-hunter",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "DOROTHY A",
    lastName: "HUNTER",
    title: "Manager D, Research CB-Cancer Biology",
    slug: "dorothy-a-hunter",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Christa",
    lastName: "Hunter",
    title: "Director of Career Services, OSS Education",
    slug: "christa-hunter",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Lauren",
    lastName: "Hurray",
    title:
      " Managing Director Jacobs Levy Equity Management Center for Quantitative Financial Research",
    slug: "lauren-hurray",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Leslie",
    lastName: "Hurtig",
    title:
      " Vice Dean of Administration Weitzman School of Design Dean's Office",
    slug: "leslie-hurtig",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jay",
    lastName: "Hurtt",
    title:
      " Systems Administrator B Wharton Computing and Instructional Technology (WCIT)",
    slug: "jay-hurtt",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Vincent",
    lastName: "Hurtubise",
    title: "SYST PROG SR SAS COMP SAS COMPUTING",
    slug: "vincent-hurtubise",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Zehra",
    lastName: "Husikic",
    title: "Associate Director B, Business and Finance Wharton Finance Pillar",
    slug: "zehra-husikic",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "AMEY A",
    lastName: "HUTCHINS",
    title: "MSS CATALOGING LIBRARIAN SCHOENBERG INSTITUTE FOR MS STUDIES",
    slug: "amey-a-hutchins",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Adam",
    lastName: "Hutler",
    title: "Associate Registrar, Museum University Museum",
    slug: "adam-hutler",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rebecca A",
    lastName: "Huxta",
    title: "Director of Public Health Prevention, Education, and Promotion",
    slug: "rebecca-a-huxta",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mary",
    lastName: "Hyde",
    title: "Cataloging Librarian Cataloging & Metadata",
    slug: "mary-hyde",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Erick S.",
    lastName: "Hyde",
    title:
      " University Connection Counseling Specialist English Language Program",
    slug: "erick-s-hyde",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Shawn",
    lastName: "Hyla",
    title: "Information Technology Manager University Museum",
    slug: "shawn-hyla",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "CHRIS",
    lastName: "HYSON",
    title: "SR. HEALTH AND WELLNESS SPECIALIST Benefits",
    slug: "chris-hyson",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Chris",
    lastName: "Hyzer",
    title: "Application Architect ISC Identity and Access Management",
    slug: "chris-hyzer",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "William",
    lastName: "Iamurri",
    title: "Dispatcher Escort",
    slug: "william-iamurri",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "David",
    lastName: "Iapalucci",
    title: "TECHNOLOGY SOLUTIONS AND SUPPORT MGR Admissions",
    slug: "david-iapalucci",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Tammer",
    lastName: "Ibrahim",
    title: "Information Technology Technical Director RA-Radiology",
    slug: "tammer-ibrahim",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Amrou",
    lastName: "Ibrahim",
    title:
      " Associate Director C, Academic Affairs, Academic Center Student Disability Services Office",
    slug: "amrou-ibrahim",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Ann",
    lastName: "Idichandy",
    title:
      " Program Manager, Executive Education Wharton Executive Education (Open Enrollment)",
    slug: "ann-idichandy",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Crissy",
    lastName: "Iglesias",
    title: "Sr. Associate Director Admissions",
    slug: "crissy-iglesias",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Nicholas",
    lastName: "Igo",
    title:
      " Associate Director of Operations and New Initiatives Office of Academic Innovation",
    slug: "nicholas-igo",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "WILLIAM A, IV",
    lastName: "IHLENFELD",
    title:
      " Director of Information Technology Penn Medicine Academic Computing Services",
    slug: "william-a-iv-ihlenfeld",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jacqueline Elizabeth",
    lastName: "Ihnacik",
    title: "Grant and Contract Finance Administrator Research Services",
    slug: "jacqueline-elizabeth-ihnacik",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Alex",
    lastName: "Ing",
    title: "Editor A University Communications",
    slug: "alex-ing",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Stephanie",
    lastName: "Ingenito",
    title: "Director C, Business and Finance FINANCE AND ADMINISTRATION",
    slug: "stephanie-ingenito",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "CLAIRE M",
    lastName: "INGULLI",
    title: "Coordinator, Undergraduate Program Psychology Dept.",
    slug: "claire-m-ingulli",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Meg",
    lastName: "Insall",
    title: "ISC OPS SYST SUPPORT SPEC ISC SEO",
    slug: "meg-insall",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Miles A.",
    lastName: "Inserra",
    title: "Administrative Assistant B Wharton San Francisco",
    slug: "miles-a-inserra",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tom",
    lastName: "Interrante",
    title: "Sales Director WXPN",
    slug: "tom-interrante",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Andrew",
    lastName: "Ioli",
    title:
      " Senior Information Technology Project Leader Nursing Office of Information Services",
    slug: "andrew-ioli",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Monica",
    lastName: "Ionescu",
    title: "Director of Data Science Wharton Graduate Division",
    slug: "monica-ionescu",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kaitlin",
    lastName: "Irvine",
    title: "Assistant Director of Advising Services and Academic Support COL",
    slug: "kaitlin-irvine",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Diamond",
    lastName: "Irwin",
    title: "Communications Specialist Senior Central Administration",
    slug: "diamond-irwin",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "David W.",
    lastName: "Ishmael",
    title: "Executive Director Financial Systems & Training",
    slug: "david-w-ishmael",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Dimitri M",
    lastName: "Islam",
    title: "Associate Director for Student Affairs Student Affairs",
    slug: "dimitri-m-islam",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Colleen",
    lastName: "Itani",
    title:
      " Associate Director C, Academic Affairs TM-Institute for Translational Medicine and Therapeutics",
    slug: "colleen-itani",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Christopher",
    lastName: "Iwane",
    title:
      " IT Support Specialist Sr Wharton Computing and Instructional Technology (WCIT)",
    slug: "christopher-iwane",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Lorin K.",
    lastName: "Jackson",
    title: "Assistant Director, Holman Biotech Commons Holman Biotech Commons",
    slug: "lorin-k-jackson",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "David",
    lastName: "Jackson",
    title:
      " Information Technology Manager Senior ISC-Tech Services-Network Operations",
    slug: "david-jackson",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "JOSEPH K",
    lastName: "JACKSON",
    title: "Administrative Coordinator Graduate School of Education",
    slug: "joseph-k-jackson",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Dashawn M",
    lastName: "Jackson",
    title: "Operations Team Lead, Operations Space and Events Management",
    slug: "dashawn-m-jackson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Darlene A",
    lastName: "Jackson",
    title: "Administrative Coordinator History of Art",
    slug: "darlene-a-jackson",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kyhawnia",
    lastName: "Jackson-Pinckney",
    title: "Administrative Assistant Procurement Services",
    slug: "kyhawnia-jackson-pinckney",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rebecca",
    lastName: "Jacob",
    title:
      " Administrative Coordinator Graphic Support Office of the University Architect",
    slug: "rebecca-jacob",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Melanie A",
    lastName: "Jacob Roberts",
    title:
      " Intellectual Property Compliance Manager Penn Center for Innovation",
    slug: "melanie-a-jacob-roberts",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Donna M",
    lastName: "Jacobs",
    title: "IT SR DIRECTOR ISC-Technology Services Infrastructure Operations",
    slug: "donna-m-jacobs",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Madeleine C",
    lastName: "Jacobs",
    title: "Associate Director Admissions",
    slug: "madeleine-c-jacobs",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Charlotte E",
    lastName: "Jacobs",
    title: "Director, Independent School Teaching Residency Program Education",
    slug: "charlotte-e-jacobs",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Luisa Klemm",
    lastName: "Jacobsen",
    title: "Director of Events Annenberg School for Communication",
    slug: "luisa-klemm-jacobsen",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Scott",
    lastName: "Jacobson",
    title:
      " Information Technology Technical Director Wharton Computing and Instructional Technology (WCIT)",
    slug: "scott-jacobson",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Michael",
    lastName: "Jaeger",
    title: "IT/AV SUPPORT SPECIALIST ISC-CLIENT SERVICES-HIREIT",
    slug: "michael-jaeger",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Waged",
    lastName: "Jafer",
    title: "Deputy Ombuds Ombudsman",
    slug: "waged-jafer",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alan",
    lastName: "Jaffe",
    title: "Assignment Editor, FactCheck.org Annenberg Public Policy Center",
    slug: "alan-jaffe",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Manisha",
    lastName: "Jain",
    title:
      " Associate Director D, Student Services, Advising MBA Career Management",
    slug: "manisha-jain",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Emily",
    lastName: "Jakimowicz",
    title:
      " Assistant Athletic Director, Marketing and Digital Strategy DRIA Marketing",
    slug: "emily-jakimowicz",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Patricia S.",
    lastName: "James",
    title: "Business Administrator B Wharton Marketing, Centers & WBL",
    slug: "patricia-s-james",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "DR PATRICK E.",
    lastName: "JAMIESON",
    title: "DIRECTOR AHRCI/APPC",
    slug: "dr-patrick-e-jamieson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Elizabeth A",
    lastName: "Jamieson",
    title:
      " Director of Events and Guest Services Annenberg Center for Performing Arts",
    slug: "elizabeth-a-jamieson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Catalina",
    lastName: "Jaramillo",
    title: "Staff Writer Annenberg Public Policy Center",
    slug: "catalina-jaramillo",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Dr. R. Michael",
    lastName: "Jarvis",
    title: "APPLICATION DEVELOPER Physics and Astronomy",
    slug: "dr-r-michael-jarvis",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Alexander",
    lastName: "Jarymovych",
    title:
      " Information Technology Director Weitzman School of Design Computing Center",
    slug: "alexander-jarymovych",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Stuart",
    lastName: "Jasper",
    title: "Director, Finance & Administration Admissions",
    slug: "stuart-jasper",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Donna M",
    lastName: "Jastrzebski",
    title: "Disbursement Representative Procurement Services",
    slug: "donna-m-jastrzebski",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Erin M.",
    lastName: "Jayyusi",
    title: "Internal Auditor Senior Audit and Privacy",
    slug: "erin-m-jayyusi",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Michee",
    lastName: "Jean Pierre",
    title: "IT Support Specialist, Sr. Information Technology Services",
    slug: "michee-jean-pierre",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jennifer C.",
    lastName: "Jefferis",
    title:
      " Assistant Director of Annual & Special Gifts, Penn Medicine Penn Medicine Development",
    slug: "jennifer-c-jefferis",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Chanda",
    lastName: "Jefferson",
    title:
      " Director of Community Engagement and Outreach, Office of Diversity, Equity, and Inclusion School of Engineering & Applied Science",
    slug: "chanda-jefferson",
    dei: true,
    category: "Communications",
  },
  {
    firstName: "CHRISTOPHER H",
    lastName: "JEFFREY",
    title: "Executive Director, Penn Chemistry Chemistry",
    slug: "christopher-h-jeffrey",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Robert",
    lastName: "Jenkins",
    title: "Academic Counselor Penn First Plus",
    slug: "robert-jenkins",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Adelia D",
    lastName: "Jenkins",
    title:
      " Executive Director, Actionable Intelligence for Social Policy Actionable Intelligence for Social Policy",
    slug: "adelia-d-jenkins",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Wendy M",
    lastName: "Jensen",
    title: "Administrative Assistant Fox Leadership International",
    slug: "wendy-m-jensen",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Laurie",
    lastName: "Jensen",
    title: "Associate Director Penn Abroad",
    slug: "laurie-jensen",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Roger Alberto",
    lastName: "Jerez",
    title: "Assistant Director of Structured Sports Club Sports",
    slug: "roger-alberto-jerez",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Lauren E.",
    lastName: "Jerla",
    title: "Admissions Coordinator Nursing Academic Affairs",
    slug: "lauren-e-jerla",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "MICHELLE T",
    lastName: "JESTER",
    title: "Senior Executive Assistant ASC",
    slug: "michelle-t-jester",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "William",
    lastName: "Jester",
    title:
      " Windows Systems Administrator Computing and Educational Technology Services",
    slug: "william-jester",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Yunye",
    lastName: "Jiang",
    title: "Application Developer Senior Penn Wharton Budget Model",
    slug: "yunye-jiang",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Joanna Marie",
    lastName: "Jimenez",
    title:
      " Clinic Manager, Department of Oral and Maxillofacial Surgery/Pharmocolgy Oral Surgery and Pharmacology",
    slug: "joanna-marie-jimenez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Elizabeth Nan",
    lastName: "Johnson",
    title:
      " Managing Director, Wharton Neuroscience Initiative Wharton Neuroscience Initiative",
    slug: "elizabeth-nan-johnson",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Tyeisha L.",
    lastName: "Johnson",
    title:
      " Student Accounts Assistant Student Registration & Financial Services",
    slug: "tyeisha-l-johnson",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Shalaya",
    lastName: "Johnson",
    title: "Administrative Assistant B CHAS House Deans",
    slug: "shalaya-johnson",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Sarah Jayne",
    lastName: "Johnson",
    title:
      " Associate Director for Case Management and Outreach, Student Intervention Services Office of Student Intervention Services",
    slug: "sarah-jayne-johnson",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "RENEE",
    lastName: "JOHNSON",
    title: "Grants Coordinator B PY-Physiology",
    slug: "renee-johnson",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Patricia",
    lastName: "Johnson",
    title: "Executive Assistant SM-DN-Vice Dean of Finance and Operations",
    slug: "patricia-johnson",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Mekhi K.",
    lastName: "Johnson",
    title: "Senior Director, Stewardship Communications Central Development",
    slug: "mekhi-k-johnson",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Marcus",
    lastName: "Johnson",
    title: "Information Technology Support Specialist Senior SASC-Computing",
    slug: "marcus-johnson",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Keisha N",
    lastName: "Johnson",
    title: "DIRECTOR, PENNKIPP Equity and Access Programs",
    slug: "keisha-n-johnson",
    dei: true,
    category: "Academic",
  },
  {
    firstName: "Jasmine Renee",
    lastName: "Johnson",
    title:
      " College Mental Health Professional Counseling and Psychological Services",
    slug: "jasmine-renee-johnson",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "James F",
    lastName: "Johnson",
    title: "IT DIRECTOR ISC - Administrative Information Services",
    slug: "james-f-johnson",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Ty",
    lastName: "Johnson",
    title: "Associate Director, UTR Education",
    slug: "ty-johnson",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Addie",
    lastName: "Johnson",
    title:
      " Associate Director, School Financial Operations Wharton Finance and Administration",
    slug: "addie-johnson",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Gregory E.",
    lastName: "Johnson",
    title: "Senior Director, Gift Planning Gift Planning",
    slug: "gregory-e-johnson",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Gregory",
    lastName: "Johnson",
    title: "MANAGING EDITOR University Communications",
    slug: "gregory-johnson",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Donna-Marie",
    lastName: "Johnson",
    title:
      " Assistant Director, Alumni Engagement Annenberg School for Communication",
    slug: "donna-marie-johnson",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Diana A",
    lastName: "Johnson",
    title: "Executive Assistant, Dean's Office Education",
    slug: "diana-a-johnson",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Courtney K",
    lastName: "Johnson",
    title: "Graduate Affairs Advisor - OAS Office of Academic Services",
    slug: "courtney-k-johnson",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Cat",
    lastName: "Johnson",
    title: "Coordinator C Theatre Arts",
    slug: "cat-johnson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "BENJAMIN G, IV",
    lastName: "JOHNSON",
    title: "Systems Administrator Financial Systems",
    slug: "benjamin-g-iv-johnson",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Avanti",
    lastName: "Johnson",
    title: "Executive Director of ONR Office of Nursing Research",
    slug: "avanti-johnson",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Albert",
    lastName: "Johnson",
    title: "Human Resources Director HUMAN RESOURCES",
    slug: "albert-johnson",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Allan Gordon",
    lastName: "Johnson",
    title: "Operations Manager Institutional Real Estate",
    slug: "allan-gordon-johnson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sarah",
    lastName: "Johnston",
    title:
      " Assistant University Registrar for Calendars, Classrooms, and Scheduling Student Registration & Financial Services",
    slug: "sarah-johnston",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "ERIC D",
    lastName: "JOHNSTON",
    title: "RES SPEC BIOENGR",
    slug: "eric-d-johnston",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Christiane",
    lastName: "Johnston",
    title: "Sales Representative, WXPN WXPN Surrogate",
    slug: "christiane-johnston",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kaitlin E",
    lastName: "Johnstone",
    title: "Assistant Director of Master in Law MASTER IN LAW",
    slug: "kaitlin-e-johnstone",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Nicholas",
    lastName: "Jonczak",
    title:
      " Information Technology Technical Director Wharton Computing and Instructional Technology (WCIT)",
    slug: "nicholas-jonczak",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Taja",
    lastName: "Jones",
    title:
      " Associate Director of Individual Giving Penn Live Arts Administration",
    slug: "taja-jones",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Stephanie R",
    lastName: "Jones",
    title: "Admin Coord Acad Affairs Coll Dean's Office",
    slug: "stephanie-r-jones",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Samuel",
    lastName: "Jones",
    title: "Director, Strategic Initiatives MBA Career Management",
    slug: "samuel-jones",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sade Iteal",
    lastName: "Jones",
    title: "Manager, ULAR Husbandry ULAR",
    slug: "sade-iteal-jones",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Philip",
    lastName: "Jones",
    title: "ASSOCIATE CURATOR AND KEEPER University Museum",
    slug: "philip-jones",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Monica",
    lastName: "Jones",
    title: "STAFF ASST AFFIRMATIVE ACTION",
    slug: "monica-jones",
    dei: true,
    category: "Human Resources",
  },
  {
    firstName: "Maria",
    lastName: "Jones",
    title:
      " Administrative Coordinator Operations and Maintenance Administration",
    slug: "maria-jones",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jennifer D.",
    lastName: "Jones",
    title: "Administrative Coordinator Business Economics and Public Policy",
    slug: "jennifer-d-jones",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Christina M",
    lastName: "Jones",
    title:
      " Director B, Arts and Media, Communications and Marketing University Museum",
    slug: "christina-m-jones",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Adam T.L.",
    lastName: "Jones",
    title:
      " Tech Audio Visual C Wharton Computing and Instructional Technology (WCIT)",
    slug: "adam-t-l-jones",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Adara",
    lastName: "Jones",
    title: "Academic Coordinator Music",
    slug: "adara-jones",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Tatiana",
    lastName: "Jordan",
    title: "Clerk B Instrument Management Service",
    slug: "tatiana-jordan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kyle",
    lastName: "Jordan",
    title: "Course Coordinator Management",
    slug: "kyle-jordan",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Alissa M.",
    lastName: "Jordan",
    title:
      " Associate Director, Center for Experimental Ethnography Anthropology",
    slug: "alissa-m-jordan",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kyle",
    lastName: "Jorstad",
    title: "Assistant General Counsel SM-DN-Research",
    slug: "kyle-jorstad",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Jin-Chen",
    lastName: "Jou",
    title:
      " Information Technology Project Leader Senior ISC-CLIENT SERVICES-HIREIT",
    slug: "jin-chen-jou",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Dana M",
    lastName: "Joyce",
    title:
      " Associate Director of Enrollment and Marketing, Center for Professional Learning Education",
    slug: "dana-m-joyce",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Thomas",
    lastName: "Judice",
    title:
      " Information Technology Support Specialist Senior Information Technology Services",
    slug: "thomas-judice",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Tanya A",
    lastName: "Jung",
    title:
      " Associate Director of Academic Advising & Assistant Dean The College",
    slug: "tanya-a-jung",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kimberly A.",
    lastName: "Junod",
    title: "World Cafe Senior Producer WXPN",
    slug: "kimberly-a-junod",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Ben Edward",
    lastName: "Jurutka",
    title: "Administrative Coordinator East Asian Languages and Culture",
    slug: "ben-edward-jurutka",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Harveen Kalra",
    lastName: "K",
    title: "Affiliation: Staff",
    slug: "harveen-kalra-k",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nicholas",
    lastName: "Kachur",
    title:
      " Application Developer C Computing and Educational Technology Services",
    slug: "nicholas-kachur",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Taylor R",
    lastName: "Kahny",
    title:
      " Senior Instructional Technology Project Leader Wharton Computing and Instructional Technology (WCIT)",
    slug: "taylor-r-kahny",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Eden Elizabeth",
    lastName: "Kainer",
    title: "VISTA Program Manager Netter Center for Community Partnerships",
    slug: "eden-elizabeth-kainer",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kevin M",
    lastName: "Kaiser",
    title:
      " Sr Director, Bus Dev Finance Programs Wharton Executive Education (Operations)",
    slug: "kevin-m-kaiser",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Anne N",
    lastName: "Kalbach",
    title: "Administrative Coordinator Political Science",
    slug: "anne-n-kalbach",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Licinia Lulu B",
    lastName: "Kaliher",
    title:
      " Senior Director of Housing Operations College Houses and Academic Services",
    slug: "licinia-lulu-b-kaliher",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Abigail",
    lastName: "Kalkstein",
    title:
      " Associate Director of Graduate Admissions SEAS Graduate Admissions Programs",
    slug: "abigail-kalkstein",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Stephen G",
    lastName: "Kallao",
    title: "World Cafe Contributing Host WXPN Surrogate",
    slug: "stephen-g-kallao",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Fida A.",
    lastName: "Kanaan",
    title:
      " Director, Program Design and Delivery Operations LIVE Wharton Executive Education (Wharton LIVE)",
    slug: "fida-a-kanaan",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "James P.",
    lastName: "Kane",
    title: "Senior Systems Administrator SASC-Computing",
    slug: "james-p-kane",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Hillary A",
    lastName: "Kane",
    title: "DIRECTOR PHENND",
    slug: "hillary-a-kane",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jennifer",
    lastName: "Kaper",
    title: "Associate Director C External Affairs",
    slug: "jennifer-kaper",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Staci L",
    lastName: "Kaplan",
    title:
      " Program Manager, Data Science Masters Program, CIS Computer and Information Science",
    slug: "staci-l-kaplan",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Michael",
    lastName: "Kaplan",
    title: "COORDINATOR INSTRUCTION LABS Biological Basis of Behavior",
    slug: "michael-kaplan",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jayashree",
    lastName: "Karar",
    title:
      " Translational Science Project Manager CI-Center for Cellular Immunotherapy",
    slug: "jayashree-karar",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Victoria N.",
    lastName: "Karkov",
    title: "Administrative Coordinator Urban Studies",
    slug: "victoria-n-karkov",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rebecca Z",
    lastName: "Kass",
    title:
      " Senior Associate Director, Employer Engagement MBA Career Management",
    slug: "rebecca-z-kass",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Sumandeep",
    lastName: "Kassis",
    title:
      " Application Developer Senior ISC-Applications & Information Services",
    slug: "sumandeep-kassis",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "DR ZIV",
    lastName: "KATALAN",
    title: "Managing Director, Academic Affairs Global Initiatives",
    slug: "dr-ziv-katalan",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Rena",
    lastName: "Katsev",
    title: "Resident COH Extramural Activities",
    slug: "rena-katsev",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Sarah R",
    lastName: "Katz",
    title:
      " Client Relationship Manager ISC-Client Services-Technology Support Services",
    slug: "sarah-r-katz",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "LISA S.",
    lastName: "KATZ",
    title:
      " Director of Leadership Gifts Penn Medicine Development and Alumni Relations",
    slug: "lisa-s-katz",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Allison R",
    lastName: "Katz",
    title: "Associate Director C, Arts and Media, Events Kelly Writers House",
    slug: "allison-r-katz",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jessica",
    lastName: "Katz",
    title: "Head of Alumni Career Management MBA Career Management",
    slug: "jessica-katz",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Daniel",
    lastName: "Katzenberg",
    title: "DEPUTY DIR BUDGET & MGMT ANALYSIS",
    slug: "daniel-katzenberg",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Sam Lev",
    lastName: "Katzman",
    title:
      " Information Technology Support Specialist Senior Information Technology Services",
    slug: "sam-lev-katzman",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "David",
    lastName: "Katzman",
    title:
      " Managing Director, Business and Finance, Investments Office of Investments",
    slug: "david-katzman",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Ira A.",
    lastName: "Kauderwood",
    title: "ASSOC GENERAL COUNSEL",
    slug: "ira-a-kauderwood",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Kamaljit",
    lastName: "Kaur",
    title: "Senior Associate Director, Career Advisor MBA Career Management",
    slug: "kamaljit-kaur",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Dhivya",
    lastName: "Kaushik",
    title:
      " Associate Director B, Student Services, Academic Programs Business Economics and Public Policy",
    slug: "dhivya-kaushik",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Venkateswaran",
    lastName: "Kavachery",
    title:
      " Application Developer Senior ISC-Applications & Information Services",
    slug: "venkateswaran-kavachery",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Joseph Simon",
    lastName: "Kay",
    title: "Director C, Research, Administration Behavior Change for Good",
    slug: "joseph-simon-kay",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Greta JL",
    lastName: "Kazenski",
    title: "Associate Director C, Student Services Penn Abroad",
    slug: "greta-jl-kazenski",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "KRIS",
    lastName: "KEALEY",
    title: "URBAN PARK MANAGER FACIL OPER AND MAINT ADM",
    slug: "kris-kealey",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kerri",
    lastName: "Kearney",
    title: "Dean's Office Manager Law Dean's Office",
    slug: "kerri-kearney",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Jessica",
    lastName: "Keating Whitney",
    title: "Student Services and Programs Manager English Language Program",
    slug: "jessica-keating-whitney",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Dr. THOMAS A",
    lastName: "KECSKEMETHY",
    title:
      " Executive Director American Academy of Political and Social Science",
    slug: "dr-thomas-a-kecskemethy",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jeanette",
    lastName: "Kee-Scott",
    title: "FIN SVCS ADVISOR STUDENT LIFE",
    slug: "jeanette-kee-scott",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Sabria",
    lastName: "Kegler",
    title:
      " Associate Director C, Student Services Student Disability Services Office",
    slug: "sabria-kegler",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Ian A.",
    lastName: "Kelley",
    title:
      " Information Technology Manager Senior ISC-Client Services-Technology Support Services",
    slug: "ian-a-kelley",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Heather",
    lastName: "Kelley",
    title: "Senior Director Biobehavioral and Health Sciences",
    slug: "heather-kelley",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tracy",
    lastName: "Kellmer",
    title: "MARKETING OPERATIONS MANAGER University Press",
    slug: "tracy-kellmer",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Betsy Jane",
    lastName: "Kells",
    title:
      " Information Technology Support Specialist Senior Penn Language Center",
    slug: "betsy-jane-kells",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Teresa A",
    lastName: "Kelly",
    title: "Executive Assistant A ME-Division of Health Policy",
    slug: "teresa-a-kelly",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Robert Paul",
    lastName: "Kelly",
    title: "Parking Attendant Parking",
    slug: "robert-paul-kelly",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Patrick M",
    lastName: "Kelly",
    title: "EDITOR STAT",
    slug: "patrick-m-kelly",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Morgan",
    lastName: "Kelly",
    title: "Student Records Coordinator, SRO Education",
    slug: "morgan-kelly",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Lynn",
    lastName: "Kelly",
    title: "Admin Asst A Pediatric Dentistry",
    slug: "lynn-kelly",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Melissa A",
    lastName: "Kelly",
    title:
      " Deputy Managing Director, Penn Center for Innovation Penn Center for Innovation",
    slug: "melissa-a-kelly",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jaime Robin",
    lastName: "Kelly",
    title:
      " Director, Certificate and Non-Degree Programs College of Liberal and Professional Studies",
    slug: "jaime-robin-kelly",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Eileen",
    lastName: "Kelly",
    title: "Librarian C Preservation",
    slug: "eileen-kelly",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Colleen",
    lastName: "Kelly",
    title:
      " Leadership Annual Giving Officer, Penn Medicine Penn Medicine Development",
    slug: "colleen-kelly",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Braden I",
    lastName: "Kelner",
    title: "Associate Editor, Wharton Magazine Wharton External Affairs",
    slug: "braden-i-kelner",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Lauren M",
    lastName: "Kemp",
    title: "Employer Relationship Manager Office of Academic Services",
    slug: "lauren-m-kemp",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Nicole M",
    lastName: "Kennedy",
    title: "Grants Manager B CV-Cardiovascular Institute",
    slug: "nicole-m-kennedy",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Brendan",
    lastName: "Kennedy",
    title:
      " Career Services Associate Director, Wharton Undergraduate Team Career Services",
    slug: "brendan-kennedy",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Tara",
    lastName: "Kenner",
    title: "Financial Admin Coordinator Operations, Information and Decisions",
    slug: "tara-kenner",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Eileen",
    lastName: "Kenney",
    title:
      " Director of Communications, CTIC Center for Technology Innovation and Competition",
    slug: "eileen-kenney",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Anna",
    lastName: "Kent",
    title:
      " Director, IT Communications Wharton Computing and Instructional Technology (WCIT)",
    slug: "anna-kent",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Joann M",
    lastName: "Kent",
    title:
      " Senior Director, Delivery and Operations Wharton Executive Education",
    slug: "joann-m-kent",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Mary Jo Nancy",
    lastName: "Keough",
    title: "Administrative Coordinator General Counsel",
    slug: "mary-jo-nancy-keough",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Christopher J",
    lastName: "Kern",
    title: "EXECUTIVE DIRECTOR FACIL SVCS PROJ MGMT",
    slug: "christopher-j-kern",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Stacey",
    lastName: "Kerr",
    title: "Major Gifts Officer External Affairs",
    slug: "stacey-kerr",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "DR MICHAEL",
    lastName: "KETNER",
    title: "DIR OF PERFORMANCE MUSIC",
    slug: "dr-michael-ketner",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tatraina",
    lastName: "Ketter",
    title: "Administrative Coordinator Penn Center for Innovation",
    slug: "tatraina-ketter",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Laura Elizabeth",
    lastName: "Ketterer",
    title: "Business Administrator B Wharton Finance and Administration",
    slug: "laura-elizabeth-ketterer",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Lamont Troy",
    lastName: "Keyes",
    title: "COORD MAIL SVCS.,  WH Wharton Operations",
    slug: "lamont-troy-keyes",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Morris",
    lastName: "Khamsaen",
    title:
      " Information Technology Support Specialist Senior IT CLIENT SERVICES",
    slug: "morris-khamsaen",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Fariha",
    lastName: "Khan",
    title:
      " Co-Director of Asian American Studies  Program (ASAM) Asian American Studies Program",
    slug: "fariha-khan",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Hasina A",
    lastName: "Khanom",
    title: "Associate Director Institutional Research & Analysis",
    slug: "hasina-a-khanom",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Shawn",
    lastName: "Kilgallon",
    title:
      " Information Technology Project Leader Wharton Computing and Instructional Technology (WCIT)",
    slug: "shawn-kilgallon",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Karen E",
    lastName: "Kille",
    title:
      " Senior Worklife Consultant Quality of Worklife Programs, Division of Human Resources",
    slug: "karen-e-kille",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Patrick",
    lastName: "Killilee",
    title: "Director Residential Services",
    slug: "patrick-killilee",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Hagana",
    lastName: "Kim",
    title: "Director B, Academic Affairs Legal Education Programs",
    slug: "hagana-kim",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Ah-Young",
    lastName: "Kim",
    title: "Associate Director, Interpretive Programs University Museum",
    slug: "ah-young-kim",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ash",
    lastName: "Kim",
    title: "Coordinator B Kim Program in Korean Studies",
    slug: "ash-kim",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Andrew",
    lastName: "Kimball",
    title: "DevOps and Infrastructure Manager IT CLIENT SERVICES",
    slug: "andrew-kimball",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jamie T",
    lastName: "Kimbrough",
    title: "Administrative Coordinator Institutional Review Board",
    slug: "jamie-t-kimbrough",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Pete",
    lastName: "Kimchuk",
    title: "Academic Coordinator Learning Resources",
    slug: "pete-kimchuk",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Valentine Sky",
    lastName: "King",
    title:
      " Senior Instructional Design Project Leader Wharton Computing and Instructional Technology (WCIT)",
    slug: "valentine-sky-king",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Rich",
    lastName: "King",
    title: "Information Technology Manager SASC-Computing",
    slug: "rich-king",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Richard P",
    lastName: "King",
    title: "SYS TECH LIPPINCOTT LIB",
    slug: "richard-p-king",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sherriann",
    lastName: "King",
    title: "Financial Coordinator Education",
    slug: "sherriann-king",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Bridgette S.",
    lastName: "King",
    title: "Financial Administrative Coordinator Research Services",
    slug: "bridgette-s-king",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jennifer Reynolds",
    lastName: "Kinkead",
    title: "Director of Project Management Project Management",
    slug: "jennifer-reynolds-kinkead",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kate",
    lastName: "Kinney",
    title: "Testing and Programs Manager English Language Program",
    slug: "kate-kinney",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Mary K",
    lastName: "Kinney",
    title: "Administrative Coordinator PSOM, PCI",
    slug: "mary-k-kinney",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Karin M.",
    lastName: "Kinney",
    title: "Associate General Counsel General Counsel",
    slug: "karin-m-kinney",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Gregory J",
    lastName: "Kinter",
    title:
      " Information Technology Support Specialist Senior VPUL Computing Services",
    slug: "gregory-j-kinter",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Margaret",
    lastName: "Kip",
    title:
      " University Registrar Office of the University Registrar, Student Registration & Financial Services",
    slug: "margaret-kip",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Brian Justin",
    lastName: "Kirk",
    title: "IT Support Specialist SAS Computing",
    slug: "brian-justin-kirk",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Wade",
    lastName: "Kirkpatrick",
    title: "Business Administrator B Business Operations",
    slug: "wade-kirkpatrick",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "DR ARTHUR",
    lastName: "KIRON",
    title: "LIBRARIAN CUR JUDAICA COLLECTIONS",
    slug: "dr-arthur-kiron",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "John",
    lastName: "Kiser",
    title: "Information Technology Project Leader Access Services",
    slug: "john-kiser",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Randy",
    lastName: "Kitchens",
    title:
      " Information Technology Project Leader Senior Wharton Computing and Instructional Technology (WCIT)",
    slug: "randy-kitchens",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Christian E",
    lastName: "Kittrell",
    title:
      " Assistant Director of Finance & Administration Penn Live Arts Administration",
    slug: "christian-e-kittrell",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Regan R",
    lastName: "Kladstrup",
    title: "Director Kislak Center, Special Collections Processing",
    slug: "regan-r-kladstrup",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Christopher M",
    lastName: "Klaniecki",
    title:
      " Global Initiatives Program Manager Penn Global International Policy",
    slug: "christopher-m-klaniecki",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Karen M",
    lastName: "Klaverkamp",
    title: "Executive Assistant, Office of the President President's Office",
    slug: "karen-m-klaverkamp",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jeanine Mary",
    lastName: "Kleba",
    title:
      " Information Technology Director ISC-Applications & Information Services",
    slug: "jeanine-mary-kleba",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Domenick",
    lastName: "Klein",
    title: "Senior Regulatory Compliance Officer Research Integrity Office",
    slug: "domenick-klein",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jeff",
    lastName: "Klein",
    title: "Executive Director Wharton Leadership Program",
    slug: "jeff-klein",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jonathan D",
    lastName: "Klein",
    title: "DATABASE ADMINISTRATOR FRES INFO TECH SVCS",
    slug: "jonathan-d-klein",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Michele A",
    lastName: "Klekotka",
    title: "Associate Director C, Academic Affairs Marketing",
    slug: "michele-a-klekotka",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Philip J.",
    lastName: "Kligman",
    title: "Managing Director Investments Office of Investments",
    slug: "philip-j-kligman",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Joseph O",
    lastName: "Klim",
    title: "Assistant Director of Track and Field Men's Track Team",
    slug: "joseph-o-klim",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Lusi",
    lastName: "Klimenko",
    title: "Senior Director, Creative Services SAS Office of Advancement",
    slug: "lusi-klimenko",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Yvonne D",
    lastName: "Kline",
    title: "OFC ADM ASST CHEM",
    slug: "yvonne-d-kline",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Anastasia E",
    lastName: "Kloos",
    title:
      " Associate Director, OE Inbound Sales Wharton Executive Education (Open Enrollment)",
    slug: "anastasia-e-kloos",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alison L",
    lastName: "Knasin",
    title:
      " Research Administrative Coordinator Kleinman Center on Energy Policy",
    slug: "alison-l-knasin",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Beth A.",
    lastName: "Knaul",
    title:
      " Director, Corporate Tax, Compliance and Payroll Comptroller's Office",
    slug: "beth-a-knaul",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Pamela",
    lastName: "Knight",
    title: "Director, Administrative Systems Executive Education",
    slug: "pamela-knight",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Tomea S",
    lastName: "Knight",
    title:
      " Director of Marketing & Communications Professional and Liberal Education (PLE)",
    slug: "tomea-s-knight",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Christopher David M",
    lastName: "Knoecklein",
    title:
      " Assistant Director, Benjamin Franklin Society School and Center Annual Giving",
    slug: "christopher-david-m-knoecklein",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Mark",
    lastName: "Kocent",
    title: "UNIVERSITY ARCHITECT OFFICE OF UNIV ARCHITECT",
    slug: "mark-kocent",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Artemis Velahos",
    lastName: "Koch",
    title:
      " Executive Director, Global Support Services Global Support Services",
    slug: "artemis-velahos-koch",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Stephen R",
    lastName: "Kocher",
    title: "Associate Chaplain The Office of the Chaplain",
    slug: "stephen-r-kocher",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Teresa M",
    lastName: "Kocudak",
    title: "ASSISTANT DIRECTOR Wharton People Analytics",
    slug: "teresa-m-kocudak",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Albi Ibrahim",
    lastName: "Kohen",
    title: "Systems Architect SM-DN External Info Services",
    slug: "albi-ibrahim-kohen",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jake",
    lastName: "Kohler",
    title: "Director of Evaluation and Selection Graduate Admissions",
    slug: "jake-kohler",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Michael",
    lastName: "Kokozos",
    title:
      " Associate Director of Teaching, Learning, and Historical Foundations, ISTR Education",
    slug: "michael-kokozos",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "JEN",
    lastName: "KOLLAR",
    title:
      " Associate Director, Undergraduate Degree Programs College of Liberal & Professional Studies, School of Arts & Sciences",
    slug: "jen-kollar",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Drew",
    lastName: "Koloup",
    title:
      " UACS High School Site Coordinator Netter Center for Community Partnerships",
    slug: "drew-koloup",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Bruce D.",
    lastName: "Konopka",
    title: "Senior Class Giving Director Penn Fund",
    slug: "bruce-d-konopka",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Aneta",
    lastName: "Konova",
    title: "Information Technology Leader HR Information Management",
    slug: "aneta-konova",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Asia",
    lastName: "Kopcsandy",
    title: "Administrative Assistant B Pathobiology",
    slug: "asia-kopcsandy",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Victoria Anne",
    lastName: "Kopesky",
    title:
      " Information Technology Support Specialist B ISC-Client Services-Technology Support Services",
    slug: "victoria-anne-kopesky",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kimberly",
    lastName: "Kopple",
    title: "Director Planning, Design and Construction Vet Dean's Office",
    slug: "kimberly-kopple",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Joseph",
    lastName: "Korcbaum",
    title:
      " Information Technology Architect ISC-Tech Services-Network Operations",
    slug: "joseph-korcbaum",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Andrij",
    lastName: "Korchynsky",
    title: "LAB SERVICES ASSISTANT Chemistry",
    slug: "andrij-korchynsky",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Brian",
    lastName: "Korn",
    title:
      " Information Technology Project Leader Senior SM-DN External Info Services",
    slug: "brian-korn",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Shawn",
    lastName: "Kornhauser",
    title: "Video Producer Annenberg School for Communication",
    slug: "shawn-kornhauser",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Cristina M",
    lastName: "Kossak",
    title: "Associate Head Athletic Trainer Trainer Support",
    slug: "cristina-m-kossak",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Heather Leigh",
    lastName: "Kostick",
    title:
      " Associate Director, Penn Center for Science, Sustainability and the Media Earth and Environmental Science",
    slug: "heather-leigh-kostick",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Brian A",
    lastName: "Kotloff",
    title: "Director, Social Media Wharton Marketing Communications",
    slug: "brian-a-kotloff",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "VARVARA (BARBARA)",
    lastName: "KOUNTOUZI",
    title:
      " Head, Bollinger Digital Fabrication Lab (on sabbatical leave till January 2025) Holman Biotech Commons, Penn Libraries",
    slug: "varvara-barbara-kountouzi",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Dr. Georgia",
    lastName: "Kouzoukas",
    title: "Director of Communications External Affairs",
    slug: "dr-georgia-kouzoukas",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "BARBARA S",
    lastName: "KOVOLSKI",
    title:
      " Sr. Director of University Stewardship Development and Alumni Relations",
    slug: "barbara-s-kovolski",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lily",
    lastName: "Kozak",
    title:
      " Project Manager, Penn Resilience Program Positive Psychology Center",
    slug: "lily-kozak",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Marianne",
    lastName: "Kozakiewicz",
    title: "Administrative Coordinator, Compensation Compensation",
    slug: "marianne-kozakiewicz",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Erica R",
    lastName: "Kozal",
    title:
      " Associate Director D, Business and Finance Finance and Administration",
    slug: "erica-r-kozal",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Svetlana",
    lastName: "Kozik",
    title: "Lab Assitant Biology",
    slug: "svetlana-kozik",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Karu",
    lastName: "Kozuma",
    title: "Vice Provost, University Life Office of University Life",
    slug: "karu-kozuma",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Elise L",
    lastName: "Kraemer",
    title:
      " Assistant Dean for Graduate Programs Law Admissions and Financial Aid",
    slug: "elise-l-kraemer",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Meredith R",
    lastName: "Krain",
    title: "Associate Director, Research Services Research Services",
    slug: "meredith-r-krain",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Brandon L",
    lastName: "Krakowsky",
    title:
      " Director, Data Computing and Research Support Wharton's AI & Analytics Initiative",
    slug: "brandon-l-krakowsky",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Alex",
    lastName: "Kralicek",
    title: "Talent Acquisition Manager Provost's Office",
    slug: "alex-kralicek",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Kate",
    lastName: "Krapf",
    title:
      " MBA Admissions Administrative Operations Coordinator Graduate Admissions",
    slug: "kate-krapf",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Brian",
    lastName: "Kravitz",
    title: "Director of Desktop Computing Services SASC-Computing",
    slug: "brian-kravitz",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "William",
    lastName: "Krebs",
    title:
      " Application Architect Computing and Educational Technology Services",
    slug: "william-krebs",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "ANN",
    lastName: "KREIDLE",
    title: "Project Coordinator Education",
    slug: "ann-kreidle",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Alex S",
    lastName: "Kremstein",
    title:
      " Director of Regional Development - WHEA Major Gifts External Affairs",
    slug: "alex-s-kremstein",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Vicky J",
    lastName: "Kresge",
    title: "IT SUPPORT SPECIALIST, VIDEOCONFERENCING Wharton Computing",
    slug: "vicky-j-kresge",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Meryl",
    lastName: "Krieger",
    title: "Senior Learning Designer Professional and Liberal Education (PLE)",
    slug: "meryl-krieger",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Eric D",
    lastName: "Krilowicz",
    title: "NETWORK SPEC ISC",
    slug: "eric-d-krilowicz",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Allison",
    lastName: "Krisch",
    title: "Assistant Director, Family and Camp Programs University Museum",
    slug: "allison-krisch",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Raghu",
    lastName: "Krishnamoorthy",
    title: "Director, CLO Doctoral Program Education",
    slug: "raghu-krishnamoorthy",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Linda M",
    lastName: "Kromer",
    title: "Associate Director, Off Campus Services Residential Administration",
    slug: "linda-m-kromer",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Gloria G.",
    lastName: "Kropiewnicki",
    title: "DIR ACCTG STUDENT FIN SVCS",
    slug: "gloria-g-kropiewnicki",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Kathy",
    lastName: "Kruger",
    title: "Executive Assistant A Vet Dean's Office",
    slug: "kathy-kruger",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Michael",
    lastName: "Krystopolski",
    title:
      " Associate Director, Corporate & Foundation Relations Penn Medicine Development",
    slug: "michael-krystopolski",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ryan S",
    lastName: "Kubanoff",
    title: "MANAGER, BCRC AND GENERAL CHEMISTRY LABORATORIES Chemistry",
    slug: "ryan-s-kubanoff",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Chris",
    lastName: "Kubik Cedeño",
    title:
      " Director of Graduate Academic Affairs, Admissions & Student Affairs Education",
    slug: "chris-kubik-cede-o",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Bryant",
    lastName: "Kuehner",
    title: "Information Technology Project Leader HR Information Management",
    slug: "bryant-kuehner",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Marissa",
    lastName: "Kuhnel",
    title: "Coordinator, Program Quality of Work Life",
    slug: "marissa-kuhnel",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Seth",
    lastName: "Kulick",
    title:
      " ASSOC DIR, ANNOTATION AND INFORMATION EXTRACTION Linguistic Data Consortium",
    slug: "seth-kulick",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Rachel",
    lastName: "Kuperinsky",
    title:
      " Associate Athletic Director, Compliance/Senior Woman Administrator Compliance/Eligibility",
    slug: "rachel-kuperinsky",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rachel",
    lastName: "Kurlander",
    title: "Associate Director, OGCA Government, Community and Public Affairs",
    slug: "rachel-kurlander",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Kristen",
    lastName: "Kurtis",
    title: "Morning Show Host WXPN Surrogate",
    slug: "kristen-kurtis",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Taryn",
    lastName: "Kutish",
    title: "IT MANAGER SAS",
    slug: "taryn-kutish",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Tony",
    lastName: "Kutovoy",
    title:
      " Information Technology Director Senior Wharton Computing and Instructional Technology (WCIT)",
    slug: "tony-kutovoy",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Cynthia",
    lastName: "Kwan",
    title: "IT OPS Manager School of Medicine, PMACS",
    slug: "cynthia-kwan",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Caroline",
    lastName: "La Rochelle",
    title: "Program Associate Criminology",
    slug: "caroline-la-rochelle",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kate L",
    lastName: "La Spina",
    title: "Coordinator B Environmental Innovations Initiative",
    slug: "kate-l-la-spina",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kayla",
    lastName: "Labrador",
    title: "Procurement Specialist ISC-ACIO-HCP",
    slug: "kayla-labrador",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "JAMES",
    lastName: "LAC",
    title: "Senior Application Developer SASC-Computing",
    slug: "james-lac",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Nathalie D",
    lastName: "Lacarriere",
    title: "Graduate Coordinator Political Science",
    slug: "nathalie-d-lacarriere",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Lesa M",
    lastName: "Lacomchek",
    title: "Manager A, Healthcare Endodontics",
    slug: "lesa-m-lacomchek",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jenny",
    lastName: "Laden",
    title: "Director of Development, ICA ICA in DAR",
    slug: "jenny-laden",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lawrence Oliver",
    lastName: "Ladia",
    title:
      " CUSTOMER CALL CENTER AGENT Operations and Maintenance Administration",
    slug: "lawrence-oliver-ladia",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Brandon Daniel",
    lastName: "Lafving",
    title:
      " Information Technology Project Leader Senior Wharton Computing and Instructional Technology (WCIT)",
    slug: "brandon-daniel-lafving",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Amy",
    lastName: "Lahm",
    title: "Business Administrator A Penn Global Administration",
    slug: "amy-lahm",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Michelle Y",
    lastName: "Lai",
    title:
      " Senior Executive Director of Finance and Administration SM-DN-Business Office",
    slug: "michelle-y-lai",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Theresa G",
    lastName: "Lake",
    title: "Senior Grants Manager Office of Nursing Research",
    slug: "theresa-g-lake",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jaquetta",
    lastName: "Lamar",
    title: "ADMINISTRATIVE COORDINATOR School of Nursing",
    slug: "jaquetta-lamar",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Denise E",
    lastName: "LaMarra",
    title: "Director C, Academic Affairs SM-ED-Vice Dean Education",
    slug: "denise-e-lamarra",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "ROGER",
    lastName: "LAMAY",
    title: "General Manager WXPN-FM",
    slug: "roger-lamay",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alexandra",
    lastName: "Lamay",
    title: "Senior Associate Director Wharton MBA Admissions & Financial Aid",
    slug: "alexandra-lamay",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "SUSAN M",
    lastName: "LAMB",
    title: "Manager C RA-Radiology",
    slug: "susan-m-lamb",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ken",
    lastName: "Lambert Jr",
    title:
      " Associate Director of Research Programs and Communications Vice Provost for Research",
    slug: "ken-lambert-jr",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Alec",
    lastName: "Lamon",
    title: "Executive IT Director Research & Analytics, WCIT",
    slug: "alec-lamon",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Mike",
    lastName: "LaMonaca",
    title:
      " Sr. IT Project Leader Wharton Computing and Instructional Technology (WCIT)",
    slug: "mike-lamonaca",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Janae D",
    lastName: "Lamoureux",
    title: "Director of Advising and Student Affairs Nursing Academic Affairs",
    slug: "janae-d-lamoureux",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Anthony Emmanuel",
    lastName: "Landry",
    title: "Deputy Vice Dean, Academic Affairs, MBA Program MBA Program Office",
    slug: "anthony-emmanuel-landry",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Matthew",
    lastName: "Lane",
    title: "Associate Provost for Finance and Administration Provost's Office",
    slug: "matthew-lane",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Stephen A",
    lastName: "Lang",
    title: "Keeper, Asian Section University Museum",
    slug: "stephen-a-lang",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "BARBARA A",
    lastName: "LANG",
    title: "Residency Coordinator DERMATOLOGY",
    slug: "barbara-a-lang",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jennifer",
    lastName: "Langenberger",
    title: "Chief Operations Officer Penn Center for Innovation",
    slug: "jennifer-langenberger",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Dennis",
    lastName: "Langlois",
    title:
      " Senior Information Technology Director, FRES FRES Information Technology Services",
    slug: "dennis-langlois",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Natalie R",
    lastName: "Larkin-Gilmore",
    title:
      " Associate Director B, Academic Affairs, Academic Center Center for Neuroscience and Society",
    slug: "natalie-r-larkin-gilmore",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Joshua A",
    lastName: "Larosa",
    title:
      " Senior Associate Athletic Director, External Operations DRIA Marketing",
    slug: "joshua-a-larosa",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Emilie CK",
    lastName: "LaRosa",
    title: "Assistant Director, Penn Alumni Lifelong Learning Alumni Relations",
    slug: "emilie-ck-larosa",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jena",
    lastName: "Laske",
    title:
      " Associate Director of Stewardship - Penn Medicine Penn Medicine Development",
    slug: "jena-laske",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Michelle L",
    lastName: "Last",
    title: "ASSISTANT TO THE CHAIR Physics and Astronomy",
    slug: "michelle-l-last",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "DWAUNE",
    lastName: "LATIMER",
    title: "KEEPER AFRICAN SECTION MUSEUM",
    slug: "dwaune-latimer",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kiu",
    lastName: "Lau",
    title: "Business Administrator C Business Operations",
    slug: "kiu-lau",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sherisse",
    lastName: "Laud-Hammond",
    title:
      " Senior Director, Penn Alumni Leadership and Inclusion Alumni Relations",
    slug: "sherisse-laud-hammond",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Marcus",
    lastName: "Lauer",
    title:
      " Systems Administrator C Computing and Educational Technology Services",
    slug: "marcus-lauer",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Julie",
    lastName: "Lav",
    title: "Business Administrator B Wharton Finance and Administration",
    slug: "julie-lav",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Daniel J",
    lastName: "Lavery",
    title:
      " Director, CDKL5 Program of Excellence OD-Center for Orphan Disease Research and Therapy",
    slug: "daniel-j-lavery",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Liza",
    lastName: "Law",
    title:
      " Information Technology Senior Director Wharton Computing and Instructional Technology (WCIT)",
    slug: "liza-law",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Robert M.",
    lastName: "Lawler",
    title: "ASSOCIATE DIRECTOR FINANCE & PLANNING ISC-ACIO-Shared Services",
    slug: "robert-m-lawler",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Robert Steven",
    lastName: "Lawlor",
    title: "Building Operations Supervisor Building Operations",
    slug: "robert-steven-lawlor",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Julian A",
    lastName: "Lawrence",
    title: "Operations Associate, University Life Space and Events Management",
    slug: "julian-a-lawrence",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Rachel",
    lastName: "Lawson",
    title: "Graduate Admissions CRM Specialist Provost's Office",
    slug: "rachel-lawson",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Julia B",
    lastName: "Lawson",
    title: "CONSERVATOR University Museum",
    slug: "julia-b-lawson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Denise Mancuso",
    lastName: "Lay",
    title:
      " DIRECTOR, HUMAN RESOURCES - SEAS SEAS - Office of Budget and Administration",
    slug: "denise-mancuso-lay",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Rose",
    lastName: "Le",
    title: "Administrative Assistant B Marketing",
    slug: "rose-le",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Richard",
    lastName: "Le",
    title: "Affiliation: Staff",
    slug: "richard-le",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Quyen T",
    lastName: "Le",
    title: "Associate Director Wharton Finance and Administration",
    slug: "quyen-t-le",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Nancy Anh Thuy",
    lastName: "Le",
    title: "Information Technology Support Specialist B SASC-Computing",
    slug: "nancy-anh-thuy-le",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Natty",
    lastName: "Leach",
    title:
      " Senior Associate Director, Wharton Undergraduate Advising Career Services",
    slug: "natty-leach",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Marion",
    lastName: "Leary",
    title: "Director of Innovation Office of Nursing Research",
    slug: "marion-leary",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Laken C.",
    lastName: "Leber",
    title: "Assistant Director of Stewardship, DAR Penn Nursing",
    slug: "laken-c-leber",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Yvette T.",
    lastName: "Lebrun",
    title:
      " Student Accounts Assistant Student Registration & Financial Services",
    slug: "yvette-t-lebrun",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Meghan",
    lastName: "LeCates",
    title: "Grant and Contract Finance Administrator Research Services",
    slug: "meghan-lecates",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Julia K.",
    lastName: "Ledwell",
    title: "EVENTS MANAGER PRES",
    slug: "julia-k-ledwell",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Seok",
    lastName: "Lee",
    title: "Coordinator B Kim Program in Korean Studies",
    slug: "seok-lee",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Mary Kathryn",
    lastName: "Lee",
    title:
      " Director of Strategic Communications, Penn Medicine Penn Medicine Development",
    slug: "mary-kathryn-lee",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Michelle C.",
    lastName: "Lee",
    title: "Administrative Coordinator Finance",
    slug: "michelle-c-lee",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Mercedes",
    lastName: "Lee",
    title: "Administrative Coordinator Office of Social Equity and Community",
    slug: "mercedes-lee",
    dei: true,
    category: "Miscellaneous",
  },
  {
    firstName: "Linda J.",
    lastName: "Lee",
    title:
      " Information Technology Technical Director, Instructional Design Wharton Computing and Instructional Technology (WCIT)",
    slug: "linda-j-lee",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "John C",
    lastName: "Lee",
    title:
      " Information Technology Manager Senior ISC-Tech Services-Network Operations",
    slug: "john-c-lee",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Joe C",
    lastName: "Lee",
    title:
      " Senior Director of Learning Innovation and Collaboration, WCIT Wharton Computing and Instructional Technology (WCIT)",
    slug: "joe-c-lee",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jae",
    lastName: "Lee",
    title: "Administrative Coordinator Civic House",
    slug: "jae-lee",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Graci",
    lastName: "Lee",
    title:
      " Administrative Coordinator Boettner Center for Pensions and Retirement Research",
    slug: "graci-lee",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Ezra J",
    lastName: "Lee",
    title: "IT Support Specialist, Information Technology Education",
    slug: "ezra-j-lee",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Christine P.",
    lastName: "Lee",
    title: "Program Manager Education",
    slug: "christine-p-lee",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Charles R",
    lastName: "Lee",
    title: "Services Assistant A New Bolton Center",
    slug: "charles-r-lee",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Chiho",
    lastName: "Lee",
    title:
      " Information Technology Technical Director Wharton Computing and Instructional Technology (WCIT)",
    slug: "chiho-lee",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Martin M",
    lastName: "Leet",
    title: "Administrative Coordinator Chemistry",
    slug: "martin-m-leet",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jen",
    lastName: "Lege",
    title: "Medical Research Librarian Holman Biotech Commons",
    slug: "jen-lege",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jason R",
    lastName: "Lehman",
    title:
      " IT Technical Director Wharton Computing and Instructional Technology (WCIT)",
    slug: "jason-r-lehman",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kimberly A",
    lastName: "Leichner",
    title: "Manager A, Arts and Media University Press",
    slug: "kimberly-a-leichner",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jennifer L",
    lastName: "Leight",
    title: "Executive Assistant A CI-Center for Cellular Immunotherapy",
    slug: "jennifer-l-leight",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Randall K",
    lastName: "Lemaster",
    title:
      " Director of Operations, Men?s and Women?s Fencing / Recreation Operations Supervisor (Limited Servic Men's Fencing Team",
    slug: "randall-k-lemaster",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jamie B",
    lastName: "Lemisch",
    title: "Sr. Associate Director, Wharton Fund External Affairs",
    slug: "jamie-b-lemisch",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Cheryl",
    lastName: "Lemon",
    title:
      " Assistant Director for Student Loans Student Registration & Financial Services",
    slug: "cheryl-lemon",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "DR BRUCE K",
    lastName: "LENTHALL",
    title:
      " Executive Director Center for Excellence in Teaching, Learning and Innovation",
    slug: "dr-bruce-k-lenthall",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "KRISTINA",
    lastName: "LEONARD",
    title: "Senior Associate Director, Space and Scheduling Wharton Operations",
    slug: "kristina-leonard",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Francine Theresa",
    lastName: "Leonetti-Radziszewski",
    title: "Legal Secretary General Counsel",
    slug: "francine-theresa-leonetti-radziszewski",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Ani",
    lastName: "Leonhart",
    title: "IT SUPPORT SPECIAlIST SR SASC-Computing",
    slug: "ani-leonhart",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Victoria",
    lastName: "Leopardi",
    title: "Resident Pathobiology",
    slug: "victoria-leopardi",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "IRMA T",
    lastName: "LERMA",
    title: "Senior Associate Trust Administrator Comptroller's Office",
    slug: "irma-t-lerma",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Carol",
    lastName: "Lerner",
    title: "Director of Finance and Accounting WXPN Surrogate",
    slug: "carol-lerner",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Stephanie G",
    lastName: "Lesage",
    title: "Institutional Review Board Institutional Review Board",
    slug: "stephanie-g-lesage",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jessica G",
    lastName: "Lesovitz",
    title: "Background Check Consultant Recruitment",
    slug: "jessica-g-lesovitz",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "ELI J",
    lastName: "LESSER",
    title: "Executive Director Wharton Global Youth Program",
    slug: "eli-j-lesser",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "MOLLY",
    lastName: "LESTER",
    title: "Associate Director Urban Heritage Project",
    slug: "molly-lester",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Danielle",
    lastName: "Lever",
    title:
      " Senior Advisor, Pre-Health Programs College of Liberal & Professional Studies",
    slug: "danielle-lever",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Neil",
    lastName: "Levin",
    title: "CARDIOVAS",
    slug: "neil-levin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Leslie M.",
    lastName: "Levin",
    title:
      " Assistant Dean of Admissions & Financial Aid Graduate School of Education",
    slug: "leslie-m-levin",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Noah",
    lastName: "Levine",
    title: "Associate Director Theatre Arts Program",
    slug: "noah-levine",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Hoag",
    lastName: "Levins",
    title: "Managing Editor Leonard Davis Institute",
    slug: "hoag-levins",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "STACIA C",
    lastName: "LEVY",
    title: "DIRECTOR, CONTRACT SERVICES RES SVCS",
    slug: "stacia-c-levy",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Joanne H.",
    lastName: "Levy",
    title:
      " DIRECTOR, Student Initiatives, Leonard Davis Institute of Health Economics Associate Director, Wharton Health Care Management PhD Program",
    slug: "joanne-h-levy",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Eugene",
    lastName: "Lew",
    title: "Director of Sound & Music Technology MUSIC",
    slug: "eugene-lew",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Nora E",
    lastName: "Lewis",
    title: "Vice Dean SAS Professional & Liberal Education",
    slug: "nora-e-lewis",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Trevor C",
    lastName: "Lewis",
    title: "Vice President Penn Budget Planning & Analysis",
    slug: "trevor-c-lewis",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Brian P.",
    lastName: "Lewis",
    title: "Director, Data Services Penn Medicine Development",
    slug: "brian-p-lewis",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kimberly M.",
    lastName: "Lewis",
    title: "Legal Secretary General Counsel",
    slug: "kimberly-m-lewis",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Juanita M",
    lastName: "Lewis",
    title: "Administrative Coordinator Project Management",
    slug: "juanita-m-lewis",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "DALILA",
    lastName: "LEWIS",
    title: "Communications Coordinator Law Communications",
    slug: "dalila-lewis",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Chelsea",
    lastName: "Lewis",
    title:
      " Associate Director, Digital Strategies Center for Excellence in Teaching, Learning and Innovation",
    slug: "chelsea-lewis",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Brent",
    lastName: "Lewis",
    title: "University Landscape Architect Office of the University Architect",
    slug: "brent-lewis",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Wing",
    lastName: "Li",
    title:
      " Virtual Desktop Administrator Sr. ISC-Tech Services-Network Operations",
    slug: "wing-li",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Wei",
    lastName: "Li",
    title: "Information Technology Manager Senior Biology",
    slug: "wei-li",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Tong",
    lastName: "Li",
    title: "Database Administrator SR ISC-Tech Services-Network Operations",
    slug: "tong-li",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Stacy",
    lastName: "Li",
    title:
      " Associate Director, Graduate and Professional School Advising Career Services",
    slug: "stacy-li",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jie",
    lastName: "Li",
    title: "APPLICATION DEVELOPER IT CLIENT SERVICES",
    slug: "jie-li",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Man",
    lastName: "Liang",
    title:
      " Associate Director, Technology Licensing Senior Penn Center for Innovation",
    slug: "man-liang",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Ellen",
    lastName: "Liebman",
    title: "Associate Director of Administration The College",
    slug: "ellen-liebman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Willey Y",
    lastName: "Lin",
    title: "Project Manager EIDOS LGBT + Health Initiative",
    slug: "willey-y-lin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Felicia",
    lastName: "Lin",
    title: "Vice Dean of Student Services Student Affairs",
    slug: "felicia-lin",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Lynn Anne",
    lastName: "Linahan",
    title: "Coordinator B SM-DN- Office of Masters Programs",
    slug: "lynn-anne-linahan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jane L",
    lastName: "Lindahl",
    title: "Associate Director for Development and Alumni Relations Education",
    slug: "jane-l-lindahl",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rodney",
    lastName: "Linder",
    title: "Accommodations Specialist Student Disability Services Office",
    slug: "rodney-linder",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Monica",
    lastName: "Lindsay",
    title: "Director, Workers Compensation General University EB Pool",
    slug: "monica-lindsay",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Mark R",
    lastName: "Lindsay",
    title: "Building Administrator Senior Vet Dean's Office",
    slug: "mark-r-lindsay",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Luke",
    lastName: "Ling",
    title:
      " Senior Information Technology Project Leader Wharton Computing and Instructional Technology (WCIT)",
    slug: "luke-ling",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jeanne M",
    lastName: "Linkens",
    title:
      " Education Assistant & Receptionist; Morris Arboretum Arboretum Education",
    slug: "jeanne-m-linkens",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sarah",
    lastName: "Linn",
    title: "Manager B, Student Services, Student Engagement University Museum",
    slug: "sarah-linn",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Darrin J",
    lastName: "Linn",
    title:
      " CONTROLS CENTER SUPERVISOR Operations and Maintenance Administration",
    slug: "darrin-j-linn",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Noel",
    lastName: "Lipki",
    title: "Administrative Coordinator, POLS Education",
    slug: "noel-lipki",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Len",
    lastName: "Lipkin",
    title: "Director IT Service Management ISC-ACIO-Shared Services",
    slug: "len-lipkin",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Lindsay",
    lastName: "Liprando",
    title:
      " Information Technology Support Specialist Senior ISC-Client Services-Technology Support Services",
    slug: "lindsay-liprando",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Brian D",
    lastName: "Lipscomb",
    title:
      " Information Technology Support Specialist B Katz Center for Advanced Judaic Studies",
    slug: "brian-d-lipscomb",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Eric R.",
    lastName: "Litchendorf",
    title:
      " Supervisor, Control Center Operations and Maintenance Administration",
    slug: "eric-r-litchendorf",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Eve Nora Cotterill",
    lastName: "Litt",
    title: "Language Specialist English Language Program",
    slug: "eve-nora-cotterill-litt",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Timothy J",
    lastName: "Litty",
    title:
      " Sr. Building Administrator Krishna P. Singh Center for Nanotechnology",
    slug: "timothy-j-litty",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "STAN",
    lastName: "LIU",
    title:
      " Senior IT Director, Infrastructure and Services Wharton Computing and Instructional Technology (WCIT)",
    slug: "stan-liu",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jen",
    lastName: "Liu",
    title: "Director of Custom Programs Wharton Executive Education (Custom)",
    slug: "jen-liu",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Fernanda D",
    lastName: "Liu",
    title:
      " Director D, Student Services, Executive Education Wharton Executive Education (Open Enrollment)",
    slug: "fernanda-d-liu",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Chiu-Fang",
    lastName: "Liu",
    title:
      " Associate Director E, Business and Finance Office of Nursing Research",
    slug: "chiu-fang-liu",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Richard",
    lastName: "Liuzzi",
    title: "Community Partnerships Liaison Education",
    slug: "richard-liuzzi",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Amanda T",
    lastName: "Lloyd",
    title: "Project Manager Institute for Urban Research",
    slug: "amanda-t-lloyd",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Marc",
    lastName: "Lo",
    title: "Executive Director Penn First Plus",
    slug: "marc-lo",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Daniel",
    lastName: "Lo Mastro",
    title: "Collections Digitization Assistant University Museum",
    slug: "daniel-lo-mastro",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Therese Elise",
    lastName: "Lockard",
    title: "Associate Director D, Student Services Wharton Dean's Office",
    slug: "therese-elise-lockard",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "ROBERT E",
    lastName: "LOCKHART",
    title: "SENIOR EDITOR ACQUISITIONS",
    slug: "robert-e-lockhart",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Cayla M",
    lastName: "Lockwood",
    title: "Designer, Publications Senior Marketing and Communications",
    slug: "cayla-m-lockwood",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Brandon",
    lastName: "Lodriguss",
    title: "Chief Information Officer School of Nursing",
    slug: "brandon-lodriguss",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "William",
    lastName: "Loftus",
    title: "Line Producer WXPN Surrogate",
    slug: "william-loftus",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Thomas Joseph",
    lastName: "Logan",
    title: "Chief of Strategy and Business Officer DM-Gene Therapy Program",
    slug: "thomas-joseph-logan",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Helen C.",
    lastName: "Logan",
    title: "Sr. Administrator of Legal Services GEN COUNSEL",
    slug: "helen-c-logan",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Beth",
    lastName: "Logan",
    title:
      " Information Technology Manager Senior ISC-Client Services-Technology Support Services",
    slug: "beth-logan",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Lisa",
    lastName: "Logue",
    title: "Business Administrator B Admissions",
    slug: "lisa-logue",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Dr Sanjeevini Badigar",
    lastName: "Lokhande",
    title: "Academic Counselor Penn First Plus",
    slug: "dr-sanjeevini-badigar-lokhande",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Paige Knight",
    lastName: "Lombard",
    title:
      " Partnerships Manager for UACS Public Health Initiatives at the School of Arts and Sciences Netter Center for Community Partnerships",
    slug: "paige-knight-lombard",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Daniel",
    lastName: "Loney",
    title: "On Air Host, Producer Marketing and Communications Group",
    slug: "daniel-loney",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Tyree",
    lastName: "Long",
    title: "Central Pool Classroom Administrator Vice Provost Education",
    slug: "tyree-long",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Shelbi R.",
    lastName: "Long",
    title:
      " Associate Athletic Director/Director of Campus Recreation Recreation Administration",
    slug: "shelbi-r-long",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nyia C",
    lastName: "Long",
    title: "Affiliation: Staff",
    slug: "nyia-c-long",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "XIUMEI",
    lastName: "LONG",
    title: "Director Pan-Asian American Community House",
    slug: "xiumei-long",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "John M",
    lastName: "Longwill",
    title: "APPLICATION DEVELOPER University Communications",
    slug: "john-m-longwill",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Vania L.",
    lastName: "Loper",
    title: "Global Programs Manager Penn Abroad",
    slug: "vania-l-loper",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Stacey J",
    lastName: "Lopez",
    title: "Associate Vice President Institutional Research & Analysis",
    slug: "stacey-j-lopez",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Rogelio A.",
    lastName: "Lopez",
    title: "Disbursement Clerk Procurement Services",
    slug: "rogelio-a-lopez",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Carlos",
    lastName: "Lopez",
    title: "ULAR Husbandry Supervisor ULAR",
    slug: "carlos-lopez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Gerald G",
    lastName: "Lopez",
    title:
      " Director of Operations and Business Development / Center Associate Director Singh Center for Nanotechnology",
    slug: "gerald-g-lopez",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Hilary M",
    lastName: "Lopez",
    title: "SR BENEFIT SPEC HUMAN RESOURCES HUMAN RESOURCES",
    slug: "hilary-m-lopez",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Elsie",
    lastName: "Lopez",
    title:
      " Administrative Coordinator La Casa Latina-Penn Center for Hispanic Excellence",
    slug: "elsie-lopez",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Maria Carolina",
    lastName: "Lopez Alejandre",
    title: "Coordinator B Wharton San Francisco",
    slug: "maria-carolina-lopez-alejandre",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rogelio",
    lastName: "Lopez-Ramirez",
    title: "Senior Information Technology Support Specialist Financial Systems",
    slug: "rogelio-lopez-ramirez",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kia",
    lastName: "Lor",
    title:
      " Associate Director of the Greenfield Intercultural Center Greenfield Intercultural Center",
    slug: "kia-lor",
    dei: true,
    category: "Student Life",
  },
  {
    firstName: "Michael",
    lastName: "Loreti",
    title: "Grant and Contract Finance Administrator Research Services",
    slug: "michael-loreti",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Rachel Marie",
    lastName: "Losinno",
    title: "Senior Director Family and Community Health",
    slug: "rachel-marie-losinno",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Cathy Ann",
    lastName: "Lourenco",
    title: "Associate General Counsel General Counsel",
    slug: "cathy-ann-lourenco",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Maleekah",
    lastName: "Love",
    title: "Treasury Services Associate FINANCE AND TREASURY",
    slug: "maleekah-love",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Amanda",
    lastName: "Love",
    title: "Operations Manager, Penn Children's Center Day Care Center",
    slug: "amanda-love",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mary Ellen",
    lastName: "Lovejoy",
    title: "Director, Financial Planning Vet Dean's Office",
    slug: "mary-ellen-lovejoy",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jessica",
    lastName: "Lowenthal",
    title: "Director Kelly Writers House",
    slug: "jessica-lowenthal",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Christine",
    lastName: "Lowery",
    title: "Privacy Investigator, Senior Audit and Privacy",
    slug: "christine-lowery",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Jill L.",
    lastName: "Loxterman",
    title: "Senior Staff Writer, Penn Medicine Penn Medicine Development",
    slug: "jill-l-loxterman",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Rachel",
    lastName: "Lozano",
    title: "Coordinator, School Leadership Program Education",
    slug: "rachel-lozano",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Tiffany",
    lastName: "Lu",
    title: "Assistant Box Office Manager Penn Live Arts Administration",
    slug: "tiffany-lu",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rachael",
    lastName: "Lubberman",
    title: "Program Manager Wharton Executive Education (Custom)",
    slug: "rachael-lubberman",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kelsie Maria",
    lastName: "Lucas",
    title: "Administrative Coordinator External Affairs",
    slug: "kelsie-maria-lucas",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Joseph",
    lastName: "Lucca",
    title: "Associate Director, Research Services Research Services",
    slug: "joseph-lucca",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Andrea",
    lastName: "Luckey",
    title: "Manager, Human Resources Abramson Cancer Center",
    slug: "andrea-luckey",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Vera",
    lastName: "Ludwig",
    title:
      " Director, Human Sexuality and Well-Being Project Positive Psychology Center",
    slug: "vera-ludwig",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Michael A",
    lastName: "Lukasek",
    title: "Managing Director Office of Investments",
    slug: "michael-a-lukasek",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Elizabeth A.",
    lastName: "Lunger",
    title: "Business Coordinator ENGLISH",
    slug: "elizabeth-a-lunger",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "John Robert",
    lastName: "Lusky",
    title: "APPLICATION DEVELOPER University Communications",
    slug: "john-robert-lusky",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Sydney D",
    lastName: "Luu",
    title: "Database Administrator Senior SDM Computing",
    slug: "sydney-d-luu",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kevin D.",
    lastName: "Lux",
    title: "IT SPECIAL PROJECTS LEADER SM-DN External Info Services",
    slug: "kevin-d-lux",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Danielle",
    lastName: "Lybrand",
    title:
      " Administrative Data Coordinator Community Standards and Accountability",
    slug: "danielle-lybrand",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Mark T",
    lastName: "Lycett",
    title: "Director South Asia Regional Center",
    slug: "mark-t-lycett",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Daniel",
    lastName: "Lynam",
    title: "Business Manager B Marketing",
    slug: "daniel-lynam",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Selah Frost",
    lastName: "Lynch",
    title: "Data Science Navigator BI-Institute for Biomedical Informatics",
    slug: "selah-frost-lynch",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Stephen Patrick",
    lastName: "Lynch",
    title: "Direct Response Coordinator, The Penn Fund Penn Fund",
    slug: "stephen-patrick-lynch",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Meaghan R",
    lastName: "Lynch",
    title:
      " Director of Development Research and Analysis, Penn Medicine Penn Medicine Development",
    slug: "meaghan-r-lynch",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jeffrey",
    lastName: "Lyons",
    title:
      " Assistant Director of Web Development College of Liberal & Professional Studies",
    slug: "jeffrey-lyons",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Keith W",
    lastName: "Lyons",
    title: "Assistant Director, Annual Fund Arboretum Development",
    slug: "keith-w-lyons",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kerrin A",
    lastName: "Lyons",
    title: "OFFICE COORDINATOR Civic House",
    slug: "kerrin-a-lyons",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Christina",
    lastName: "Lyons-Maull",
    title: "Clinic Manager, Dept of Orthodontics Orthodontics",
    slug: "christina-lyons-maull",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Linda",
    lastName: "Lyons-Pierce",
    title: "Staff Assistant C ULAR",
    slug: "linda-lyons-pierce",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "LOWELL J",
    lastName: "LYSINGER JR",
    title:
      " IT Support Specialist Sr Wharton Computing and Instructional Technology (WCIT)",
    slug: "lowell-j-lysinger-jr",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Catherine A",
    lastName: "Lyssenko",
    title: "Associate Director Institutional Research & Analysis",
    slug: "catherine-a-lyssenko",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Zoe Moore",
    lastName: "Macdonald",
    title: "Production Coordinator Penn Live Arts Operations",
    slug: "zoe-moore-macdonald",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Megan C.",
    lastName: "Macdonald",
    title:
      " Associate Director C, Student Services, Graduate Programs Education",
    slug: "megan-c-macdonald",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Felice",
    lastName: "Macera",
    title: "PHOTOGRAPHER/WEBMASTER LRSM",
    slug: "felice-macera",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Matthew A.",
    lastName: "Macgregor",
    title: "Disbursement Coordinator University Museum",
    slug: "matthew-a-macgregor",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Michael Lawrence",
    lastName: "Mack",
    title: "Network Specialist Senior ISC-Tech Services-Network Operations",
    slug: "michael-lawrence-mack",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Arthur K.",
    lastName: "Mack",
    title:
      " Associate Director A, Student Services, Student Engagement Management and Technology Program",
    slug: "arthur-k-mack",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Elizabeth R",
    lastName: "Mackenzie",
    title:
      " Program Manager, Counseling and Human Development Programs Education",
    slug: "elizabeth-r-mackenzie",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Cynthia M.",
    lastName: "Macleon",
    title: "Administrative Coordinator General University EB Pool",
    slug: "cynthia-m-macleon",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jane",
    lastName: "MacManus",
    title: "Associate Director B, Arts and Media Penn Live Arts",
    slug: "jane-macmanus",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Hugh , IV",
    lastName: "MacMullan",
    title:
      " Director of Research Computing Wharton Computing and Instructional Technology (WCIT)",
    slug: "hugh-iv-macmullan",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "John",
    lastName: "Macri",
    title: "Coordinator, Program Perry World House",
    slug: "john-macri",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Trainor",
    lastName: "Macrone",
    title:
      " Associate Director C, Substance Use Specialist Prevention, Education, and Promotion",
    slug: "trainor-macrone",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Vanessa",
    lastName: "Madden",
    title:
      " Director of Portfolio Development Palliative and Advanced Illness Research (PAIR) Center",
    slug: "vanessa-madden",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Sophie",
    lastName: "Maddocks",
    title: "Research & Outreach Director Annenberg School for Communication",
    slug: "sophie-maddocks",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Stephanie M",
    lastName: "Magee",
    title: "Director, SP2 Sponsored Research SP2 Finance and Administration",
    slug: "stephanie-m-magee",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Christine",
    lastName: "Maguire",
    title: "ADMIN ASST MBO",
    slug: "christine-maguire",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Dennis F",
    lastName: "Mahoney",
    title: "DIR CEBS PROG WHARTON",
    slug: "dennis-f-mahoney",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Michael W",
    lastName: "Mahoney",
    title: "Director Athletic Communications DRIA",
    slug: "michael-w-mahoney",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Brennan",
    lastName: "Maier",
    title:
      " Associate Director E, Student Services, Graduate Programs Wharton Communications Unit",
    slug: "brennan-maier",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "TROY G",
    lastName: "MAJNERICK",
    title:
      " ASSOCIATE DIRECTOR OFFICE OF  NEW STUDENT ORIENTATION AND ACADEMIC INITIATIVES",
    slug: "troy-g-majnerick",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jequan",
    lastName: "Major",
    title:
      " UACS Sports, Fitness, and Health High School Coordinator Netter Center for Community Partnerships",
    slug: "jequan-major",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Lyndsey",
    lastName: "Makinen",
    title: "Coordinator, Program CB-Cancer Biology",
    slug: "lyndsey-makinen",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Lynn C",
    lastName: "Makowsky",
    title: "The Keith DeVries Keeper Mediterranean Section",
    slug: "lynn-c-makowsky",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Dr. Andrew B.",
    lastName: "Maksymowych",
    title:
      " Associate Director, Biological Safety; Institutional Biosafety Officer Environmental Health and Safety",
    slug: "dr-andrew-b-maksymowych",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Maureen S",
    lastName: "Malachowski",
    title: "Director, Environmental Health and Safety EHRS",
    slug: "maureen-s-malachowski",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Reema",
    lastName: "Malhotra Phillips",
    title: "Associate Director C, Student Services Penn Violence Prevention",
    slug: "reema-malhotra-phillips",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jillian",
    lastName: "Mallon",
    title:
      " Administrative Assistant B General Robotics, Automation, Sensing and Perception Lab",
    slug: "jillian-mallon",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Leon J",
    lastName: "Malloy",
    title: "Associate Director, Finance & Operations Provost's Office",
    slug: "leon-j-malloy",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Hannah",
    lastName: "Malloy",
    title: "Administrative Officer Penn Global",
    slug: "hannah-malloy",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Fiachra",
    lastName: "Malone",
    title: "Business Administrator, Health Care Management Health Care",
    slug: "fiachra-malone",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Maeve",
    lastName: "Malone",
    title: "Administrative Coordinator Religious Studies",
    slug: "maeve-malone",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kate M",
    lastName: "Maloney",
    title:
      " Director, Open Enrollment Programs Wharton Executive Education (Open Enrollment)",
    slug: "kate-m-maloney",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Nicole C",
    lastName: "Maloy",
    title: "Director Social Equity & Community",
    slug: "nicole-c-maloy",
    dei: true,
    category: "Miscellaneous",
  },
  {
    firstName: "SANDRA C",
    lastName: "MANCINI",
    title: "DIRECTOR HUMAN RESOURCES SCH VET MED",
    slug: "sandra-c-mancini",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "SARA C",
    lastName: "MANGAT",
    title: "Associate Director E, Student Services Undergraduate Division",
    slug: "sara-c-mangat",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Danielle",
    lastName: "Mangino",
    title: "Operations Coordinator MBA Career Management",
    slug: "danielle-mangino",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nasrin",
    lastName: "Mani",
    title:
      " Information Technology Support Specialist Senior VPUL Computing Services",
    slug: "nasrin-mani",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jean",
    lastName: "Manna",
    title: "Events Manager Admissions",
    slug: "jean-manna",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Joseph S",
    lastName: "Manning",
    title: "Director of Graduate Aid Student Registration & Financial Services",
    slug: "joseph-s-manning",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Blair G",
    lastName: "Mannix",
    title: "Director of Admissions - Wharton MBA Admissions Admissions",
    slug: "blair-g-mannix",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Shannon H.",
    lastName: "Mannon",
    title: "Associate Director of Operations Urban Institute",
    slug: "shannon-h-mannon",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "ROBERTO L",
    lastName: "MANSFIELD",
    title: "IT Senior Project Leader SAS Computing/IRAD",
    slug: "roberto-l-mansfield",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kenneth",
    lastName: "Mansfield",
    title: "Grants Coordintor B CC-Cancer Center",
    slug: "kenneth-mansfield",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Aliza",
    lastName: "Mansolino",
    title: "Administrative Coordinator Corporate and Foundation Relations",
    slug: "aliza-mansolino",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Michael C",
    lastName: "Mantz",
    title: "Director of Game Operations Game Event Management",
    slug: "michael-c-mantz",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lynn",
    lastName: "Manuel",
    title:
      " Associate Director of Veteran and Military-Affiliated (VAMA) Engagement Student Registration & Financial Services",
    slug: "lynn-manuel",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Prapey",
    lastName: "Mao",
    title: "Venue Sales and Events Coordinator Museum Rentals",
    slug: "prapey-mao",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Anthony C.",
    lastName: "Mapp",
    title:
      " Associate Dean of Finance & Administration, SP2 SP2 Finance and Administration",
    slug: "anthony-c-mapp",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Leslie R.",
    lastName: "Marchant",
    title:
      " Financial Aid Counselor Senior Student Registration & Financial Services",
    slug: "leslie-r-marchant",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Mike",
    lastName: "Marco",
    title: "CONF ASST President's Office",
    slug: "mike-marco",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mary",
    lastName: "Marcopul",
    title: "Lecture Demonstration Coordinator Physics and Astronomy",
    slug: "mary-marcopul",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jessica L",
    lastName: "Marcus",
    title: "Program Manager MindCORE/COGS/CNI/VRC",
    slug: "jessica-l-marcus",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jessica C",
    lastName: "Marcus",
    title: "Director B, Academic Affairs Vet Dean's Office",
    slug: "jessica-c-marcus",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jillian",
    lastName: "Marcussen",
    title: "Chief of Staff Penn Vet",
    slug: "jillian-marcussen",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Gabe",
    lastName: "Marenco-Garcia",
    title:
      " Associate Director B, Student Services, Student Engagement Office of Student Affairs",
    slug: "gabe-marenco-garcia",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Kathleen A.",
    lastName: "Margay",
    title:
      " Associate Director of Development, Penn Medicine Penn Medicine Development",
    slug: "kathleen-a-margay",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lisa",
    lastName: "Margolis",
    title: "Director of Finance and Administration Business Affairs",
    slug: "lisa-margolis",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Kate",
    lastName: "Marini",
    title: "Director, Finance & Planning SP2 Finance and Administration",
    slug: "kate-marini",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Mary R",
    lastName: "Marino",
    title:
      " Wharton Financial Processes Auditor Wharton Finance and Administration",
    slug: "mary-r-marino",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Khattab",
    lastName: "Markar",
    title:
      " Director C, Business and Finance, Investments Office of Investments",
    slug: "khattab-markar",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Genevieve D.",
    lastName: "Markle",
    title:
      " Executive Assistant A TM-Institute for Translational Medicine and Therapeutics",
    slug: "genevieve-d-markle",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Therese J.",
    lastName: "Marmion",
    title:
      " Senior Major Gifts Officer, Penn Medicine Penn Medicine Development",
    slug: "therese-j-marmion",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Michael",
    lastName: "Marolla",
    title:
      " Director of Project and Content Management - Wharton Online Executive Education Online",
    slug: "michael-marolla",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "LaDonna",
    lastName: "Marrero",
    title:
      " Associate Director of Leadership and Reflective Development, Civic House Civic House",
    slug: "ladonna-marrero",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Vincent A.",
    lastName: "Marrocco",
    title: "ASSOC DIRECTOR HORTICULTURE MORRIS ARB",
    slug: "vincent-a-marrocco",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Suzanne B",
    lastName: "Marsh",
    title:
      " Director of Career Counseling & Private Sector Careers Office of Career Strategy",
    slug: "suzanne-b-marsh",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Erin",
    lastName: "Marshall",
    title: "Online Learning and Instructional Design Manager School of Nursing",
    slug: "erin-marshall",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Edward H",
    lastName: "Marshall",
    title:
      " Director C, Academic Affairs, Diversity, Equity, and Inclusion SM-DN-Inclusion, Diversity, Equity, & Learner Exp Prog in Me",
    slug: "edward-h-marshall",
    dei: true,
    category: "Academic",
  },
  {
    firstName: "André",
    lastName: "Marston",
    title:
      " Administrative Coordinator - Cora Ingrum Center for Community and Outreach Office of Diversity, Equity and Inclusion",
    slug: "andr-marston",
    dei: true,
    category: "Miscellaneous",
  },
  {
    firstName: "Dr. SIMON",
    lastName: "MARTIN",
    title: "Curator University Museum",
    slug: "dr-simon-martin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Michael P",
    lastName: "Martin",
    title:
      " Assistant Athletic Director, Athletic Operations Game Event Management",
    slug: "michael-p-martin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Irene",
    lastName: "Martin",
    title: "Instrument Sterilization Attendant A Instrument Management Service",
    slug: "irene-martin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Christopher J.",
    lastName: "Martin",
    title: "IT SUPPORT SPECIALIST SR SASC-Computing",
    slug: "christopher-j-martin",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Chereese Y",
    lastName: "Martin",
    title:
      " Director D, Human Resources, School/ Center FRES Finance and Administration",
    slug: "chereese-y-martin",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Bradley J",
    lastName: "Martin",
    title:
      " Application Developer Wharton Computing and Instructional Technology (WCIT)",
    slug: "bradley-j-martin",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Miguel",
    lastName: "Martinez",
    title: "Senior Associate Director of Projects Wharton Operations",
    slug: "miguel-martinez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Deirdre",
    lastName: "Martinez",
    title: "Executive Director Penn in Washington",
    slug: "deirdre-martinez",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Erika Marie",
    lastName: "Martinez",
    title: "Administrative Coordinator Chemistry",
    slug: "erika-marie-martinez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Annette",
    lastName: "Martinez",
    title:
      " Senior Associate Director of Information Services Penn Medicine Development and Alumni Relations",
    slug: "annette-martinez",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Daijzanaee",
    lastName: "Martinez-Black",
    title: "Immunization Navigator Prevention, Education, and Promotion",
    slug: "daijzanaee-martinez-black",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jessica",
    lastName: "Martucci",
    title: "Librarian C University Archives",
    slug: "jessica-martucci",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Angela M",
    lastName: "Martyak",
    title: "Strategic Sourcing Manager Penn Purchasing Services",
    slug: "angela-m-martyak",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Nicolo",
    lastName: "Marziani",
    title: "Information Technology Support Specialist Senior SASC-Computing",
    slug: "nicolo-marziani",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Gina M",
    lastName: "Marziani",
    title:
      " Director of Financial Operations and Administrative Services COLLEGE HOUSES AND ACADEMIC SERVICES",
    slug: "gina-m-marziani",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Victor",
    lastName: "Masella",
    title: "Information Technology Support Specialist B SDM Computing",
    slug: "victor-masella",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Elisabeth S.",
    lastName: "Maselli",
    title: "Editor B University Press",
    slug: "elisabeth-s-maselli",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Cori A",
    lastName: "Maskart",
    title: "Training Specialist SM-ED-Network/Primary Care",
    slug: "cori-a-maskart",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Alexa",
    lastName: "Mason",
    title: "Program Associate Criminology",
    slug: "alexa-mason",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Chris",
    lastName: "Masotti",
    title: "Vice Dean, Finance & Operations Perelman School of Medicine",
    slug: "chris-masotti",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Nicole",
    lastName: "Massimiani",
    title:
      " Director, Marketing Administration & Project Management Marketing and Communications Group",
    slug: "nicole-massimiani",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Joan",
    lastName: "Massimo",
    title: "Administrative Coordinator Psychology",
    slug: "joan-massimo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Joyce A",
    lastName: "Massott-Burnett",
    title: "Director, Penn Medicine Audit Audit, Compliance and Privacy",
    slug: "joyce-a-massott-burnett",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lilia",
    lastName: "Mataac",
    title:
      " Associate Director D, Business and Finance Katz Center for Advanced Judaic Studies",
    slug: "lilia-mataac",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Alison Poarch",
    lastName: "Matejczyk",
    title: "Senior Executive Director of Development WH EXT AFFRS",
    slug: "alison-poarch-matejczyk",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Varughese",
    lastName: "Mathew",
    title: "Application Developer Senior SDM Computing",
    slug: "varughese-mathew",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "SHIJOY KULATHOOR",
    lastName: "MATHEW",
    title: "Network Architect ISC-Tech Services-Network Operations",
    slug: "shijoy-kulathoor-mathew",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jiju",
    lastName: "Mathew",
    title:
      " MANAGER OF FINANCIAL SERVICES/SERVICE CENTERS SM-DN-Business Office",
    slug: "jiju-mathew",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Crystal Y",
    lastName: "Mathis",
    title: "Coordinator C SM-ED-Continuing Medical Education/Extramural",
    slug: "crystal-y-mathis",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Andrew E",
    lastName: "Mathis",
    title: "SCIENTIFIC ADMINISTRATOR NS-Neuroscience",
    slug: "andrew-e-mathis",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kinjal K",
    lastName: "Mathur",
    title: "Director, Class Giving and Reunion Programs External Affairs",
    slug: "kinjal-k-mathur",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Kyra",
    lastName: "Matin",
    title: "Propagator; Morris Arboretum Horticulture",
    slug: "kyra-matin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jason J.",
    lastName: "Matjasic",
    title: "Information Technology Director Senior SASC-Computing",
    slug: "jason-j-matjasic",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Nicholas",
    lastName: "Matlin",
    title:
      " Program Manager for Engagement and Education Center for High Impact Philanthropy",
    slug: "nicholas-matlin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Carlos",
    lastName: "Mattei-Ramos",
    title: "Project Manager Project Management",
    slug: "carlos-mattei-ramos",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Marie",
    lastName: "Mattera",
    title: "Assistant to the President President's Office",
    slug: "marie-mattera",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Zachary",
    lastName: "Matthew",
    title: "Administrative Coordinator Annenberg School for Communication",
    slug: "zachary-matthew",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Megan S",
    lastName: "Maxwell",
    title:
      " Associate Director D, Student Services, Graduate Programs TM-Institute for Translational Medicine and Therapeutics",
    slug: "megan-s-maxwell",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Lorleen Ann",
    lastName: "Maxwell",
    title: "Assistant Director of Gift Management Gift Management",
    slug: "lorleen-ann-maxwell",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Brittany Nichole",
    lastName: "Maxwell",
    title:
      " Assistant Director of Institutional Events, Penn Medicine Penn Medicine Development",
    slug: "brittany-nichole-maxwell",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Godwin M.",
    lastName: "Mayers",
    title: "RES SPEC PHYSICS",
    slug: "godwin-m-mayers",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alfonso",
    lastName: "Mayers",
    title:
      " Information Technology Support Specialist Senior Information Technology Services",
    slug: "alfonso-mayers",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Andy",
    lastName: "Maynard",
    title: "Associate Director of Data Analytics SAVP University Development",
    slug: "andy-maynard",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Tia",
    lastName: "Mayo",
    title: "Relationship Manager MBA Career Management",
    slug: "tia-mayo",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jessica",
    lastName: "Mazzeo",
    title: "Administrative Coordinator Psychology",
    slug: "jessica-mazzeo",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Mary C",
    lastName: "Mazzola",
    title:
      " ASSOCIATE DEAN, ENROLLMENT & GLOBAL OUTREACH SP2 Enrollment Services",
    slug: "mary-c-mazzola",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Andrea",
    lastName: "Mazzucchi",
    title: "Information Technology Director Linguistic Data Consortium",
    slug: "andrea-mazzucchi",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Anne Lois Feza",
    lastName: "Mbombo",
    title:
      " Business Affairs, Financial Administrative Coordinator Business Affairs",
    slug: "anne-lois-feza-mbombo",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Nicholas",
    lastName: "McAllister",
    title: "Director of Advancement SAS in DAR",
    slug: "nicholas-mcallister",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Patrick Southerland",
    lastName: "McAllister",
    title: "Event Assistant Development Programs",
    slug: "patrick-southerland-mcallister",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Pat",
    lastName: "McAlorum",
    title: "Gift Audit Coordinator- GIFTS ACCNTG & ADMIN TREASURER'S OFFICE",
    slug: "pat-mcalorum",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Megan",
    lastName: "McAnany",
    title:
      " Associate Director, OE Inbound Sales Wharton Executive Education (Open Enrollment)",
    slug: "megan-mcanany",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lisa M",
    lastName: "McBriar",
    title:
      " Information Technology Project Leader Senior ISC-Applications & Information Services",
    slug: "lisa-m-mcbriar",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kelly K.",
    lastName: "McBride",
    title: "Director of Development, Penn Medicine Penn Medicine Development",
    slug: "kelly-k-mcbride",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jo Ellen",
    lastName: "McBride",
    title:
      " Associate Director, Graduate Student Center Graduate Student Center",
    slug: "jo-ellen-mcbride",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "THOMAS M",
    lastName: "MCCAFFERY",
    title: "NETWORK PROJ MGR ISC INFO. SYST. AND COMP., VICE PROVOST",
    slug: "thomas-m-mccaffery",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Laurie",
    lastName: "McCaffrey",
    title: "Director of Strategic Initiatives Office of University Life",
    slug: "laurie-mccaffrey",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Laurie",
    lastName: "Mccall",
    title: "Director Student Performing Arts and Pre-Orientation Programs",
    slug: "laurie-mccall",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Stephen",
    lastName: "McCann",
    title: "Administrative Assistant B Penn Center for Innovation",
    slug: "stephen-mccann",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jennifer",
    lastName: "Mccart",
    title:
      " Associate Director D, Administration & Finance Williams Hall Business Administration Services",
    slug: "jennifer-mccart",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Matt",
    lastName: "McCarthy",
    title:
      " Associate Director, Stewardship and Engagement Strategy AVP for Principal Gifts",
    slug: "matt-mccarthy",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Katie",
    lastName: "McCarthy",
    title: "Senior Philanthropy Officer AVP for Principal Gifts",
    slug: "katie-mccarthy",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Beth A",
    lastName: "McCarthy",
    title: "Administrative Coordinator Marketing",
    slug: "beth-a-mccarthy",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Phil",
    lastName: "McClelland",
    title: "Classroom Technology Manager Annenberg School for Communication",
    slug: "phil-mcclelland",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Shona",
    lastName: "McClelland",
    title:
      " Director, Open Enrollment Programs Wharton Executive Education (Open Enrollment)",
    slug: "shona-mcclelland",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Elena",
    lastName: "Mcclelland",
    title: "Director D, Human Resources Quality of Work Life",
    slug: "elena-mcclelland",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Domonique Michelle",
    lastName: "McClendon",
    title: "Program Manager, Student Life Office of Academic Services",
    slug: "domonique-michelle-mcclendon",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "DENISE M",
    lastName: "MCCOLE",
    title:
      " Information Technology Project Leader Senior General University EB Pool",
    slug: "denise-m-mccole",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Patricia",
    lastName: "McConnell",
    title: "Executive Director, Human Resources SM-DN-Business Office",
    slug: "patricia-mcconnell",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Jeff M",
    lastName: "Mccray",
    title:
      " Director of Internal Loan Program Division of Finance-Finance and Treasury Team",
    slug: "jeff-m-mccray",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "JESSIE",
    lastName: "MCCULLEY",
    title: "Director of Development Penn Medicine Development",
    slug: "jessie-mcculley",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lynn M",
    lastName: "Mccullough",
    title:
      " Adult Nutrition Education Coordinator Netter Center for Community Partnerships",
    slug: "lynn-m-mccullough",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Emily M",
    lastName: "McCully",
    title: "Director of Student Services Weitzman School of Design",
    slug: "emily-m-mccully",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Gwendolyn E",
    lastName: "Mcday",
    title: "Director C, Student Services, Academic Programs Leadership Program",
    slug: "gwendolyn-e-mcday",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Antionnette M",
    lastName: "Mcdermott",
    title:
      " Director of the MBA Wharton Communications Wharton Communications Unit",
    slug: "antionnette-m-mcdermott",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Kathryn P",
    lastName: "Mcdonald",
    title: "House Director CHAS House Deans",
    slug: "kathryn-p-mcdonald",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jessica",
    lastName: "McDonald",
    title: "Science Writer Annenberg Public Policy Center",
    slug: "jessica-mcdonald",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jerry",
    lastName: "McDonnell",
    title:
      " Information Technology Senior Manager ISC-Tech Services-Network Operations",
    slug: "jerry-mcdonnell",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Amanda",
    lastName: "McDonnell",
    title: "HR Business Partner/Generalist DAR Human Resources",
    slug: "amanda-mcdonnell",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "DR NIEL",
    lastName: "MCDOWELL",
    title: "ASSOC DIR OF ACAD ADVISING & ASST. DEAN COLLEGE OF ARTS & SCIENCES",
    slug: "dr-niel-mcdowell",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Terry Maria",
    lastName: "Mceachern",
    title:
      " CUSTOMER CALL CENTER AGENT Operations and Maintenance Administration",
    slug: "terry-maria-mceachern",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Stephen",
    lastName: "Mcelwee",
    title: "Staff Writer  - Stewardship Communications DAR Communications",
    slug: "stephen-mcelwee",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Corrie",
    lastName: "McFarlane",
    title: "Director of Events SEAS Office of the Dean",
    slug: "corrie-mcfarlane",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rachel",
    lastName: "McGarrigle",
    title: "Director, Education Perelman School of Medicine",
    slug: "rachel-mcgarrigle",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Wendy Boyle",
    lastName: "McGeehan",
    title:
      " Senior Director, Open Enrollment, General Management Programs Executive Education",
    slug: "wendy-boyle-mcgeehan",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Marissa C.",
    lastName: "McGeehan",
    title: "Associate Director, Research Services Research Services",
    slug: "marissa-c-mcgeehan",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Alison",
    lastName: "McGhie",
    title: "Affiliation: Staff",
    slug: "alison-mcghie",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Molly Jean",
    lastName: "Mcglone",
    title: "Deputy Dean for Undergraduate Education The College",
    slug: "molly-jean-mcglone",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Liam B",
    lastName: "Mcglynn",
    title: "Information Technology Support Specialist A SASC-Computing",
    slug: "liam-b-mcglynn",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "JAMES V",
    lastName: "MCGONIGLE",
    title:
      " Director of Research Support and Development Office of the Vice Provost for Research",
    slug: "james-v-mcgonigle",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jennifer",
    lastName: "McGough",
    title: "Museum Conservator University Museum",
    slug: "jennifer-mcgough",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Billie S.",
    lastName: "McGrane",
    title: "Project Manager Vice Provost Education",
    slug: "billie-s-mcgrane",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jim",
    lastName: "McGuinn",
    title: "Assistant Program Director / On-Air Host WXPN",
    slug: "jim-mcguinn",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Betsy (Elizabeth)",
    lastName: "McGuire",
    title: "Customer Service Coordinator RHS Central Services",
    slug: "betsy-elizabeth-mcguire",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "John P",
    lastName: "Mcinerney",
    title: "Executive Director Sachs Program for Arts Innovation",
    slug: "john-p-mcinerney",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Mia",
    lastName: "Mcintyre",
    title:
      " Assistant Director of Gifts Accounting & Administration Gift Administration",
    slug: "mia-mcintyre",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Rebecca",
    lastName: "McKeaney",
    title: "Associate Director, Marketing DRIA Marketing",
    slug: "rebecca-mckeaney",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "William",
    lastName: "McKeaney",
    title:
      " EXEC DIRECTOR OF FINANCE, ACCTG & ANALYSIS Institutional Real Estate",
    slug: "william-mckeaney",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Hannah",
    lastName: "Mckeever",
    title:
      " Financial Aid Counselor Senior Student Registration & Financial Services",
    slug: "hannah-mckeever",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Colin S.",
    lastName: "Mckelvie",
    title: "Director Design & Construction",
    slug: "colin-s-mckelvie",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Molly",
    lastName: "McKenzie",
    title: "Director of Regional Development External Affairs",
    slug: "molly-mckenzie",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Marla D",
    lastName: "McKenzie",
    title: "CUSTOMER SRV ASST FACIL OPER AND MAINT ADMIN",
    slug: "marla-d-mckenzie",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "FAYE J.",
    lastName: "McKOY",
    title: "Coordinator Professional and Liberal Education (PLE)",
    slug: "faye-j-mckoy",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Susan C",
    lastName: "Mclaughlin",
    title: "Student Loan Specialist Student Registration & Financial Services",
    slug: "susan-c-mclaughlin",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "MaryKate",
    lastName: "McLaughlin",
    title: "Dean's Office Coordinator SDM Deans Office",
    slug: "marykate-mclaughlin",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jacqueline",
    lastName: "McLaughlin",
    title:
      " Director, Pre-Health Post-Baccalaureate Programs LPS-School of Arts and Sciences",
    slug: "jacqueline-mclaughlin",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Colin",
    lastName: "McLaughlin",
    title: "Application Developer Office of Academic Innovation",
    slug: "colin-mclaughlin",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Joseph",
    lastName: "Mclaurin",
    title: "Manager Enterprise Command Center",
    slug: "joseph-mclaurin",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Andrew R",
    lastName: "Mcmackin",
    title: "Systems Administrator C Linguistic Data Consortium",
    slug: "andrew-r-mcmackin",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Chad J",
    lastName: "Mcmahon",
    title: "ELECTRICAL OPERATIONS SUPERVISOR FACIL OPER AND MAINT ADMIN",
    slug: "chad-j-mcmahon",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ari",
    lastName: "McManus",
    title: "Administrative Coordinator Physics and Astronomy",
    slug: "ari-mcmanus",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Megan B",
    lastName: "McManus",
    title: "Coordinator, Program Law Dean's Office",
    slug: "megan-b-mcmanus",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Nate",
    lastName: "McManus",
    title: "Coordinator, Program Professional and Liberal Education (PLE)",
    slug: "nate-mcmanus",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Marcella D",
    lastName: "Mcmillan",
    title: "Affiliation: Staff",
    slug: "marcella-d-mcmillan",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Susan",
    lastName: "Mcmullen",
    title:
      " Director, Alumni and Student Engagement Jay H. Baker Retailing Center",
    slug: "susan-mcmullen",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Kathleen",
    lastName: "McMullen",
    title: "Senior Benefits Specialist Benefits",
    slug: "kathleen-mcmullen",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Candace S",
    lastName: "Mcmullen",
    title: "Financial Administrative Coordinator Nursing Finance",
    slug: "candace-s-mcmullen",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Meghan E",
    lastName: "McNally",
    title:
      " Associate Athletic Director / Director of Financial Operations DRIA Administrative Affairs",
    slug: "meghan-e-mcnally",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Michaela Rose",
    lastName: "McNamara",
    title: "Business and Administrative Coordinator Perry World House",
    slug: "michaela-rose-mcnamara",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Elizabeth L",
    lastName: "McNamara",
    title: "Administrative Assistant Office of Research Services",
    slug: "elizabeth-l-mcnamara",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "William M",
    lastName: "McNeil",
    title: "Preventive Maintenance Coordinator FACIL OPER AND MAINT ADMIN",
    slug: "william-m-mcneil",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Bernadette",
    lastName: "Mcnelis",
    title:
      " Associate Dir., Leadership & Strategic Initiatives, Penn Medicine Penn Medicine Development",
    slug: "bernadette-mcnelis",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Scott",
    lastName: "McNulty",
    title:
      " Executive Director, WCIT Communications Strategy Wharton Computing and Instructional Technology (WCIT)",
    slug: "scott-mcnulty",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Olivia M.",
    lastName: "McPherson",
    title: "Associate Director D, Research EIDOS LGBT + Health Initiative",
    slug: "olivia-m-mcpherson",
    dei: true,
    category: "Academic",
  },
  {
    firstName: "Schotland",
    lastName: "McQuade",
    title: "Coordinator, Program Wharton Neuroscience Initiative",
    slug: "schotland-mcquade",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Anna Janeen",
    lastName: "McQuarrie",
    title: "Director Executive Education",
    slug: "anna-janeen-mcquarrie",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Mary",
    lastName: "McQuiston",
    title: "Education Director, Penn Children's Center Day Care Center",
    slug: "mary-mcquiston",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Michelle",
    lastName: "McSorley",
    title:
      " Director, Intellectual Property and Operations Penn Center for Innovation",
    slug: "michelle-mcsorley",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Julia",
    lastName: "Mcwilliams",
    title: "Co-Director, Penn Urban Studies Program Urban Studies",
    slug: "julia-mcwilliams",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Monica",
    lastName: "Mean",
    title: "Financial Administrative Coordinator University Museum",
    slug: "monica-mean",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Lynn Kathryn",
    lastName: "Meaney",
    title:
      " EXEC DIR DECISION SUPPORT & ANALYSIS SCHOOL OF MEDICINE ADMINISTRATION",
    slug: "lynn-kathryn-meaney",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Hermon",
    lastName: "Mebrahtu",
    title: "Director, Finance and Administion Student Wellness",
    slug: "hermon-mebrahtu",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jonathan",
    lastName: "Mech",
    title:
      " Information Technology Support Specialist Wharton Computing and Instructional Technology (WCIT)",
    slug: "jonathan-mech",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Tara A.",
    lastName: "Medeiros",
    title:
      " Director of Communications and Strategic Outreach Perry World House",
    slug: "tara-a-medeiros",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Alejandra",
    lastName: "Medina",
    title: "Space Management Planner Office of the University Architect",
    slug: "alejandra-medina",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Brenda M",
    lastName: "Medley",
    title:
      " Gifts & Records Coordinator, Penn Medicine Penn Medicine Development",
    slug: "brenda-m-medley",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Leslie D",
    lastName: "Medley",
    title: "Executive Assistant A CC-Cancer Center",
    slug: "leslie-d-medley",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tunisia",
    lastName: "Meek",
    title: "Coordinator Program Leadership Program",
    slug: "tunisia-meek",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kali E",
    lastName: "Meeks",
    title:
      " Director of Professional Development & Leadership Weitzman School of Design Dean's Office",
    slug: "kali-e-meeks",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Dan",
    lastName: "Meeks",
    title:
      " Information Technology Support Specialist Senior Office of Residential Computer Support",
    slug: "dan-meeks",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Heather E",
    lastName: "Meier",
    title:
      " Sr. Operations & Relationship Manager Learning Lab, Wharton Computing",
    slug: "heather-e-meier",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Louis",
    lastName: "Meiselman",
    title:
      " Judaica Special Collections Librarian Special Collections Processing Center",
    slug: "louis-meiselman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Dorothy Nicole",
    lastName: "Mejia-Smith",
    title:
      " Senior Associate Director of Development and Communications Penn Medicine Development and Alumni Relations",
    slug: "dorothy-nicole-mejia-smith",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Miles Nathan",
    lastName: "Meline",
    title: "Staff Writer C Leonard Davis Institute",
    slug: "miles-nathan-meline",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "William",
    lastName: "Melleby",
    title: "Director, Fiscal Operations SDM Fiscal Operations",
    slug: "william-melleby",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "TINA",
    lastName: "MELLON",
    title: "Associate Director D, Business and Finance Business Operations",
    slug: "tina-mellon",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "David",
    lastName: "Menchaca",
    title:
      " Information Technology Manager Senior ISC-Tech Services-Network Operations",
    slug: "david-menchaca",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Bingqing",
    lastName: "Meng",
    title:
      " Associate Director for Recruitment and Special Projects, PICCLO International Master of Public Administration",
    slug: "bingqing-meng",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Kathleen",
    lastName: "Menkes",
    title:
      " IT Project Leader, Marketing and Communications Marketing and Communications Group",
    slug: "kathleen-menkes",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Cecilia E",
    lastName: "Mensah-Atoo",
    title: "COORDINATOR MANAGEMENT",
    slug: "cecilia-e-mensah-atoo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "ANGELA D",
    lastName: "MERRITTE MANSARAY",
    title: "Senior Benefits Specialist Benefits",
    slug: "angela-d-merritte-mansaray",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Marcie",
    lastName: "Merz",
    title:
      " Executive Director, Gift Planning & Associate General Counsel Development & Alumni Relations",
    slug: "marcie-merz",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Meredith J",
    lastName: "Methlie",
    title:
      " Administrative Director, Organizational Dynamics LPS Administration",
    slug: "meredith-j-methlie",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Louis",
    lastName: "Metzger",
    title:
      " Director of Information and Management Systems Undergraduate Admissions",
    slug: "louis-metzger",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Julie S",
    lastName: "Meyer",
    title: "Workday Functional Lead Payroll ISC-HCM Operations",
    slug: "julie-s-meyer",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Waffiyah",
    lastName: "Mian",
    title:
      " Senior Director International Development Penn Medicine Development",
    slug: "waffiyah-mian",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Anastasiya",
    lastName: "Miazhevich",
    title: "Center Manager Annenberg School for Communication",
    slug: "anastasiya-miazhevich",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Sherry",
    lastName: "Michael",
    title: "Director Information Security ISC-Information Security",
    slug: "sherry-michael",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Adam P",
    lastName: "Michaels",
    title:
      " Associate Dean and Chief of Staff, Wharton Office of the Dean Wharton Dean's Office",
    slug: "adam-p-michaels",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Desiree",
    lastName: "Micheaux",
    title: "Financial Administrative Coordinator Office of Student Affairs",
    slug: "desiree-micheaux",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Carolyn",
    lastName: "Michel",
    title: "Coordinator B Vet Dean's Office",
    slug: "carolyn-michel",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Bradley",
    lastName: "Midgett",
    title: "COMP ELEC TECH SAS COMP",
    slug: "bradley-midgett",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Tyler A",
    lastName: "Migliaccio",
    title: "Raw Materials Management Specialist CVPF",
    slug: "tyler-a-migliaccio",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nicole",
    lastName: "Mikanik",
    title:
      " Research Manager, Human Sexuality and Well-Being Project Positive Psychology Center",
    slug: "nicole-mikanik",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kenneth",
    lastName: "Miksitz",
    title: "Network Specialist Senior ISC-Tech Services-Network Operations",
    slug: "kenneth-miksitz",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kaitlin",
    lastName: "Milano",
    title:
      " Assistant Director of Alumni Relations, Penn Medicine Penn Medicine Development",
    slug: "kaitlin-milano",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "BARBARA M",
    lastName: "MILANO",
    title:
      " Director, PEFS Research Services - Post-Award Office of Finance and Administration",
    slug: "barbara-m-milano",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Kerry F",
    lastName: "Milch",
    title:
      " Associate Director B, Student Services, Advising Center for Undergraduate Research",
    slug: "kerry-f-milch",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Gregory",
    lastName: "Milewski",
    title: "Grants Manager B Business Operations",
    slug: "gregory-milewski",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Katie",
    lastName: "Milholin",
    title: "Manager A, Research Leonard Davis Institute",
    slug: "katie-milholin",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Donna M",
    lastName: "Milici",
    title: "IT EXECUTIVE DIRECTOR CLIENT SERVICES ISC-ACIO-Shared Services",
    slug: "donna-m-milici",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Ross",
    lastName: "Miller",
    title:
      " Assistant Director Quattrone Center for the Fair Administration of Justice",
    slug: "ross-miller",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "MAUREEN P",
    lastName: "MILLER",
    title: "Grants Manager B Business Operations",
    slug: "maureen-p-miller",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Monica",
    lastName: "Miller",
    title: "Pipeline Development Research Director External Affairs",
    slug: "monica-miller",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Amy A",
    lastName: "Miller",
    title:
      " Information Technology Technical Director ISC-Applications & Information Services",
    slug: "amy-a-miller",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Michelle R",
    lastName: "Miller",
    title: "Disbursement Clerk Procurement Services",
    slug: "michelle-r-miller",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Ryan",
    lastName: "Miller",
    title: "Director D, Student Services Learning Resources",
    slug: "ryan-miller",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Madison Ann",
    lastName: "Miller",
    title: "Administrative Coordinator Annenberg School for Communication",
    slug: "madison-ann-miller",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Leslie",
    lastName: "Miller",
    title: "Production Coordinator Penn Live Arts Operations",
    slug: "leslie-miller",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lauren S",
    lastName: "Miller",
    title: "ASSOC DIR Pre-Award Administration Office of Research Services",
    slug: "lauren-s-miller",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jacquelyn",
    lastName: "Miller",
    title: "Coordinator B Vet Dean's Office",
    slug: "jacquelyn-miller",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jim",
    lastName: "Miller",
    title:
      " Systems Administrator Senior Wharton Computing and Instructional Technology (WCIT)",
    slug: "jim-miller",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Elias",
    lastName: "Miller",
    title: "Director of Football Operations Football Team",
    slug: "elias-miller",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Carlyn A",
    lastName: "Miller",
    title: "Interim Director of Conferences and Events Events",
    slug: "carlyn-a-miller",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Carolyn",
    lastName: "Miller",
    title: "Associate Director of Development Undergraduate Financial Aid",
    slug: "carolyn-miller",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Amy",
    lastName: "Miller",
    title: "Senior Writer, Penn Medicine Penn Medicine Development",
    slug: "amy-miller",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Amy J.",
    lastName: "Miller",
    title: "Project Manager CTR FOR HEALTH OUTCOMES, NURSING",
    slug: "amy-j-miller",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lisa K",
    lastName: "Millman",
    title: "Senior Managing Director, Principal Giving External Affairs",
    slug: "lisa-k-millman",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Muriel F",
    lastName: "Mills",
    title:
      " Senior Associate Director of International Operations and Board Relations Development International Programs",
    slug: "muriel-f-mills",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mark Edward",
    lastName: "Mills",
    title: "Chief Procurement Officer Penn Purchasing Services",
    slug: "mark-edward-mills",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alexander M",
    lastName: "Milne",
    title: "Associate Director, Sr. IT Project Leader Wharton Online",
    slug: "alexander-m-milne",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Shoshana",
    lastName: "Milovsky",
    title: "Associate Director of Major Gifts INSTITUTIONAL ADVANCEMENT VET",
    slug: "shoshana-milovsky",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "KEVIN Kyung Ha",
    lastName: "MIN",
    title:
      " Systems Administrator Sr Wharton Computing and Instructional Technology (WCIT)",
    slug: "kevin-kyung-ha-min",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Euria",
    lastName: "Min",
    title: "Director, Lipman Family Prize McNulty Leadership Program",
    slug: "euria-min",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Steven",
    lastName: "Minicola",
    title: "Director, Web Communications University Communications",
    slug: "steven-minicola",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Millicent",
    lastName: "Minnick",
    title: "Department Administrator PHYSICS & ASTRONOMY",
    slug: "millicent-minnick",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Chelsea",
    lastName: "Minsky",
    title:
      " College Mental Health Professional Counseling and Psychological Services",
    slug: "chelsea-minsky",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jen",
    lastName: "Mintzer",
    title: "Lauder Travel Manager Lauder Institute",
    slug: "jen-mintzer",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "JACQUELINE M",
    lastName: "MIRAGLIA",
    title: "Business Administrator Penn Center for Innovation",
    slug: "jacqueline-m-miraglia",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Paul B.",
    lastName: "Mischler",
    title:
      " Associate Vice President, Development & Principal Gifts University Development & Alumni Relations",
    slug: "paul-b-mischler",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "James",
    lastName: "Mishinkash",
    title:
      " Assistant Director, Undergraduate Aid Student Registration & Financial Services",
    slug: "james-mishinkash",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Joann",
    lastName: "Mitchell",
    title: "Vice President for Institutional Affairs PRES OFC",
    slug: "joann-mitchell",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Darryl W.",
    lastName: "Mitchell",
    title:
      " Information Technology Support Specialist Senior FRES Information Technology Services",
    slug: "darryl-w-mitchell",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Amanda C.",
    lastName: "Mitchell-Boyask",
    title: "Deputy Director and Chief of Staff Museum Director's Office",
    slug: "amanda-c-mitchell-boyask",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "HELEN",
    lastName: "MITCHELL-SEARS",
    title: "Director Sponsored Programs Education",
    slug: "helen-mitchell-sears",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Rouaa",
    lastName: "Mohamed",
    title: "Affiliation: Staff",
    slug: "rouaa-mohamed",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Bhavana",
    lastName: "Mohanraj",
    title: "Associate Director, Ventures Penn Center for Innovation",
    slug: "bhavana-mohanraj",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Carol L.",
    lastName: "Moll",
    title: "Primary Care Unit Coordinator Restorative Clinic",
    slug: "carol-l-moll",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "CHARLES A",
    lastName: "MOLLI",
    title:
      " Director, Fiscal Operations TM-Institute for Translational Medicine and Therapeutics",
    slug: "charles-a-molli",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Lilach",
    lastName: "Mollick",
    title:
      " Director D, Research, Administration Generative Artificial Intelligence Lab",
    slug: "lilach-mollick",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Catherine A",
    lastName: "Molony",
    title:
      " DIRECTOR MBA Exec Philadelphia  & DIRECTOR MBA Exec Alumni Engagement Wharton School MBA Program for Execuitves",
    slug: "catherine-a-molony",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jaime L",
    lastName: "Molyneux",
    title: "Director International Risk Management Division of Finance",
    slug: "jaime-l-molyneux",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "David C.",
    lastName: "Mongeluzi",
    title: "DIRECTOR CONTRACT & VENDOR MANAGEMENT ISC-ACIO-Shared Services",
    slug: "david-c-mongeluzi",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Christine",
    lastName: "Monigle",
    title: "Administrative Assistant B Chemistry",
    slug: "christine-monigle",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Ramon",
    lastName: "Monras-Sender",
    title: "Associate Registrar, Student Records Office Education",
    slug: "ramon-monras-sender",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Catherine",
    lastName: "Monsky",
    title:
      " Senior Associate Director of Development for Undergraduate Financial Aid Development",
    slug: "catherine-monsky",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "ANTHONY W",
    lastName: "MONTAGNA",
    title: "Associate Director E, Research GE-Genetics",
    slug: "anthony-w-montagna",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Erica Ahlin",
    lastName: "Montemayor",
    title:
      " Associate Director D, Student Services, Academic Programs Leadership Program",
    slug: "erica-ahlin-montemayor",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kim L.",
    lastName: "Montgomery",
    title: "Senior Accounting Clerk Comptroller",
    slug: "kim-l-montgomery",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Amy L.",
    lastName: "Montgomery",
    title: "Managing Director Urban Institute",
    slug: "amy-l-montgomery",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jeannie",
    lastName: "Moon",
    title: "LAW FIRM COORDINATOR GENERAL COUNSEL",
    slug: "jeannie-moon",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Sean",
    lastName: "Moore",
    title: "Accountant C FRES Finance and Administration",
    slug: "sean-moore",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Shelby J.",
    lastName: "Moore",
    title:
      " Coordinator, Undergraduate Financial Aid Undergraduate Financial Aid Development",
    slug: "shelby-j-moore",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Sarah Gutekunst",
    lastName: "Moore",
    title:
      " Associate Director C, Student Services, Academic Programs Real Estate",
    slug: "sarah-gutekunst-moore",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Scott Michael",
    lastName: "Moore",
    title: "China Program Director Penn Global International Policy",
    slug: "scott-michael-moore",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Melissa C",
    lastName: "Moore",
    title: "Coordinator, Program Professional and Liberal Education (PLE)",
    slug: "melissa-c-moore",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jennifer L",
    lastName: "Moore",
    title: "Staff Writer, Communications Education",
    slug: "jennifer-l-moore",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Elizabeth S",
    lastName: "Moore",
    title: "Director of Research Emergency Medicine",
    slug: "elizabeth-s-moore",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Shannon A",
    lastName: "Moore-Shabazz",
    title:
      " Associate Director, Curriculum & Registrations - Academic Affairs SDM Academic Affairs",
    slug: "shannon-a-moore-shabazz",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Joseph R.",
    lastName: "Moorman",
    title:
      " Director B, Academic Affairs, Academic Partnerships Professional and Liberal Education (PLE)",
    slug: "joseph-r-moorman",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kathleen A",
    lastName: "Moosbrugger",
    title: "RES SPECIALIST GENETICS",
    slug: "kathleen-a-moosbrugger",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Julia",
    lastName: "Morales",
    title: "Development and Finance Coordinator Kelly Writer's House",
    slug: "julia-morales",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Margot",
    lastName: "Morales",
    title:
      " Leadership Development Specialist SM-DN Organizational Effectiveness",
    slug: "margot-morales",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Alexandra",
    lastName: "Morales",
    title: "Associate Director Regional Clubs Alumni Relations",
    slug: "alexandra-morales",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Emmanuel",
    lastName: "Morales-Negron",
    title: "TECHNICAL INSTRUMENTATION Physics and Astronomy",
    slug: "emmanuel-morales-negron",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Zachary Andres",
    lastName: "Moran",
    title: "Administrative Assistant B CHAS House Deans",
    slug: "zachary-andres-moran",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Robert P.",
    lastName: "Mordeczko",
    title: "Researcher Advancement Research & Analysis",
    slug: "robert-p-mordeczko",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Valeria",
    lastName: "Moreira",
    title: "House Coordinator CHAS House Deans",
    slug: "valeria-moreira",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Lesley",
    lastName: "Moreno",
    title: "Administrative Assistant B CB-Cancer Biology",
    slug: "lesley-moreno",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Valerie J",
    lastName: "Morgan",
    title: "Information Assurance Project Leader ISC-Information Security",
    slug: "valerie-j-morgan",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Maureen",
    lastName: "Morgan",
    title:
      " AVP Prospect Development and Strategic Planning University of Pennsylvania",
    slug: "maureen-morgan",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Lucy",
    lastName: "Morgan",
    title: "Systems Administrator B SDM Admissions",
    slug: "lucy-morgan",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "LEE ANN",
    lastName: "MORGAN",
    title: "Finance Manager Penn Center for Innovation",
    slug: "lee-ann-morgan",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Kaden",
    lastName: "Moriarty",
    title:
      " College Mental Health Professional Counseling and Psychological Services",
    slug: "kaden-moriarty",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Bruce L.",
    lastName: "Morrell",
    title: "Train Master, Morris Arboretum Horticulture",
    slug: "bruce-l-morrell",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Beth Truta",
    lastName: "Morris",
    title: "Director of the Wharton Fund External Affairs",
    slug: "beth-truta-morris",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Rich",
    lastName: "Morris",
    title:
      " Director, Regional Business Development Wharton Executive Education (Custom)",
    slug: "rich-morris",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "NINA",
    lastName: "MORRIS",
    title: "Sustainability Director Office of the University Architect",
    slug: "nina-morris",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jane",
    lastName: "Morris",
    title: "Director C, Academic Affairs Center for Undergraduate Research",
    slug: "jane-morris",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jessica E",
    lastName: "Morris",
    title:
      " Director, Instructional Design & Technology Center for Excellence in Teaching, Learning and Innovation",
    slug: "jessica-e-morris",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Pamela Anne",
    lastName: "Morris Olshefski",
    title: "Plant Records Manager; Morris Arboretum Botany",
    slug: "pamela-anne-morris-olshefski",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sean Michael",
    lastName: "Morrison",
    title: "Lab Safety Specialist Environmental Health and Safety",
    slug: "sean-michael-morrison",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Emily G",
    lastName: "Morton-Owens",
    title:
      " Associate Vice Provost of Technology and Digital Initiatives IT CLIENT SERVICES",
    slug: "emily-g-morton-owens",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Marcus A",
    lastName: "Moseley",
    title: "Information Technology Manager DRIA Technical Support",
    slug: "marcus-a-moseley",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jerome P",
    lastName: "Moses",
    title: "Business Administrator C Leadership Program",
    slug: "jerome-p-moses",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sandra",
    lastName: "Mosgo",
    title: "Assistant Director Operations & Planning",
    slug: "sandra-mosgo",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "John P",
    lastName: "Mosley",
    title:
      " Assistant Director, Penn Alumni Regional Clubs Program Alumni Relations",
    slug: "john-p-mosley",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Amanda M",
    lastName: "Mott",
    title:
      " Director B, Arts and Media, Communications and Marketing University Communications",
    slug: "amanda-m-mott",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Rebecca A",
    lastName: "Moulder",
    title:
      " SENIOR INSTRUCTIONAL DESIGN PROJECT LEADER IDEA Courseware Team, Wharton Computing",
    slug: "rebecca-a-moulder",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Rabih",
    lastName: "Moussawi",
    title: "Research Director Wharton Research Data Services (WRDS)",
    slug: "rabih-moussawi",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "James A",
    lastName: "Mowery",
    title: "HEALTH PHYSICS TECH EHRS",
    slug: "james-a-mowery",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rhonda",
    lastName: "Moyer",
    title: "Director, Corporate and Foundation Relations Penn Arts & Sciences",
    slug: "rhonda-moyer",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kristin E.",
    lastName: "Mozzachio",
    title: "Student Financial Aid Coordinator Vet Student Affairs",
    slug: "kristin-e-mozzachio",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Malik",
    lastName: "Muhammad",
    title:
      " Director for Interpersonal Development and Engagement Office of University Life",
    slug: "malik-muhammad",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Sunil Vashu",
    lastName: "Mulani",
    title: "Managing Director Office of Investments",
    slug: "sunil-vashu-mulani",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Robert J",
    lastName: "Mulcahy",
    title: "Grant and Contract Finance Administrator Research Services",
    slug: "robert-j-mulcahy",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Andrea E",
    lastName: "Mules",
    title:
      " Business Manager, Wharton Executive Education Wharton Finance & Administration",
    slug: "andrea-e-mules",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Amy K",
    lastName: "Mulhern",
    title:
      " Associate Director, Graduate and Professional School Advising Career Services",
    slug: "amy-k-mulhern",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "John J",
    lastName: "Mulhern III",
    title: "Principal Technology Advisor Technology Services",
    slug: "john-j-mulhern-iii",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Masila waMuema",
    lastName: "Muli",
    title:
      " Audio Visual Support Specialist Computing and Educational Technology Services",
    slug: "masila-wamuema-muli",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "DR. JULIE M.",
    lastName: "MULLANY",
    title:
      " College Mental Health Professional Counseling and Psychological Services",
    slug: "dr-julie-m-mullany",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Ralph",
    lastName: "Mullen",
    title: "Manager B, Arts and Media Student Affairs",
    slug: "ralph-mullen",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Sarah",
    lastName: "Mullen",
    title: "Senior Director, Deputy Dean's Office Wharton Dean's Office",
    slug: "sarah-mullen",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Christine",
    lastName: "Muller",
    title:
      " Associate Director of Undergraduate Studies History and Sociology of Science",
    slug: "christine-muller",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Joe",
    lastName: "Mullock",
    title: "TRAINING SPECIALIST SR FIN TRAINING",
    slug: "joe-mullock",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Dayna B",
    lastName: "Muniz",
    title: "Associate Director, Coalition for Educational Equity Education",
    slug: "dayna-b-muniz",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "ANN E",
    lastName: "MURAMATSU",
    title: "Associate Director D, Research Biobehavioral and Health Sciences",
    slug: "ann-e-muramatsu",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Laura Marie",
    lastName: "Murillo",
    title:
      " Manager, Marketing and Administration CB-PENN CENTER FOR GENOME INTEGRITY",
    slug: "laura-marie-murillo",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Thomas H",
    lastName: "Murphy",
    title: "Senior Vice President and CIO Information Systems and Computing",
    slug: "thomas-h-murphy",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Patrick H.",
    lastName: "Murphy",
    title: "Lab Coordinator Restorative Clinic",
    slug: "patrick-h-murphy",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Allysia A.",
    lastName: "Murphy",
    title:
      " Information Technology Project Leader Wharton Computing and Instructional Technology (WCIT)",
    slug: "allysia-a-murphy",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Nicole",
    lastName: "Murphy",
    title: "Grants Coordinator B CB-Cancer Biology",
    slug: "nicole-murphy",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Timothy",
    lastName: "Murphy",
    title: "Information Technology Support Specialist B SASC-Computing",
    slug: "timothy-murphy",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jennifer",
    lastName: "Murphy",
    title:
      " Director of Strategic Initiatives and Leadership Support Undergraduate Division",
    slug: "jennifer-murphy",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jakob C.",
    lastName: "Murphy",
    title:
      " Administrative Coordinator Center for Excellence in Teaching, Learning and Innovation",
    slug: "jakob-c-murphy",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Debra P",
    lastName: "Murphy",
    title:
      " Creative Marketing Manager College of Liberal and Professional Studies",
    slug: "debra-p-murphy",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Daniel Scott",
    lastName: "Murphy",
    title: "NETWORK SPECIALIST  SR ISC-Tech Services-Enterprise Command Center",
    slug: "daniel-scott-murphy",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Austin S",
    lastName: "Murphy",
    title:
      " Information Technology Manager ISC-Tech Services-Network Operations",
    slug: "austin-s-murphy",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Tye",
    lastName: "Murray",
    title: "Financial Administrative Coordinator DAR Operations",
    slug: "tye-murray",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Gidget M",
    lastName: "Murray",
    title: "Director B, Student Services Wharton Doctoral Program Office",
    slug: "gidget-m-murray",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Phoebe Fisher",
    lastName: "Murray",
    title: "Academic Coordinator Earth and Environmental Science",
    slug: "phoebe-fisher-murray",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Joseph L.",
    lastName: "Murtaugh",
    title: "Gardening Aide Horticulture",
    slug: "joseph-l-murtaugh",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Katie",
    lastName: "Murtha",
    title:
      " Senior Director of Development for Development and Alumni Relations Museum in DAR",
    slug: "katie-murtha",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Dr. Chris",
    lastName: "Mustazza",
    title: "Director of Academic Computing School of Arts & Sciences",
    slug: "dr-chris-mustazza",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Ravi K",
    lastName: "Musuku",
    title:
      " Application Developer Senior ISC-Applications & Information Services",
    slug: "ravi-k-musuku",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Melissa R",
    lastName: "Muth",
    title: "IT SECURITY ARCHITECT ISC-Information Security",
    slug: "melissa-r-muth",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Laura C",
    lastName: "Mutis",
    title: "Coordinator C Criminology",
    slug: "laura-c-mutis",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Amy S",
    lastName: "Myers",
    title: "ASSOC DIRECTOR Wharton MBA Program for Executives",
    slug: "amy-s-myers",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Laney",
    lastName: "Myers",
    title:
      " Administrative and Communications Coordinator Historic Preservation",
    slug: "laney-myers",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "SARAH A",
    lastName: "NACHMIAS",
    title:
      " Computer Allocations Program Manager (working title) SASC-Computing",
    slug: "sarah-a-nachmias",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Alicja",
    lastName: "Nalewajek",
    title: "Associate Director, Cost Studies Research Services",
    slug: "alicja-nalewajek",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Ms. Amma",
    lastName: "Napier",
    title: "Senior Training & Development Consultant Learning & Education",
    slug: "ms-amma-napier",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Roopashree",
    lastName: "Narasimhaiah",
    title:
      " Senior Associate Vice President, Development and Alumni Relations SAVP University Capital Giving",
    slug: "roopashree-narasimhaiah",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Michele",
    lastName: "Narcavage",
    title:
      " Information Technology Project Leader Senior ISC-Tech Services-Network Operations",
    slug: "michele-narcavage",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Nicole",
    lastName: "Nardone",
    title:
      " College Mental Health Professional Counseling and Psychological Services",
    slug: "nicole-nardone",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Medha",
    lastName: "Narvekar",
    title: "Vice President and University Secretary President's Center",
    slug: "medha-narvekar",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Lora J",
    lastName: "Nase",
    title:
      " Manager, Administration & Finance - Market St. Business Office SAS Business Operations",
    slug: "lora-j-nase",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Joann",
    lastName: "Nasino",
    title:
      " Administrative Assistant B Fraternity and Sorority Affairs-Operating",
    slug: "joann-nasino",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Radha",
    lastName: "Natarajan",
    title: "Assistant Head Of Stacks II Access Services",
    slug: "radha-natarajan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Amy",
    lastName: "Natello",
    title:
      " Assistant Director of Data Quality and Analytics SAS Office of Advancement",
    slug: "amy-natello",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Andrea J",
    lastName: "Naughton",
    title:
      " Assistant Director New Student Orientation and Academic Initiatives",
    slug: "andrea-j-naughton",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Kimberly",
    lastName: "Navarro",
    title:
      " Program Manager, Wharton Global Youth Wharton Global Youth Programs",
    slug: "kimberly-navarro",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Maya",
    lastName: "Nayak",
    title: "Deputy Chief Privacy Officer Audit and Privacy",
    slug: "maya-nayak",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Andrew E",
    lastName: "Nealis",
    title: "Graphic Designer SAS Office of Advancement",
    slug: "andrew-e-nealis",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Joseph P",
    lastName: "Nebistinsky",
    title:
      " Senior Associate Director for Engagement Mack Institute for Innovation Management",
    slug: "joseph-p-nebistinsky",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Michael R",
    lastName: "Neborak",
    title: "Commuter Benefits Program Manager Business Services Division",
    slug: "michael-r-neborak",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Chadd S.",
    lastName: "Nedd",
    title:
      " IT SUPPORT SPECIALIST Computing and Educational Technology Services",
    slug: "chadd-s-nedd",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Matthew J.",
    lastName: "Neff",
    title: "Director C, Student Services, Undergraduate Programs Fine Arts",
    slug: "matthew-j-neff",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "RACHELLE R",
    lastName: "NELSON",
    title: "Resource Management Coordinator Cataloging & Metadata",
    slug: "rachelle-r-nelson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kristin E",
    lastName: "Nelson",
    title: "Sr IT Project Leader ISC HireIT",
    slug: "kristin-e-nelson",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Rob",
    lastName: "Nelson",
    title: "EXECUTIVE DIRECTOR Provost's Office",
    slug: "rob-nelson",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Lauren",
    lastName: "Nelson Hyppolite",
    title:
      " Managing Director, Research, Centers and Academic Initiatives Deputy Dean's Office",
    slug: "lauren-nelson-hyppolite",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "TINA L",
    lastName: "NEMETZ",
    title: "STAFF ASST",
    slug: "tina-l-nemetz",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mary Ellen",
    lastName: "Nepps",
    title: "SR COUNSEL GENERAL COUNSEL",
    slug: "mary-ellen-nepps",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "David M",
    lastName: "Nerenberg",
    title:
      " CFO & Senior Director of Organizational Effectiveness Penn Libraries",
    slug: "david-m-nerenberg",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Amy",
    lastName: "Neskie",
    title:
      " Program Manager, Executive Education Wharton Executive Education (Custom)",
    slug: "amy-neskie",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Julie A.",
    lastName: "Nettleton",
    title:
      " Associate Vice Provost for Graduate Education Vice Provost Education",
    slug: "julie-a-nettleton",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "MELISSA",
    lastName: "NEVADOMSKI",
    title: "Associate Director DAR Communications",
    slug: "melissa-nevadomski",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "F Mitchell",
    lastName: "Newcomer",
    title: "INSTRUMENTATION SPEC PHYSICS",
    slug: "f-mitchell-newcomer",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jennifer A",
    lastName: "Newell",
    title: "Contract Administrator Research Services",
    slug: "jennifer-a-newell",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "CHAD W.",
    lastName: "NEWILL",
    title: "Associate Vice Dean for Advancement SAS Office of Advancement",
    slug: "chad-w-newill",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Miriam Ann",
    lastName: "Newman",
    title:
      " Counseling Field Placement Coordinator Applied Psychology & Human Development",
    slug: "miriam-ann-newman",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Megan E",
    lastName: "Newsome",
    title: "Privacy Investigator, Senior Audit and Privacy",
    slug: "megan-e-newsome",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Russell",
    lastName: "Ney",
    title:
      " Information Technology Technical Director Wharton Research Data Services",
    slug: "russell-ney",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "DONNA M.",
    lastName: "NEY",
    title: "Associate Director, Penn ERA Research Services",
    slug: "donna-m-ney",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Wai-Ping",
    lastName: "Ng",
    title:
      " Associate Director, PRECISE Center Computer and Information Science",
    slug: "wai-ping-ng",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "MICHAEL P",
    lastName: "NG",
    title: "Manager, IT Support Services INFO TECHNOLOGY SRVCS",
    slug: "michael-p-ng",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Sam Lien",
    lastName: "Nguyen",
    title: "Climate Coordinator Vet Dean's Office",
    slug: "sam-lien-nguyen",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Oanh",
    lastName: "Nguyen",
    title: "DEVELOPMENT COORDINATOR Arboretum Development",
    slug: "oanh-nguyen",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Cuong Hung",
    lastName: "Nguyen",
    title: "MATERIALS CONTROL SUPV CHEM",
    slug: "cuong-hung-nguyen",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Frank",
    lastName: "Nguyen",
    title:
      " Application Developer Senior ISC-Applications & Information Services",
    slug: "frank-nguyen",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Tam M.",
    lastName: "Nguyen",
    title:
      " Associate Director, Student Employment Programs Student Registration & Financial Services",
    slug: "tam-m-nguyen",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Yen",
    lastName: "Nguyen",
    title: "Coordinator, Program Chemistry",
    slug: "yen-nguyen",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Chau",
    lastName: "Nguyen",
    title:
      " Coordinator of Integrated Research Programs Office of Nursing Research",
    slug: "chau-nguyen",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Petra",
    lastName: "Nichols",
    title: "Investment Associate Senior Office of Investments",
    slug: "petra-nichols",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Ian",
    lastName: "Nichols",
    title: "Advising Specialist Professional and Liberal Education (PLE)",
    slug: "ian-nichols",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Briana",
    lastName: "Nichols",
    title: "Qualitative Research Manager, CGIR Center for Guaranteed Income",
    slug: "briana-nichols",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Amy S",
    lastName: "Nichols",
    title:
      " Director C, Academic Affairs, Academic Partnerships Global Initiatives",
    slug: "amy-s-nichols",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Anita",
    lastName: "Nicholson",
    title: "Web Designer Senior SASC-Computing",
    slug: "anita-nicholson",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Laura",
    lastName: "Nickrosz",
    title:
      " Senior Director, EVP/Dean's Office Communications Perelman School of Medicine",
    slug: "laura-nickrosz",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Maddie",
    lastName: "Nicol",
    title: "Associate Director, Alumni Engagement Nursing in DAR",
    slug: "maddie-nicol",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Chelsea E.",
    lastName: "Nicolais",
    title: "Associate Director Programs and Special Events",
    slug: "chelsea-e-nicolais",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "JAY",
    lastName: "NICOLLETTA",
    title:
      " E Resources and Serials Acquisitions Librarian Collection Development and Management",
    slug: "jay-nicolletta",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jody A",
    lastName: "Nicoloso",
    title: "Coordinator B DM-Pulmonary Airways Biology Initiative",
    slug: "jody-a-nicoloso",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ivelina",
    lastName: "Nikolova",
    title: "Resident COH Extramural Activities",
    slug: "ivelina-nikolova",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kayvon J",
    lastName: "Nikoo",
    title:
      " Associate Director, Research & Research Training Office of the Exec Vice Dean and Chief Scientific Officer",
    slug: "kayvon-j-nikoo",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Tomoharu",
    lastName: "Nishino",
    title:
      " Associate Director D, Student Services, Undergraduate Programs International Relations/Undg",
    slug: "tomoharu-nishino",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Rosey",
    lastName: "Nissley",
    title:
      " IT EXECUTIVE DIRECTOR APPLICATION & INFORMATION SERVICES ISC-Applications & Information Services",
    slug: "rosey-nissley",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Abby",
    lastName: "Nixon",
    title: "Assistant to the General Manager WXPN Surrogate",
    slug: "abby-nixon",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Asantewaa Mawusi",
    lastName: "Nkrumah-Ture",
    title: "Administrative Assistant A FRES Office of the Vice President",
    slug: "asantewaa-mawusi-nkrumah-ture",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Scott",
    lastName: "Nobel",
    title: "Director of Project Management Project Management",
    slug: "scott-nobel",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "John",
    lastName: "Nocito",
    title: "Director Privacy Investigations Audit and Privacy",
    slug: "john-nocito",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "John C.",
    lastName: "Nolan",
    title: "Business Administrator B Wharton Executive MBA",
    slug: "john-c-nolan",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Darragh",
    lastName: "Nolan",
    title: "Grants Manager A DM-Pulmonary, Allergy and Critical Care",
    slug: "darragh-nolan",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Rhiannon N.",
    lastName: "Nolt",
    title:
      " Associate Director of Annual and Special Gifts Penn Medicine Development & Alumni Relations",
    slug: "rhiannon-n-nolt",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "DR C. ERIK",
    lastName: "NORDGREN",
    title: "Bioinformatics Data Administrator Biology",
    slug: "dr-c-erik-nordgren",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Grier E",
    lastName: "Nori",
    title: "Procurement Card Manager Procurement Services",
    slug: "grier-e-nori",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "EILEEN",
    lastName: "NORMOYLE",
    title: "Director, Radiation Safety EHRS",
    slug: "eileen-normoyle",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Spencer",
    lastName: "Norris",
    title: "Information Technology Support Specialist A SASC-Computing",
    slug: "spencer-norris",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Dawn N.",
    lastName: "Norris",
    title: "PERSONNEL ADMIN COORD Towne Business Office",
    slug: "dawn-n-norris",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Alexis",
    lastName: "North",
    title: "CONSERVATOR MUSEUM University Museum",
    slug: "alexis-north",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jessica",
    lastName: "Noto",
    title:
      " Senior Director of Communications & Stewardship, Penn Medicine Penn Medicine Development",
    slug: "jessica-noto",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Thomas Peter",
    lastName: "Novak",
    title: "Development Coordinator Penn Medicine Development",
    slug: "thomas-peter-novak",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nikki",
    lastName: "Novak",
    title:
      " College Mental Health Professional Counseling and Psychological Services",
    slug: "nikki-novak",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Amy",
    lastName: "Novak",
    title: "Administrative Coordinator External Affairs",
    slug: "amy-novak",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "RENEE",
    lastName: "NOWACZYK",
    title: "ASSOCIATE DIRECTOR- ACCOUNTS PAYABLE PROCUREMENT SERVICES",
    slug: "renee-nowaczyk",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Lauren H",
    lastName: "Nunez",
    title: "Assistant Director Programs & Special Events",
    slug: "lauren-h-nunez",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Aashir Aswad",
    lastName: "Nuri",
    title: "Help Desk Support Annenberg School for Communication",
    slug: "aashir-aswad-nuri",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Andrea A",
    lastName: "Nurse",
    title: "Business Administrator C Operations, Information and Decisions",
    slug: "andrea-a-nurse",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Robin",
    lastName: "Nussbaum Gold",
    title:
      " Director of Marketing Wharton Research Data Services (WRDS), Wharton Computing",
    slug: "robin-nussbaum-gold",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Teresa",
    lastName: "Nutter",
    title:
      " Business Administrator B, Provost Administrative Affairs Provost's Office",
    slug: "teresa-nutter",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Maryanne",
    lastName: "Nuzzo",
    title: "ASST DIRECTOR DEVELOPMENT MGMT REPORTING & ANALYSIS",
    slug: "maryanne-nuzzo",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "CHINWE L",
    lastName: "NWADIOGBU",
    title:
      " Associate Director C, Academic Affairs, Academic Administration SM-DN-Combined Degree",
    slug: "chinwe-l-nwadiogbu",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kathleen",
    lastName: "O'Boyle",
    title: "Senior Training Specialist Information Services",
    slug: "kathleen-o-boyle",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "John W",
    lastName: "O'Brien",
    title: "Network Architect ISC Technology Services",
    slug: "john-w-o-brien",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Elisabeth",
    lastName: "O'Connell",
    title: "SENIOR ASSOCIATE DEAN UNDERGRADUATE ADMISSIONS",
    slug: "elisabeth-o-connell",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Kathy",
    lastName: "O'Connell",
    title: "KIDS CORNER HOST & PRODUCER WXPN",
    slug: "kathy-o-connell",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Kelly",
    lastName: "O'Connor",
    title: "Senior Director, Alumni Engagement Alumni Relations",
    slug: "kelly-o-connor",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "NOREEN",
    lastName: "O'CONNOR-ABEL",
    title: "Production Editor University Press",
    slug: "noreen-o-connor-abel",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Rhoda L",
    lastName: "O'Donnell",
    title: "Assistant Director of Events and Operations Penn Museum",
    slug: "rhoda-l-o-donnell",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alexander S",
    lastName: "O'Donnell",
    title: "Administrative Coordinator Periodontics",
    slug: "alexander-s-o-donnell",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Meghan E",
    lastName: "O'Grady",
    title:
      " Program Manager, Executive Education Wharton Executive Education (Open Enrollment)",
    slug: "meghan-e-o-grady",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Adrienne",
    lastName: "O'Hanlon",
    title: "Business Administrator C Business Operations",
    slug: "adrienne-o-hanlon",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "JENNIFER",
    lastName: "O'KEEFE",
    title: "EXEC ASST WH DEPUTY DEAN",
    slug: "jennifer-o-keefe",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Maureen",
    lastName: "O'Leary",
    title: "Associate Vice Provost, EHRS Environmental Health and Safety",
    slug: "maureen-o-leary",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Maryann",
    lastName: "O'Leary-Salas",
    title:
      " Executive Director of Development Undergraduate Financial Aid and Penn First Plus",
    slug: "maryann-o-leary-salas",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Paige",
    lastName: "O'Malley",
    title:
      " Associate Director of Development, Penn Medicine Penn Medicine Development",
    slug: "paige-o-malley",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Megan Leigh",
    lastName: "O'Malley",
    title: "Associate Director, Curricular Initiatives Leadership Program",
    slug: "megan-leigh-o-malley",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Katherine",
    lastName: "O'Morchoe",
    title: "Business Administrator Weitzman School of Design Finance",
    slug: "katherine-o-morchoe",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Kevin",
    lastName: "O'Neil",
    title: "Operations Manager Environmental Health and Safety",
    slug: "kevin-o-neil",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "William Brendan",
    lastName: "O'Neill",
    title: "Scheduling Coordinator Wharton Operations",
    slug: "william-brendan-o-neill",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Christina",
    lastName: "O'Neill",
    title:
      " Associate Director, OE Inbound Sales Wharton Executive Education (Open Enrollment)",
    slug: "christina-o-neill",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "PRISCILLA C",
    lastName: "O'NEILL",
    title: "ADMIN ASST",
    slug: "priscilla-c-o-neill",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Colleen A.",
    lastName: "O'Neill",
    title:
      " Vice Dean of Administration, Academic Affairs Wharton Finance and Administration",
    slug: "colleen-a-o-neill",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Caitlin",
    lastName: "O'Neill",
    title: "MANAGER ME-Medical Ethics",
    slug: "caitlin-o-neill",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tina",
    lastName: "O'Rourke",
    title:
      " Sr. Associate Director, Principal Gift Operations Development & Alumni Relations",
    slug: "tina-o-rourke",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Daniel C.",
    lastName: "O'Rourke",
    title: "Senior Project Manager-5 YR Term Project Management",
    slug: "daniel-c-o-rourke",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Eileen M",
    lastName: "O'Shaughnessy",
    title: "Executive Assistant A AN-Anesthesia",
    slug: "eileen-m-o-shaughnessy",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mary",
    lastName: "Obropta",
    title: "Instructional Designer Wharton Research Data Services",
    slug: "mary-obropta",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jared A",
    lastName: "Obstfeld",
    title:
      " Information Technology Director Wharton Computing and Instructional Technology (WCIT)",
    slug: "jared-a-obstfeld",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Joan I",
    lastName: "Ockman",
    title: "Coordinator B Architecture",
    slug: "joan-i-ockman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jaclyn L",
    lastName: "Ocumpaugh",
    title: "Center Associate Director Education",
    slug: "jaclyn-l-ocumpaugh",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Peter",
    lastName: "Odintsov",
    title: "IT/AV Help Desk Support Annenberg School for Communication",
    slug: "peter-odintsov",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Martin I.",
    lastName: "Oestergaard",
    title: "Business Systems Administrator IT CLIENT SERVICES",
    slug: "martin-i-oestergaard",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Neoshie",
    lastName: "Ofuani",
    title: "Senior Program Manager & Training Coordinator Events",
    slug: "neoshie-ofuani",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Cathy",
    lastName: "Ogur",
    title:
      " IT Technology Technical Director, Strategic Partnership Admin and Students Wharton Computing and Instructional Technology (WCIT)",
    slug: "cathy-ogur",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "SUZANNE I",
    lastName: "OH",
    title: "ADM ASST LED GSE",
    slug: "suzanne-i-oh",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Momoko",
    lastName: "Oi",
    title:
      " Program Manager, Executive Education Wharton Executive Education (Custom)",
    slug: "momoko-oi",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Niya",
    lastName: "Okike",
    title: "Onboarding Center Specialist Onboard at Penn",
    slug: "niya-okike",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Nicholas",
    lastName: "Okrent",
    title: "LIBRARIAN RES & INSTRUCTIONAL SER",
    slug: "nicholas-okrent",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Anthony J",
    lastName: "Olejnik",
    title: "IT SUPPORT SPECIALIST SR ISC",
    slug: "anthony-j-olejnik",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kristen Tieri",
    lastName: "Oliva",
    title:
      " Senior Director of Advancement and Parent Outreach SAS Office of Advancement",
    slug: "kristen-tieri-oliva",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Peter Jakob",
    lastName: "Olsen Harbich",
    title:
      " Associate Director, The McNeil Center for Early American Studies McNeil Center for Early American Studies (MCEAS)",
    slug: "peter-jakob-olsen-harbich",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Christopher Thomas Nielsen",
    lastName: "Olson",
    title: "IT Support Specialist, Sr. Information Technology Services",
    slug: "christopher-thomas-nielsen-olson",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Caroline Marie",
    lastName: "Olson",
    title:
      " Managing Director Center for Technology, Innovation and Competition",
    slug: "caroline-marie-olson",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Aaron E",
    lastName: "Olson",
    title:
      " Information Technology Project Leader Senior Wharton Computing and Instructional Technology (WCIT)",
    slug: "aaron-e-olson",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Nick",
    lastName: "Ongpauco",
    title: "SR. IT SUPPORT SPECIALIST Wharton Computing",
    slug: "nick-ongpauco",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Gary E",
    lastName: "Onley Jr",
    title: "Instrument Sterilization Supervisor Instrument Management Service",
    slug: "gary-e-onley-jr",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Dana L",
    lastName: "Opiela",
    title:
      " Executive Assistant to Dr. Kevin Volpp Health Policy and Medical Ethics",
    slug: "dana-l-opiela",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Murphy",
    lastName: "Orji",
    title:
      " IT Support Specialist, WCIT Client Services Wharton Computing and Instructional Technology (WCIT)",
    slug: "murphy-orji",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "JANICE M",
    lastName: "ORLOV",
    title: "Director of Strategic Projects Wharton School",
    slug: "janice-m-orlov",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Brandon T",
    lastName: "Orselli",
    title:
      " Information Technology Support Specialist B Weitzman School of Design Computing Center",
    slug: "brandon-t-orselli",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Allyse",
    lastName: "Orsini",
    title: "Senior Associate Director of Development Penn Medicine Development",
    slug: "allyse-orsini",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Petra M",
    lastName: "Ortiz",
    title: "Assignments Coordinator Residential Administration",
    slug: "petra-m-ortiz",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Roxanne",
    lastName: "Ortiz",
    title: "Business Administrator C Business Operations",
    slug: "roxanne-ortiz",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Evelyn",
    lastName: "Ortiz",
    title:
      " Academic Program Services Manager Student Registration & Financial Services",
    slug: "evelyn-ortiz",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Anita",
    lastName: "Ortiz",
    title:
      " Manager, Academic Administration SM-DN-Vice Dean of Academic Affairs",
    slug: "anita-ortiz",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Chandrasekhar",
    lastName: "Oruganty",
    title:
      " Information Technology Technical Director ISC-Applications & Information Services",
    slug: "chandrasekhar-oruganty",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Matthew J",
    lastName: "Osborn",
    title: "Director Critical Writing Program",
    slug: "matthew-j-osborn",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Zoe K.",
    lastName: "Osborne",
    title: "Assistant Director Admissions",
    slug: "zoe-k-osborne",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Brian G.",
    lastName: "Osbourne",
    title: "Director, Strategic Procurement Procurement Services",
    slug: "brian-g-osbourne",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Oshuwa",
    lastName: "Osiemi-Rush",
    title:
      " Information Technology Support Specialist B ISC-CLIENT SERVICES-HIREIT",
    slug: "oshuwa-osiemi-rush",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Megan Renaut",
    lastName: "Osvath",
    title:
      " Associate Director of Development for Biomedical Research Penn Medicine",
    slug: "megan-renaut-osvath",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Antoinette",
    lastName: "Oteri",
    title: "Director of Financial Aid NURSING ACADEMIC AFFAIRS",
    slug: "antoinette-oteri",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Stephanie",
    lastName: "Ottino",
    title:
      " Senior Associate Director, Stewardship & Engagement Strategy Development and Alumni Relations",
    slug: "stephanie-ottino",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Laron Kariff",
    lastName: "Overby",
    title: "Operations Associate, University Life Space and Events Management",
    slug: "laron-kariff-overby",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Anthony P.",
    lastName: "Overend",
    title: "ATHLETICS OPER MGR FACIL OPER AND MAINT ADM",
    slug: "anthony-p-overend",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kristy L.",
    lastName: "Owen",
    title: "Director, Financial Systems Financial Systems",
    slug: "kristy-l-owen",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Karen M",
    lastName: "Owens",
    title: "Financial Administrator Arboretum Administration",
    slug: "karen-m-owens",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Eddrena",
    lastName: "Owens",
    title: "Coordinator of Transfer Credit & Advanced Standing Admissions",
    slug: "eddrena-owens",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "RON",
    lastName: "OZIO",
    title: "DIRECTOR MEDIA RELS UNIV COMMUN",
    slug: "ron-ozio",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Merjan L",
    lastName: "Ozisik",
    title: "Research Administrative Coordinator ME-Medical Ethics",
    slug: "merjan-l-ozisik",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jane L",
    lastName: "Pablos",
    title:
      " Residential Service Manager,  DuBois College House Housing Services",
    slug: "jane-l-pablos",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Dena",
    lastName: "Paffas",
    title:
      " Associate Director C, Human Resources, School/ Center SDM Human Resources",
    slug: "dena-paffas",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Lizabeth",
    lastName: "Page",
    title: "Assistant Director, Fiscal Operations Business Affairs",
    slug: "lizabeth-page",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Luis",
    lastName: "Palacios",
    title: "Research Services, Director WRDS",
    slug: "luis-palacios",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Simon",
    lastName: "Palenchar",
    title: "Application Developer Senior Penn Wharton Budget Model",
    slug: "simon-palenchar",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Douglas",
    lastName: "Paletta",
    title: "Associate Director of Advising and Assistant Dean The College",
    slug: "douglas-paletta",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "James Alan",
    lastName: "Palka",
    title: "PROJECT MANAGER FACIL SVCS PROJ MGMT",
    slug: "james-alan-palka",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lily R",
    lastName: "Palladino",
    title: "MANAGING EDITOR University Press",
    slug: "lily-r-palladino",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Monica Dalin",
    lastName: "Pallanti",
    title: "SR DEPT ADMIN MATH",
    slug: "monica-dalin-pallanti",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Stephanie Y",
    lastName: "Palmer",
    title: "ADMIN ASST  TO THE CHAIR ENGLISH",
    slug: "stephanie-y-palmer",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kristyn",
    lastName: "Palmiotto",
    title: "Executive Director, Penn Abroad Penn Abroad",
    slug: "kristyn-palmiotto",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "J. Kayleen",
    lastName: "Palumbo",
    title:
      " Associate Director B, Academic Affairs, Global Affairs Global Initiatives",
    slug: "j-kayleen-palumbo",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jessica",
    lastName: "Palumbo",
    title: "Business Administrator B Business Affairs",
    slug: "jessica-palumbo",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Gina E",
    lastName: "Pambianchi",
    title:
      " Community Engagement Librarian Collection Development and Management",
    slug: "gina-e-pambianchi",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Diane",
    lastName: "Panaritis",
    title:
      " Associate Director of Project Management Planning | Design | Construction",
    slug: "diane-panaritis",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Wally",
    lastName: "Pansing",
    title:
      " Associate Director of Academic Advising and Assistant Dean The College",
    slug: "wally-pansing",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Gina M.",
    lastName: "Pantalone",
    title: "Grants Coordinator Department of Genetics",
    slug: "gina-m-pantalone",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Christine Moira",
    lastName: "Panucci",
    title:
      " Development and Communications Coordinator Undergraduate Financial Aid Development",
    slug: "christine-moira-panucci",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Sarah Jeng",
    lastName: "Paolella",
    title: "Associate Director, Investments Office of Investments",
    slug: "sarah-jeng-paolella",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Cassie",
    lastName: "Paoli",
    title: "Wellbeing Coordinator Quality of Work Life",
    slug: "cassie-paoli",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Olivia Rose",
    lastName: "Paone",
    title: "Administrative Coordinator Benefits",
    slug: "olivia-rose-paone",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Dean F",
    lastName: "Paone",
    title: "Associate Director, Penn Mail Services Mail",
    slug: "dean-f-paone",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lara",
    lastName: "Paparo",
    title: "Director, Penn Literacy Network Penn Literacy Networks",
    slug: "lara-paparo",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "George",
    lastName: "Papp McClellan",
    title:
      " Director of Training and Assessment Director of CHAS (College House and Academic Services",
    slug: "george-papp-mcclellan",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Maria",
    lastName: "Paredes Fernandez",
    title: "Language Specialist English Language Program",
    slug: "maria-paredes-fernandez",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Matthew",
    lastName: "Parisi",
    title: "Internal Auditor Senior Audit and Privacy",
    slug: "matthew-parisi",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Maressa",
    lastName: "Park",
    title: "Communications Specialist OP-Ophthalmology",
    slug: "maressa-park",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Ju L",
    lastName: "Park",
    title: "Office Operations Coordinator Wharton Finance and Administration",
    slug: "ju-l-park",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "William G.",
    lastName: "Parker",
    title: "Vice Dean of Marketing and Communications Education",
    slug: "william-g-parker",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jeanette",
    lastName: "Parker",
    title: "Business Manager B ISC-ACIO-Shared Services",
    slug: "jeanette-parker",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Robert L.",
    lastName: "Parker",
    title: "Application Developer Senior Linguistic Data Consortium",
    slug: "robert-l-parker",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Ridhdhi",
    lastName: "Parmar",
    title:
      " Associate Director C, Academic Affairs, Academic Partnerships Professional and Liberal Education (PLE)",
    slug: "ridhdhi-parmar",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Eden",
    lastName: "Parra",
    title: "Senior Intellectual Property Paralegal Penn Center for Innovation",
    slug: "eden-parra",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Ethan",
    lastName: "Parry",
    title:
      " Director of Digital Media and Special Initiatives, Penn Medicine Penn Medicine Development",
    slug: "ethan-parry",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Emily",
    lastName: "Parry",
    title:
      " Associate Director for Professional Development and Networking Office of Academic Services",
    slug: "emily-parry",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "MAURICE",
    lastName: "PARSON",
    title: "Systems Administrator Senior ISC-Tech Services-Network Operations",
    slug: "maurice-parson",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jordan",
    lastName: "Pascucci",
    title: "Vice Dean, Director of Admissions Admissions",
    slug: "jordan-pascucci",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Christopher",
    lastName: "Passanante",
    title: "Information Technology Support Specialist Senior SASC-Computing",
    slug: "christopher-passanante",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Dr. Christopher",
    lastName: "Pastore",
    title:
      " Director B, Student Services, Graduate Programs Master of Liberal Arts",
    slug: "dr-christopher-pastore",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Ahan",
    lastName: "Patani",
    title: "Student - International Studies College of Arts & Sciences",
    slug: "ahan-patani",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "NESHA",
    lastName: "PATEL",
    title: "Courseware IT Support Specialist Sr Wharton Computing",
    slug: "nesha-patel",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Dee",
    lastName: "Patel",
    title:
      " Director C, Arts and Media, Communications and Marketing Marketing and Communications Group",
    slug: "dee-patel",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Colleen",
    lastName: "Pattanite",
    title:
      " Information Technology Manager ISC-Tech Services-Network Operations",
    slug: "colleen-pattanite",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jeanel",
    lastName: "Patten",
    title: "Administrative Assistant B Health and Wellness Administration",
    slug: "jeanel-patten",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Sandy",
    lastName: "Patterson",
    title: "Assistant Office of Parent Outreach and Development",
    slug: "sandy-patterson",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Storm",
    lastName: "Paul",
    title: "Information Technology Support Specialist Senior SASC-Computing",
    slug: "storm-paul",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Adelaide S.",
    lastName: "Paul",
    title:
      " Associate Director C, Academic Affairs, Academic Administration Biomedical Sciences",
    slug: "adelaide-s-paul",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Bob",
    lastName: "Paul",
    title:
      " Director, Corporate & Foundation Relations Wharton External Affairs",
    slug: "bob-paul",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Billy",
    lastName: "Paul",
    title: "Admissions Counselor Admissions",
    slug: "billy-paul",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Cynthia Lee",
    lastName: "Paul",
    title: "Senior Executive Assistant Central Administration",
    slug: "cynthia-lee-paul",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ally",
    lastName: "Paul",
    title:
      " Associate Director, Communication Neuroscience Lab Annenberg School for Communication",
    slug: "ally-paul",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Mariko",
    lastName: "Paulson",
    title: "Senior Front-End Developer Penn Wharton Budget Model",
    slug: "mariko-paulson",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Emily",
    lastName: "Pavie",
    title: "Member Services Manager WXPN",
    slug: "emily-pavie",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Dr. Felicity Hannah",
    lastName: "Paxton",
    title: "Associate Dean Annenberg School for Communications",
    slug: "dr-felicity-hannah-paxton",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Charity A",
    lastName: "Payne",
    title:
      " Administrative Director, GRASP Lab and PERCH General Robotics, Automation, Sensing and Perception Lab",
    slug: "charity-a-payne",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Julia Eileen",
    lastName: "Pearse",
    title: "Administrative Coordinator Spanish and Portuguese",
    slug: "julia-eileen-pearse",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Dayne",
    lastName: "Peavy",
    title:
      " Senior Client Services Manager, Wharton San Francisco Wharton San Francisco",
    slug: "dayne-peavy",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rhea Amruta",
    lastName: "Peddinti",
    title: "Administrative Coordinator RA-Radiology",
    slug: "rhea-amruta-peddinti",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Louise",
    lastName: "Pedraz",
    title: "MANAGER OF COMPENSATION HUMAN RESOURCES",
    slug: "louise-pedraz",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Aleksandar",
    lastName: "Pejcic",
    title:
      " Information Technology Manager Senior ISC-Applications & Information Services",
    slug: "aleksandar-pejcic",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Anthony",
    lastName: "Pellechio",
    title:
      " Information Technology Architect ISC-Tech Services-Network Operations",
    slug: "anthony-pellechio",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Greg",
    lastName: "Pellicano",
    title: "VP Audit, Compliance & Privacy General University Special",
    slug: "greg-pellicano",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Elizabeth Duggins",
    lastName: "Peloso",
    title:
      " Senior Associate Vice Provost/President, Office of Research Services Research Services",
    slug: "elizabeth-duggins-peloso",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Caroline",
    lastName: "Pennartz",
    title:
      " Director, Reputation Management and Dean's Communications Marketing and Communications Group",
    slug: "caroline-pennartz",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Amanda",
    lastName: "Penney",
    title: "Associate Director of Group Sales Penn Museum",
    slug: "amanda-penney",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Joseph D",
    lastName: "Pennington",
    title: "Services Assistant C New Bolton Center",
    slug: "joseph-d-pennington",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rachel",
    lastName: "Pepper",
    title:
      " Director of the Graduate Program Annenberg School for Communication",
    slug: "rachel-pepper",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Sarvelia",
    lastName: "Peralta-Duran",
    title:
      " Associate Director C, Student Services, Advising Program in International Studies and Business",
    slug: "sarvelia-peralta-duran",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Valerie J",
    lastName: "Perez",
    title: "Industrial Hygiene Program Manager Environmental Health and Safety",
    slug: "valerie-j-perez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tatiana A",
    lastName: "Perez",
    title:
      " Temporary Staff - Non-Degree Penn Student SM-DN-Inclusion, Diversity, Equity, & Learner Exp Prog in Me",
    slug: "tatiana-a-perez",
    dei: true,
    category: "Student Life",
  },
  {
    firstName: "Daniel",
    lastName: "Perez",
    title: "Senior Associate Director of Admissions Graduate Admissions",
    slug: "daniel-perez",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Steven",
    lastName: "Perez",
    title:
      " Information Technology Support Specialist B ISC-Client Services-Technology Support Services",
    slug: "steven-perez",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Mayelin D",
    lastName: "Perez",
    title: "Librarian for Literatures in English Humanities Collections",
    slug: "mayelin-d-perez",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Catherine",
    lastName: "Perez",
    title: "Associate Director, Annual Giving Museum Development",
    slug: "catherine-perez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nykia M.",
    lastName: "Perez Kibler",
    title: "Director of Information Management Population Studies Center",
    slug: "nykia-m-perez-kibler",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Carmen Maria",
    lastName: "Perez-Fisher",
    title: "Senior Training and Wellness Specialist ULAR",
    slug: "carmen-maria-perez-fisher",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kelly D",
    lastName: "Perfit",
    title: "Administrative Services Manager Naval Science",
    slug: "kelly-d-perfit",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tracy",
    lastName: "Perillo",
    title: "Coordinator, Program Family and Community Health",
    slug: "tracy-perillo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "MARIA",
    lastName: "PERKINS",
    title:
      " Senior Director/Gifts Accounting, Administration and Records Development and Alumni Relations",
    slug: "maria-perkins",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Andrew",
    lastName: "Perkins",
    title: "Senior Information Technology Support Specialist SDM Computing",
    slug: "andrew-perkins",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "ROBERT A",
    lastName: "PERLISH",
    title: "Director E, Business and Finance GE-Genetics",
    slug: "robert-a-perlish",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Nicole",
    lastName: "Perry",
    title: "ASSISTANT EDITOR Pennsylvania Gazette",
    slug: "nicole-perry",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Shelby D",
    lastName: "Person",
    title: "Business Manager Wharton Executive Education (Operations)",
    slug: "shelby-d-person",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tiffany Kim",
    lastName: "Peterson",
    title: "Administrative Coordinator ISC-VP and Administration",
    slug: "tiffany-kim-peterson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Brian",
    lastName: "Peterson",
    title: "Director, Makuu Black Cultural Center VPUL",
    slug: "brian-peterson",
    dei: true,
    category: "Student Life",
  },
  {
    firstName: "Michael",
    lastName: "Peterson",
    title:
      " Senior Associate Director, Strategic Initiatives & Academic Programming The Wharton School, MBA Program",
    slug: "michael-peterson",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Malika",
    lastName: "Peterson",
    title: "Instrument Sterilization Attendant A Instrument Management Service",
    slug: "malika-peterson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jay",
    lastName: "Peterson",
    title: "Technical Support Specialist, IT Education",
    slug: "jay-peterson",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Ian C.",
    lastName: "Petrie",
    title:
      " Director, Graduate Student Programming and Pedagogy Center for Excellence in Teaching, Learning and Innovation",
    slug: "ian-c-petrie",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Amina",
    lastName: "Petrizio",
    title: "Coordinator B OPPORTUNITY LAB",
    slug: "amina-petrizio",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Erica",
    lastName: "Petrongola",
    title: "Executive Assistant A DM-Pulmonary, Allergy and Critical Care",
    slug: "erica-petrongola",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Stephen Scott",
    lastName: "Pettigrew",
    title:
      " Associate Director of Data Sciences Program on Opinion Research and Election Studies",
    slug: "stephen-scott-pettigrew",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Karleigh Rose",
    lastName: "Pettit",
    title:
      " Senior Director of Development for the Abramson Cancer Center and Department of Radiation Oncology Penn Medicine Development",
    slug: "karleigh-rose-pettit",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Evan",
    lastName: "Peugh",
    title: "Archivist A University Museum",
    slug: "evan-peugh",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kimberly",
    lastName: "Peurifoy",
    title: "Senior Director of Finance Nursing Finance",
    slug: "kimberly-peurifoy",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Alessandro",
    lastName: "Pezzati",
    title: "ARCHIVIST",
    slug: "alessandro-pezzati",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Trang",
    lastName: "Pham",
    title: "Executive Director Venture Lab",
    slug: "trang-pham",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "William H",
    lastName: "Phillips",
    title: "IT SUPPORT SPECIALIST",
    slug: "william-h-phillips",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "DR. STEPHEN R.",
    lastName: "PHILLIPS",
    title: "FTE: ADMIN COORDINATOR GRADE 25 University Museum",
    slug: "dr-stephen-r-phillips",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rachel",
    lastName: "Phillips",
    title: "Administrative Coordinator Institutional Real Estate",
    slug: "rachel-phillips",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Magida",
    lastName: "Phillips",
    title: "IT SR DIRECTOR BSD Support",
    slug: "magida-phillips",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Herman",
    lastName: "Phillips",
    title: "COMP ELEC TECH SAS COMP",
    slug: "herman-phillips",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "AMY S",
    lastName: "PHILLIPS",
    title:
      " Information Technology Technical Director ISC-Client Services-Technology Support Services",
    slug: "amy-s-phillips",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "West",
    lastName: "Phinney",
    title:
      " Director, Relationship Management Information Systems and Computing",
    slug: "west-phinney",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Helen Nguyen",
    lastName: "Pho",
    title:
      " Senior Associate Director, Career Advisor and Employer Engagement Wharton Executive MBA",
    slug: "helen-nguyen-pho",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Donna Wehrle",
    lastName: "Piarulli",
    title:
      " Chief Executive Director, Leadership & Strategic Initiatives Penn Medicine Development and Alumni Relations",
    slug: "donna-wehrle-piarulli",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Robert M",
    lastName: "Piasecki",
    title: "Project Manager Design and Construction",
    slug: "robert-m-piasecki",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "MARYANN Q",
    lastName: "PICCOLO",
    title:
      " Executive Associate Comptroller - Corporate Tax, Compliance, and Payroll Comptroller's Office",
    slug: "maryann-q-piccolo",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Katelyn G",
    lastName: "Pierce",
    title: "Assistant Manager B, Research BE-Epidemiology Division",
    slug: "katelyn-g-pierce",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Franceleen",
    lastName: "Pierce",
    title:
      " Assistant to Dr. Arthur H. Rubenstein, MBBCh DM-Endocrinology, Diabetes and Metobolism",
    slug: "franceleen-pierce",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Tucker",
    lastName: "Piergallini",
    title: "Biosafety Officer A Environmental Health and Safety",
    slug: "tucker-piergallini",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Yasmina",
    lastName: "Pierre",
    title: "Global Programs Manager Penn Abroad",
    slug: "yasmina-pierre",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Linda",
    lastName: "Pierson",
    title: "Business Administrator C Management",
    slug: "linda-pierson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Matthew",
    lastName: "Pierson",
    title: "Director, Senior Research Support Wharton Research Data Services",
    slug: "matthew-pierson",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Steve",
    lastName: "Piltch",
    title: "Director, School Leadership Program Education",
    slug: "steve-piltch",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Yetunde",
    lastName: "Pinckney",
    title:
      " Office Coordinator Netter Center for Community Partnerships Netter Center for Community Partnerships",
    slug: "yetunde-pinckney",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Diane P.",
    lastName: "Pinder",
    title: "Associate Director Compliance & QA Institutional Review Board",
    slug: "diane-p-pinder",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "John R",
    lastName: "Piotrowski",
    title:
      " Sr. IT Project Leader Wharton Computing and Instructional Technology (WCIT)",
    slug: "john-r-piotrowski",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Melissa M.",
    lastName: "Pirylis",
    title: "Business Manager C Wharton Finance and Administration",
    slug: "melissa-m-pirylis",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Kathryn Duffy",
    lastName: "Pischke",
    title:
      " Director of Business Development LIVE Wharton Executive Education (Wharton LIVE)",
    slug: "kathryn-duffy-pischke",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nicole",
    lastName: "Piser",
    title: "Video Producer Online Learning",
    slug: "nicole-piser",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Maria J",
    lastName: "Pitone",
    title: "Director, Executive Programs Executive Education",
    slug: "maria-j-pitone",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Josh",
    lastName: "Piven",
    title: "Writer to the Provost Provost's Office",
    slug: "josh-piven",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Sherri",
    lastName: "Place",
    title:
      " Director, Instructional Design and Content Strategy Executive Education Online",
    slug: "sherri-place",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Allison",
    lastName: "Plaisted",
    title: "Administrative Assistant Annenberg School for Communication",
    slug: "allison-plaisted",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Patrizia Salani",
    lastName: "Platt",
    title:
      " Associate Director, Leadership & Professional Development Organization Effectiveness",
    slug: "patrizia-salani-platt",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Krystal",
    lastName: "Pleasant",
    title:
      " Senior Associate Director of Communications Leonard Davis Institute",
    slug: "krystal-pleasant",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Gabriela",
    lastName: "Plesa",
    title: "Deputy Director CACT CI-TCSL/CVPF",
    slug: "gabriela-plesa",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "EMILY",
    lastName: "PLOWMAN",
    title: "Global Programs Manager - Penn Abroad Penn Global",
    slug: "emily-plowman",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Shanel",
    lastName: "Plummer",
    title: "Disbursement Clerk Procurement Services",
    slug: "shanel-plummer",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Adam T",
    lastName: "Podlaski",
    title: "Information Technology Project Leader Senior SASC-Computing",
    slug: "adam-t-podlaski",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Carolyn",
    lastName: "Poerio",
    title: "Associate Director, Pre-Award Services Office of Research Services",
    slug: "carolyn-poerio",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Gabrielle",
    lastName: "Polche",
    title: "Supervisor, ULAR Husbandry ULAR",
    slug: "gabrielle-polche",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Paul R",
    lastName: "Polichino",
    title: "Managing Director Office of Investments",
    slug: "paul-r-polichino",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Shain C",
    lastName: "Polk",
    title: "BSD Day Care Center",
    slug: "shain-c-polk",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Mindy",
    lastName: "Pollock Troy",
    title: "Coordinator, Program SM-ED-Vice Dean Education",
    slug: "mindy-pollock-troy",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Catherine E",
    lastName: "Poole",
    title: "Staff Assistant C Provost's Office",
    slug: "catherine-e-poole",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Joyce M.",
    lastName: "Poole",
    title: "Administrative Coordinator Management",
    slug: "joyce-m-poole",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Anthony E.",
    lastName: "Poole",
    title: "IT Support Specialist, Penn Medicine Penn Medicine Development",
    slug: "anthony-e-poole",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Michael J.",
    lastName: "Popko",
    title: "Director, Disbursements Procurement Services",
    slug: "michael-j-popko",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Leah A",
    lastName: "Popowich",
    title: "President's Office President's Office",
    slug: "leah-a-popowich",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Trey",
    lastName: "Popp",
    title: "Senior Editor, The Pennsylvania Gazette Pennsylvania Gazette",
    slug: "trey-popp",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Deborah E",
    lastName: "Porter",
    title: "BLDG ADM ASC",
    slug: "deborah-e-porter",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lindsay",
    lastName: "Possiel",
    title:
      " Senior Assistant Registrar for Student Systems and Information Services Student Registration & Financial Services",
    slug: "lindsay-possiel",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Renee C",
    lastName: "Post",
    title:
      " Senior Associate Dean of Admissions Law Admissions and Financial Aid",
    slug: "renee-c-post",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Janelle L",
    lastName: "Post",
    title: "Coordinator, Office of the Dean SEAS Office of the Dean",
    slug: "janelle-l-post",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Dan",
    lastName: "Potenzieri",
    title:
      " Regional Director, Business Development Wharton Executive Education (Custom)",
    slug: "dan-potenzieri",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Felicia T",
    lastName: "Potter",
    title: "Language Specialist English Language Program",
    slug: "felicia-t-potter",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kate R.",
    lastName: "Pourshariati",
    title: "Film and Media Archivist University Museum",
    slug: "kate-r-pourshariati",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mia",
    lastName: "Powell",
    title: "Business Administrator B Business Operations",
    slug: "mia-powell",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jillian C.",
    lastName: "Powell",
    title: "Director, Budget and Analysis Provost's Office",
    slug: "jillian-c-powell",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Samantha",
    lastName: "Powers",
    title: "Project Manager, McGraw Center Education",
    slug: "samantha-powers",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alison",
    lastName: "Powers",
    title:
      " Information Technology Project Leader ISC-Client Services-Classroom Technology Services",
    slug: "alison-powers",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Rebecca",
    lastName: "Poyourow",
    title: "Assistant Dean for Advising College of Arts and Sciences",
    slug: "rebecca-poyourow",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Steven J",
    lastName: "Predjulek",
    title: "Associate Comptroller Comptroller's Office",
    slug: "steven-j-predjulek",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Michael T",
    lastName: "Prell",
    title: "Senior IT Project Leader SASC-Computing",
    slug: "michael-t-prell",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Sarah",
    lastName: "Prendergast",
    title:
      " Alumni Relations Coordinator, Penn Medicine Penn Medicine Development",
    slug: "sarah-prendergast",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "JOHN",
    lastName: "PRENDERGAST",
    title: "ED PA GAZETTE PENNSYLVANIA GAZETTE",
    slug: "john-prendergast",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Michelle L.",
    lastName: "Presbury",
    title: "Contract Administrator Penn Center for Innovation",
    slug: "michelle-l-presbury",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "SR, JAMES P",
    lastName: "PRESS",
    title:
      " IT Sr Project Leader ISC - Technology Services - Infrastructure Operations",
    slug: "sr-james-p-press",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Patricia",
    lastName: "Pressman",
    title: "Senior Business Support Representative WXPN Surrogate",
    slug: "patricia-pressman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Shaneice D",
    lastName: "Price",
    title:
      " Human Resource Manager, Provost Administrative Affairs Provost's Office",
    slug: "shaneice-d-price",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Matt",
    lastName: "Primus",
    title: "Director D, Human Resources Benefits",
    slug: "matt-primus",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Paula",
    lastName: "Pritchett",
    title: "Director, Human Resources, SAS Finance and Administration",
    slug: "paula-pritchett",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Karoline T",
    lastName: "Prosperi",
    title: "Procurement Manager FRES Finance and Administration",
    slug: "karoline-t-prosperi",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Lucy",
    lastName: "Provost",
    title:
      " Associate Director D, Development, Corporate and Foundation Relations External Affairs",
    slug: "lucy-provost",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Kshitiz",
    lastName: "Pudasaini",
    title:
      " Information Technology Architect ISC-Tech Services-Network Operations",
    slug: "kshitiz-pudasaini",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Sarah",
    lastName: "Punderson",
    title: "Assistant Director of Communications President's Office",
    slug: "sarah-punderson",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Christopher",
    lastName: "Pupik Dean",
    title:
      " Director, Urban Teaching Apprenticeship Program Teaching, Learning and Leadership",
    slug: "christopher-pupik-dean",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Justin",
    lastName: "Purohit",
    title: "Manager, Property Management Accounting Comptroller's Office",
    slug: "justin-purohit",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "DR GARY",
    lastName: "PURPURA",
    title:
      " Executive Director for Education and Academic Planning Provost's Office",
    slug: "dr-gary-purpura",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Todd A",
    lastName: "Pustilnick",
    title:
      " Director C, Business and Finance Wharton Finance and Administration",
    slug: "todd-a-pustilnick",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "PATRICIA S",
    lastName: "PUTNAM",
    title: "EXEC ASST/BUDGET & CLAIMS COORDINATOR GEN COUNSEL",
    slug: "patricia-s-putnam",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Kristine S.",
    lastName: "Pyzyna",
    title: "Associate General Counsel General Counsel",
    slug: "kristine-s-pyzyna",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Zoe",
    lastName: "Qiao",
    title: "Director, Penn AI Vice Provost for Research",
    slug: "zoe-qiao",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Q",
    lastName: "Quaye",
    title:
      " Online Student Services Coordinator Center for Excellence in Teaching, Learning and Innovation",
    slug: "q-quaye",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Cica Sabine",
    lastName: "Quenum",
    title: "Supervisor, Husbandry ULAR",
    slug: "cica-sabine-quenum",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Steven H",
    lastName: "Quimby",
    title: "IT ASSET MANAGER ISC-ACIO-Shared Services",
    slug: "steven-h-quimby",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kelly A",
    lastName: "Quinn",
    title: "Department Administrator ECONOMICS",
    slug: "kelly-a-quinn",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Caitlin Kelly",
    lastName: "Quinn",
    title: "Associate Director D, Development, Services External Affairs",
    slug: "caitlin-kelly-quinn",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Abigail L",
    lastName: "Quirk",
    title: "Evaluation Manager Professional and Liberal Education (PLE)",
    slug: "abigail-l-quirk",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Sofia",
    lastName: "Rabate",
    title: "Talent Search Counselor (Coordinator B) Student Engagement",
    slug: "sofia-rabate",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "DR KRISTINE LYNN",
    lastName: "RABBERMAN",
    title:
      " Assistant Vice Dean & Director, Academic Affairs Division of Professional and Liberal Education, SAS",
    slug: "dr-kristine-lynn-rabberman",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Cynthia",
    lastName: "Rabuck",
    title: "Director SDM Academic Affairs",
    slug: "cynthia-rabuck",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Lindsay Docherty",
    lastName: "Rachlin",
    title: "Executive Assistant Leonard Davis Institute",
    slug: "lindsay-docherty-rachlin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rebecca M",
    lastName: "Racine",
    title: "Staff Writer B External Affairs",
    slug: "rebecca-m-racine",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Mia",
    lastName: "Radanavong",
    title:
      " Enrollment and Operations Coordinator, DSO English Language Program",
    slug: "mia-radanavong",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Janice M",
    lastName: "Radway",
    title: "Associate Director C, Academic Affairs SM-ED-Vice Dean Education",
    slug: "janice-m-radway",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "SHERITA M",
    lastName: "RAGINS",
    title: "Admin Cord. for Cross Disciplinary Programs REGISTRAR",
    slug: "sherita-m-ragins",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Malini",
    lastName: "Ragoopath",
    title:
      " Director of Creative & Digital Strategy School and Center - Annual Giving",
    slug: "malini-ragoopath",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Kenneth A",
    lastName: "Raining",
    title: "Circulation Desk Administrator Departmental Libraries Public Svs",
    slug: "kenneth-a-raining",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Raji",
    lastName: "Raja",
    title: "Senior Records Assistant Student Registration & Financial Services",
    slug: "raji-raja",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Neetu",
    lastName: "Rajpal",
    title: "Bioinformatics Librarian Holman Biotech Commons",
    slug: "neetu-rajpal",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sheila",
    lastName: "Raman",
    title:
      " Director of Development for Arts and Culture Development and Alumni Relations",
    slug: "sheila-raman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jim",
    lastName: "Ramey",
    title:
      " Associate Director, Professional and Organizational Development Professional and Organizational Development (POD)",
    slug: "jim-ramey",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Alisha",
    lastName: "Ramirez",
    title: "Sustainable Labs Manager Oper/Maint-Utilities",
    slug: "alisha-ramirez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Antoinette",
    lastName: "Ramos",
    title: "Administrative Coordinator Staff & Labor",
    slug: "antoinette-ramos",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Jessica L.",
    lastName: "Ramsey",
    title:
      " Senior Director, Leadership and Strategic Initiatives Penn Medicine Development",
    slug: "jessica-l-ramsey",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Diana G",
    lastName: "Ran",
    title: "Internal Audit Project Manager Audit and Privacy",
    slug: "diana-g-ran",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Gwendolin",
    lastName: "Randolph",
    title:
      " Director of Student Accounts Student Registration & Financial Services",
    slug: "gwendolin-randolph",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Lynn",
    lastName: "Ransom",
    title: "Curator of Programs Schoenberg Institute for Manuscript Studies",
    slug: "lynn-ransom",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Mukund",
    lastName: "Rao",
    title: "Financial Solutions Architect Wharton Research Data Services",
    slug: "mukund-rao",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "John",
    lastName: "Rapczynski",
    title: "Network Specialist ISC-Tech Services-Network Operations",
    slug: "john-rapczynski",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jennifer L",
    lastName: "Rappaport",
    title: "Associate Director Office of Equal Opportunity Programs",
    slug: "jennifer-l-rappaport",
    dei: true,
    category: "Human Resources",
  },
  {
    firstName: "Alexandra",
    lastName: "Rasdal",
    title:
      " Associate Director of Academic Programs & Registrar Services SDM Academic Affairs",
    slug: "alexandra-rasdal",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Carolyn S",
    lastName: "Rasp",
    title: "Executive Assistant Finance Administration",
    slug: "carolyn-s-rasp",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Necole J",
    lastName: "Rasul",
    title: "Affiliation: Staff",
    slug: "necole-j-rasul",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Yogi",
    lastName: "Rathore",
    title:
      " Associate Director, Finance and Accounting Operations Wharton Finance and Administration",
    slug: "yogi-rathore",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "JAMES",
    lastName: "RAUER",
    title: "RESOURCE CNTR COORD OFC UNIV ARCH",
    slug: "james-rauer",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Yuri J",
    lastName: "Rayford",
    title: "Financial Administrative Coordinator Financial Systems",
    slug: "yuri-j-rayford",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "JACQUELINE KOURY",
    lastName: "RAYNOR",
    title:
      " Information Technology Project Leader Senior ISC-ACIO-Shared Services",
    slug: "jacqueline-koury-raynor",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Patricia S",
    lastName: "Rea",
    title: "Associate Director for Admissions GRAD. DIV. ARTS & SCIENCES",
    slug: "patricia-s-rea",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Michael T",
    lastName: "Reagan",
    title:
      " Information Technology Manager Senior ISC-Tech Services-Network Operations",
    slug: "michael-t-reagan",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Colleen",
    lastName: "Reardon",
    title:
      " Senior Director, Strategic Sourcing & Sustainability Procurement Services",
    slug: "colleen-reardon",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Angela",
    lastName: "Reason",
    title: "Financial Admin Coord Office of Student Affairs",
    slug: "angela-reason",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jaclyn Radford",
    lastName: "Recktenwald",
    title:
      " Director of Wellbeing Initiatives Prevention, Education, and Promotion",
    slug: "jaclyn-radford-recktenwald",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Colin",
    lastName: "Redick",
    title: "Web Designer Senior INSTITUTIONAL ADVANCEMENT VET",
    slug: "colin-redick",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "KEVIN K.",
    lastName: "REED",
    title: "Logistics and Operations Manager University Records Center",
    slug: "kevin-k-reed",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Anna M",
    lastName: "Reed",
    title: "Associate Director, Payroll Education",
    slug: "anna-m-reed",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Traci",
    lastName: "Rees",
    title:
      " Associate University Registrar for Student Systems and Information Services Student Registration & Financial Services",
    slug: "traci-rees",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Lindsay M.",
    lastName: "Rees",
    title: "Marketing Coordinator B Wharton Research Data Services",
    slug: "lindsay-m-rees",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Zachary",
    lastName: "Reese",
    title: "Designer Annenberg Public Policy Center",
    slug: "zachary-reese",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Michael Thomas",
    lastName: "Reese",
    title:
      " Audio Visual Support Specialist Computing and Educational Technology Services",
    slug: "michael-thomas-reese",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jennifer",
    lastName: "Reese",
    title: "Associate Director, Grants and Student Financial Aid Education",
    slug: "jennifer-reese",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Kisha",
    lastName: "Reeves",
    title: "Operations Specialist, Data Processing Admissions",
    slug: "kisha-reeves",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "JANESSA",
    lastName: "REEVES",
    title:
      " Collections Coordinator, Academic Engagement Department University Museum",
    slug: "janessa-reeves",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Maria Elizabeth",
    lastName: "Regueiro",
    title:
      " Assistant Alliance Manager, Corporate Alliances Penn Center for Innovation",
    slug: "maria-elizabeth-regueiro",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "William G",
    lastName: "Reh",
    title: "Application Architect ISC-Applications & Information Services",
    slug: "william-g-reh",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Christina L.",
    lastName: "Reichert",
    title: "Marketing Communications Specialist Gift Planning",
    slug: "christina-l-reichert",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "EMILY",
    lastName: "REICHLIN",
    title:
      " Associate Director, Campaign and Engagement Exec Dir: Strategy Engagement & Campaign",
    slug: "emily-reichlin",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Felix",
    lastName: "Reichling",
    title: "Economist Penn Wharton Public Policy Initiative",
    slug: "felix-reichling",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Renell",
    lastName: "Reid",
    title: "Development Associate Penn Medicine Development",
    slug: "renell-reid",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sarah",
    lastName: "Reidell",
    title: "Librarian D Collection Development and Management",
    slug: "sarah-reidell",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Edward",
    lastName: "Reidell",
    title: "Director of Visitor Services University Museum",
    slug: "edward-reidell",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Andrea J.",
    lastName: "Reidell",
    title:
      " Director of Outreach and Curriculum, Leonore Annenberg Institute for Civics Annenberg Public Policy Center",
    slug: "andrea-j-reidell",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Marian",
    lastName: "Reiff",
    title: "Assessment Specialist Counseling and Psychological Services",
    slug: "marian-reiff",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Maryellen",
    lastName: "Reilly",
    title: "Vice Dean of Graduate Student Affairs Deputy Dean's Office",
    slug: "maryellen-reilly",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Meghan",
    lastName: "Reilly",
    title: "Associate Director Family and Community Health",
    slug: "meghan-reilly",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Roger A",
    lastName: "Reina",
    title: "ASSC DIR ATHLETICS SR DRIA ADMINISTRATIVE AFFAIRS",
    slug: "roger-a-reina",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Heather M",
    lastName: "Reinhardt",
    title:
      " Financial Administrative Coordinator SP2 Finance and Administration",
    slug: "heather-m-reinhardt",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "KENDALL Joy",
    lastName: "REINISCH",
    title: "Instructional Operations Coordinator Office of Academic Innovation",
    slug: "kendall-joy-reinisch",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jamie Flather",
    lastName: "Reisman",
    title:
      " Director of Public Interest Career Strategy & Counseling Office of Career Strategy",
    slug: "jamie-flather-reisman",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Chloe I",
    lastName: "Reison",
    title:
      " Associate Director C, Academic Affairs, Academic Administration SACHS Program for Arts Innovation",
    slug: "chloe-i-reison",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Hailey",
    lastName: "Reissman",
    title: "Staff Writer Annenberg School for Communication",
    slug: "hailey-reissman",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Charles",
    lastName: "Rejonis",
    title: "Director E, Information Technology Wharton Research Data Services",
    slug: "charles-rejonis",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Alexander Richard",
    lastName: "Renaud",
    title: "Investment Associate Office of Investments",
    slug: "alexander-richard-renaud",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "James",
    lastName: "Renfro",
    title:
      " Information Technology Technical Director ISC-Tech Services-Network Operations",
    slug: "james-renfro",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Eleni",
    lastName: "Rengepis",
    title:
      " Chief Marketing and Communications Officer Office of Marketing and Communications",
    slug: "eleni-rengepis",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Carrie",
    lastName: "Renner",
    title: "Director of Student Affairs Perelman School of Medicine",
    slug: "carrie-renner",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Sasha",
    lastName: "Renninger",
    title:
      " Web Development and Digital Research Manager, Information Technology GSE Computing Services",
    slug: "sasha-renninger",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Emily",
    lastName: "Renwick",
    title: "Communications Coordinator FRES",
    slug: "emily-renwick",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Gina M",
    lastName: "Renzi",
    title:
      " DIRECTOR, THE ROTUNDA and DIRECTOR, 40TH STREET ARTIST-IN-RESIDENCE PROGRAM (AIR) Institutional Real Estate",
    slug: "gina-m-renzi",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Deborah",
    lastName: "Requesens",
    title:
      " Director, Jumpstart Program OD-Center for Orphan Disease Research and Therapy",
    slug: "deborah-requesens",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Karen B",
    lastName: "Ressler",
    title: "Administrative Coordinator Marketing",
    slug: "karen-b-ressler",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Catharine",
    lastName: "Restrepo",
    title: "Director, Master in Law Program Law",
    slug: "catharine-restrepo",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Katie",
    lastName: "Retherford",
    title: "Administrative Coordinator WXPN Surrogate",
    slug: "katie-retherford",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tonya W.",
    lastName: "Revell",
    title:
      " IT CLIENT SERVICES PROJECT MANAGER Computing and Educational Technology Services",
    slug: "tonya-w-revell",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "SHANESHA",
    lastName: "REVELL",
    title: "Business Administrator C Wharton Graduate Division",
    slug: "shanesha-revell",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "JENNY",
    lastName: "REYES",
    title:
      " Associate Director E, Business and Finance Wharton Finance and Administration",
    slug: "jenny-reyes",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Adrian Charles",
    lastName: "Reynolds",
    title: "AREA MANAGER Operations and Maintenance Administration",
    slug: "adrian-charles-reynolds",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nel",
    lastName: "Reynolds Snyder",
    title:
      " Assistant Director, Leadership and Strategic Inititatives Penn Medicine Development",
    slug: "nel-reynolds-snyder",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Miguel",
    lastName: "Reynoso",
    title:
      " Information Technology Support Specialist Senior Linguistic Data Consortium",
    slug: "miguel-reynoso",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Deborah",
    lastName: "Rhebergen",
    title: "Vice Dean for Advancement SAS in DAR",
    slug: "deborah-rhebergen",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Kathy J",
    lastName: "Rho",
    title:
      " Director, Leadership Research & Applied Learning Leadership Program",
    slug: "kathy-j-rho",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Philomena",
    lastName: "Rhoades",
    title: "Manager, Gifts Administration Wharton School",
    slug: "philomena-rhoades",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jaron J",
    lastName: "Rhodes",
    title: "Director of Communications Information Systems & Computing",
    slug: "jaron-j-rhodes",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jacquelyn",
    lastName: "Rhodes",
    title: "Business Manager A TM-Administration",
    slug: "jacquelyn-rhodes",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Kelsey",
    lastName: "Rhodes-Soldatos",
    title:
      " Associate Director of Donor and Board Relations INSTITUTIONAL ADVANCEMENT VET",
    slug: "kelsey-rhodes-soldatos",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ellen",
    lastName: "Rhudy",
    title:
      " Associate Director, Instructional Design Center for Excellence in Teaching, Learning and Innovation",
    slug: "ellen-rhudy",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Andrew",
    lastName: "Rice",
    title: "Classroom Technology Support Specialist Education",
    slug: "andrew-rice",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Emily E",
    lastName: "Rich",
    title: "Academic Coordinator PhD in Social Welfare",
    slug: "emily-e-rich",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jessica",
    lastName: "Richard",
    title:
      " Associate Director, School Leadership Program Executive Education and Professional Development",
    slug: "jessica-richard",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "William M",
    lastName: "Richards",
    title: "Assistant Manager, Class of 1923 Penn Ice Rink Ice Rink",
    slug: "william-m-richards",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Paul L",
    lastName: "Richards",
    title: "Vice Dean, Director of Strategic Communications Admissions",
    slug: "paul-l-richards",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Tarik",
    lastName: "Richardson",
    title: "ADMIN COORD WH EXEC EDUC",
    slug: "tarik-richardson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Meghan K.",
    lastName: "Richardson",
    title:
      " Associate Registrar for Calendars, Classrooms, and Scheduling Student Registration & Financial Services",
    slug: "meghan-k-richardson",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Julia",
    lastName: "Riches",
    title: "IT Director, Strategic Partnerships Wharton Computing",
    slug: "julia-riches",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Russell",
    lastName: "Richie",
    title:
      " Associate Director, MindCORE & Cog Sci Mind Center for Outreach, Research, and Education",
    slug: "russell-richie",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Daina A.",
    lastName: "Richie-Troy",
    title:
      " Director of Penn Spectrum Programs and Shared Interest Groups Alumni Relations",
    slug: "daina-a-richie-troy",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Nox",
    lastName: "Richmond",
    title:
      " Coordinator, Program Wharton Center for Leadership and Change Management",
    slug: "nox-richmond",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "David Liam",
    lastName: "Riddell",
    title:
      " Information Technology Support Specialist B Residential Computer Labs",
    slug: "david-liam-riddell",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Chya M",
    lastName: "Riddick",
    title:
      " Administrative Coordinator French and Francophone, Italian, and Germanic Studies",
    slug: "chya-m-riddick",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Corey",
    lastName: "Riddle",
    title: "Creative Director External Affairs",
    slug: "corey-riddle",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Kim Harris",
    lastName: "Ridley",
    title: "Director, Adminstrative Operations Executive Education",
    slug: "kim-harris-ridley",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alyssa",
    lastName: "Ridley-Hamlin",
    title: "Coordinator B Netter Center for Community Partnerships",
    slug: "alyssa-ridley-hamlin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mariana",
    lastName: "Riestra",
    title: "Development Assistant School and Center - Annual Giving",
    slug: "mariana-riestra",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Adam W.",
    lastName: "Riggar",
    title: "Director of Production & Operations Penn Live Arts",
    slug: "adam-w-riggar",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Stephanie D",
    lastName: "Riley",
    title:
      " Information Technology Manager ISC-Client Services-Technology Support Services",
    slug: "stephanie-d-riley",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "JAMES J",
    lastName: "RILEY",
    title: "Director, Fiscal Operations CB-Cancer Biology",
    slug: "james-j-riley",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Staci",
    lastName: "Rinehart",
    title:
      " Sr. Associate Director of Marketing and Operations The Wharton Fund, Wharton External Affairs",
    slug: "staci-rinehart",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Eliza Marie",
    lastName: "Rios",
    title: "Financial Administrative Coordinator Business Operations",
    slug: "eliza-marie-rios",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Erica N",
    lastName: "Ritchie",
    title: "Assistant Manager B, Human Resources HCM Operations",
    slug: "erica-n-ritchie",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Joe",
    lastName: "Rively",
    title:
      " Director of International Development Development and Alumni Relations",
    slug: "joe-rively",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Amanda",
    lastName: "Rivera",
    title: "Director, Employer Engagement MBA Career Management",
    slug: "amanda-rivera",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Alexis , Sr",
    lastName: "Rivera",
    title: "Information Technology Director ISC-ACIO-Shared Services",
    slug: "alexis-sr-rivera",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Arlene",
    lastName: "Rivera Finkelstein",
    title: "Director E, Academic Affairs, Diversity, Equity, and Inclusion Law",
    slug: "arlene-rivera-finkelstein",
    dei: true,
    category: "Academic",
  },
  {
    firstName: "Leslie Juan",
    lastName: "Rivera Ramos",
    title: "Video Producer, Liberal & Prof. Studies Online Learning",
    slug: "leslie-juan-rivera-ramos",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Angela K",
    lastName: "Rivers",
    title: "ADMIN ASST B Development & Alumni Relations, The Fund for Penn Law",
    slug: "angela-k-rivers",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ariel A",
    lastName: "Robbins",
    title:
      " Director B, Student Services, Student Engagement Undergraduate Division",
    slug: "ariel-a-robbins",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Russell H.",
    lastName: "Roberts",
    title: "Communications Specialist PI-Penn Institute for mRNA",
    slug: "russell-h-roberts",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Reni",
    lastName: "Roberts",
    title:
      " Information Technology Project Leader Senior ISC-Tech Services-Network Operations",
    slug: "reni-roberts",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "MATTHEW C",
    lastName: "ROBERTS",
    title: "IT Desktop/AV Support Specialist ISC-CLIENT SERVICES-HIREIT",
    slug: "matthew-c-roberts",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Matthew E",
    lastName: "Roberts",
    title: "NBC GARDENER New Bolton Center",
    slug: "matthew-e-roberts",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "John F",
    lastName: "Roberts",
    title: "Director C, Business and Finance Office of Investments",
    slug: "john-f-roberts",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Claire",
    lastName: "Robertson-Kraft",
    title: "Director, ImpactED Professional and Liberal Education (PLE)",
    slug: "claire-robertson-kraft",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Will S.",
    lastName: "Robinson",
    title: "Onboarding Center Specialist Onboard at Penn",
    slug: "will-s-robinson",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Terema S",
    lastName: "Robinson",
    title: "Referral Coordinator Student Health Services",
    slug: "terema-s-robinson",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Rodney V",
    lastName: "Robinson",
    title: "ASSOCIATE DIRECTOR OFFICE OF STUDENT AFFAIRS",
    slug: "rodney-v-robinson",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Marlana V",
    lastName: "Robinson",
    title: "Training Specialist Senior SM-DN External Info Services",
    slug: "marlana-v-robinson",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Nicole",
    lastName: "Robinson",
    title: "Coordinator B SM-ED-Vice Dean Education",
    slug: "nicole-robinson",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "LAUREN",
    lastName: "ROBINSON",
    title: "Compensation Specialist SM-DN-Senior Executive Director",
    slug: "lauren-robinson",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Jasmin I.",
    lastName: "Robinson",
    title:
      " Financial Support & Engagement Coordinator, CGIR Center for Guaranteed Income",
    slug: "jasmin-i-robinson",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Javon",
    lastName: "Robinson",
    title: "Referral Coordinator Student Health Services",
    slug: "javon-robinson",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Harold",
    lastName: "Robinson",
    title: "Support and Endpoint Administrator Financial Systems",
    slug: "harold-robinson",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Ciara",
    lastName: "Robinson",
    title: "Financial Administrative Coordinator Business Operations",
    slug: "ciara-robinson",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Chrisey",
    lastName: "Robinson",
    title: "Administrative Coordinator SDM Academic Affairs",
    slug: "chrisey-robinson",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Britannia V.",
    lastName: "Robinson",
    title: "Training Coordinator / Developer ULAR",
    slug: "britannia-v-robinson",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Betsy",
    lastName: "Robinson",
    title: "DIRECTOR Special Projects FACIL OPER AND MAINT ADM",
    slug: "betsy-robinson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alexis",
    lastName: "Robinson",
    title: "Grants Manager B, Business Office Education",
    slug: "alexis-robinson",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Emily M",
    lastName: "Robley",
    title:
      " Sr. Associate Director of Administration and Volunteer Management DRIA Development",
    slug: "emily-m-robley",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Georgette A.",
    lastName: "Rochlin",
    title: "Associate Director Center for the Advanced Study of India",
    slug: "georgette-a-rochlin",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Amara A.",
    lastName: "Rockar",
    title:
      " Onboarding and Compliance Workday Manager Weitzman School of Design Finance",
    slug: "amara-a-rockar",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Lizann Boyle",
    lastName: "Rode",
    title:
      " Associate Vice President and Associate University Secretary Secretary's Office",
    slug: "lizann-boyle-rode",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Kara",
    lastName: "Rodgers",
    title: "Technical Support Manager Online Learning",
    slug: "kara-rodgers",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Tina D",
    lastName: "Rodia",
    title: "Editor Assistant Senior University Communications",
    slug: "tina-d-rodia",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Carlos Ivan",
    lastName: "Rodriguez",
    title: "LIAISON BIOMED LIB SCH MED",
    slug: "carlos-ivan-rodriguez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jessica",
    lastName: "Rodriguez",
    title: "Assistant to the Dean Annenberg School for Communication",
    slug: "jessica-rodriguez",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Christina",
    lastName: "Rodriguez",
    title: "Associate Director C, Student Services Family Resource Center",
    slug: "christina-rodriguez",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Bri",
    lastName: "Rodriguez",
    title: "Assistant Director, Admissions Visitor Center Admissions",
    slug: "bri-rodriguez",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Jillian E",
    lastName: "Rogers",
    title:
      " Director of Marketing & Communications, Analytics at Wharton Wharton's AI & Analytics Initiative",
    slug: "jillian-e-rogers",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Lanese T",
    lastName: "Rogers",
    title: "EXEC ASST TO VICE PRES ISC",
    slug: "lanese-t-rogers",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kate",
    lastName: "Rojas",
    title: "Training Specialist Educational Technology & Learning Management",
    slug: "kate-rojas",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "William",
    lastName: "Roka",
    title:
      " Senior Director of Data, Analytics & Salesforce CRM External Affairs",
    slug: "william-roka",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Nic",
    lastName: "Romanazzi",
    title: "Application Architect ISC-Applications & Information Services",
    slug: "nic-romanazzi",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Emily R",
    lastName: "Romanello",
    title: "Undergraduate Coordinator Department of Economics",
    slug: "emily-r-romanello",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Carol M.",
    lastName: "Romani",
    title: "Coordinator Alumni Relations",
    slug: "carol-m-romani",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Audrey",
    lastName: "Romano",
    title:
      " Business Administrator & Payroll Manager Annenberg School for Communication",
    slug: "audrey-romano",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Dr Dan",
    lastName: "Romer",
    title: "DIRECTOR of Research Annenberg Public Policy Center",
    slug: "dr-dan-romer",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Daisy M",
    lastName: "Romero",
    title:
      " Assistant Director, Leadership & Strategic Initiatives, Penn Medicine Penn Medicine Development",
    slug: "daisy-m-romero",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Craig J.",
    lastName: "Roncace",
    title: "URBAN PARK MANAGER Operations and Maintenance Administration",
    slug: "craig-j-roncace",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Erika",
    lastName: "Rood",
    title:
      " Assistant Director, Financial Management, Planning & Analysi Finance and Administration",
    slug: "erika-rood",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Neil",
    lastName: "Roper",
    title: "Information Technology Support Specialist A ISC HireIT",
    slug: "neil-roper",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Sarah",
    lastName: "Ropp",
    title:
      " Director A, Student Services, Student Engagement Stavros Niarchos Foundation Paideia Program",
    slug: "sarah-ropp",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Tania",
    lastName: "Rorke",
    title:
      " Senior Associate Director, Corporate and Donor Engagement Wharton's AI & Analytics Initiative",
    slug: "tania-rorke",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jolshua S.",
    lastName: "Rosado",
    title:
      " Administrative Coordinator Center for Social Norms and Behavioral Dynamics",
    slug: "jolshua-s-rosado",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kiara Lee",
    lastName: "Rosario",
    title:
      " Financial Administrative Coordinator Annenberg School for Communication",
    slug: "kiara-lee-rosario",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Cynthia",
    lastName: "Rosario",
    title: "Administrative Assistant B Prevention, Education, and Promotion",
    slug: "cynthia-rosario",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "SUSAN",
    lastName: "ROSATI",
    title: "Training Manager ULAR",
    slug: "susan-rosati",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Juliana Beth",
    lastName: "Rosati",
    title:
      " Sr. Associate Director, Strategic Marketing & Communications SP2 Office of the Dean",
    slug: "juliana-beth-rosati",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "KYLE",
    lastName: "ROSATO",
    title: "Associate Director EHRS",
    slug: "kyle-rosato",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ryan A.",
    lastName: "Rose",
    title: "Director of Design and Construction Finance and Administration",
    slug: "ryan-a-rose",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Sharon",
    lastName: "Rosenberg",
    title: "Salesforce Administrator Information Services",
    slug: "sharon-rosenberg",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Marielle A",
    lastName: "Rosenberg",
    title: "Grants Coordinator Office of Nursing Research",
    slug: "marielle-a-rosenberg",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Christina M",
    lastName: "Rosenberry",
    title: "Sr. Building Administrator Vet Dean's Office",
    slug: "christina-m-rosenberry",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Katherina",
    lastName: "Rosqueta",
    title:
      " Founding Executive Director Center for High Impact Philanthropy (CHIP)",
    slug: "katherina-rosqueta",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Joy",
    lastName: "Ross",
    title: "Manager, Compensation Staff & Labor",
    slug: "joy-ross",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Samuel",
    lastName: "Rossi",
    title: "Information Technology Support Specialist Senior SASC-Computing",
    slug: "samuel-rossi",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "CYNTHIA",
    lastName: "ROSSI",
    title: "Senior Director Development Programs & Special Events",
    slug: "cynthia-rossi",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Gregory S",
    lastName: "Rost",
    title: "SR VP & CHIEF OF STAFF President's Office",
    slug: "gregory-s-rost",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Laura",
    lastName: "Rostock",
    title: "Senior Executive Director of Development Penn Medicine Development",
    slug: "laura-rostock",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Olivia Nyce",
    lastName: "Roth",
    title:
      " Director of Advising and Student Success Office of Academic Services",
    slug: "olivia-nyce-roth",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Adam G",
    lastName: "Roth-Saks",
    title:
      " ADMINISTRATIVE DIRECTOR & FINANCE MANAGER Masters of Non-Profit Leadership",
    slug: "adam-g-roth-saks",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Kimberly L",
    lastName: "Rothman",
    title: "Business Administrator B General University EB Pool",
    slug: "kimberly-l-rothman",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Sarah E.",
    lastName: "Rottenberg",
    title: "Associate Director IPD Architecture",
    slug: "sarah-e-rottenberg",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Joe",
    lastName: "Rouse",
    title: "Event Operations Manager Wharton Operations",
    slug: "joe-rouse",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "David",
    lastName: "Roush",
    title:
      " IT Technical Director for Infrastructure & Operations Information Technology Services",
    slug: "david-roush",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Michele",
    lastName: "Rovinsky-Mayer",
    title:
      " Associate Vice President Office of the AVP for Equity and Title IX Officer",
    slug: "michele-rovinsky-mayer",
    dei: true,
    category: "Human Resources",
  },
  {
    firstName: "JENNIFER L",
    lastName: "ROWAN",
    title:
      " Senior Associate Director, Operations and Cash Management Research Services",
    slug: "jennifer-l-rowan",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Carmen M.",
    lastName: "Rowe",
    title: "ORS Operations Supervisor Research Services",
    slug: "carmen-m-rowe",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jeffrey S.",
    lastName: "Rowland",
    title: "Executive Director HR, Recruitment Services Human Resources",
    slug: "jeffrey-s-rowland",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Jake",
    lastName: "Rowland",
    title: "Business Manager B Wharton Finance and Administration",
    slug: "jake-rowland",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Cody G",
    lastName: "Rowlands",
    title:
      " Cloud Infrastructure Architect Wharton Computing and Instructional Technology (WCIT)",
    slug: "cody-g-rowlands",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jules",
    lastName: "Roy",
    title: "Director B, Student Services, Academic Programs Leadership Program",
    slug: "jules-roy",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Samuel P",
    lastName: "Royer",
    title:
      " Supervisor, Campus Maintenance Operations and Maintenance Administration",
    slug: "samuel-p-royer",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Adio",
    lastName: "Royster",
    title: "Administrative Assistant B Architecture",
    slug: "adio-royster",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Michael",
    lastName: "Rozansky",
    title: "Director of Communications Annenberg Public Policy Center",
    slug: "michael-rozansky",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Kathleen Anne",
    lastName: "Rozecki",
    title: "Operations Coordinator and Registrar Specialist Lauder Institute",
    slug: "kathleen-anne-rozecki",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Lisa",
    lastName: "Rudi",
    title: "Associate Director MBA Program Office",
    slug: "lisa-rudi",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Lisa Charlotte",
    lastName: "Rudi",
    title: "Senior Project Manager-5 YR Term Project Management",
    slug: "lisa-charlotte-rudi",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Lauren",
    lastName: "Rudick",
    title:
      " DIRECTOR STUDENT INTERVENTION SERVICES, University Life Administration",
    slug: "lauren-rudick",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Antoinette",
    lastName: "Ruffin",
    title: "Administrative Coordinator Law Admissions and Financial Aid",
    slug: "antoinette-ruffin",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Maureen",
    lastName: "Ruhl",
    title: "Director of Risk Management GEN COUNSEL",
    slug: "maureen-ruhl",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Caroline A",
    lastName: "Ruhle",
    title:
      " Director of LLM Counseling and International Careers Office of Career Strategy",
    slug: "caroline-a-ruhle",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Felipe",
    lastName: "Ruiz Mazin",
    title: "Economist Penn Wharton Budget Model",
    slug: "felipe-ruiz-mazin",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Scott M",
    lastName: "Rusch",
    title: "Supervisor, Daytime Services Penn Transit Services",
    slug: "scott-m-rusch",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jeffrey P",
    lastName: "Rusling",
    title: "DIRECTOR, Office of Software Licensing ISC-ACIO-Shared Services",
    slug: "jeffrey-p-rusling",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Madeleine",
    lastName: "Russell",
    title: "Project Coordinator, Dean's Office Education",
    slug: "madeleine-russell",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Robert C.",
    lastName: "Russell",
    title: "Supervisor C OP-Ophthalmology",
    slug: "robert-c-russell",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Leslie A.",
    lastName: "Russell",
    title: "Assistant Director Penn Medicine Development",
    slug: "leslie-a-russell",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Joe",
    lastName: "Russo",
    title: "Senior Director; Business Services Business Services",
    slug: "joe-russo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Albert F",
    lastName: "Russo",
    title: "Senior Major Gifts Officer Law Alumni and Development",
    slug: "albert-f-russo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sherell A.",
    lastName: "Rutland",
    title:
      " Assistant Director, Graduate Aid Student Registration & Financial Services",
    slug: "sherell-a-rutland",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Michael P",
    lastName: "Ruzzo",
    title: "Business Administrator C Business Operations",
    slug: "michael-p-ruzzo",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Carly",
    lastName: "Ryan",
    title: "Business Operations Manager Environmental Health and Safety",
    slug: "carly-ryan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Dawn M.",
    lastName: "Ryan",
    title: "Administrative Coordinator Population Studies Center",
    slug: "dawn-m-ryan",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kathleen",
    lastName: "Ryan",
    title: "Asst to the Chief of Rheumatology DM-Rheumatology",
    slug: "kathleen-ryan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Neville G.",
    lastName: "Ryant",
    title: "APPLICATION DEVELOPER Linguistic Data Consortium",
    slug: "neville-g-ryant",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Andrea M",
    lastName: "Rycroft",
    title: "Senior Associate Director, Career Advisor MBA Career Management",
    slug: "andrea-m-rycroft",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Richard",
    lastName: "Rys",
    title: "Editor, Wharton Magazine External Affairs",
    slug: "richard-rys",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Meghan",
    lastName: "Ryzinski Yerkov",
    title: "Associate Director, Research Services Research Services",
    slug: "meghan-ryzinski-yerkov",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Pooja",
    lastName: "S",
    title:
      " Administrative Coordinator, Wharton San Francisco Wharton San Francisco",
    slug: "pooja-s",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Aiasha B.",
    lastName: "Saalim Graham",
    title: "STAFF SOCIOLOGY",
    slug: "aiasha-b-saalim-graham",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Eden",
    lastName: "Sabala",
    title:
      " Associate Director C, Arts and Media, Events Wharton Center for Leadership and Change Management",
    slug: "eden-sabala",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Natalie Clare",
    lastName: "Sabiston",
    title: "Academic Services Coordinator SDM Academic Affairs",
    slug: "natalie-clare-sabiston",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jared",
    lastName: "Sabre",
    title: "Information Technology Director Vet Information Technology",
    slug: "jared-sabre",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Leigh",
    lastName: "Sacco",
    title: "Associate Director and Manager of Operations Development Programs",
    slug: "leigh-sacco",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alice C",
    lastName: "Saccucci",
    title: "SERVICES ASSISTANT President's House",
    slug: "alice-c-saccucci",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rana",
    lastName: "Sachdev",
    title: "Associate Director, BSD Human Resources Business Services",
    slug: "rana-sachdev",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Melissa L",
    lastName: "Sachs",
    title: "Supervisor, ULAR Husbandry ULAR",
    slug: "melissa-l-sachs",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Terry",
    lastName: "Sacksith",
    title: "Business Administrator C President's Office",
    slug: "terry-sacksith",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Robert A",
    lastName: "Sadoff",
    title: "Staff University Life Administration",
    slug: "robert-a-sadoff",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Sana",
    lastName: "Saeed",
    title: "Associate Chaplain Chaplain",
    slug: "sana-saeed",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Ty",
    lastName: "Saekouay",
    title: "Accounts Payable Accountant Procurement Services",
    slug: "ty-saekouay",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Kimberly V.",
    lastName: "Sahms",
    title: "Business Administrator Health and Wellness Administration",
    slug: "kimberly-v-sahms",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Maggie",
    lastName: "Saia",
    title: "Director B, Student Services Wharton Doctoral Program Office",
    slug: "maggie-saia",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Yadira",
    lastName: "Sakornpan",
    title: "Application Developer Senior Wharton Research Data Services",
    slug: "yadira-sakornpan",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Mohamed Nur",
    lastName: "Salih",
    title: "Parking Attendant Parking",
    slug: "mohamed-nur-salih",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "RICHARD C",
    lastName: "SALMON",
    title: "Systems Administrator SR SDM Computing",
    slug: "richard-c-salmon",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Cara",
    lastName: "Salsberg",
    title: "Payroll/Payroll Tax Manager Corporate Tax, Compliance & Payroll",
    slug: "cara-salsberg",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Linda M",
    lastName: "Salter",
    title: "RECEPTIONIST B Community Oral Health",
    slug: "linda-m-salter",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nicholas G",
    lastName: "Salvatore",
    title: "Information Technology Manager SASC-Computing",
    slug: "nicholas-g-salvatore",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Lindsey Austin",
    lastName: "Samahon",
    title:
      " DIRECTOR OF MARKETING AND COMMUNICATIONS Kleinman Center on Energy Policy",
    slug: "lindsey-austin-samahon",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Philip W",
    lastName: "Samko",
    title: "ASST TRAINER ATHLETICS",
    slug: "philip-w-samko",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Usha R",
    lastName: "Sampathirao",
    title:
      " Application Developer Senior ISC-Applications & Information Services",
    slug: "usha-r-sampathirao",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Molly",
    lastName: "Sampson",
    title: "Registrar University Curator",
    slug: "molly-sampson",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Rob",
    lastName: "Samuel",
    title:
      " Executive Director, Information Technology Vet Information Technology",
    slug: "rob-samuel",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "IRIS J",
    lastName: "SANCHEZ",
    title: "ADMIN COORD PLN/GSE",
    slug: "iris-j-sanchez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jennifer",
    lastName: "Sanchez",
    title: "Human Resources Coordinator Wharton Human Resources",
    slug: "jennifer-sanchez",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Donna H",
    lastName: "Sandfort",
    title: "Associate Director of Finance Nursing Finance",
    slug: "donna-h-sandfort",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Scott L",
    lastName: "Sandler",
    title: "Information Technology Support Specialist B SASC-Computing",
    slug: "scott-l-sandler",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Samantha",
    lastName: "Sangenito",
    title: "Assoc Dir-Data Analytics Fox Leadership Program",
    slug: "samantha-sangenito",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Mike",
    lastName: "Sanker",
    title: "Information Technology Director ISC-Information Security",
    slug: "mike-sanker",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Adam",
    lastName: "Santana",
    title: "Internal Auditor Audit and Privacy",
    slug: "adam-santana",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Christopher",
    lastName: "Santaspirt",
    title: "Manager, Healthcare Nursing Healthcare Labs",
    slug: "christopher-santaspirt",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jewel",
    lastName: "Santiago",
    title:
      " Financial Administrative Coordinator SAS Graduate Division Administration",
    slug: "jewel-santiago",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "ELIZABETH MANOTTI",
    lastName: "SANTILLI",
    title:
      " Director, Strategic Event Development and Production Programs and Special Events, Donor and Alumni Relations",
    slug: "elizabeth-manotti-santilli",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jonathan R.",
    lastName: "Santos",
    title:
      " Information Technology Support Specialist Senior ISC-Client Services-Technology Support Services",
    slug: "jonathan-r-santos",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Corey",
    lastName: "Sapp",
    title: "Information Technology Support Specialist Senior Vet Dean's Office",
    slug: "corey-sapp",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Lenora",
    lastName: "Sapp",
    title: "IP Compliance Coordinator Penn Center for Innovation",
    slug: "lenora-sapp",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Andrew",
    lastName: "Saraceni",
    title:
      " Information Technology Director Wharton Computing and Instructional Technology (WCIT)",
    slug: "andrew-saraceni",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Francine",
    lastName: "Sarin Sweeney",
    title: "PHOTOGRAPHER MUSEUM",
    slug: "francine-sarin-sweeney",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Amoh",
    lastName: "Sarkodie",
    title: "P2P Program Associate; Penn Procurement Procurement Services",
    slug: "amoh-sarkodie",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Andrew L",
    lastName: "Sarno",
    title: "Strategic Planning Officer Impact & Assessment",
    slug: "andrew-l-sarno",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mary Ellen",
    lastName: "Sarno",
    title: "Director of Fiscal Operations Finance and Administration",
    slug: "mary-ellen-sarno",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Patricia A.",
    lastName: "Sarro",
    title: "Business Administrator C GE-Genetics",
    slug: "patricia-a-sarro",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Caitlin J",
    lastName: "Satterfield",
    title: "Director C, Research, Administration Leadership Program",
    slug: "caitlin-j-satterfield",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "J. Anthony",
    lastName: "Sauder",
    title: "MSAG Advisor LPS Administration",
    slug: "j-anthony-sauder",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Eric D",
    lastName: "Sauers",
    title: "IT Project Manager The Wharton School | WRDS",
    slug: "eric-d-sauers",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "S. Shani",
    lastName: "Saunders",
    title: "Affiliation: Staff",
    slug: "s-shani-saunders",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Carletha V",
    lastName: "Savage",
    title: "Operations Specialist Admissions",
    slug: "carletha-v-savage",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Sam",
    lastName: "Savello",
    title: "Communications and Marketing Manager Penn Center for Innovation",
    slug: "sam-savello",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "JENNIFER",
    lastName: "SAVOIE",
    title: "Sr Associate Director WH MBA CAREER MGMT",
    slug: "jennifer-savoie",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Virginia V",
    lastName: "Sayer",
    title: "Associate Director, Administrative Operations Executive Education",
    slug: "virginia-v-sayer",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "LIBBY (ELISABETH)",
    lastName: "SAYLOR",
    title:
      " History of Art Coordinator Department of Art History - School of Arts & Sciences",
    slug: "libby-elisabeth-saylor",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Michael D",
    lastName: "Scales",
    title:
      " Vice President of Business Services Special Executive Vice President",
    slug: "michael-d-scales",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Leigh Anne",
    lastName: "Scarborough",
    title:
      " Assistant Director, Student Services and Records Professional and Liberal Education (PLE)",
    slug: "leigh-anne-scarborough",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Paula M.",
    lastName: "Scarborough",
    title: "ADMIN ASST Mathematics",
    slug: "paula-m-scarborough",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Sarah E",
    lastName: "Scarlata-Nesbitt",
    title:
      " Associate Director of Financial Aid and Admissions Law Admissions and Financial Aid",
    slug: "sarah-e-scarlata-nesbitt",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Cecilia",
    lastName: "Scavelli",
    title: "Director C, Research CC-Cancer Center",
    slug: "cecilia-scavelli",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "John Anderson",
    lastName: "Schaeffer",
    title: "Application Developer Senior Wharton Research Data Services",
    slug: "john-anderson-schaeffer",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Scott D",
    lastName: "Schafer",
    title: "Associate Vice President, Business and Finance Audit and Privacy",
    slug: "scott-d-schafer",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Joseph",
    lastName: "Schaffner",
    title: "Associate Director of Online Operations Online Learning",
    slug: "joseph-schaffner",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Leah Miriam",
    lastName: "Schatz",
    title: "Coordinator, Program School Partnerships",
    slug: "leah-miriam-schatz",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Hillary",
    lastName: "Schaub",
    title: "Major Gift Officer, Penn Medicine Penn Medicine Development",
    slug: "hillary-schaub",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "ALEX",
    lastName: "SCHEIN",
    title: "Director Digital Communications SAS Office of Advancement",
    slug: "alex-schein",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Bethany Robblee",
    lastName: "Schell",
    title:
      " Sr. Assistant University Registrar - Academic & Student Services Student Registration & Financial Services",
    slug: "bethany-robblee-schell",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Rebecca A.",
    lastName: "Schept",
    title: "Assistant Director of Advising Services and Academic Support COL",
    slug: "rebecca-a-schept",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "ELIZABETH C",
    lastName: "SCHEYDER",
    title: "SR IT PROJECT LEADER SAS COMPUTING",
    slug: "elizabeth-c-scheyder",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jackie",
    lastName: "Schlindwein",
    title: "Graphic Designer, Signage FRES, Office of the University Architect",
    slug: "jackie-schlindwein",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Megan",
    lastName: "Schmidgal",
    title: "Communications Director Urban Institute",
    slug: "megan-schmidgal",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Leah J.",
    lastName: "Schmidt",
    title: "Training and Wellness Coordinator and Developer ULAR",
    slug: "leah-j-schmidt",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jamie",
    lastName: "Schnaitter",
    title:
      " Systems Administrator C Computing and Educational Technology Services",
    slug: "jamie-schnaitter",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Eileen M",
    lastName: "Schnapp",
    title: "Program Manager Wharton Executive Education (Custom)",
    slug: "eileen-m-schnapp",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jake",
    lastName: "Schneider",
    title: "Associate General Counsel General Counsel",
    slug: "jake-schneider",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Sheila M",
    lastName: "Schneyder",
    title: "Coordinator, Program SM-DN-Business Office",
    slug: "sheila-m-schneyder",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Karen J",
    lastName: "Schnitker",
    title: "Receptionist Katz Center for Advanced Judaic Studies",
    slug: "karen-j-schnitker",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kevin",
    lastName: "Schott",
    title:
      " Director of Engagement, Eidos LGBTQ+ Health Initiative School of Nursing, Family and Community Health",
    slug: "kevin-schott",
    dei: true,
    category: "Academic",
  },
  {
    firstName: "Chelsea A",
    lastName: "Schuett",
    title: "Assistant Director of Donor Engagement Arboretum Development",
    slug: "chelsea-a-schuett",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Adam M",
    lastName: "Schuett",
    title: "Graphic Designer Professional and Liberal Education (PLE)",
    slug: "adam-m-schuett",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Erica",
    lastName: "Schulke",
    title: "Senior Manager of Workday Operations ISC-HCM Operations",
    slug: "erica-schulke",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Peter E",
    lastName: "Schulman",
    title: "Executive Director Positive Psychology Center",
    slug: "peter-e-schulman",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Trevor",
    lastName: "Schulte",
    title: "Horticulturist Section Leader; Morris Arboretum Horticulture",
    slug: "trevor-schulte",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kyle E",
    lastName: "Schumacher",
    title: "Information Technology Support Specialist B SDM Computing",
    slug: "kyle-e-schumacher",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Eric",
    lastName: "Schuman",
    title: "Producer/Host WXPN Surrogate",
    slug: "eric-schuman",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Brian",
    lastName: "Schwabenland",
    title:
      " Assistant Director of Development, Penn Medicine Penn Medicine Development",
    slug: "brian-schwabenland",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Susan",
    lastName: "Schwartz",
    title: "ASST DEAN STUDENT LIFE SCH DENT MED",
    slug: "susan-schwartz",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Melissa",
    lastName: "Schwartz",
    title:
      " Associate Director of Research and Prospect Management Law Alumni and Development",
    slug: "melissa-schwartz",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Ariel",
    lastName: "Schwartz",
    title: "MANAGING DIRECTOR, CSIS Center for Social Impact Strategy",
    slug: "ariel-schwartz",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Aliza A",
    lastName: "Schwartzman",
    title: "ASSOC GENERAL COUNSEL GEN COUNSEL",
    slug: "aliza-a-schwartzman",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Alexander C",
    lastName: "Schwarz",
    title: "Information Technology Support Specialist A Vet Dean's Office",
    slug: "alexander-c-schwarz",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "TIM",
    lastName: "SCHWEIDEL",
    title: "Business Administrator C Biomedical Sciences & Pathobiology",
    slug: "tim-schweidel",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Erin M.",
    lastName: "Schweikert",
    title: "Legal Secretary General Counsel",
    slug: "erin-m-schweikert",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Lauren E",
    lastName: "Scicluna",
    title: "Manager C, Student Services, Graduate Programs Education",
    slug: "lauren-e-scicluna",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Catharine",
    lastName: "Sciolla-Schechter",
    title:
      " Associate Director, Penn Women's Center Penn Women's Center Administration",
    slug: "catharine-sciolla-schechter",
    dei: true,
    category: "Student Life",
  },
  {
    firstName: "Elise",
    lastName: "Scioscia",
    title: "Director Penn Violence Prevention",
    slug: "elise-scioscia",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "James C",
    lastName: "Sclavunos",
    title: "Project Interior Designer SEAS Planning, Design, and Construction",
    slug: "james-c-sclavunos",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Teri",
    lastName: "Scott",
    title: "Director of Marketing, Morris Arboretum Morris Arboretum Marketing",
    slug: "teri-scott",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Peter G",
    lastName: "Scott",
    title: "Program Manager Wharton Executive Education (Custom)",
    slug: "peter-g-scott",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "QUABENA",
    lastName: "SCOTT",
    title: "Affiliation: Staff",
    slug: "quabena-scott",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Lauren C",
    lastName: "Scott",
    title: "Development Assistant/Back Up Traffic Manager WXPN Surrogate",
    slug: "lauren-c-scott",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lechelle",
    lastName: "Scott",
    title:
      " Conduct Case Manager Center for Community Standards and Accountability",
    slug: "lechelle-scott",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Thomas Patrick",
    lastName: "Scriven",
    title: "Managing Director Investments Office of Investments",
    slug: "thomas-patrick-scriven",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Shawmeron",
    lastName: "Seal",
    title:
      " Associate Director, Planning, Design, and Construction Provost's Office",
    slug: "shawmeron-seal",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rajith",
    lastName: "Sebastian",
    title:
      " Director, Special Projects Environmental, Social and Governance (ESG) Analytics Lab",
    slug: "rajith-sebastian",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Erica",
    lastName: "Sebastian",
    title: "Global People Operations Director Global Support Services",
    slug: "erica-sebastian",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Kevin A",
    lastName: "Secrest",
    title: "Director, Internal Audit Audit and Privacy",
    slug: "kevin-a-secrest",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jessica A.",
    lastName: "Segal",
    title:
      " Director, Strategic Initiatives McNulty Leadership Program at Wharton",
    slug: "jessica-a-segal",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Heather A",
    lastName: "Seitz",
    title:
      " Director of Cash Management, PCI and Treasury Operations FINANCE AND TREASURY",
    slug: "heather-a-seitz",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Kathryn",
    lastName: "Seiverling",
    title:
      " Operations Support Specialist Center for Excellence in Teaching, Learning and Innovation",
    slug: "kathryn-seiverling",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "DiAnna E",
    lastName: "Sela",
    title: "Administrative Assistant, Gift Planning Gift Planning",
    slug: "dianna-e-sela",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Page",
    lastName: "Selinsky",
    title: "Editor B University Museum",
    slug: "page-selinsky",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Marie T",
    lastName: "Selvato",
    title: "Supervisor, Penn Transit Escort",
    slug: "marie-t-selvato",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kyra",
    lastName: "Selwyn",
    title:
      " College Mental Health Professional Counseling and Psychological Services",
    slug: "kyra-selwyn",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Ian C",
    lastName: "Semmler",
    title: "BUS ADMINISTRATOR C Law",
    slug: "ian-c-semmler",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Mary",
    lastName: "Seng",
    title:
      " Associate Director D, Business and Finance Wharton Finance and Administration",
    slug: "mary-seng",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jenny Lynda",
    lastName: "Seng-Russo",
    title:
      " Leadership Development Specialist Office of Organization Effectiveness",
    slug: "jenny-lynda-seng-russo",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Donna",
    lastName: "Seravello",
    title: "Coordinator C Orthopaedic Surgery",
    slug: "donna-seravello",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Oscar J",
    lastName: "Serpell",
    title: "Deputy Director Kleinman Center on Energy Policy",
    slug: "oscar-j-serpell",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Marta E.",
    lastName: "Serrano",
    title: "Receptionist Benefits",
    slug: "marta-e-serrano",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Daisy L.",
    lastName: "Serrano",
    title: "RES LAB TECH ENV MED INST FOR ENVIRON. MEDICINE",
    slug: "daisy-l-serrano",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Susan Stutsman",
    lastName: "Sessa",
    title: "Managing Director Zell/Lurie Real Estate Center",
    slug: "susan-stutsman-sessa",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Paul",
    lastName: "Severin",
    title: "Special Events Producer WXPN",
    slug: "paul-severin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "DENISE V",
    lastName: "SEYMOUR",
    title: "MANAGER CALL CENTER FACIL OPER AND MAINT ADMIN",
    slug: "denise-v-seymour",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Zoe",
    lastName: "Seznec Sweetland",
    title:
      " Associate Director C, Arts and Media, Events Wharton's AI & Analytics Initiative",
    slug: "zoe-seznec-sweetland",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Samuel",
    lastName: "Sfirri",
    title: "Archivist B University Archives",
    slug: "samuel-sfirri",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Paul W",
    lastName: "Shaffer",
    title:
      " Audio-Visual Equipment Support Computing and Educational Technology Services",
    slug: "paul-w-shaffer",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jalil M.",
    lastName: "Shafi",
    title: "Director, Human Resources Provost's Office",
    slug: "jalil-m-shafi",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Reima Y",
    lastName: "Shakeir",
    title:
      " Associate Director E, Student Services, Graduate Programs Wharton Communications Unit",
    slug: "reima-y-shakeir",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Tai",
    lastName: "Shanahan",
    title:
      " Development Assistant for Young Alumni and Student Philanthropy in The Penn Fund Penn Fund",
    slug: "tai-shanahan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Quyen",
    lastName: "Shanahan",
    title: "Associate General Manager WXPN Surrogate",
    slug: "quyen-shanahan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Cathy L.",
    lastName: "Shankman",
    title: "Academic Records Coordinator Wharton MBA Office",
    slug: "cathy-l-shankman",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Joseph P",
    lastName: "Shannon",
    title: "IT Director Financial Systems & Training, Division of Finance",
    slug: "joseph-p-shannon",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Eric L.",
    lastName: "Shapiro",
    title:
      " Research Operations Manager - Computational Social Science Lab Computer and Information Science",
    slug: "eric-l-shapiro",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Lila E",
    lastName: "Shapiro",
    title: "SYST ADMIN ISC Platforms Infrastructure",
    slug: "lila-e-shapiro",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Beth",
    lastName: "Shapiro",
    title: "Executive Director Gittis Legal Clinics",
    slug: "beth-shapiro",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Oleg",
    lastName: "Shargorodsky",
    title:
      " Application Developer Senior ISC-Applications & Information Services",
    slug: "oleg-shargorodsky",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Nadir",
    lastName: "Sharif",
    title:
      " Sr. Associate Director, Student Programs & Communication MBA Career Management",
    slug: "nadir-sharif",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Ian",
    lastName: "Sharp",
    title: "Coordinator, Program Wharton Executive MBA",
    slug: "ian-sharp",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Diane",
    lastName: "Sharp",
    title: "Director Wharton MBA Program for Executives",
    slug: "diane-sharp",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Scott",
    lastName: "Sharpe",
    title:
      " Senior Executive Director, Programs and Special Events Development and Alumni Relations",
    slug: "scott-sharpe",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Vincent",
    lastName: "Shaw",
    title: "Husbandry Cagewash/ vehicle operations Manager ULAR",
    slug: "vincent-shaw",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Christy A",
    lastName: "Shea",
    title: "Language Specialist English Language Program",
    slug: "christy-a-shea",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Angela L",
    lastName: "Sheed",
    title: "Instrument Sterilization Attendant B Instrument Management Service",
    slug: "angela-l-sheed",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Steven Jay",
    lastName: "Sheehan",
    title:
      " Exec. Dir. _ Bus. Dev., Sales, and Marketing Wharton Research Data Services (WRDS)",
    slug: "steven-jay-sheehan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Brendan",
    lastName: "Sheehan",
    title:
      " WRDS Sales and Marketing Coordinator Wharton Research Data Services",
    slug: "brendan-sheehan",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Sue",
    lastName: "Sheehan",
    title: "Financial Administrative Coordinator Wharton Dean's Office",
    slug: "sue-sheehan",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jennifer A.",
    lastName: "Sheffler",
    title: "Associate Director D, Business and Finance MBA Career Management",
    slug: "jennifer-a-sheffler",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Sam",
    lastName: "Sheldon",
    title: "Director, Fiscal Operations FRES Finance and Administration",
    slug: "sam-sheldon",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Louisa Jane",
    lastName: "Shepard",
    title: "EDITOR University Communications",
    slug: "louisa-jane-shepard",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Genevieve",
    lastName: "Sherick",
    title: "Director, Special Events External Affairs",
    slug: "genevieve-sherick",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Hanna E.",
    lastName: "Sherrill",
    title:
      " Associate Director Science Outreach Initiative, Office of Academic Excellence and Engagement",
    slug: "hanna-e-sherrill",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "ROBIN M",
    lastName: "SHERWOOD",
    title: "Academic Director Biology",
    slug: "robin-m-sherwood",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Sara Elizabeth",
    lastName: "Shibe",
    title: "Education Administrator DM-Department of Medicine",
    slug: "sara-elizabeth-shibe",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Daniel",
    lastName: "Shields",
    title: "Video Producer Senior Online Learning",
    slug: "daniel-shields",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Noor",
    lastName: "Shihabeddin",
    title: "Grant and Financial Coordinator Museum Administration",
    slug: "noor-shihabeddin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Seul Ki (Sophie)",
    lastName: "Shin",
    title: "Senior Economist Penn Wharton Budget Model",
    slug: "seul-ki-sophie-shin",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Corbett",
    lastName: "Shinn",
    title:
      " Senior Director of Data Analytics and Reporting, Penn Medicine Penn Medicine Development",
    slug: "corbett-shinn",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Robert",
    lastName: "Shipman",
    title: "Director, Staff and Labor Relations Staff & Labor",
    slug: "robert-shipman",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Jennifer",
    lastName: "Sholder",
    title: "Internal Audit Manager Audit and Privacy",
    slug: "jennifer-sholder",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Dan",
    lastName: "Shortridge",
    title: "Editor B University Communications",
    slug: "dan-shortridge",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Donna",
    lastName: "Showell",
    title: "MANAGER RECRUITMENT & STAFFING HUMAN RESOURCES",
    slug: "donna-showell",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Julie",
    lastName: "Shuttleworth",
    title: "Director E, Information Technology ISC-VP and Administration",
    slug: "julie-shuttleworth",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Chipo",
    lastName: "Siantumbu",
    title: "Director B, Academic Affairs Vet Dean's Office",
    slug: "chipo-siantumbu",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "VALERIE E",
    lastName: "SICA",
    title: "Coordinator, Program Office of Global Health Affairs",
    slug: "valerie-e-sica",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mary Ellen",
    lastName: "Siciliano",
    title: "Gift Administrator SR Wharton External Affairs",
    slug: "mary-ellen-siciliano",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sarah",
    lastName: "Sidoti",
    title:
      " Assistant Director, Humanities and Human Flourishing Project Positive Psychology Center",
    slug: "sarah-sidoti",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "David",
    lastName: "Siedell",
    title: "SENIOR DIRECTOR LEARNING TECHNOLOGY Wharton Computing",
    slug: "david-siedell",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Karl G",
    lastName: "Siegert",
    title: "Instructional Lab Coordinator Biology",
    slug: "karl-g-siegert",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sarin",
    lastName: "Sieng",
    title: "Financial Administrative Coordinator Statistics",
    slug: "sarin-sieng",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Brooke",
    lastName: "Sietinsons",
    title:
      " Associate Director of Digital Communications SAS Office of Advancement",
    slug: "brooke-sietinsons",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Michael L.",
    lastName: "Sievers",
    title: "Administrative Assistant B Office of Student Affairs",
    slug: "michael-l-sievers",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "James S",
    lastName: "Sillhart",
    title:
      " Associate Director for Occupational Safety Programs Environmental Health & Radiation Safety",
    slug: "james-s-sillhart",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Maria",
    lastName: "Silva",
    title: "Provost Administrative Affairs Office Manager Provost's Office",
    slug: "maria-silva",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Vanicleia",
    lastName: "Silva Santos",
    title: "Associate Curator University Museum",
    slug: "vanicleia-silva-santos",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Michelle P",
    lastName: "Silverio",
    title: "Assistant Director, Research Services Research Services",
    slug: "michelle-p-silverio",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Leslie",
    lastName: "Silverman",
    title:
      " Program Specialist OD-Center for Orphan Disease Research and Therapy",
    slug: "leslie-silverman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Celestine",
    lastName: "Silverman",
    title: "Business Administrator Comptroller's Office",
    slug: "celestine-silverman",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Theresa E",
    lastName: "Simmonds",
    title:
      " Training & TA Coordinator for Post-Secondary Success Program Netter Center for Community Partnerships",
    slug: "theresa-e-simmonds",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Richard",
    lastName: "Simmons",
    title: "CIRCULATION DESK ADM BIOMED LIB",
    slug: "richard-simmons",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lily G",
    lastName: "Simmons",
    title: "Coordinator B University Press",
    slug: "lily-g-simmons",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "HEATHER L",
    lastName: "SIMMONS",
    title: "Director of Research Penn Arts & Sciences Office of Advancement",
    slug: "heather-l-simmons",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Mollie",
    lastName: "Simon",
    title: "Senior Communications Specialist Kleinman Center on Energy Policy",
    slug: "mollie-simon",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Antoinette",
    lastName: "Simon",
    title: "DIRECTOR WH EXEC EDUC",
    slug: "antoinette-simon",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Phyllis C.",
    lastName: "Simon",
    title:
      " Patent Attorney, Associate General Counsel Penn Center for Innovation",
    slug: "phyllis-c-simon",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Kristen M",
    lastName: "Simon",
    title: "GRADUATE COORDINATOR Chemistry",
    slug: "kristen-m-simon",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Fatimah S",
    lastName: "Simpkins",
    title: "Talent Acquisition Coordinator Recruitment",
    slug: "fatimah-s-simpkins",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Beverly N",
    lastName: "Simpson",
    title: "Network Specialist Senior ISC-Tech Services-Network Operations",
    slug: "beverly-n-simpson",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Sunshine",
    lastName: "Singer",
    title: "DIRECTOR OF STUDENT ENGAGEMENT MBA Career Mangement",
    slug: "sunshine-singer",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Manroocha Kaur",
    lastName: "Singh",
    title:
      " Talent and Organizational Development Consultant Learning & Education",
    slug: "manroocha-kaur-singh",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Justin A.",
    lastName: "Singleton",
    title: "Veterans Upward Bound Administrative Assistant Student Engagement",
    slug: "justin-a-singleton",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Janice",
    lastName: "Singleton",
    title: "Coordinator B Health Care",
    slug: "janice-singleton",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tomea",
    lastName: "Sippio-Smith",
    title:
      " Director, Coalition for Educational Equity Penn Center for Educational Leadership",
    slug: "tomea-sippio-smith",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Edwin",
    lastName: "Siu",
    title: "Assistant Biosafety Officer Environmental Health and Safety",
    slug: "edwin-siu",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Yvonne S.",
    lastName: "Skeith",
    title: "Administrative Coordinator, Gift Planning Gift Planning",
    slug: "yvonne-s-skeith",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ben",
    lastName: "Slocum",
    title: "Investment Associate Office of Investments",
    slug: "ben-slocum",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Hanna",
    lastName: "Smal",
    title: "CONTRACTS ADMINISTRATOR General Counsel",
    slug: "hanna-smal",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Travis A.",
    lastName: "Smale",
    title: "Systems Administrator / Senior Web Designer Financial Systems",
    slug: "travis-a-smale",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Deborah",
    lastName: "Small-Mccord",
    title: "ASST MGR STOUFFER FOOD SVCS",
    slug: "deborah-small-mccord",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Paul",
    lastName: "Smalley",
    title: "ULAR Director C ULAR",
    slug: "paul-smalley",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Andrew",
    lastName: "Smarowsky",
    title: "Grant and Contract Finance Administrator Research Services",
    slug: "andrew-smarowsky",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Wilma",
    lastName: "Smith",
    title: "BSD Business Services",
    slug: "wilma-smith",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tahirah",
    lastName: "Smith",
    title: "Events Manager Marketing and Communications",
    slug: "tahirah-smith",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "CATHERINE R",
    lastName: "SMITH",
    title:
      " Marketing and Communications Writer College of Liberal and Professional Studies",
    slug: "catherine-r-smith",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Christopher J",
    lastName: "Smith",
    title:
      " Senior Director of Virtual Teaching and Learning, WCIT Wharton Computing and Instructional Technology (WCIT)",
    slug: "christopher-j-smith",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Lisa D.",
    lastName: "Smith",
    title: "Assistant Director, Disbursements Procurement Services",
    slug: "lisa-d-smith",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Marianne J",
    lastName: "Smith",
    title: "ASSOC DIR ADMISS NURS",
    slug: "marianne-j-smith",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Melissa A",
    lastName: "Smith",
    title: "BENEFITS SPECIALIST SR",
    slug: "melissa-a-smith",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Melissa P",
    lastName: "Smith",
    title: "Chief Operating Officer Wharton Executive Education",
    slug: "melissa-p-smith",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nicholas",
    lastName: "Smith",
    title: "Director, Financial Planning and Analysis FINANCE AND TREASURY",
    slug: "nicholas-smith",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Raji S",
    lastName: "Smith",
    title: "IT Support Specialist Office of Residential Computer Support",
    slug: "raji-s-smith",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Ron Kirk",
    lastName: "Smith",
    title: "Administrative Coordinator Real Estate Center",
    slug: "ron-kirk-smith",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tim",
    lastName: "Smith",
    title: "Assistant Museum Collections, University Museum University Museum",
    slug: "tim-smith",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sharon",
    lastName: "Smith",
    title: "DIRECTOR STUDENT INTERVENTION SVCS VPUL",
    slug: "sharon-smith",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Samuel C",
    lastName: "Smith",
    title:
      " IT Sr Project Leader Wharton Computing and Instructional Technology (WCIT)",
    slug: "samuel-c-smith",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Macy",
    lastName: "Smith",
    title: "Upward Bound Associate Director Student Engagement",
    slug: "macy-smith",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Michael F",
    lastName: "Smith",
    title:
      " DIRECTOR OF COMMONWEALTH RELATIONS Government, Community and Public Affairs",
    slug: "michael-f-smith",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mercedes",
    lastName: "Smith",
    title:
      " Development Coordinator, Undergraduate and Individual Giving AVP University Development",
    slug: "mercedes-smith",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Laura Park",
    lastName: "Smith",
    title: "DIR PORTFOLIO MGT Institutional Real Estate",
    slug: "laura-park-smith",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Lamar H",
    lastName: "Smith",
    title: "Administrative Assistant Health and Wellness Administration",
    slug: "lamar-h-smith",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kobie A.",
    lastName: "Smith",
    title:
      " Director of Development Raymond and Ruth Perelman School of Medicine, Development and Alumni Relations",
    slug: "kobie-a-smith",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Daphne R",
    lastName: "Smith",
    title:
      " Associate Director D, Business and Finance SM-DN Strategic Planning and Reporting",
    slug: "daphne-r-smith",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Cheryl Lisa",
    lastName: "Smith",
    title:
      " Director Space Management and Documentation Office of the University Architect",
    slug: "cheryl-lisa-smith",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Briar R.",
    lastName: "Smith",
    title:
      " Associate Director D, Academic Affairs, Academic Center Annenberg School for Communication",
    slug: "briar-r-smith",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Annette",
    lastName: "Smith",
    title:
      " Information Technology Technical Director ISC-CLIENT SERVICES-HIREIT",
    slug: "annette-smith",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Adam Daniel",
    lastName: "Smith",
    title: "Associate Curator University Museum",
    slug: "adam-daniel-smith",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Paula",
    lastName: "Smith-Marshall",
    title:
      " Information Technology Project Leader Senior ISC-Tech Services-Network Operations",
    slug: "paula-smith-marshall",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Douglas",
    lastName: "Smullens",
    title: "Director of Client and Core Services Penn Libraries",
    slug: "douglas-smullens",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "DEB",
    lastName: "SNEDDON",
    title: "Coordinator, Program CB-Cancer Biology",
    slug: "deb-sneddon",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Thomas",
    lastName: "Snow",
    title: "Development Coordinator Penn Medicine Development",
    slug: "thomas-snow",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Keith A.",
    lastName: "Snyder",
    title: "Equipment Supervisor Horticulture",
    slug: "keith-a-snyder",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jeff",
    lastName: "Snyder",
    title:
      " Assistant Dean, Development & Alumni Relations, Penn Design Design in DAR",
    slug: "jeff-snyder",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Eric M",
    lastName: "Snyder",
    title: "IT MANAGER SR ISC Technology Services",
    slug: "eric-m-snyder",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Lisa",
    lastName: "Sochovka",
    title: "Associate Director, Special Events External Affairs",
    slug: "lisa-sochovka",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Abdul Moiz",
    lastName: "Sohu",
    title: "Sr. Application Developer Marketing and Communications Group",
    slug: "abdul-moiz-sohu",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Trina Nocerino",
    lastName: "Sokoloski",
    title:
      " Senior Director for Academic and Residential Programs Director of CHAS (College House and Academic Services",
    slug: "trina-nocerino-sokoloski",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Sara R",
    lastName: "Solomon",
    title: "DEPUTY DIRECTOR PENN INJURY SCIENCE CENTER EG-Emergency Medicine",
    slug: "sara-r-solomon",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Ellen C",
    lastName: "Solvibile",
    title:
      " Director, Academic Business Operations CD-Cell and Development Biology",
    slug: "ellen-c-solvibile",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Michelle C.",
    lastName: "Sonsino",
    title: "Director, Federal Affairs Government, Community and Public Affairs",
    slug: "michelle-c-sonsino",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Tom",
    lastName: "Sontag",
    title:
      " Executive Director HR, Learning & Education/Communications Learning & Education",
    slug: "tom-sontag",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Patricia",
    lastName: "Soria",
    title: "ADMIN ASST Greenfield Intercultural Center",
    slug: "patricia-soria",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nicole Christine",
    lastName: "Soroka",
    title:
      " Associate Director, Graduate Aid Student Registration & Financial Services",
    slug: "nicole-christine-soroka",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jennifer Lee",
    lastName: "Sorrentino",
    title: "Grants Manager A Research Support Center (RSC)",
    slug: "jennifer-lee-sorrentino",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "ANTHONY P",
    lastName: "SORRENTINO",
    title: "Assistant Vice President Office of the EXECUTIVE VICE PRESIDENT",
    slug: "anthony-p-sorrentino",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Michele R M",
    lastName: "Souli",
    title: "Affiliation: Staff",
    slug: "michele-r-m-souli",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Yvonne Monique",
    lastName: "Sousa",
    title: "Administrative Coordinator Penn Vet",
    slug: "yvonne-monique-sousa",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Danielle P",
    lastName: "Southerland",
    title: "IT SUPPORT SPECIALIST ISC",
    slug: "danielle-p-southerland",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kristin",
    lastName: "Sowden",
    title:
      " Associate Director C, Student Services, Advising Bachelor of Applied Arts & Sciences and Certificate Programs",
    slug: "kristin-sowden",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Julie",
    lastName: "Spaeth",
    title: "Chief Executive Director of Operations Penn Medicine",
    slug: "julie-spaeth",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Matthew A",
    lastName: "Spalding",
    title: "Application Developer Sr Wharton Research Data Services",
    slug: "matthew-a-spalding",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Ms. M. PATRICIA A.",
    lastName: "SPANN",
    title: "ASST TO CHR PSYCHOL",
    slug: "ms-m-patricia-a-spann",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Wendy",
    lastName: "Sparks",
    title: "DIRECTOR OF HOUSEKEEPING Operations and Maintenance Administration",
    slug: "wendy-sparks",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sarah",
    lastName: "Spaulding",
    title:
      " Information Technology Executive Director, Administrative Partnership Wharton Computing and Instructional Technology (WCIT)",
    slug: "sarah-spaulding",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Michael",
    lastName: "Speechley",
    title:
      " Information Technology Project Leader ISC-Tech Services-Network Operations",
    slug: "michael-speechley",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Ansheai M",
    lastName: "Spence-Jones",
    title: "Coordinator B SM-ED-Continuing Medical Education/Extramural",
    slug: "ansheai-m-spence-jones",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Saranac Hale",
    lastName: "Spencer",
    title: "Staff Writer, FactCheck.org Annenberg Public Policy Center",
    slug: "saranac-hale-spencer",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Alaina",
    lastName: "Spiegel",
    title:
      " College Mental Health Professional Counseling and Psychological Services",
    slug: "alaina-spiegel",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Elaine K",
    lastName: "Spiro",
    title: "COMPENSATION SPEC SR HUMAN RESOURCES",
    slug: "elaine-k-spiro",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Scott H",
    lastName: "Spitzer",
    title:
      " Manager, Web Design & Photographic Content University Communications",
    slug: "scott-h-spitzer",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Melanie",
    lastName: "Sposa",
    title: "Executive Director of Human Resources SDM Deans Office",
    slug: "melanie-sposa",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Laura Anne",
    lastName: "Sprague",
    title:
      " Administrative & Quality Assurance Manager Basic and Translational Sciences",
    slug: "laura-anne-sprague",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Emma",
    lastName: "Springer",
    title: "Assistant Director, Student-Athlete Success DRIA Academic Support",
    slug: "emma-springer",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Susan",
    lastName: "Sproat",
    title: "Executive Director HR, Benefits Benefits",
    slug: "susan-sproat",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Giovanni",
    lastName: "Stabile",
    title: "Senior Training Specialist Information Services",
    slug: "giovanni-stabile",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "MICHAEL",
    lastName: "STACK",
    title: "DIRECTOR, BUDGET & CAPITAL PLANNING FRES ADMIN",
    slug: "michael-stack",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Susan",
    lastName: "Staggs",
    title: "Production Coordinator University Press",
    slug: "susan-staggs",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Samantha F.",
    lastName: "Stahl",
    title:
      " Director C, Student Services, Executive Education Wharton Center for Leadership and Change Management",
    slug: "samantha-f-stahl",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Katie Tracey",
    lastName: "Staley",
    title: "DATA WAREHOUSE ARCHITECT ISC-Applications & Information Services",
    slug: "katie-tracey-staley",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Donna P",
    lastName: "Stalker",
    title: "Executive Assistant to the Provost Provost's Office",
    slug: "donna-p-stalker",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kris",
    lastName: "Stallings",
    title:
      " Temporary Staff - Non-Degree Penn Student SM-DN-Inclusion, Diversity, Equity, & Learner Exp Prog in Me",
    slug: "kris-stallings",
    dei: true,
    category: "Student Life",
  },
  {
    firstName: "Cherie M",
    lastName: "Stanford",
    title: "Administrative Assistant B Health and Wellness Administration",
    slug: "cherie-m-stanford",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Patrick A.",
    lastName: "Stanko",
    title: "IRB Reliance Review Manager Institutional Review Board",
    slug: "patrick-a-stanko",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Thomas A",
    lastName: "Stanley",
    title: "Associate Director of Digital Communications DAR Communications",
    slug: "thomas-a-stanley",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Karl",
    lastName: "Stark",
    title: "Director C, Business and Finance Leonard Davis Institute",
    slug: "karl-stark",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Samuel B",
    lastName: "Starks",
    title: "EXECUTIVE DIRECTOR Office of Equal Opportunity Programs",
    slug: "samuel-b-starks",
    dei: true,
    category: "Human Resources",
  },
  {
    firstName: "Basha",
    lastName: "Starr",
    title:
      " Registrar & Director of Student Services, Undergraduate Studies Annenberg School for Communication",
    slug: "basha-starr",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "SUGIRTHA",
    lastName: "STATHIS",
    title:
      " Director of Student Programs and Communication MBA Career Management",
    slug: "sugirtha-stathis",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Stephanie A",
    lastName: "Stawicki",
    title:
      " Director E, Student Services, Executive Education Executive Education Online",
    slug: "stephanie-a-stawicki",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Katie",
    lastName: "Steele",
    title:
      " Associate Director B, Student Services, Undergraduate Programs Program on Opinion Research and Election Studies",
    slug: "katie-steele",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Douglas Edward",
    lastName: "Steele",
    title: "Senior Project Manager-5 YR Term Project Management",
    slug: "douglas-edward-steele",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Leah",
    lastName: "Steely",
    title: "Administrative Coordinator Benefits",
    slug: "leah-steely",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Hillary",
    lastName: "Stein",
    title: "Tax Accountant Administrator Comptroller's Office",
    slug: "hillary-stein",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jarrett M.",
    lastName: "Stein",
    title:
      " Director- Academic Partnerships Agatston Urban Nutrition Initiative",
    slug: "jarrett-m-stein",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "John",
    lastName: "Stein",
    title: "STAFF PSYCHIATRIST Counseling and Psychological Services",
    slug: "john-stein",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Robert",
    lastName: "Stein",
    title: "NETWORK ADMINISTRATOR FRES INFO TECH SVCS",
    slug: "robert-stein",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kat",
    lastName: "Stein",
    title: "Executive Director, Communications Education",
    slug: "kat-stein",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Kathryn Ann",
    lastName: "Stellato",
    title:
      " Center Coordinator, Center for Ethics and the Rule of Law Annenberg Public Policy Center",
    slug: "kathryn-ann-stellato",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Monica",
    lastName: "Stepanow",
    title: "Director of the Penn Alumni Interview Program Alumni Relations",
    slug: "monica-stepanow",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Christopher",
    lastName: "Stepansky",
    title:
      " Information Technology Support Specialist Senior ISC-Client Services-Technology Support Services",
    slug: "christopher-stepansky",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Roz",
    lastName: "Stepteau",
    title: "Gifts/Records Administrator Senior Gift Administration",
    slug: "roz-stepteau",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "GWENDOLYN",
    lastName: "STEVENS",
    title: "House Director CHAS House Deans",
    slug: "gwendolyn-stevens",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Zachary",
    lastName: "Stevenson",
    title:
      " Senior Director, Planning, Design, & Construction SEAS Planning, Design, and Construction",
    slug: "zachary-stevenson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Xavier O",
    lastName: "Stewart",
    title:
      " Associate Director D, Business and Finance, Innovation Wharton Entrepreneurship",
    slug: "xavier-o-stewart",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Thomas",
    lastName: "Stewart",
    title:
      " Director of Student Loans, Financial Aid Systems and Title VI Operations Student Registration & Financial Services",
    slug: "thomas-stewart",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Ida D",
    lastName: "Stewart",
    title: "Managing Editor, Journal of History of Ideas History",
    slug: "ida-d-stewart",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Bob",
    lastName: "Stewart",
    title:
      " Information Technology Support Specialist Senior Wharton Behavioral Lab",
    slug: "bob-stewart",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Pashia",
    lastName: "Stewart",
    title: "Operations Associate Research Services",
    slug: "pashia-stewart",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "DuBois Ellington",
    lastName: "Stewart",
    title: "IT Support Specialist Admissions",
    slug: "dubois-ellington-stewart",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Sean",
    lastName: "Stickel",
    title: "Controller Business Services",
    slug: "sean-stickel",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Eric Bernard",
    lastName: "Stills Jr",
    title: "Administrative Coordinator External Affairs",
    slug: "eric-bernard-stills-jr",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Julia",
    lastName: "Stilwell",
    title: "Social Worker PS-Mental Health Services",
    slug: "julia-stilwell",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Caryn H",
    lastName: "Stivelman",
    title: "Director of Career Advancement VET Office of Students",
    slug: "caryn-h-stivelman",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Barbara L",
    lastName: "Stoddard",
    title: "Assistant Director Undergraduate Admissions",
    slug: "barbara-l-stoddard",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Yolanda",
    lastName: "Stokes",
    title: "Operations Manager Family Resource Center",
    slug: "yolanda-stokes",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Patricia Marie",
    lastName: "Stokes",
    title: "Grants Coordinator MED- Pathology Business Office",
    slug: "patricia-marie-stokes",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Peter M.",
    lastName: "Stokes",
    title:
      " Director of Administration and Advising Vagelos Program in Life Sciences & Management",
    slug: "peter-m-stokes",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "DEBORAH L",
    lastName: "STOKES",
    title: "ADMIN COORDINATOR ADMINISTRATION",
    slug: "deborah-l-stokes",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Katelyn A",
    lastName: "Stoler",
    title: "Graduate Coordinator SAS Graduate Division Administration",
    slug: "katelyn-a-stoler",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Vanessa",
    lastName: "Stoloff",
    title: "Medical Director Student Health Services",
    slug: "vanessa-stoloff",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Quentin A",
    lastName: "Stoltzfus",
    title:
      " IT Project Leader Wharton Computing and Instructional Technology (WCIT)",
    slug: "quentin-a-stoltzfus",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Rae",
    lastName: "Stone",
    title:
      " Information Technology Support Specialist Senior ISC-Client Services-Technology Support Services",
    slug: "rae-stone",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Meredith",
    lastName: "Stone",
    title:
      " Director B, Arts and Media, Communications and Marketing Undergraduate Division",
    slug: "meredith-stone",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Lori E",
    lastName: "Stone",
    title: "Swine Manager NBC SWINE",
    slug: "lori-e-stone",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ellen M",
    lastName: "Stone",
    title: "Bus Administrator Information Services SOM SOM",
    slug: "ellen-m-stone",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Elizabeth",
    lastName: "Stone",
    title: "Administrative Assistant B Wharton San Francisco",
    slug: "elizabeth-stone",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nicole R",
    lastName: "Stottlemyer",
    title: "Coordinator, Program Master of Applied Positive Psychology",
    slug: "nicole-r-stottlemyer",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Sandy",
    lastName: "Strapp",
    title:
      " Associate Director, Parent & Family Giving Major Gifts Parent's Program",
    slug: "sandy-strapp",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Christina",
    lastName: "Strathearn Vanco",
    title: "PennERA Support Specialist Research Services",
    slug: "christina-strathearn-vanco",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Ashley M.",
    lastName: "Straub",
    title:
      " College Mental Health Professional Counseling and Psychological Services",
    slug: "ashley-m-straub",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jamie",
    lastName: "Strausbaugh",
    title: "Application Developer Senior Linguistic Data Consortium",
    slug: "jamie-strausbaugh",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Ella",
    lastName: "Strauss",
    title:
      " Associate Director, Advising, Programming, and Communications Program in International Studies and Business",
    slug: "ella-strauss",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Kerri",
    lastName: "Strike Stahller",
    title:
      " Director, Procurement Innovation and Effectiveness Procurement Services",
    slug: "kerri-strike-stahller",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Elisa",
    lastName: "Stroh",
    title: "ADMIN COORDINATOR Center for the Study of the History of Nursing",
    slug: "elisa-stroh",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Timothy C",
    lastName: "Struder",
    title:
      " Information Technology Director Nursing Office of Information Services",
    slug: "timothy-c-struder",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Laura",
    lastName: "Stubbs",
    title:
      " Director SEAS Office of Diversity & Inclusion (formerly Multicultural Programs)",
    slug: "laura-stubbs",
    dei: true,
    category: "Academic",
  },
  {
    firstName: "Ella Bronson",
    lastName: "Studdiford",
    title: "Administrative Coordinator, Communication & Events Career Services",
    slug: "ella-bronson-studdiford",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Rebecca Kane",
    lastName: "Studdy",
    title:
      " Information Technology Support Specialist Senior Wharton Computing and Instructional Technology (WCIT)",
    slug: "rebecca-kane-studdy",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Aubrey",
    lastName: "Stueven",
    title: "Compensation Specialist SM-DN-Senior Executive Director",
    slug: "aubrey-stueven",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Deborah",
    lastName: "Stull",
    title: "Editor C University Communications",
    slug: "deborah-stull",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Sreya",
    lastName: "Subramanian",
    title: "Assistant Program Manager Wharton Executive Education (Operations)",
    slug: "sreya-subramanian",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Eric A",
    lastName: "Sucar",
    title: "PHOTOGRAPHER University Communications",
    slug: "eric-a-sucar",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Gretchen E L",
    lastName: "Suess",
    title: "Director of Evaluation Netter Center for Community Partnerships",
    slug: "gretchen-e-l-suess",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Alaysha A.",
    lastName: "Suggs",
    title: "Manager, Pre-Baccalaureate Programs Wharton Global Youth Programs",
    slug: "alaysha-a-suggs",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Dr. Michael E., MD",
    lastName: "Sulewski",
    title: "Affiliation: Staff",
    slug: "dr-michael-e-md-sulewski",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Jennifer",
    lastName: "Sullenberger",
    title: "ASSOCIATE DIRECTOR, DONOR ENGAGEMENT Major Gifts Program",
    slug: "jennifer-sullenberger",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Matthew D",
    lastName: "Sullivan",
    title:
      " Information Technology Manager ISC-Client Services-Technology Support Services",
    slug: "matthew-d-sullivan",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Michael R",
    lastName: "Sullivan",
    title: "Language Specialist - Science English Language Program",
    slug: "michael-r-sullivan",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jack M",
    lastName: "Sullivan",
    title:
      " Director, English Language Programs Professional and Liberal Education (PLE)",
    slug: "jack-m-sullivan",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Lauren",
    lastName: "Summers",
    title: "Senior Staff University Communications",
    slug: "lauren-summers",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Zhuoxuan",
    lastName: "Sun",
    title: "UACS Literacy Coordinator Netter Center for Community Partnerships",
    slug: "zhuoxuan-sun",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Faustine",
    lastName: "Sun",
    title:
      " Assistant Director of the Netter Center Netter Center for Community Partnerships",
    slug: "faustine-sun",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Andrew",
    lastName: "Sun",
    title: "Systems Administrator Senior IT CLIENT SERVICES",
    slug: "andrew-sun",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Emily R",
    lastName: "Sutcliffe",
    title: "Director, Social Justice Programs Penn Law",
    slug: "emily-r-sutcliffe",
    dei: true,
    category: "Legal",
  },
  {
    firstName: "Hiral",
    lastName: "Suthar",
    title: "Resident COH Extramural Activities",
    slug: "hiral-suthar",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "DAVOR",
    lastName: "SVETINOVIC",
    title: "Graduate Coordinator Cinema and Media Studies",
    slug: "davor-svetinovic",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Lauren T",
    lastName: "Swain",
    title:
      " Financial Administrative Coordinator Weingarten Learning Resource Center Operations",
    slug: "lauren-t-swain",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Alyssa D.",
    lastName: "Swanson",
    title: "Associate Director Wharton External Affairs",
    slug: "alyssa-d-swanson",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "John S.",
    lastName: "Swartley",
    title: "ASSOC VICE PROVOST Penn Center for Innovation",
    slug: "john-s-swartley",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Suzy",
    lastName: "Swartz",
    title: "Senior Business Support Representative WXPN Surrogate",
    slug: "suzy-swartz",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "TODD S",
    lastName: "SWAVELY",
    title:
      " Director, Electronic Research Administration Systems Research Services",
    slug: "todd-s-swavely",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Christine M",
    lastName: "Sweeney",
    title:
      " Director, Open Enrollment Programs Wharton Executive Education (Open Enrollment)",
    slug: "christine-m-sweeney",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jaime L",
    lastName: "Sweet",
    title: "Pennovation Center Programming Manager PCI Ventures",
    slug: "jaime-l-sweet",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "michelle",
    lastName: "swenson",
    title:
      " Systems Administrator Senior Wharton Computing and Instructional Technology (WCIT)",
    slug: "michelle-swenson",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Violette A",
    lastName: "Swinton",
    title: "ADMIN ASST Economics",
    slug: "violette-a-swinton",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Neal R",
    lastName: "Swisher",
    title:
      " IT Technical Director for Instructional and Academic Services Information Technology Services",
    slug: "neal-r-swisher",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Annalee Jude",
    lastName: "Switek",
    title: "Application Developer Senior IH-Immune Health Core",
    slug: "annalee-jude-switek",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kimberle",
    lastName: "Szczurowski",
    title:
      " Financial Administrative Coordinator Kleinman Center on Energy Policy",
    slug: "kimberle-szczurowski",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Bruce",
    lastName: "Szewczyk",
    title: "Storage Administrator ISC Technology Services",
    slug: "bruce-szewczyk",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Rachel L",
    lastName: "Szkaradnik",
    title: "BUSINESS MANAGER Wharton Finance & Administration",
    slug: "rachel-l-szkaradnik",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Emily",
    lastName: "Szmidt",
    title: "Grant and Contract Finance Administrator Research Services",
    slug: "emily-szmidt",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jason S",
    lastName: "Szostek",
    title: "IT SR Project Leader PMACS",
    slug: "jason-s-szostek",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Eric",
    lastName: "Szot",
    title: "STEM Tutoring Coordinator Tutoring",
    slug: "eric-szot",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Teran",
    lastName: "Tadal",
    title:
      " Director of Student Development & Initiatives Undergraduate Division",
    slug: "teran-tadal",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Lisa",
    lastName: "Taglang",
    title: "University Connection Programs Manager English Language Programs",
    slug: "lisa-taglang",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Grace Eun",
    lastName: "Tak",
    title:
      " Associate Director of Custom Programs, Wharton Online Executive Education Online",
    slug: "grace-eun-tak",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Yoko",
    lastName: "Takahashi",
    title: "Publications Designer Law Communications",
    slug: "yoko-takahashi",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Tomo",
    lastName: "Takebe",
    title:
      " Information Technology Architect ISC-Tech Services-Network Operations",
    slug: "tomo-takebe",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Andrew",
    lastName: "Talaga",
    title:
      " Director, Campus Identification Services (PennCard); Division of Business Services Campus Card Services",
    slug: "andrew-talaga",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "CRYSTAL",
    lastName: "TALBOT",
    title: "Accounting Clerk WXPN Surrogate",
    slug: "crystal-talbot",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Susan J.",
    lastName: "Talbutt",
    title: "APPLICATIONS DEVELOPER SR SM-DN-Business Office",
    slug: "susan-j-talbutt",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Angelo A",
    lastName: "Talley",
    title: "Mail Carrier; Business Services Mail",
    slug: "angelo-a-talley",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Michael",
    lastName: "Talley",
    title: "Strategic Sourcing Manager Penn Purchasing Services",
    slug: "michael-talley",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ka-Wing",
    lastName: "Tam",
    title:
      " Enterprise Service and Systems Director Wharton Computing and Instructional Technology (WCIT)",
    slug: "ka-wing-tam",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Rebecca",
    lastName: "Tamayo White",
    title:
      " Community-Engaged Professional Education Administrator Masters of Social Work",
    slug: "rebecca-tamayo-white",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Montana Leigh",
    lastName: "Tamny",
    title: "Program Manager, CSIS Center for Social Impact Strategy",
    slug: "montana-leigh-tamny",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Reshma",
    lastName: "Tanna",
    title: "Graduate & Personnel Administrator Mathematics",
    slug: "reshma-tanna",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Dave",
    lastName: "Tarampi",
    title: "Software Asset Manager ISC : Shared Services : IT Supply Chain",
    slug: "dave-tarampi",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Blythe",
    lastName: "Tarbox",
    title:
      " Associate Director of Development, Major Gifts - Athletics DRIA Development",
    slug: "blythe-tarbox",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jerry",
    lastName: "Tardiff",
    title: "Director, Strategic Analysis Wharton Finance and Administration",
    slug: "jerry-tardiff",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Marissa Anne",
    lastName: "Tartaglia",
    title: "Assistant Director Philosophy, Politics and Economics",
    slug: "marissa-anne-tartaglia",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Edward",
    lastName: "Tatum",
    title: "BUSINESS MANAGER LAUDER INSTITUTE",
    slug: "edward-tatum",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Gregory M",
    lastName: "Tausz",
    title:
      " Sr. Director of Finance and Facility Management The Graduate School of Education",
    slug: "gregory-m-tausz",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jose I.",
    lastName: "Tavarez",
    title:
      " Director of Financial Management, Planning, and Analysis Finance and Administration",
    slug: "jose-i-tavarez",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Brent",
    lastName: "Taylor",
    title: "Administrative Assistant, NGSS ISC-VP and Administration",
    slug: "brent-taylor",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Brian T",
    lastName: "Taylor",
    title: "MEMBERSHIP COORDINATOR Linguistic Data Consortium",
    slug: "brian-t-taylor",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ed",
    lastName: "Taylor",
    title: "Senior Web Developer Admissions",
    slug: "ed-taylor",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Melody",
    lastName: "Taylor",
    title: "Senior Grants Manager Office of Nursing Research",
    slug: "melody-taylor",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Laura",
    lastName: "Taylor",
    title:
      " Manager B, Student Services, Academic Programs Bachelor of Applied Arts & Sciences and Certificate Programs",
    slug: "laura-taylor",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "KRISTIN A",
    lastName: "TEDERSTROM",
    title: "ASSOCIATE DIRECTOR OFFICE OF RESEARCH SERVICES",
    slug: "kristin-a-tederstrom",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Michael P",
    lastName: "Tees",
    title: "IT Associate Director, Support Services SDM Computing",
    slug: "michael-p-tees",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Ryan T",
    lastName: "Teitman",
    title: "Senior Development Writer DAR Communications",
    slug: "ryan-t-teitman",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Yacob T",
    lastName: "Tekie",
    title:
      " College Mental Health Professional Counseling and Psychological Services",
    slug: "yacob-t-tekie",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Mr. F. Omar",
    lastName: "Telan",
    title:
      " Systems Administrator Senior Wharton Computing and Instructional Technology (WCIT)",
    slug: "mr-f-omar-telan",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jessica",
    lastName: "Templeton",
    title: "Administrative Coordinator Office of Finance and Administration",
    slug: "jessica-templeton",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Kyle A.",
    lastName: "Teoh",
    title:
      " Administrative Assistant, Preventive & Restorative Sciences/Prosthodontics Preventive and Restorative Sciences",
    slug: "kyle-a-teoh",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Laura D.",
    lastName: "Tepper",
    title: "Vice Dean for Development and Alumni Relations GSE in DAR",
    slug: "laura-d-tepper",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Paolo",
    lastName: "Terni",
    title: "Director, Senior Research Support Psychology",
    slug: "paolo-terni",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "ROBERT R",
    lastName: "TERRELL",
    title: "ASSOC GEN COUNSEL",
    slug: "robert-r-terrell",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Loraine",
    lastName: "Terrell",
    title: "Executive Director of Communications SAS",
    slug: "loraine-terrell",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Katrina Z",
    lastName: "Terrell",
    title: "Senior Benefits Specialist Human Resources",
    slug: "katrina-z-terrell",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Muthukrishnan",
    lastName: "Thiagarajan",
    title:
      " Application Developer Senior ISC-Applications & Information Services",
    slug: "muthukrishnan-thiagarajan",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Stephanie M",
    lastName: "Thistle",
    title:
      " Director of Recruitment, Admissions, and Financial Aid Law Admissions and Financial Aid",
    slug: "stephanie-m-thistle",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "WYLIE A",
    lastName: "THOMAS",
    title:
      " Senior Associate Vice President, University Development SAVP University Development",
    slug: "wylie-a-thomas",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Timothy N",
    lastName: "Thomas",
    title: "HLTH PHYSICS TECH ENV HLTH & RAD SAFETY",
    slug: "timothy-n-thomas",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Joshua",
    lastName: "Thomas",
    title: "Regional Director, International Relations External Affairs",
    slug: "joshua-thomas",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Philip Peter",
    lastName: "Thomas",
    title: "Grants Manager A Business Operations",
    slug: "philip-peter-thomas",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "PHILIP",
    lastName: "THOMAS",
    title:
      " South Asia Technical Services Assistant AREA STUDIES TECHNICAL SERVICES",
    slug: "philip-thomas",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Nyamah",
    lastName: "Thomas",
    title: "Senior Staff and Labor Relations Specialist Staff & Labor",
    slug: "nyamah-thomas",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Michelle D.",
    lastName: "Thomas",
    title:
      " Senior Gifts and Records Administrator, Penn Medicine Penn Medicine Development",
    slug: "michelle-d-thomas",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lillian E",
    lastName: "Thomas",
    title: "Financial Admin Coordinator MBO",
    slug: "lillian-e-thomas",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Dan",
    lastName: "Thomas",
    title:
      " Director of College House Information Technology College Houses and Academic Services",
    slug: "dan-thomas",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Alyssa D'Alconzo",
    lastName: "Thomas",
    title: "Director, Penn Alumni Lifelong Learning Alumni Relations",
    slug: "alyssa-d-alconzo-thomas",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Daivone",
    lastName: "Thomas",
    title: "Junior Accountant FRES Finance and Administration",
    slug: "daivone-thomas",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Andreana",
    lastName: "Thomas",
    title: "Executive Assistant A Office of Investments",
    slug: "andreana-thomas",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Tamika N.",
    lastName: "Thomas-Jackson",
    title:
      " Manager of Gifts Administration, Penn Medicine Penn Medicine Development",
    slug: "tamika-n-thomas-jackson",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Tena",
    lastName: "Thomason",
    title: "Assistant Director for Public Programs Penn Museum",
    slug: "tena-thomason",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Allison E",
    lastName: "Thompson",
    title:
      " Executive Director, Center for Guaranteed Income Research Center for Guaranteed Income",
    slug: "allison-e-thompson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ashley P.",
    lastName: "Thompson",
    title: "Pennant Operations Senior Director Financial Systems",
    slug: "ashley-p-thompson",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Ann Marie J",
    lastName: "Thompson",
    title: "Administrative Coordinator AN-Anesthesia",
    slug: "ann-marie-j-thompson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Catherine",
    lastName: "Thompson",
    title: "Senior Project Manager Admissions",
    slug: "catherine-thompson",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Bryan S",
    lastName: "Thompson-Nowak",
    title: "Director, Education and Urban Forestry Arboretum Education",
    slug: "bryan-s-thompson-nowak",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Keith",
    lastName: "Thorne",
    title: "Supervisor B Mail Services",
    slug: "keith-thorne",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Yuni",
    lastName: "Thornton",
    title: "Department Manager Psychology",
    slug: "yuni-thornton",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Erin E",
    lastName: "Thornton",
    title: "Senior Internal Auditor Audit and Privacy",
    slug: "erin-e-thornton",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Elizabeth M",
    lastName: "Thornton",
    title:
      " Executive Assistant Central Administration, Office of the Senior Executive Vice President",
    slug: "elizabeth-m-thornton",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alison Elizabeth",
    lastName: "Thornton",
    title: "Associate Director of Development Morris Arboretum",
    slug: "alison-elizabeth-thornton",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Robert",
    lastName: "Thurlow",
    title: "Special Projects Manager University Museum",
    slug: "robert-thurlow",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Claire",
    lastName: "Thurston-Emmert",
    title: "Garden Supervisor Biology",
    slug: "claire-thurston-emmert",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Miao",
    lastName: "Tian",
    title:
      " College Mental Health Professional, International Specialist Counseling and Psychological Services",
    slug: "miao-tian",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Anne",
    lastName: "Tiballi",
    title: "Director B, Curatorial, University Museum University Museum",
    slug: "anne-tiballi",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kyle",
    lastName: "Tice",
    title: "Lab Safety Specialist Environmental Health and Safety",
    slug: "kyle-tice",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rachel E",
    lastName: "Tichane",
    title: "Assistant Director Penn Medicine Development",
    slug: "rachel-e-tichane",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kevin C",
    lastName: "Tickner",
    title:
      " Business Administrator, Division of Human Resources Benefits Finance",
    slug: "kevin-c-tickner",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "April",
    lastName: "Tidwell",
    title: "Executive Assistant to the Dean Law Dean's Office",
    slug: "april-tidwell",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Sierra Nashay",
    lastName: "Tilghman",
    title: "Administrative Coordinator Management",
    slug: "sierra-nashay-tilghman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Carter E.",
    lastName: "Timon",
    title:
      " Associate Director, Master of Behavioral & Decision Sciences Master of Behavioral and Decision Sciences",
    slug: "carter-e-timon",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Tamla M.",
    lastName: "Tinsley",
    title: "Administrative Coordinator SP2 Office of the Dean",
    slug: "tamla-m-tinsley",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Robert J",
    lastName: "Tisot",
    title: "IT Technical Director, Student Systems Financial Systems",
    slug: "robert-j-tisot",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Joanne",
    lastName: "Titcomb",
    title:
      " Associate Director of Design, Construction, & Interiors SEAS Planning, Design, and Construction",
    slug: "joanne-titcomb",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Anthony",
    lastName: "Tiziana",
    title: "Associate Director D, Business and Finance Business Operations",
    slug: "anthony-tiziana",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "David",
    lastName: "Toccafondi",
    title: "Manager, Vitale Digital Media Lab University Libraries",
    slug: "david-toccafondi",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Robin L.",
    lastName: "Todd",
    title: "Director, Gift Planning Gift Planning",
    slug: "robin-l-todd",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Lynda",
    lastName: "Toe",
    title:
      " Information Technology Support Specialist B ISC-Client Services-Technology Support Services",
    slug: "lynda-toe",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Darin",
    lastName: "Toliver",
    title: "Assoc Dir Afr Amr Res Ctr African American Resource Center",
    slug: "darin-toliver",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Michele",
    lastName: "Tollok",
    title: "Procurement Service Coordinator Procurement Services",
    slug: "michele-tollok",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Donna M",
    lastName: "Tomlinson",
    title:
      " Manager, Administration and Special Projects College of Liberal and Professional Studies",
    slug: "donna-m-tomlinson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rebecca N.",
    lastName: "Toner",
    title: "Associate Director Lifelong Learning, Wharton External Affairs",
    slug: "rebecca-n-toner",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Robin",
    lastName: "Toney",
    title: "ADMIN ASST UGRAD CHR",
    slug: "robin-toney",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Mary",
    lastName: "Tong",
    title: "Senior Major Gifts Officer, School of Nursing Nursing in DAR",
    slug: "mary-tong",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Christina",
    lastName: "Torossian-Mira",
    title:
      " Student Success Advisor, Penn LPS Online Certificates Bachelor of Applied Arts & Sciences and Certificate Programs",
    slug: "christina-torossian-mira",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Terry",
    lastName: "Torres",
    title:
      " Director, PEFS Research Services - Post Award Office of Finance and Administration",
    slug: "terry-torres",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jacinta",
    lastName: "Torres",
    title: "Drafter CAD Office of the University Architect",
    slug: "jacinta-torres",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Nicole",
    lastName: "Torsella Harris",
    title: "Director D, Human Resources Recruitment",
    slug: "nicole-torsella-harris",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Susan E.",
    lastName: "Tracy",
    title: "Associate Director ULAR Business Services ULAR",
    slug: "susan-e-tracy",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "James",
    lastName: "Tracy",
    title:
      " Information Technology Director Nursing Office of Information Services",
    slug: "james-tracy",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Cheryl A",
    lastName: "Tracy",
    title: "Administrative Coordinator Economics",
    slug: "cheryl-a-tracy",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Uyen P",
    lastName: "Tran",
    title: "Internal Audit Project Manager Audit and Privacy",
    slug: "uyen-p-tran",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "FRANK J",
    lastName: "TRESNAN",
    title: "Executive Director, Internal Audit Audit, Compliance and Privacy",
    slug: "frank-j-tresnan",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Lauren",
    lastName: "Treutler",
    title: "Executive Assistant and Communications Manager Lauder Institute",
    slug: "lauren-treutler",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Dani",
    lastName: "Trimmer",
    title: "Senior Talent Acquisition Specialist Recruitment",
    slug: "dani-trimmer",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Joe",
    lastName: "Tripodi",
    title: "Director of Student Services Stuart Weitzman School of Design",
    slug: "joe-tripodi",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Christopher",
    lastName: "Trollen",
    title:
      " Associate Director D, Academic Affairs, Academic Center Wharton Finance Pillar",
    slug: "christopher-trollen",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Matthew",
    lastName: "Tront",
    title: "Associate Director, IT Infrastructure Operations Financial Systems",
    slug: "matthew-tront",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Emily",
    lastName: "Trott",
    title: "Assistive Technology Specialist Student Disability Services Office",
    slug: "emily-trott",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Sarah",
    lastName: "Trout",
    title:
      " Associate Director B, Development, Services INSTITUTIONAL ADVANCEMENT VET",
    slug: "sarah-trout",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Dann",
    lastName: "Truitt",
    title:
      " Chief of Staff, Vice Provost for Student Engagement Student Engagement",
    slug: "dann-truitt",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "James J.",
    lastName: "Trumbo",
    title: "BLDG ADMINISTARTOR SAS FACIL SAS",
    slug: "james-j-trumbo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sarah E",
    lastName: "Trumbull",
    title: "Senior Grants Manager Office of Nursing Research",
    slug: "sarah-e-trumbull",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kenric K.",
    lastName: "Tsethlikai",
    title: "Managing Director Lauder Institute",
    slug: "kenric-k-tsethlikai",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Artemis Ann",
    lastName: "Tsingiropoulos",
    title: "Relationship Manager MBA Career Management MBA Career Management",
    slug: "artemis-ann-tsingiropoulos",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Ricardo",
    lastName: "Tucker",
    title: "Administrative Coordinator CD-CDB Cancer Biology",
    slug: "ricardo-tucker",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sheila E",
    lastName: "Tucker",
    title: "Grants Manager B PE-Pediatrics",
    slug: "sheila-e-tucker",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "DR ELIZABETH A",
    lastName: "TULEJA",
    title:
      " Associate Director, Experiential Learning, Fels Institute of Government Fels Institute of Government",
    slug: "dr-elizabeth-a-tuleja",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kim",
    lastName: "Tulish",
    title: "Rodent Breeding Program Manager ULAR",
    slug: "kim-tulish",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Julio Roberto",
    lastName: "Tuma",
    title: "Associate Director, Integrated Studies Program The College",
    slug: "julio-roberto-tuma",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Michele P.",
    lastName: "Tuohy",
    title:
      " Senior Assistant Registrar for Catalog and Curriculum Student Registration & Financial Services",
    slug: "michele-p-tuohy",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Katharine",
    lastName: "Tuohy",
    title: "Staff Veterinarian ULAR",
    slug: "katharine-tuohy",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "TRACEY L.",
    lastName: "TURNER",
    title:
      " Director, Graduate Division of Arts and Sciences GRAD ARTS & SCIENCES",
    slug: "tracey-l-turner",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Robyn L",
    lastName: "Turner",
    title: "Associate Director, Lifelong Learning External Affairs",
    slug: "robyn-l-turner",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Linda",
    lastName: "Turner",
    title: "ADMIN ASST - OFFICE OF STUDENT SERVICES ACAD AFFRS",
    slug: "linda-turner",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Loretta M Witham",
    lastName: "Turner",
    title: "DEPT ADMINISTRATOR English",
    slug: "loretta-m-witham-turner",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "PAULA L",
    lastName: "Turse",
    title: "Contract Administrator GENERAL COUNSEL",
    slug: "paula-l-turse",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Mary",
    lastName: "Tweddle",
    title:
      " University Registrar Scheduling Coordinator Student Registration & Financial Services",
    slug: "mary-tweddle",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Caroline Sunshine",
    lastName: "Tweedy",
    title:
      " Assistant Director for Development Communication & Events ICA Development",
    slug: "caroline-sunshine-tweedy",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Colin R",
    lastName: "Twomey",
    title: "Managing Director, DDDI Data Science Initiative",
    slug: "colin-r-twomey",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "RASOOL",
    lastName: "TYLER",
    title:
      " Information Technology Manager Weitzman School of Design Computing Center",
    slug: "rasool-tyler",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Alana",
    lastName: "Tyndall",
    title: "Administrative Coordinator Biobehavioral and Health Sciences",
    slug: "alana-tyndall",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Joanna",
    lastName: "Tzen",
    title: "Senior Associate Director of Gift Management Gift Management",
    slug: "joanna-tzen",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "William A.",
    lastName: "Udell",
    title: "Manager B, Arts and Media Fine Arts",
    slug: "william-a-udell",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Paul D.",
    lastName: "Umbriac",
    title: "Director E, Business and Finance SM-DN-Business Office",
    slug: "paul-d-umbriac",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Patrick",
    lastName: "Underwood",
    title: "Admissions Visitor Experience Assistant Education",
    slug: "patrick-underwood",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Scott T",
    lastName: "Unger",
    title: "ULAR Transportation and Logistics Coordinator ULAR",
    slug: "scott-t-unger",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Fele",
    lastName: "Uperesa",
    title:
      " Associate Director D, Student Services, Graduate Programs Wharton Executive MBA",
    slug: "fele-uperesa",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Kathy L.",
    lastName: "Urban",
    title: "Senior Director, Undergraduate Programs LPS Administration",
    slug: "kathy-l-urban",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Rosa",
    lastName: "Urbina",
    title: "Associate Director C, Research Translational Research",
    slug: "rosa-urbina",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jason",
    lastName: "Vail",
    title: "Director Reports and Analytics",
    slug: "jason-vail",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Faramarz",
    lastName: "Vakili",
    title: "Executive Director Operations and Maintenance -- FRES",
    slug: "faramarz-vakili",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Misha",
    lastName: "Vaksman",
    title:
      " Information Technology Manager Wharton Computing and Instructional Technology (WCIT)",
    slug: "misha-vaksman",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Mariana",
    lastName: "Valdes-Fauli",
    title:
      " Associate Vice President, Student Registration and Financial Services Student Registration & Financial Services",
    slug: "mariana-valdes-fauli",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Peter T",
    lastName: "Valelly",
    title: "ELECTRONIC MARKETING COORDINATOR University Press",
    slug: "peter-t-valelly",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Matt",
    lastName: "Valenti",
    title: "ASST ATH DIR, RECRUITING Recreation and Athletics",
    slug: "matt-valenti",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jennifer",
    lastName: "Valerio",
    title: "Associate Director, Urban Teaching Residency Program Education",
    slug: "jennifer-valerio",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Michel",
    lastName: "van der List",
    title: "Individual ISC Technical Services",
    slug: "michel-van-der-list",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Julie",
    lastName: "Van Duzer",
    title: "Compensation Specialist Senior Compensation",
    slug: "julie-van-duzer",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Juliana",
    lastName: "van Hoeven",
    title:
      " Director of Regulatory Affairs and Advising & Deputy Registrar Law Registrar",
    slug: "juliana-van-hoeven",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Lindsay Adams",
    lastName: "Van Ostenbridge",
    title: "Case Manager Student Intervention Services",
    slug: "lindsay-adams-van-ostenbridge",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Dr. Barbara A., PhD",
    lastName: "Vance",
    title:
      " Director of Strategy and Business Development (CSTL) DM-Translational Medicine and Human Genetics",
    slug: "dr-barbara-a-phd-vance",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ronald J",
    lastName: "Vance",
    title: "Coordinator B Restorative Clinic",
    slug: "ronald-j-vance",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Usha",
    lastName: "Vankireddy",
    title: "Mail Room Senior Specialist Admissions",
    slug: "usha-vankireddy",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Raminderjit",
    lastName: "Vansal",
    title:
      " Information Technology Manager Senior ISC-Tech Services-Network Operations",
    slug: "raminderjit-vansal",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kimber L",
    lastName: "VanSant",
    title:
      " Manager, Communications & Administration Penn Budget Planning & Analysis",
    slug: "kimber-l-vansant",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Nancy F",
    lastName: "Vantrieste",
    title: "CLAIMS ADMINISTRATOR GENERAL COUNSEL",
    slug: "nancy-f-vantrieste",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Elaine P.",
    lastName: "Varas",
    title:
      " Senior Director, Student Financial Aid Student Registration & Financial Services",
    slug: "elaine-p-varas",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Elsa",
    lastName: "Varela",
    title:
      " Special Collections Cataloging Librarian Kislak Center, Special Collections Processing",
    slug: "elsa-varela",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Enrique",
    lastName: "Vargas",
    title: "SENIOR BUILDING ADMINISTRATOR Chemistry",
    slug: "enrique-vargas",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rosa M",
    lastName: "Vargas",
    title: "SEMINAR COORDINATOR Chemistry",
    slug: "rosa-m-vargas",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Alberto",
    lastName: "Vargas",
    title:
      " Information Technology Support Specialist Nursing Office of Information Services",
    slug: "alberto-vargas",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Matthew",
    lastName: "Varghese",
    title: "Information Technology Director Vet Dean's Office",
    slug: "matthew-varghese",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Stewart",
    lastName: "Varner",
    title:
      " MANAGING DIRECTOR OF PRICE DIGITAL HUMANITIES Price Lab for Digital Humanities",
    slug: "stewart-varner",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Sara J",
    lastName: "Varney",
    title: "Associate Director Wolf Humanities Center",
    slug: "sara-j-varney",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Lisa Ann",
    lastName: "Varotsis",
    title: "Coordinator, Program PATHOBIOLOGY NBC",
    slug: "lisa-ann-varotsis",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Michael A",
    lastName: "Vasilikos",
    title: "Asst. Music Director, On-Air Host WXPN",
    slug: "michael-a-vasilikos",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "LADA V",
    lastName: "VASSILIEVA",
    title: "DIRECTOR A Penn Language Center",
    slug: "lada-v-vassilieva",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Steven",
    lastName: "Vaughn-Lewis",
    title:
      " Director, Student Services, Fox Leadership International Fox Leadership International",
    slug: "steven-vaughn-lewis",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Eugene",
    lastName: "Vaynberg",
    title: "Director B, Academic Affairs President's Office",
    slug: "eugene-vaynberg",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Christopher",
    lastName: "Veitz",
    title:
      " Director of Student Services and Records College of Liberal & Professional Studies",
    slug: "christopher-veitz",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "David",
    lastName: "Venanzi",
    title: "Internal Audit Project Manager Audit and Privacy",
    slug: "david-venanzi",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jared",
    lastName: "Venezia",
    title: "IT Director, Infrastructure Services SDM Computing",
    slug: "jared-venezia",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Danielle L",
    lastName: "Venit",
    title: "Coordinator, Program The College",
    slug: "danielle-l-venit",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mackenzie Kirsch",
    lastName: "Venkatadri",
    title:
      " Associate Director of Development for Undergraduate Financial Aid Undergraduate Financial Aid Development",
    slug: "mackenzie-kirsch-venkatadri",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Namitha G",
    lastName: "Venkatesh",
    title:
      " Information Technology Manager Senior ISC-Tech Services-Network Operations",
    slug: "namitha-g-venkatesh",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Sandra L",
    lastName: "Venne",
    title: "Administrative Assistant Economics",
    slug: "sandra-l-venne",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Karen",
    lastName: "Verderame",
    title: "Assistant Director of Outreach Education Vet Dean's Office",
    slug: "karen-verderame",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Katherine",
    lastName: "Veri",
    title: "Senior Video Producer Office of Academic Innovation",
    slug: "katherine-veri",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Ann Elizabeth",
    lastName: "Vernon-Grey",
    title:
      " Director for Undergraduate Research Center for Undergraduate Research",
    slug: "ann-elizabeth-vernon-grey",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Nicole A.",
    lastName: "Verostick",
    title: "Director of Communications Penn Medicine Development",
    slug: "nicole-a-verostick",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Ian F",
    lastName: "Verstegen",
    title: "Associate Director of Visual Studies Visual Studies",
    slug: "ian-f-verstegen",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kellie",
    lastName: "Vetter",
    title: "Business Administrator DRIA Administrative Affairs",
    slug: "kellie-vetter",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "John",
    lastName: "Vettese",
    title: "Editor of The Key / Social Media Coordinator WXPN",
    slug: "john-vettese",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Noel",
    lastName: "Victor",
    title: "Application Architect Wharton Research Data Services",
    slug: "noel-victor",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Anne M",
    lastName: "Viggiano",
    title:
      " Assistant Director of Advancement School of Arts and Sciences, Office of Advancement",
    slug: "anne-m-viggiano",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Patricia M.",
    lastName: "Villa",
    title: "EXEC ASST Wharton Chief Advancement Officer",
    slug: "patricia-m-villa",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Susan Martin",
    lastName: "Visoskas",
    title: "Operations Manager, Career Services Career Services",
    slug: "susan-martin-visoskas",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Steven Robert",
    lastName: "Vitale",
    title:
      " Systems Administrator Computing and Educational Technology Services",
    slug: "steven-robert-vitale",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jose",
    lastName: "Vithayathil",
    title: "RES SPEC PHYSICS PHYSICS AND ASTRONOMY",
    slug: "jose-vithayathil",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Antonio Enrique",
    lastName: "Vivas",
    title:
      " Cloud Architect Director Wharton Computing and Instructional Technology (WCIT)",
    slug: "antonio-enrique-vivas",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Sangeeta",
    lastName: "Vohra",
    title: "Director, M&T Integration Management and Technology Program",
    slug: "sangeeta-vohra",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Rebecca W.",
    lastName: "Vold",
    title: "Administrative Coordinator Health Care",
    slug: "rebecca-w-vold",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Robert",
    lastName: "Vosburgh",
    title:
      " Executive Director of Planned Giving, Penn Medicine Penn Medicine Development",
    slug: "robert-vosburgh",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Lindsey",
    lastName: "Votto",
    title: "Director of Finance Annenberg School for Communication",
    slug: "lindsey-votto",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Julia",
    lastName: "Votto",
    title:
      " Associate Director, Innovative Projects EIDOS LGBT + Health Initiative",
    slug: "julia-votto",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "William",
    lastName: "Vought",
    title: "Research Lab Tech C CD-Cell and Development Biology",
    slug: "william-vought",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Anastasia",
    lastName: "Voutsinas",
    title:
      " Senior Director of Revenue Wharton Executive Education (Operations)",
    slug: "anastasia-voutsinas",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jacquelyn M",
    lastName: "Vrettos",
    title: "Financial Coordinator Wharton Entrepreneurship",
    slug: "jacquelyn-m-vrettos",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Rathea",
    lastName: "Vuthy",
    title:
      " Information Technology Support Specialist Senior SM-DN External Info Services",
    slug: "rathea-vuthy",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Joseph",
    lastName: "Waclawski",
    title:
      " Director, AMP & Senior Management Programs Wharton Executive Education (Operations)",
    slug: "joseph-waclawski",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "SUSAN",
    lastName: "WADDINGTON-PILDER",
    title: "Executive Assistant A Pathobiology",
    slug: "susan-waddington-pilder",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alexander F",
    lastName: "Waegel",
    title: "Associate Director, CEBD Center for Environmental Building Design",
    slug: "alexander-f-waegel",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jodi B",
    lastName: "Wagner",
    title:
      " Assistant Director, Undergraduate Aid Student Registration & Financial Services",
    slug: "jodi-b-wagner",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Mara",
    lastName: "Wai",
    title: "Coordinator, Program Biobehavioral and Health Sciences",
    slug: "mara-wai",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Chris",
    lastName: "WAILOO",
    title:
      " Associate Dean for Finance and Administration and Chief Financial Officer Business Affairs",
    slug: "chris-wailoo",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Eric",
    lastName: "Waldron",
    title: "Assistant Gardener; Morris Arboretum Horticulture",
    slug: "eric-waldron",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "George V.",
    lastName: "Walker",
    title:
      " Associate Director of Institutional Methodology Student Registration & Financial Services",
    slug: "george-v-walker",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Lindsey Dorn",
    lastName: "Walker",
    title:
      " Director of Developement Centers & Institutes Penn Medicine Developement",
    slug: "lindsey-dorn-walker",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "John M.",
    lastName: "Walker",
    title: "Information Technology Technical Director Wharton School",
    slug: "john-m-walker",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Andrea",
    lastName: "Walkup",
    title: "Administrative Coordinator Student Engagement",
    slug: "andrea-walkup",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "CLAIRE E",
    lastName: "WALLACE",
    title: "Associate Dean & Registrar Law",
    slug: "claire-e-wallace",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Deanne E",
    lastName: "Wallaert",
    title:
      " Assistant Director, Academic Programs - Division of Pediatric Dentistry Pediatric Dentistry",
    slug: "deanne-e-wallaert",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Erin",
    lastName: "Walsh",
    title:
      " Global Support Services Projects Coordinator Global Support Services",
    slug: "erin-walsh",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lexie",
    lastName: "Walsh",
    title:
      " Associate Director C, Academic Affairs, Academic Partnerships Professional and Liberal Education (PLE)",
    slug: "lexie-walsh",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kathryn Louise",
    lastName: "Walsh",
    title: "Project Manager, Digital Discourse Project Education",
    slug: "kathryn-louise-walsh",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kelly",
    lastName: "Walsh",
    title:
      " Director of Student and Academic Affairs SAS Graduate Division Administration",
    slug: "kelly-walsh",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Kelli",
    lastName: "Walsh",
    title:
      " Associate Director of Development for Biomedical Research, Penn Medicine Penn Medicine Development",
    slug: "kelli-walsh",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jamie",
    lastName: "Walter",
    title:
      " IT Project Leader Wharton Computing and Instructional Technology (WCIT)",
    slug: "jamie-walter",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Craig",
    lastName: "Walter",
    title: "IT Technical Director Financial Systems",
    slug: "craig-walter",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Emily K",
    lastName: "Walters",
    title: "Executive Assistant A ME-Medical Ethics",
    slug: "emily-k-walters",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Cory",
    lastName: "Walts",
    title: "Director of Strength & Conditioning Strength and Fitness",
    slug: "cory-walts",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Denene Michele",
    lastName: "Wambach",
    title: "Associate General Counsel General Counsel",
    slug: "denene-michele-wambach",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Fredrick Hoopes",
    lastName: "Wampler",
    title:
      " Senior Associate Vice President, Development and Alumni Relations Alumni Relations",
    slug: "fredrick-hoopes-wampler",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ye",
    lastName: "Wang",
    title: "Application Developer Senior Wharton Research Data Services",
    slug: "ye-wang",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Alina J",
    lastName: "Wang",
    title:
      " Information Technology Support Specialist B Weitzman School of Design Computing Center",
    slug: "alina-j-wang",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Erkuan",
    lastName: "Wang",
    title:
      " Associate Director E, Research ME- Center for Healthcare Equity and Payment",
    slug: "erkuan-wang",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Scott Eric",
    lastName: "Ward",
    title: "SR ASSOCIATE ATHLETIC DIRECTOR, OPERATIONS DRIA",
    slug: "scott-eric-ward",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rick",
    lastName: "Ward",
    title:
      " Information Technology Manager Senior ISC-Applications & Information Services",
    slug: "rick-ward",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Amy M.",
    lastName: "Ware",
    title:
      " Program Director, Organizational Dynamics Master of Science in Organizational Dynamics",
    slug: "amy-m-ware",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "SHERYL D",
    lastName: "WARFIELD",
    title:
      " Associate Director, Operations Weingarten Learning Resources Center",
    slug: "sheryl-d-warfield",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Christopher J",
    lastName: "Wargo",
    title:
      " Information Technology Support Specialist Senior ISC-CLIENT SERVICES-HIREIT",
    slug: "christopher-j-wargo",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "LISA E",
    lastName: "WARING",
    title:
      " Information Technology Director ISC-Applications & Information Services",
    slug: "lisa-e-waring",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Bibi Abeeda N",
    lastName: "Warnauth",
    title: "Office Manager Health and Wellness Administration",
    slug: "bibi-abeeda-n-warnauth",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Christina A",
    lastName: "Warner",
    title:
      " Senior Case Manager Center for Community Standards and Accountability",
    slug: "christina-a-warner",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Michael Paul",
    lastName: "Warren",
    title: "PSA Program Manager Penn Student Agencies",
    slug: "michael-paul-warren",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Bruce M.",
    lastName: "Warren",
    title: "Assistant GM - Programming - WXPN WXPN",
    slug: "bruce-m-warren",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "MICHAEL",
    lastName: "WASHBURN",
    title: "Senior Director of Gift Management DAR Services",
    slug: "michael-washburn",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Yolanda L",
    lastName: "Washington",
    title: "Assistant Director, Research Services Research Services",
    slug: "yolanda-l-washington",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Tesi T'Keyah",
    lastName: "Washington",
    title:
      " Administrative Coordinator, College of Liberal and Professional  Studies Professional and Liberal Education (PLE)",
    slug: "tesi-t-keyah-washington",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Felicia A.",
    lastName: "Washington",
    title: "Vice President of Human Resources Special Executive Vice President",
    slug: "felicia-a-washington",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Charles E.",
    lastName: "Washington",
    title: "Classroom Technology Manager Education",
    slug: "charles-e-washington",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Emerson",
    lastName: "Waterbel",
    title:
      " Information Technology Project Leader Senior ISC-Client Services-Technology Support Services",
    slug: "emerson-waterbel",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Estelle E",
    lastName: "Waters",
    title: "Office Manager Penn Arts and Sciences, Office of Advancement",
    slug: "estelle-e-waters",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Madison Rene",
    lastName: "Waters",
    title:
      " Assistant Director, Programs and Special Events Development Programs",
    slug: "madison-rene-waters",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Charles G.",
    lastName: "Watkins",
    title: "Sr. Associate Director, Major Gifts Major Gifts Program",
    slug: "charles-g-watkins",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Matthew D.",
    lastName: "Watkins",
    title:
      " Associate Director, Prospect Research DEVELOPMENT & ALUMNI RELATIONS",
    slug: "matthew-d-watkins",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Katie",
    lastName: "Watkins",
    title:
      " Information Technology Technical Director Wharton Computing and Instructional Technology (WCIT)",
    slug: "katie-watkins",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jason R.",
    lastName: "Watkins",
    title: "Information Technology Manager SASC-Computing",
    slug: "jason-r-watkins",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Elizabeth",
    lastName: "Watkins",
    title:
      " Associate Dir. of Community Fundraising & Communications, Penn Medicine Penn Medicine Development",
    slug: "elizabeth-watkins",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Abigail",
    lastName: "Watson",
    title: "Director of Donor Relations External Affairs",
    slug: "abigail-watson",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Tammy",
    lastName: "Watson",
    title: "Administrative Coordinator External Affairs",
    slug: "tammy-watson",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "India",
    lastName: "Watson",
    title:
      " Associate Director of Education and Operations SM-DN-Penn Center for Health, Devices and Technology",
    slug: "india-watson",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Shomari",
    lastName: "Watts",
    title: "Assistant Director, Annual Giving DRIA Development",
    slug: "shomari-watts",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Arttia",
    lastName: "Watts",
    title:
      " UACS Site Director, Lea elementary school Netter Center for Community Partnerships",
    slug: "arttia-watts",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nancy",
    lastName: "Waxman",
    title: "Executive Assistant to the Dean Law School",
    slug: "nancy-waxman",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Timothy E",
    lastName: "Weal",
    title:
      " SR. BUSINESS ADMINISTRATOR Fisher-Bennett Hall Business Admin Services / 6273",
    slug: "timothy-e-weal",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mike",
    lastName: "Weaver",
    title: "Director Penn Budget Planning & Analysis",
    slug: "mike-weaver",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Megan L",
    lastName: "Webb",
    title: "Academic Coordinator Music",
    slug: "megan-l-webb",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Ann C.",
    lastName: "Webb",
    title: "Executive Assistant, Penn Medicine Penn Medicine Development",
    slug: "ann-c-webb",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Dr. Sue",
    lastName: "Weber",
    title: "Associate Director Communication Within the Curriculum SAS",
    slug: "dr-sue-weber",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "LAURA E",
    lastName: "WEBER",
    title: "ASST VICE DEAN PENN ARTS & SCIENCES OFFICE OF ADVANCEMENT",
    slug: "laura-e-weber",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Debora",
    lastName: "Weber-Miller",
    title: "APPLICATION DEVELOPER University Communications",
    slug: "debora-weber-miller",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Benjamin A. M.",
    lastName: "Webster",
    title: "Assistant Head Of Stacks II Access Services",
    slug: "benjamin-a-m-webster",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Christine N.",
    lastName: "Weeks",
    title:
      " Associate Director E, Arts and Media, Communications and Marketing Leonard Davis Institute",
    slug: "christine-n-weeks",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "DR JENNIFER HOUSER",
    lastName: "WEGNER",
    title: "Associate Curator, EGYPTIAN SECTION MUSEUM",
    slug: "dr-jennifer-houser-wegner",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mark H",
    lastName: "Wehrle",
    title:
      " IT Technical Director ISC TS Communications and Collaboration Technologies",
    slug: "mark-h-wehrle",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Baowei",
    lastName: "Wei",
    title: "Senior Developer IT CLIENT SERVICES",
    slug: "baowei-wei",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "E PAUL",
    lastName: "WEIDNER",
    title: "DIRECTOR FIN TRAINING DEPT",
    slug: "e-paul-weidner",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Steven S",
    lastName: "Weiner",
    title:
      " Senior Director, SEAS Innovation and Technology Penn Center for Innovation",
    slug: "steven-s-weiner",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "ANNIE",
    lastName: "WEINSTEIN",
    title:
      " Associate Director, Communications & External Relations Business Services",
    slug: "annie-weinstein",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "DeAnna Morgan",
    lastName: "Weise",
    title: "Director, Global Operations and Compliance Global Support Services",
    slug: "deanna-morgan-weise",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Penny",
    lastName: "Weisman",
    title:
      " Marketing Traffic Coordinator College of Liberal and Professional Studies",
    slug: "penny-weisman",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Cara M.",
    lastName: "Weismann",
    title:
      " Director, Program of Excellence in MPS Diseases Orphan Disease Center, Perelman School of Medicine",
    slug: "cara-m-weismann",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Rose",
    lastName: "Weiss",
    title: "Coordinator B Global Initiatives",
    slug: "rose-weiss",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Richard L",
    lastName: "Weiss",
    title: "DIR ECHOCARDIOGRAPHY-PMC MEDICINE",
    slug: "richard-l-weiss",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Amy",
    lastName: "Weiss",
    title: "Case Manager for Integrated Care Learning Resources",
    slug: "amy-weiss",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jaclyn",
    lastName: "Weisser",
    title:
      " Senior Office Manager and Events Director Office of Academic Innovation",
    slug: "jaclyn-weisser",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "CHRISTINE",
    lastName: "WELLER",
    title: "Associate General Counsel General Counsel",
    slug: "christine-weller",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Cehara M",
    lastName: "Wellington",
    title: "Assist Manager of Tennis Levy Tennis",
    slug: "cehara-m-wellington",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "KARL M",
    lastName: "WELLMAN JR",
    title:
      " Senior Director of Operations and Planning/Design and Construction Weitzman School of Design Dean's Office",
    slug: "karl-m-wellman-jr",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Keith Robert",
    lastName: "Wells",
    title: "Senior Director of Budget Analysis SDM Fiscal Operations",
    slug: "keith-robert-wells",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Theresa M.",
    lastName: "Welsh",
    title: "Director, Trustees Council of Penn Women Alumni Relations",
    slug: "theresa-m-welsh",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Marlon",
    lastName: "Wenceslao",
    title:
      " Dir. of Information Systems & Infrastructure Annenberg School for Communication",
    slug: "marlon-wenceslao",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Diane R.",
    lastName: "Wender",
    title: "Research Integrity Officer Vice Provost for Research",
    slug: "diane-r-wender",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Frank",
    lastName: "Wenger",
    title: "Associate Director School & Mental Health Counseling Program (GSE)",
    slug: "frank-wenger",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Judy",
    lastName: "Wentworth",
    title:
      " Marketing and Communications Writer Professional and Liberal Education (PLE)",
    slug: "judy-wentworth",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Michelle L",
    lastName: "Werner",
    title: "BUSINESS ADMINISTRATOR Accounting",
    slug: "michelle-l-werner",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Matthew E",
    lastName: "Werner",
    title: "SYSTEM SOFTWARE ARCHITECT RA-Radiology",
    slug: "matthew-e-werner",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Sherry L.",
    lastName: "Wert",
    title: "Writer-Editor International Affairs",
    slug: "sherry-l-wert",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Robert O.",
    lastName: "Wertz",
    title: "Administrative Coordinator Chemistry",
    slug: "robert-o-wertz",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Amanda",
    lastName: "Wessel",
    title: "Administrative Coordinator Latin American and Latino Studies",
    slug: "amanda-wessel",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "David W",
    lastName: "Wessels",
    title:
      " Director, Corporate Finance Facilitator Wharton Executive Education (Operations)",
    slug: "david-w-wessels",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Bonny Wilson",
    lastName: "West",
    title: "Systems Manager Graduate Admissions",
    slug: "bonny-wilson-west",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Deborah Ann",
    lastName: "Westerling",
    title: "NUTRITIONIST Student Health Services",
    slug: "deborah-ann-westerling",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "J. Reuben",
    lastName: "Wetherbee",
    title: "Application Architect SASC-Computing",
    slug: "j-reuben-wetherbee",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "JENNIFER L",
    lastName: "WETZEL",
    title: "DIRECTOR OF DESIGN AND CONSTRUCTION Project Management",
    slug: "jennifer-l-wetzel",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Holly",
    lastName: "Wexler",
    title: "Director of Board Relations External Affairs",
    slug: "holly-wexler",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "William Wendell",
    lastName: "Weyand",
    title:
      " ELECTRICAL SHOP SUPERVISOR Operations and Maintenance Administration",
    slug: "william-wendell-weyand",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Siobhan",
    lastName: "Whadcoat",
    title:
      " Program Director, Professional Programs in Earth & Environmental Science Master of Environmental Studies",
    slug: "siobhan-whadcoat",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Ian S",
    lastName: "Wheeler",
    title: "Information Technology Project Leader SDM Computing",
    slug: "ian-s-wheeler",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "William",
    lastName: "Whitaker",
    title: "Curator / Collections Manager Architectural Archives",
    slug: "william-whitaker",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sheronda",
    lastName: "Whitaker",
    title: "Chief Engagement and Culture Officer DAR Human Resources",
    slug: "sheronda-whitaker",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "KANDACE",
    lastName: "WHITE",
    title: "Administrative Coordinator FRES Office of the Vice President",
    slug: "kandace-white",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Keren M.",
    lastName: "White",
    title: "Sr. Director of Campaign Operations Central DAR",
    slug: "keren-m-white",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "WENDY S",
    lastName: "WHITE",
    title: "SR VICE PRESIDENT GEN COUNSEL UNIV/PENN MED GEN COUNSEL",
    slug: "wendy-s-white",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Tony",
    lastName: "White",
    title:
      " Information Technology Technical Director- Project Administration ISC-Tech Services-Network Operations",
    slug: "tony-white",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Thomas F.",
    lastName: "White",
    title:
      " Executive Director of the Fund for Penn Medicine Penn Medicine Development",
    slug: "thomas-f-white",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Stacy",
    lastName: "White",
    title: "Business Manager, Programs & Special Events Development Programs",
    slug: "stacy-white",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Deidre",
    lastName: "White",
    title:
      " Associate Director, Human Resources FRES Finance and Administration",
    slug: "deidre-white",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Cortni L",
    lastName: "White",
    title: "Administrative Coord Economics",
    slug: "cortni-l-white",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Cecily",
    lastName: "White",
    title: "PennCAP Associate Director Penn First Plus",
    slug: "cecily-white",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Sophia J",
    lastName: "Whitehead",
    title: "Contract Administrator Senior Research Services",
    slug: "sophia-j-whitehead",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Muriel",
    lastName: "Whiteside",
    title: "Administrative Coordinator Wharton Entrepreneurship",
    slug: "muriel-whiteside",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Chardae",
    lastName: "Whiting",
    title: "Grants Manager B Business Operations",
    slug: "chardae-whiting",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Chad Michael",
    lastName: "Whitman",
    title:
      " Application Developer Wharton Computing and Instructional Technology (WCIT)",
    slug: "chad-michael-whitman",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Abigail",
    lastName: "Whittington",
    title: "ADM COORDINATOR RESEARCH AND ACADEMIC SERVICES",
    slug: "abigail-whittington",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Cynthia",
    lastName: "Whybark",
    title: "Coordinator of Finance and Budget Architecture",
    slug: "cynthia-whybark",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Adam",
    lastName: "Wichryk",
    title: "Coordinator B SM-DN- Office of Masters Programs",
    slug: "adam-wichryk",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Maxine M",
    lastName: "Wicks",
    title: "Instructional Designer Nursing Office of Information Services",
    slug: "maxine-m-wicks",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "DANIEL R",
    lastName: "WIDYONO",
    title:
      " IT Director, Server Infrastructure Services Computing and Educational Technology Services",
    slug: "daniel-r-widyono",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Stephen",
    lastName: "Wielgus",
    title: "Executive Director - Fiscal Operations Business Services",
    slug: "stephen-wielgus",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Kandi J",
    lastName: "Wiens",
    title: "Director C, Student Services, Graduate Programs Education",
    slug: "kandi-j-wiens",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "William",
    lastName: "Wierzbowski",
    title: "KEEPER AMERICAN SECTION",
    slug: "william-wierzbowski",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Hillary",
    lastName: "Wiesel",
    title: "Associate Director Wharton Undergraduate Division",
    slug: "hillary-wiesel",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kathleen",
    lastName: "Wigger",
    title: "Fundraising Ops Manager WXPN",
    slug: "kathleen-wigger",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Daniel P",
    lastName: "Wilde",
    title: "Director of Video Content DRIA Marketing",
    slug: "daniel-p-wilde",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "ALLAN M.",
    lastName: "WILEY",
    title: "RECORDS ASST UNIV RECORDS CTR",
    slug: "allan-m-wiley",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Megan",
    lastName: "Wilkins",
    title:
      " Administrative Coordinator, MBDS Master of Behavioral and Decision Sciences",
    slug: "megan-wilkins",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Gia Andrea",
    lastName: "Wilkins",
    title: "Administrative Coordinator Events",
    slug: "gia-andrea-wilkins",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Carolyn",
    lastName: "Wilkinson",
    title: "Associate Director C, Research NE-Neurology",
    slug: "carolyn-wilkinson",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Samantha",
    lastName: "Williams",
    title:
      " Career Services Administrative Coordinator Office of Career Strategy",
    slug: "samantha-williams",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Ayanna",
    lastName: "Williams",
    title: "Director of Public Interest Programs Public Interest Center",
    slug: "ayanna-williams",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Victor F",
    lastName: "Williams",
    title: "Research Systems Director VPR Information Technology",
    slug: "victor-f-williams",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Tammie M.",
    lastName: "Williams",
    title:
      " Senior Development Associate, Penn Medicine Penn Medicine Development",
    slug: "tammie-m-williams",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kia",
    lastName: "Williams",
    title: "Grants Coordinator B Research Support Center (RSC)",
    slug: "kia-williams",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Robert J",
    lastName: "Williams",
    title:
      " IT Director, Networking/Security Computing and Educational Technology Services",
    slug: "robert-j-williams",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Nita",
    lastName: "Williams",
    title:
      " Associate Director, Document and Records Management Student Registration & Financial Services",
    slug: "nita-williams",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Monesa",
    lastName: "Williams",
    title: "Executive Assistant Vice Provost for Research",
    slug: "monesa-williams",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Levester",
    lastName: "Williams",
    title: "Videographer/Animator Online Learning",
    slug: "levester-williams",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kymberlie",
    lastName: "Williams",
    title:
      " Netter Center Administrative Coordinator Netter Center for Community Partnerships",
    slug: "kymberlie-williams",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Isis",
    lastName: "Williams",
    title: "Coordinator B Restorative Clinic",
    slug: "isis-williams",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Christopher A.",
    lastName: "Williams",
    title: "World Cafe Production Director WXPN",
    slug: "christopher-a-williams",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Andrew R.",
    lastName: "Williams",
    title: "Processing Archivist Annenberg School for Communication",
    slug: "andrew-r-williams",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Amber F",
    lastName: "Williams",
    title: "Instrument Sterilization Attendant A Instrument Management Service",
    slug: "amber-f-williams",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Eric H",
    lastName: "Williamson",
    title:
      " Manager, Nutrition Education Partnership Netter Center for Community Partnerships",
    slug: "eric-h-williamson",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Lisbeth",
    lastName: "Willis",
    title: "Director of Classes & Reunions Alumni Relations",
    slug: "lisbeth-willis",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Nichole E.",
    lastName: "Wilson",
    title: "Associate Director, Stewardship Communications DAR Communications",
    slug: "nichole-e-wilson",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Olivia E",
    lastName: "Wilson",
    title:
      " Associate Director C, Human Resources, School/ Center Wharton Human Resources",
    slug: "olivia-e-wilson",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Tami M.",
    lastName: "Wilson",
    title: "Department Manager Biology",
    slug: "tami-m-wilson",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Caroline",
    lastName: "Wilson",
    title:
      " Program Manager, Executive Education Wharton Executive Education (Open Enrollment)",
    slug: "caroline-wilson",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "John",
    lastName: "Wilson",
    title:
      " Application Developer Senior Nursing Office of Information Services",
    slug: "john-wilson",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jamie",
    lastName: "Wilson",
    title: "Associate Director, HR, Provost Centers Provost's Office",
    slug: "jamie-wilson",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Gregory",
    lastName: "Wilson",
    title:
      " Associate Director C, Arts and Media, Communications and Marketing Wharton Global Youth Programs",
    slug: "gregory-wilson",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Cole E.",
    lastName: "Wilson",
    title:
      " Information Technology Project Leader Wharton Computing and Instructional Technology (WCIT)",
    slug: "cole-e-wilson",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Claire",
    lastName: "Wilson",
    title: "Major Gifts Officer, Penn Medicine Penn Medicine Development",
    slug: "claire-wilson",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Alexa",
    lastName: "Wilson",
    title: "Financial Aid Coordinator Nursing Academic Affairs",
    slug: "alexa-wilson",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Joi S.",
    lastName: "Wilson-Little",
    title: "CONTRACTS ADMINISTRATOR General Counsel",
    slug: "joi-s-wilson-little",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Kristin K.",
    lastName: "Winch",
    title:
      " Director of Development, Annenberg Center for the Performing Arts School/Center Development",
    slug: "kristin-k-winch",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tanya L",
    lastName: "Winder",
    title: "ADM COORD STAT",
    slug: "tanya-l-winder",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mariann",
    lastName: "Winkelman",
    title: "Coordinator Biology",
    slug: "mariann-winkelman",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Colleen",
    lastName: "Winn",
    title: "STAFF ASSISTANT C African-American Resource Center",
    slug: "colleen-winn",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "DR. KENNETH M.",
    lastName: "WINNEG",
    title: "MANAGING DIRECTOR of Survey Research ANNENBERG PUB POL CTR",
    slug: "dr-kenneth-m-winneg",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kimberly A",
    lastName: "Winnick",
    title: "DIR MKTG WXPN",
    slug: "kimberly-a-winnick",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Justin M",
    lastName: "Winslow-Brown",
    title: "Dispatcher Escort",
    slug: "justin-m-winslow-brown",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ira",
    lastName: "Winston",
    title: "Director of Special Projects SEAS",
    slug: "ira-winston",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Whitney Evelyn",
    lastName: "Winters",
    title: "Grants Manager Business Operations",
    slug: "whitney-evelyn-winters",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Berthilla M.",
    lastName: "Wiscount",
    title: "Information Technology Manager Senior Financial Systems",
    slug: "berthilla-m-wiscount",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "SUNIDA",
    lastName: "WITAYAKARN",
    title: "Administrative Assistant A Wharton Communications Unit",
    slug: "sunida-witayakarn",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Mandi",
    lastName: "Witkovsky",
    title: "IAM Technical Director ISC-Tech Services-Network Operations",
    slug: "mandi-witkovsky",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kimberly M",
    lastName: "Wolcott",
    title: "Associate Dean and Chief of Staff SDM Deans Office",
    slug: "kimberly-m-wolcott",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "James R.",
    lastName: "Wolfe",
    title:
      " Associate Director, Innovative Projects EIDOS LGBT + Health Initiative",
    slug: "james-r-wolfe",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Danielle",
    lastName: "Wolfson",
    title: "Administrative Coordinator SAVP University Capital Giving",
    slug: "danielle-wolfson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nicole",
    lastName: "Wolverton",
    title: "Associate Director, Marketing and Communications Penn Nursing",
    slug: "nicole-wolverton",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "SUSIE C",
    lastName: "WON",
    title: "Director, Cost Analysis Research Services",
    slug: "susie-c-won",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Nicole",
    lastName: "Wood",
    title:
      " Financial Aid Counselor Senior Student Registration & Financial Services",
    slug: "nicole-wood",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Thomas Bowring",
    lastName: "Woodbury",
    title: "Managing Director Investments Office of Investments",
    slug: "thomas-bowring-woodbury",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Christine Anne",
    lastName: "Woods",
    title: "Director of Women's Basketball Operations Women's Basketball Team",
    slug: "christine-anne-woods",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Aubrey",
    lastName: "Woodward",
    title: "Director, Talent Search Student Engagement",
    slug: "aubrey-woodward",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Meredith A",
    lastName: "Wooten",
    title:
      " Executive Director, Graduate Student Center Graduate Student Center",
    slug: "meredith-a-wooten",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Tim",
    lastName: "Wortham",
    title:
      " Senior Director of Institutional Advancement, Annenberg School for Communication Annenberg School for Communication",
    slug: "tim-wortham",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Glenda D.",
    lastName: "Wortham",
    title: "Administrative Assistant B RA-Radiology",
    slug: "glenda-d-wortham",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jordan Salvatore",
    lastName: "Wren",
    title: "Staff Writer Exec Dir: Strategy Engagement & Campaign",
    slug: "jordan-salvatore-wren",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Alanna",
    lastName: "Wren",
    title: "Director of Athletics & Recreation Recreation and Athletics",
    slug: "alanna-wren",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Valerie Leduc",
    lastName: "Wrenn",
    title: "Associate Director, Tutoring Center Tutoring",
    slug: "valerie-leduc-wrenn",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Miriam R",
    lastName: "Wright",
    title:
      " Director, Enrollment Management College of Liberal & Professional Studies",
    slug: "miriam-r-wright",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Rob",
    lastName: "Wright",
    title: "Strategic Operations Project Manager MBA Career Management",
    slug: "rob-wright",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Marcus T.",
    lastName: "Wright",
    title: "Undergraduate Program and Communications Manager Sociology",
    slug: "marcus-t-wright",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Lashae Felicia",
    lastName: "Wright",
    title: "Event Coordinator Space and Events Management",
    slug: "lashae-felicia-wright",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Janine",
    lastName: "Wright",
    title: "K-16 Partnerships Manager Netter Center for Community Partnerships",
    slug: "janine-wright",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jonathan",
    lastName: "Wright",
    title: "MANAGER SOFTWARE DEVELOPMENT Linguistic Data Consortium",
    slug: "jonathan-wright",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "GABRIELLE",
    lastName: "WRIGHT",
    title: "Customer Service Representative, Penn Parking Parking",
    slug: "gabrielle-wright",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "William Thomas",
    lastName: "Wright-El",
    title:
      " Associate Director for Access and Retention Office of Student Intervention Services",
    slug: "william-thomas-wright-el",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Christiana",
    lastName: "Wu",
    title:
      " Director of Career Management, Semester in San Francisco MBA Career Management",
    slug: "christiana-wu",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Lincoln",
    lastName: "Wu",
    title: "Application Developer B GE-Genetics",
    slug: "lincoln-wu",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jun",
    lastName: "Wu",
    title: "Director, Senior Research Support Wharton Research Data Services",
    slug: "jun-wu",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Christine N",
    lastName: "Wujcik",
    title:
      " Manager, Financial Planning & Analysis; Division of Business Services Business Services",
    slug: "christine-n-wujcik",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Heidi T",
    lastName: "Wunder",
    title:
      " Associate Director, Environmental Innovations Initiative Environmental Innovations Initiative",
    slug: "heidi-t-wunder",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alan",
    lastName: "Wyche",
    title: "Affiliation: Staff",
    slug: "alan-wyche",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Robert F",
    lastName: "Wynne",
    title:
      " DIRECTOR FINANCIAL AND ADMINISTRATIVE AFFAIRS ABRAMSON CANCER CENTER",
    slug: "robert-f-wynne",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jiawen",
    lastName: "Xiong",
    title:
      " Associate Director C, Academic Affairs, Academic Administration LPS Summer School",
    slug: "jiawen-xiong",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Lana Lan",
    lastName: "Xu-Litt",
    title: "Admin Coordinator Annenberg Public Policy Center",
    slug: "lana-lan-xu-litt",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Derik",
    lastName: "Yager-Elorriaga",
    title:
      " College Mental Health Professional Counseling and Psychological Services",
    slug: "derik-yager-elorriaga",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Tarek",
    lastName: "Yahya",
    title:
      " Financial Administrative Coordinator, Penn Medicine Penn Medicine Development",
    slug: "tarek-yahya",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Alina",
    lastName: "Yakubova",
    title: "Administrative Coordinator Slavic Languages and Literatures",
    slug: "alina-yakubova",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Valery",
    lastName: "Yakubovich",
    title:
      " Executive Director, Mack Institute for Innovation Management Mack Institute for Innovation Management",
    slug: "valery-yakubovich",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Huan",
    lastName: "Yang",
    title:
      " Case Manager and Associate Director, International Students Education",
    slug: "huan-yang",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Andrew",
    lastName: "Yang",
    title:
      " Systems Administrator Senior Wharton Computing and Instructional Technology (WCIT)",
    slug: "andrew-yang",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jordan L.",
    lastName: "Yanoshik",
    title:
      " Associate Director for Students with Disabilities Learning Resources",
    slug: "jordan-l-yanoshik",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Yuan",
    lastName: "Yao",
    title: "Art Director DAR Communications",
    slug: "yuan-yao",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Cheng",
    lastName: "Yao",
    title:
      " Associate Director D, Student Services, Graduate Programs International Master of Public Administration",
    slug: "cheng-yao",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jojo",
    lastName: "Yao",
    title:
      " College Mental Health Professional Counseling and Psychological Services",
    slug: "jojo-yao",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Devin J.",
    lastName: "Yastro",
    title: "Manager C, Human Resources Onboard at Penn",
    slug: "devin-j-yastro",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Cailin Barker",
    lastName: "Yasunaga",
    title:
      " Associate Director of Recruiting Programs & Employer Relations Office of Career Strategy",
    slug: "cailin-barker-yasunaga",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Artemis N",
    lastName: "Yates",
    title: "Business Manager B Wharton Finance and Administration",
    slug: "artemis-n-yates",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "DOUGLAS M",
    lastName: "YATES",
    title: "DIRECTOR Nanoscale Characterization Facility",
    slug: "douglas-m-yates",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "FJM",
    lastName: "Yates-Wykle",
    title: "Admissions Counselor Admissions",
    slug: "fjm-yates-wykle",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Heather",
    lastName: "Yavil",
    title:
      " Special Projects Coordinator School of Arts and Sciences Dean's Office",
    slug: "heather-yavil",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Angela",
    lastName: "Yecco",
    title: "Undergrad Admissions",
    slug: "angela-yecco",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Susan E.",
    lastName: "Yeisley",
    title: "Executive Assistant Abramson Cancer Center; Dept. of Psychiatry",
    slug: "susan-e-yeisley",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rebecca",
    lastName: "Yelton",
    title: "Research Administrative Coordinator DM-Hematology/Oncology",
    slug: "rebecca-yelton",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Peggy",
    lastName: "Yetter",
    title: "Services Manager ISC Technology Services",
    slug: "peggy-yetter",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Michael F",
    lastName: "Yocum",
    title:
      " Program and Compliance Manager, Corporate Alliances Penn Center for Innovation",
    slug: "michael-f-yocum",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Adrienne C",
    lastName: "Yoder",
    title: "Student Success Manager Office of Academic Innovation",
    slug: "adrienne-c-yoder",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "LINDA EGERTER",
    lastName: "YODER",
    title: "Institutional Compliance Officer Audit, Compliance and Privacy",
    slug: "linda-egerter-yoder",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Thomas",
    lastName: "Yoo",
    title: "SENIOR PROJECT MANAGER Institutional Real Estate",
    slug: "thomas-yoo",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Kimberly",
    lastName: "York",
    title: "Senior Director for Information Technology Penn GSE",
    slug: "kimberly-york",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Dan",
    lastName: "Yoshida",
    title: "SR IT SUPPORT SPEC SAS COMP",
    slug: "dan-yoshida",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Hitomi",
    lastName: "Yoshida",
    title: "Coordinator Penn Women's Center",
    slug: "hitomi-yoshida",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Wiam H",
    lastName: "Younes",
    title:
      " NFORMATION SECURITY TRAINING & AWARENESS OFFICER ISC-Information Security",
    slug: "wiam-h-younes",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Michelle L",
    lastName: "Young",
    title:
      " Director, Wharton Sports Analytics and Business Initiative Wharton People Analytics",
    slug: "michelle-l-young",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Tori",
    lastName: "Young",
    title: "AEGD Resident COH Extramural Activities",
    slug: "tori-young",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Kimberly",
    lastName: "Young",
    title: "CUSTOMER SRV ASST FACIL OPER AND MAINT ADMIN",
    slug: "kimberly-young",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alex",
    lastName: "Yu",
    title:
      " Associate Director B, Arts and Media, Events New Student Orientation and Academic Initiatives",
    slug: "alex-yu",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Irina",
    lastName: "Yuen",
    title: "Director Venture Lab",
    slug: "irina-yuen",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alexander",
    lastName: "Yufa",
    title:
      " Information Technology Support Specialist B ISC-Client Services-Technology Support Services",
    slug: "alexander-yufa",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Mindy L",
    lastName: "Zacharjasz",
    title:
      " Director B, Student Services, Graduate Programs Fels Institute of Government",
    slug: "mindy-l-zacharjasz",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Lisa",
    lastName: "Zagacki",
    title: "Executive Assistant to the Deputy Provost Vice Provost Education",
    slug: "lisa-zagacki",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jacqueline",
    lastName: "Zahn",
    title: "Undergraduate Coordinator FIGS, Spanish and Portuguese",
    slug: "jacqueline-zahn",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Marc",
    lastName: "Zajack",
    title:
      " WCIT Info. Technology Project Leader, Instructional Designers and Ed. Architects Wharton Computing and Instructional Technology (WCIT)",
    slug: "marc-zajack",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Christine",
    lastName: "Zalewski",
    title: "Occuptional Safety Manager (FRES) Environmental Health and Safety",
    slug: "christine-zalewski",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Shawn A.",
    lastName: "Zamechek",
    title:
      " Director for Research, Programming & Advanced Technologies Wharton Computing and Instructional Technology (WCIT)",
    slug: "shawn-a-zamechek",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Natalie K",
    lastName: "Zamora",
    title: "Sr. Associate Director Admissions",
    slug: "natalie-k-zamora",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Jennifer E",
    lastName: "Zapf",
    title: "Director, Education Entrepreneurship Education",
    slug: "jennifer-e-zapf",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "ROBERT JAMES",
    lastName: "ZARAZOWSKI",
    title: "Managing Director Wharton Research Data Services",
    slug: "robert-james-zarazowski",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Laura Jane",
    lastName: "Zarrow",
    title:
      " Executive Director, Wharton Generative AI Labs Generative Artificial Intelligence Lab",
    slug: "laura-jane-zarrow",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Rafael A.",
    lastName: "Zayas",
    title: "FIN AID ASST STUDENT FIN SVCS",
    slug: "rafael-a-zayas",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Adam M.",
    lastName: "Zdanavage",
    title:
      " Information Technology Project Leader Senior ISC-Applications & Information Services",
    slug: "adam-m-zdanavage",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "KENNETH G",
    lastName: "ZEFERES",
    title: "Assistant Director of Fiscal Operations, Business Office Education",
    slug: "kenneth-g-zeferes",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "David J",
    lastName: "Zeitlin",
    title: "Associate Editor, Gazette Pennsylvania Gazette",
    slug: "david-j-zeitlin",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Lauren Mirowitz",
    lastName: "Zeitlin",
    title:
      " Senior Director of Alumni Annual Fund & Special Gifts Penn Medicine Development",
    slug: "lauren-mirowitz-zeitlin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lisagail",
    lastName: "Zeitlin",
    title: "HCM Workday Training Manager ISC-HCM Operations",
    slug: "lisagail-zeitlin",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Glenn R.",
    lastName: "Zeitzer",
    title:
      " Housekeeping Quality and Standards Manager Operations and Maintenance Administration",
    slug: "glenn-r-zeitzer",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Matthew",
    lastName: "Zemaitaitis",
    title: "Systems Administrator Senior SM-DN External Info Services",
    slug: "matthew-zemaitaitis",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Mira C",
    lastName: "Zergani",
    title: "Director of Development Morris Arboretum",
    slug: "mira-c-zergani",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Melissa",
    lastName: "Zhang",
    title: "Application Developer B, Information Technology Education",
    slug: "melissa-zhang",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Guochang",
    lastName: "Zhao",
    title:
      " Systems Administrator Sr Wharton Computing and Instructional Technology (WCIT)",
    slug: "guochang-zhao",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Dongnian",
    lastName: "Zhou",
    title:
      " Senior Manager, Learning Design and Instructional Technology Wharton Global Youth Programs",
    slug: "dongnian-zhou",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Julia",
    lastName: "Zhu",
    title: "Assistant Program Manager Wharton Executive Education (Operations)",
    slug: "julia-zhu",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Bart",
    lastName: "Ziemski",
    title: "Director E, Research CC-Cancer Center",
    slug: "bart-ziemski",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Nico F",
    lastName: "Zigouras",
    title: "Application Architect ISC-Applications & Information Services",
    slug: "nico-f-zigouras",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Eszter",
    lastName: "Zimanyi",
    title: "Senior Research Manager Annenberg School for Communication",
    slug: "eszter-zimanyi",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Amanda",
    lastName: "Zimmerman",
    title: "Director Undergraduate Leadership Development Leadership Program",
    slug: "amanda-zimmerman",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Erica",
    lastName: "Zito",
    title: "Traffic Manager WXPN",
    slug: "erica-zito",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Amy",
    lastName: "Zoll",
    title: "Information Technology Project Leader Senior SASC-Computing",
    slug: "amy-zoll",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Harriet",
    lastName: "Zucker",
    title:
      " Senior Solution Architect, Salesforce, Enterprise, Solutions & Services Wharton Computing and Instructional Technology (WCIT)",
    slug: "harriet-zucker",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Seth D.",
    lastName: "Zweifler",
    title: "Dean's Office Penn Carey Law",
    slug: "seth-d-zweifler",
    dei: false,
    category: "Academic",
  },
];
export default people;
